webpackJsonp([2],Array(166).concat([
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_main_root__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_router__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reducers__ = __webpack_require__(527);









var store = Object(__WEBPACK_IMPORTED_MODULE_6_util_redux__["a" /* createStore */])(__WEBPACK_IMPORTED_MODULE_7_reducers__["a" /* default */].reducers, __WEBPACK_IMPORTED_MODULE_7_reducers__["a" /* default */].actions);

function init() {
    Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_redux__["a" /* Provider */],
        { store: store },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* BrowserRouter */],
            { forceRefresh: globals.config.is_cms_enabled },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], { match: '/', render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_main_root__["a" /* default */],
                        props,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_router__["a" /* render */], null)
                    );
                } })
        )
    ), window.root);
}

/***/ }),
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export normalizeToHTML */
/* unused harmony export externalLinks */
/* harmony export (immutable) */ __webpack_exports__["f"] = t;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return markdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return format; });
/* harmony export (immutable) */ __webpack_exports__["a"] = Trans;
/* harmony export (immutable) */ __webpack_exports__["b"] = TransMD;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_flowRight__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_template__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_template___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_template__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_snarkdown__ = __webpack_require__(950);




var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

 // enable JSX




// Get the translations from the backend through the config, or use a fallback
var translations = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(globals, 'config.translations') || {};
var PLURALIZATION_REGEX = /\|\|\|\|/m;

/**
 * Normalize a translation string in order to wrap its content in <p>
 * @param {string} text
 * @return {string}
 */
function normalizeToHTML(text) {
    return text.replace(/^/, '<p>').replace(/(\r\n){2}/gm, '<p>').replace(/\r\n/gm, '<br/>');
}

/**
 * Add target blank to links starting with https://
 * @param {string} text
 * @return {string}
 */
function externalLinks(text) {
    return text.replace(/(<a href="(https?:)?\/\/.*?")>/g, '$1 target="_blank" rel="nofollow">');
}

/**
 * Pluralize the sentences if the `||||` separator get detected 4 example: "My singular |||| My plural |||| My super plural"
 * @param {string} translation - translation string
 * @param {number} amount - amount to manage the pluralization
 * @returns {string}
 */
function pluralize(translation, amount) {
    var isPluralized = PLURALIZATION_REGEX.exec(translation);

    if (isPluralized) {
        // take all the variations for the same vocabulary string
        var variants = translation.split(PLURALIZATION_REGEX);
        // fallback solution for values having not a specific value
        var lastVariation = variants[variants.length - 1];

        return amount > 1 ? variants[amount - 1] || lastVariation : variants[0];
    }

    return translation;
}

/**
 * Print meaningful information for the user doing translations
 * @param {string} path - path to the translations
 * @param {object} data - optional object
 * @returns {string}
 */
function printInfo(path, data) {
    if (!data) {
        return path;
    }

    return 'path="' + path + '" and data="' + JSON.stringify(data) + '"';
}

/**
 * Get the site static content translations
 * @param {string} path - key to the content
 * @param {object} data - data to interpolate into the translation string
 * @param {number} amount - variable used to pluralize our texts
 * @returns {string}
 */
function t(path, data, amount) {
    var translation = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(translations, path, path);

    var words = typeof amount === 'number' ? pluralize(translation, amount) : translation;

    // use the lodash template engine in case we want to use interpolate translations variables
    if (data) {
        return __WEBPACK_IMPORTED_MODULE_1_lodash_template___default()(words)(data);
    }

    return words;
}

var markdown = __WEBPACK_IMPORTED_MODULE_0_lodash_flowRight___default()(externalLinks, __WEBPACK_IMPORTED_MODULE_5_snarkdown__["a" /* default */], t);
var format = __WEBPACK_IMPORTED_MODULE_0_lodash_flowRight___default()(normalizeToHTML, markdown);

/**
 * Get the site static content translations and wrap it for the dom
 * The title param gives us the info if the user is a staff member
 * @param {string} path - path to the content
 * @param {object} data
 * @param {number} amount
 * @param {any} props
 * @returns {string}
 */
function Trans(_ref) {
    var path = _ref.path,
        data = _ref.data,
        amount = _ref.amount,
        props = _objectWithoutProperties(_ref, ['path', 'data', 'amount']);

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'span',
        _extends({}, props, { title: globals.config.user.isStaff ? printInfo(path, data) : null }),
        t(path, data, amount)
    );
}

Trans.propTypes = {
    path: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
    data: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
    amount: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number
};

/**
 * Like trans but with markdown support
 * @param {string} path - path to the content
 * @returns {string}
 */
function TransMD(_ref2) {
    var path = _ref2.path,
        data = _ref2.data,
        amount = _ref2.amount,
        props = _objectWithoutProperties(_ref2, ['path', 'data', 'amount']);

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', _extends({}, props, {
        title: globals.config.user.isStaff ? printInfo(path, data) : null,
        dangerouslySetInnerHTML: { __html: format(path, data, amount) } }));
}

TransMD.propTypes = {
    path: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
    data: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
    amount: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number
};

/* harmony default export */ __webpack_exports__["c"] = (t);

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export extendActions */
/* harmony export (immutable) */ __webpack_exports__["a"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_set__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reducers__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_thunk__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(517);



var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






var sharedReducers = __WEBPACK_IMPORTED_MODULE_2_reducers__["a" /* default */].reducers;
var sharedActions = __WEBPACK_IMPORTED_MODULE_2_reducers__["a" /* default */].actions;

/**
 * Object that will store all the app actions
 * @type {object}
 */
var actions = {};

/**
 * Extend permanently the reducers actions
 * @param {object} customActions - new actions we want make retrievable through the helpers
 * @returns {object}
 */
function extendActions(customActions) {
    Object.assign(actions, customActions);
    return actions;
}

/* harmony default export */ __webpack_exports__["b"] = (Object.freeze({
    /**
     * Map all the component properties to a certain state
     * @param { Object } props - component properties
     * @returns { Function } function that will be passed to the react-redux connect method
     * @example
     *
     * connect(mapStateToProps({
     *     counter: 'counter',
     *     globalMessage: 'global.message'
     * })(Component)
     */
    mapStateToProps: function mapStateToProps(props) {
        return function (state) {
            return Object.freeze(Object.entries(props).reduce(function (ret, _ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    prop = _ref2[0],
                    val = _ref2[1];

                __WEBPACK_IMPORTED_MODULE_0_lodash_set___default()(ret, prop, __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(state, val));
                return ret;
            }, {}));
        };
    },


    /**
     * Automatically bind the reducers actions to a component
     * @param { Object } props - component properties
     * @param { Object } customActions - custom actions that we could to combine together with the default ones
     * @returns {Function} function that will be passed to the react-redux connect method
     * @example
     *
     * connect(null, mapDispatchToProps({
     *     onClick: 'counter.increase'
     *     onMouseOver: 'counter.decrease',
     *     onChange: 'global.setGlobalMessage',
     * }))(Component)
     *
     * @example
     *
     * connect(null, mapDispatchToProps({
     *     onClick: 'custom.increase'
     *     onMouseOver: 'custom.decrease',
     *     onChange: 'global.setGlobalMessage',
     * }, {
     *   custom: {
     *      increase() {
     *           return { type: 'COUNTER_INCREASE' };
     *      },
     *      decrease() {
     *           return { type: 'COUNTER_DECREASE' };
     *      },
     *   },
     * ))(Component)
     *
     */
    mapDispatchToProps: function mapDispatchToProps(props, customActions) {
        return function (dispatch) {
            return Object.freeze(Object.entries(props).reduce(function (ret, _ref3) {
                var _ref4 = _slicedToArray(_ref3, 2),
                    prop = _ref4[0],
                    val = _ref4[1];

                __WEBPACK_IMPORTED_MODULE_0_lodash_set___default()(ret, prop, function () {
                    var combinedActions = Object.assign({}, actions, customActions);

                    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                    }

                    return dispatch(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(combinedActions, val).apply(null, args));
                });
                return ret;
            }, {}));
        };
    }
}));

/**
     * Create the application store from combining the local reducers with the custom ones
     * @param {object} customReducers - custom reducers that can add extra data to the app
     * @param {object} customActions - custom actions that will be stored in the actions object to be easily retrived later
     * @param {array}  middlewares - additional middlewares
     * @returns {object} a redux store
     * @example
     *
     * const store = createStore(
     *     combineReducers({ reducer1, reducer2 }), {
     *     custom: {
     *      increase() {
     *           return { type: 'COUNTER_INCREASE' };
     *      },
     *      decrease() {
     *           return { type: 'COUNTER_DECREASE' };
     *      },
     *     }
     *  });
     *
     */

function createStore() {
    var customReducers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var customActions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var middlewares = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    extendActions(sharedActions);
    extendActions(customActions);

    return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["d" /* createStore */])(Object(__WEBPACK_IMPORTED_MODULE_4_redux__["c" /* combineReducers */])(Object.assign({}, sharedReducers, customReducers)), __WEBPACK_IMPORTED_MODULE_4_redux__["a" /* applyMiddleware */].apply(undefined, [__WEBPACK_IMPORTED_MODULE_3_redux_thunk__["a" /* default */]].concat(_toConsumableArray(middlewares))));
};

/***/ }),
/* 173 */,
/* 174 */,
/* 175 */
/***/ (function(module, exports) {

module.exports = exports.default = Object.freeze({
    // Viewport actions
    SET_VIEWPORT: 'SET_VIEWPORT',
    SET_VIEWPORT_OVERLAY: 'SET_VIEWPORT_OVERLAY',
    SET_VIEWPORT_TITLE: 'SET_VIEWPORT_TITLE',

    // Scroll module
    SET_PENDING_AUTOSCROLL: 'SET_PENDING_AUTOSCROLL',
    LOCK_SCROLL: 'LOCK_SCROLL',
    UNLOCK_SCROLL: 'UNLOCK_SCROLL',

    // Modal actions
    OPEN_MODAL: 'OPEN_MODAL',
    CLOSE_MODAL: 'CLOSE_MODAL',
    RESET_MODAL: 'RESET_MODAL',
    SET_MODAL_READY: 'SET_MODAL_READY',

    // Video card reducer
    VIDEO_CARD_LOADED: 'VIDEO_CARD_LOADED',
    VIDEO_CARD_RESET: 'VIDEO_CARD_RESET',

    // Set main content
    SET_MAIN_CONTENT_LOADING: 'SET_MAIN_CONTENT_LOADING',
    SET_MAIN_CONTENT_LOADER_VISIBILITY: 'SET_MAIN_CONTENT_LOADER_VISIBILITY',

    // Subscription events
    SET_SUBSCRIPTION_EMAIL: 'SET_SUBSCRIPTION_EMAIL',
    SET_IS_FETCHING_SUBSCRIPTION: 'SET_IS_FETCHING_SUBSCRIPTION',

    // User actions
    DO_AUTOLOGIN: 'DO_AUTOLOGIN',
    SET_IS_UPDATING_ADDRESS: 'SET_IS_UPDATING_ADDRESS',
    SET_USER_AUTHENTICATION: 'SET_USER_AUTHENTICATION',
    SET_USER_FAVORITE_PRODUCTS: 'SET_USER_FAVORITE_PRODUCTS',
    SET_USER_MOST_PURCHASED_PRODUCTS: 'SET_USER_MOST_PURCHASED_PRODUCTS',
    SET_USER_LAST_PURCHASED_PRODUCTS: 'SET_USER_LAST_PURCHASED_PRODUCTS',
    SET_USER_CREDITCARDINFO: 'SET_USER_CREDITCARDINFO',
    SET_USER_REPLACEMENT_PRODUCTS_PREFERENCES: 'SET_USER_REPLACEMENT_PRODUCTS_PREFERENCES',
    SET_USER_FETCHING_CREDITCARDINFO: 'SET_USER_FETCHING_CREDITCARDINFO',

    // addresses
    SET_ORDER_ADDRESS: 'SET_ORDER_ADDRESS',
    SET_USER_ADDRESSES: 'SET_USER_ADDRESSES',
    SET_DEFAULT_ADDRESS: 'SET_DEFAULT_ADDRESS',
    SET_IS_FETCHING_USER_ADDRESSES: 'SET_IS_FETCHING_USER_ADDRESSES',

    // Region
    SET_IS_FETCHING_REGION: 'SET_IS_FETCHING_REGION',
    SET_REGION: 'SET_REGION',
    RESET_REQUESTED_REGION: 'RESET_REQUESTED_REGION',

    // Cart Actions
    SET_IS_FETCHING_CART: 'SET_IS_FETCHING_CART',
    REPLACE_CART: 'REPLACE_CART',
    RESET_CART: 'RESET_CART',
    SET_CART_DRAGGING_TUTORIAL: 'SET_CART_DRAGGING_TUTORIAL',
    SET_CART_TOOLTIP_ID: 'SET_CART_TOOLTIP_ID',
    SET_CART_TEMP_ITEM: 'SET_CART_TEMP_ITEM',
    SET_CART_ERROR: 'SET_CART_ERROR',
    SET_CART_PRODUCT_ERROR: 'SET_CART_PRODUCT_ERROR',
    SET_BLOCKED_CART: 'SET_BLOCKED_CART',
    SET_CART_FOOTER_FIXED: 'SET_CART_FOOTER_FIXED',

    // Products actions
    FETCH_PRODUCTS_BY_CATEGORY: 'FETCH_PRODUCTS_BY_CATEGORY',
    SET_IS_FETCHING_PRODUCTS: 'SET_IS_FETCHING_PRODUCTS',
    FLUSH_PRODUCTS: 'FLUSH_PRODUCTS',

    // Single product actions
    SET_PRODUCT: 'SET_PRODUCT',
    RESET_PRODUCT: 'RESET_PRODUCT',
    SET_IS_FETCHING_PRODUCT: 'SET_IS_FETCHING_PRODUCT',

    // Top-Products actions
    FETCH_TOP_PRODUCTS_BY_CATEGORY: 'FETCH_TOP_PRODUCTS_BY_CATEGORY',
    SET_IS_FETCHING_TOP_PRODUCTS: 'SET_IS_FETCHING_TOP_PRODUCTS',

    // Categories actions
    SET_IS_FETCHING_CATEGORIES: 'SET_IS_FETCHING_CATEGORIES',
    FETCH_CATEGORIES: 'FETCH_CATEGORIES',
    SET_ACTIVE_CATEGORY: 'SET_ACTIVE_CATEGORY',
    SET_CATEGORIES_COOPERATIVE: 'SET_CATEGORIES_COOPERATIVE',
    SET_ACTIVE_LEAF_CATEGORY: 'SET_ACTIVE_LEAF_CATEGORY', // the leaf nodes are the ones with no children
    SET_CATEGORIES_VISIBILITY: 'SET_CATEGORIES_VISIBILITY', // the leaf nodes are the ones with no children

    // Router actions
    SET_ROUTE: 'SET_ROUTE',
    SET_LAST_ROUTE: 'SET_LAST_ROUTE',
    SET_ROUTE_COOPERATIVE: 'SET_ROUTE_COOPERATIVE',
    SET_FORCE_NOT_FOUND: 'SET_FORCE_NOT_FOUND',

    // Header actions
    SET_HEADER_HEIGHT: 'SET_HEADER_HEIGHT',
    SET_HEADER_FACET: 'SET_HEADER_FACET',

    // Menu actions
    OPEN_PANEL: 'OPEN_PANEL',
    CLOSE_PANEL: 'CLOSE_PANEL',
    RESET_PANEL: 'RESET_PANEL',

    // Tooltip
    SET_TOOLTIP_BLOCKER: 'SET_TOOLTIP_BLOCKER',
    SET_TOOLTIPS: 'SET_TOOLTIPS',

    // Checkout
    SET_CHECKOUT_MESSAGE: 'SET_CHECKOUT_MESSAGE',
    SET_CHECKOUT_COMPLETE: 'SET_CHECKOUT_COMPLETE',
    SET_CHECKOUT_VALIDATION: 'SET_CHECKOUT_VALIDATION',
    SET_CHECKOUT_EXCLUDED_PICKERS: 'SET_CHECKOUT_EXCLUDED_PICKERS',
    RESET_CHECKOUT: 'RESET_CHECKOUT',
    TOGGLE_CHECKOUT_ERRORS_VISIBILITY: 'TOGGLE_CHECKOUT_ERRORS_VISIBILITY',
    IS_SUBMITTING_CHECKOUT: 'IS_SUBMITTING_CHECKOUT',
    SET_CHECKOUT_IS_UPDATING_DELIVERY_ADDRESS: 'SET_CHECKOUT_IS_UPDATING_DELIVERY_ADDRESS',
    SET_CHECKOUT_DELIVERY_DATES: 'SET_CHECKOUT_DELIVERY_DATES',
    SET_CHECKOUT_PAYMENT_VALID: 'SET_CHECKOUT_PAYMENT_VALID',
    IS_SUBMITTING_PROMOCODE: 'IS_SUBMITTING_PROMOCODE',

    // Delivery
    SET_DELIVERY_STATE: 'SET_DELIVERY_STATE',
    SET_IS_FETCHING_DELIVERY: 'SET_IS_FETCHING_DELIVERY',
    SET_DELIVERY_STATUS: 'SET_DELIVERY_STATUS',
    RESET_DELIVERY: 'RESET_DELIVERY',

    // Breadcrumbs
    RESET_BREADCRUMBS: 'RESET_BREADCRUMBS',
    SET_BREADCRUMBS: 'SET_BREADCRUMBS',
    ADD_BREADCRUMB: 'ADD_BREADCRUMB',
    REMOVE_BREADCRUMB: 'REMOVE_BREADCRUMB',

    // Notifications
    SET_IS_FETCHING_NOTIFICATIONS: 'SET_IS_FETCHING_NOTIFICATIONS',
    SET_NOTIFICATIONS: 'SET_NOTIFICATIONS',
    ADD_NOTIFICATION: 'ADD_NOTIFICATION',
    REMOVE_NOTIFICATION: 'REMOVE_NOTIFICATION',
    RESET_NOTIFICATIONS: 'RESET_NOTIFICATIONS',

    // Snackbar
    ADD_SNACKBAR_NOTIFICATION: 'ADD_SNACKBAR_NOTIFICATION',
    REMOVE_SNACKBAR_NOTIFICATION: 'REMOVE_SNACKBAR_NOTIFICATION',

    // Poll
    SET_POLLING_ID: 'SET_POLLING_ID',

    //Order History
    FETCH_FINISHED_ORDERS: 'FETCH_FINISHED_ORDERS',
    FETCH_ORDER: 'FETCH_ORDER',
    FETCH_PENDING_ORDERS: 'FETCH_PENDING_ORDERS',
    RESET_ORDERS: 'RESET_ORDERS',
    SET_FEEDBACK: 'SET_FEEDBACK',
    SET_PICKER_RATING: 'SET_PICKER_RATING',

    // Pickers in checkout
    SET_PICKERS: 'SET_PICKERS',
    SET_PICKERS_TOTAL: 'SET_PICKERS_TOTAL',
    SET_PICKERS_LOADED_CHUNK_INDEXES: 'SET_PICKERS_LOADED_CHUNK_INDEXES',
    SET_IS_FETCHING_PICKERS: 'SET_IS_FETCHING_PICKERS',
    SET_PICKER_EXCLUDED: 'SET_PICKER_EXCLUDED',
    SET_PICKERS_TOTAL_CHUNKS: 'SET_PICKERS_TOTAL_CHUNKS',
    SET_PICKERS_ALL_CHUNKS_LOADED: 'SET_PICKERS_ALL_CHUNKS_LOADED',

    // Search stuff
    SET_IS_FETCHING_SEARCH_WORDS: 'SET_IS_FETCHING_SEARCH_WORDS',
    SET_IS_FETCHING_SEARCH_PRODUCTS: 'SET_IS_FETCHING_SEARCH_PRODUCTS',
    SET_SEARCH_PRODUCTS: 'SET_SEARCH_PRODUCTS',
    SET_SEARCH_WORDS: 'SET_SEARCH_WORDS',
    RESET_SEARCH_PRODUCTS: 'RESET_SEARCH_PRODUCTS',
    RESET_SEARCH_WORDS: 'RESET_SEARCH_WORDS',
    RESET_SEARCH: 'RESET_SEARCH',
    SET_COMMON_CATEGORIES: 'SET_COMMON_CATEGORIES',
    SET_IS_LOADING_MORE: 'SET_IS_LOADING_MORE',
    SET_IS_SEARCHING: 'SET_IS_SEARCHING',
    SET_SEARCH_IS_ACTIVE: 'SET_SEARCH_IS_ACTIVE',
    SET_SEARCH_IS_INACTIVE: 'SET_SEARCH_IS_INACTIVE',
    SET_SEARCH_LIMIT: 'SET_SEARCH_LIMIT',
    SET_SEARCH_OFFSET: 'SET_SEARCH_OFFSET',
    SET_SEARCH_RESULT: 'SET_SEARCH_RESULT',
    SET_SEARCH_TERM: 'SET_SEARCH_TERM',
    SET_SEARCH_FUZZY: 'SET_SEARCH_FUZZY',

    // Navigator events
    SET_NAVIGATOR_ONLINE: 'SET_NAVIGATOR_ONLINE',

    STRIPE_SET_ERROR: 'STRIPE_SET_ERROR',
    STRIPE_IS_FETCHING: 'STRIPE_IS_FETCHING',

    MYMIGROS_SET_SLIDERS: 'MYMIGROS_SET_SLIDERS',
    MYMIGROS_SET_IS_FETCHING: 'MYMIGROS_SET_IS_FETCHING',
    MYMIGROS_SET_HAS_FETCHED: 'MYMIGROS_SET_HAS_FETCHED'
});

/***/ }),
/* 176 */,
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Icon;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var PLACEHOLDER_SYMBOL = 'placeholder';
var DEFAULT_SYMBOL_SIZE = 'default';

function Icon(_ref) {
    var symbol = _ref.symbol,
        size = _ref.size,
        style = _ref.style,
        className = _ref.className;

    var isPlaceholder = symbol === PLACEHOLDER_SYMBOL;
    // Finally fixed this for IE11 as well:
    // https://github.com/facebook/react/issues/2250#issuecomment-163710327
    var xlinkHref = isPlaceholder ? '#' + PLACEHOLDER_SYMBOL : '#' + size + '--' + symbol;
    className = 'icon icon__' + size + ' ' + className;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        { tabIndex: '-1', style: style, className: className, focusable: 'false' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('use', { xlinkHref: xlinkHref })
    );
}

Icon.propTypes = {
    // symbol key (required)
    symbol: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    // optional classname (can contain styling)
    className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    // optional standardized size e.g. "sm"
    size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

Icon.defaultProps = {
    displayName: 'Icon', // little hack here becuase the Component.displayName doesn't seem to work
    symbol: PLACEHOLDER_SYMBOL,
    className: '',
    style: {},
    size: DEFAULT_SYMBOL_SIZE
};

/***/ }),
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_icon__ = __webpack_require__(177);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Loader = function (_PureComponent) {
    _inherits(Loader, _PureComponent);

    function Loader() {
        _classCallCheck(this, Loader);

        return _possibleConstructorReturn(this, (Loader.__proto__ || Object.getPrototypeOf(Loader)).apply(this, arguments));
    }

    _createClass(Loader, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                facet = _props.facet,
                size = _props.size,
                symbol = _props.symbol,
                pulsate = _props.pulsate;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('loader', 'loader__' + (facet || 'default'), _defineProperty({}, 'loader__' + size, size)) },
                facet === 'icon' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_icon__["a" /* default */], { size: size, symbol: symbol,
                    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('loader--icon', { 'loader--icon__pulsate': pulsate }) }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'loader--container' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'svg',
                        { className: 'loader--circle', viewBox: '16 16 32 32' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', { className: 'loader--bg', cx: '32', cy: '32', r: '14', fill: 'none' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', { className: 'loader--path', cx: '32', cy: '32', r: '14', fill: 'none' })
                    )
                )
            );
        }
    }]);

    return Loader;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Loader.propTypes = {
    facet: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    symbol: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    pulsate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
Loader.defaultProps = {
    pulsate: true
};
/* harmony default export */ __webpack_exports__["a"] = (Loader);

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mapFacets;
/**
 * Arraify facets in order to use single or multiple facets in a react component
 * @param {string|array} facets - the facets we want to apply to the component
 * @param {string} prefix - facet root class
 * @returns {Array}
 */
function mapFacets(facets, prefix) {
    if (facets) {
        return (Array.isArray(facets) ? facets : [facets]).map(function (f) {
            return prefix + "__" + f;
        });
    }
    return [];
}

/***/ }),
/* 186 */,
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Button;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_react_facet__ = __webpack_require__(185);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/**
 * Check if the child component is an icon
 */
function isIcon(child) {
    return child && child.props && child.props.displayName === 'Icon';
}

function Button(props) {
    var children = props.children,
        size = props.size,
        facet = props.facet,
        className = props.className,
        tag = props.tag,
        hasFocus = props.hasFocus,
        disabled = props.disabled,
        additionalProps = _objectWithoutProperties(props, ['children', 'size', 'facet', 'className', 'tag', 'hasFocus', 'disabled']); // eslint-disable-line


    var Tag = props.tag === 'a' ? __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */] : props.tag;

    // normalize always the children property in order to get an array back
    if (!Array.isArray(children)) {
        children = [children];
    }

    // remove empty values
    children = children.filter(function (c) {
        return c;
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Tag,
        _extends({}, additionalProps, {
            role: 'button',
            disabled: disabled,
            className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(['btn', Object(__WEBPACK_IMPORTED_MODULE_5_util_react_facet__["a" /* default */])(facet, 'btn'), 'btn__' + size, className, {
                'btn__has-focus': hasFocus
            }]) }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'btn--wrap' },
            Object(__WEBPACK_IMPORTED_MODULE_4_looppa__["a" /* default */])(children)(function (child, i) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { key: i,
                        className: isIcon(child) ? 'btn--icon' : 'btn--text' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'btn--cell' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'btn--content' },
                            child
                        )
                    )
                );
            })
        )
    );
}

Button.propTypes = {
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
    className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    hasFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    facet: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]),
    size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['a', 'button']).isRequired
};

Button.defaultProps = {
    className: '',
    disabled: false,
    hasFocus: false,
    size: 'medium',
    facet: 'base',
    tag: 'button'
};

/***/ }),
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["zipCode"] = zipCode;
/* harmony export (immutable) */ __webpack_exports__["subscribe"] = subscribe;
/* harmony export (immutable) */ __webpack_exports__["category"] = category;
/* harmony export (immutable) */ __webpack_exports__["categories"] = categories;
/* harmony export (immutable) */ __webpack_exports__["topicProducts"] = topicProducts;
/* harmony export (immutable) */ __webpack_exports__["product"] = product;
/* harmony export (immutable) */ __webpack_exports__["cart"] = cart;
/* harmony export (immutable) */ __webpack_exports__["cartItems"] = cartItems;
/* harmony export (immutable) */ __webpack_exports__["orderExpiration"] = orderExpiration;
/* harmony export (immutable) */ __webpack_exports__["poll"] = poll;
/* harmony export (immutable) */ __webpack_exports__["placeholder"] = placeholder;
/* harmony export (immutable) */ __webpack_exports__["topProducts"] = topProducts;
/* harmony export (immutable) */ __webpack_exports__["orderDeliveryAddresses"] = orderDeliveryAddresses;
/* harmony export (immutable) */ __webpack_exports__["checkout"] = checkout;
/* harmony export (immutable) */ __webpack_exports__["promoCode"] = promoCode;
/* harmony export (immutable) */ __webpack_exports__["userAddresses"] = userAddresses;
/* harmony export (immutable) */ __webpack_exports__["userCreditCard"] = userCreditCard;
/* harmony export (immutable) */ __webpack_exports__["userFavoriteProducts"] = userFavoriteProducts;
/* harmony export (immutable) */ __webpack_exports__["mostPurchasedProducts"] = mostPurchasedProducts;
/* harmony export (immutable) */ __webpack_exports__["lastPurchasedProducs"] = lastPurchasedProducs;
/* harmony export (immutable) */ __webpack_exports__["userAddressSetDefault"] = userAddressSetDefault;
/* harmony export (immutable) */ __webpack_exports__["pendingOrders"] = pendingOrders;
/* harmony export (immutable) */ __webpack_exports__["finishedOrders"] = finishedOrders;
/* harmony export (immutable) */ __webpack_exports__["copyOrder"] = copyOrder;
/* harmony export (immutable) */ __webpack_exports__["order"] = order;
/* harmony export (immutable) */ __webpack_exports__["orderPickerRating"] = orderPickerRating;
/* harmony export (immutable) */ __webpack_exports__["orderFeedback"] = orderFeedback;
/* harmony export (immutable) */ __webpack_exports__["replacementProducts"] = replacementProducts;
/* harmony export (immutable) */ __webpack_exports__["notifications"] = notifications;
/* harmony export (immutable) */ __webpack_exports__["pickers"] = pickers;
/* harmony export (immutable) */ __webpack_exports__["search"] = search;
/* harmony export (immutable) */ __webpack_exports__["login"] = login;
/* harmony export (immutable) */ __webpack_exports__["logout"] = logout;
/* harmony export (immutable) */ __webpack_exports__["userAddressEdit"] = userAddressEdit;
/* harmony export (immutable) */ __webpack_exports__["userAddressAdd"] = userAddressAdd;
/* harmony export (immutable) */ __webpack_exports__["userEdit"] = userEdit;
/* harmony export (immutable) */ __webpack_exports__["userConnectCumulus"] = userConnectCumulus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_flowRight__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_flowRight__);



var API_VERSION = globals.config.axios.baseURL;
var PLACEHOLDERS_ENDPOINT = '/placeholders';
var REGION_PREFIX = '/regions';
var CATEGORIES_ENDPOINT = '/categories';
var PRODUCT_ENDPOINT = '/products';
var CART_ENDPOINT = '/order';
var USERS_ENDPOINT = '/users';
var POLL_ENDPOINT = '/poll';

function zipCode(code) {
    return '/users/zip/' + code;
}

function subscribe() {
    return '/subscribe';
}

function category(id, cooperative) {
    return REGION_PREFIX + '/' + cooperative + CATEGORIES_ENDPOINT + '/' + id + '/children';
}

function categories(cooperative) {
    return REGION_PREFIX + '/' + cooperative + CATEGORIES_ENDPOINT + '/';
}

function topicProducts(topicSlug) {
    return '/topics/' + topicSlug;
}

function product(slug) {
    return PRODUCT_ENDPOINT + '/' + slug;
}

function cart() {
    return CART_ENDPOINT + '/';
}

function cartItems() {
    return CART_ENDPOINT + '/items';
}

function orderExpiration() {
    return CART_ENDPOINT + '/expiration';
}

function poll(id) {
    return POLL_ENDPOINT + '/' + id;
}

function placeholder(placeholderId) {
    return PLACEHOLDERS_ENDPOINT + '/' + placeholderId;
}

function topProducts(categoryId, cooperative) {
    return REGION_PREFIX + '/' + cooperative + CATEGORIES_ENDPOINT + '/' + categoryId + '/top-products';
}

function orderDeliveryAddresses() {
    return CART_ENDPOINT + '/delivery-address';
}

function checkout() {
    return CART_ENDPOINT + '/checkout';
}

function promoCode() {
    return CART_ENDPOINT + '/promo-code';
}

function userAddresses() {
    return USERS_ENDPOINT + '/addresses';
}

function userCreditCard() {
    return USERS_ENDPOINT + '/credit-card';
}

function userFavoriteProducts() {
    return USERS_ENDPOINT + '/favorite-products';
}

function mostPurchasedProducts() {
    return userFavoriteProducts() + '/most-purchased';
}

function lastPurchasedProducs() {
    return userFavoriteProducts() + '/last-purchased';
}

function userAddressSetDefault() {
    return USERS_ENDPOINT + '/addresses/default';
}

function pendingOrders() {
    return USERS_ENDPOINT + '/orders/pending';
}

function finishedOrders() {
    return USERS_ENDPOINT + '/orders/finished';
}

function copyOrder(id) {
    return USERS_ENDPOINT + '/orders/' + id + '/copy/';
}

function order(id) {
    return USERS_ENDPOINT + '/orders/' + id;
}

function orderPickerRating(id) {
    return USERS_ENDPOINT + '/orders/' + id + '/picker-rating';
}

function orderFeedback(id) {
    return USERS_ENDPOINT + '/orders/' + id + '/feedback';
}

function replacementProducts() {
    return USERS_ENDPOINT + '/replacement-products';
}

function notifications() {
    return '/notifications';
}

function pickers() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;
    var chunkIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return CART_ENDPOINT + '/pickers?limit=' + limit + (chunkIndex === null ? '' : '&chunk_index=' + chunkIndex);
}

/*  urlParam: keyword (urlencoded)
*   getParams: offset, limit (int)
*/
function search(keyword, cooperative) {
    return REGION_PREFIX + '/' + cooperative + '/search/' + keyword;
}

/// There and back again
//  An endpoint's tale - forwarders require "/api" to be set explicitly

function login() {
    var redirectToUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location;

    return '/login?' + NEXT_PARAM + '=' + redirectToUrl;
}

function logout(url) {
    return '/logout?' + RETURN_TO_PARAM + '=' + url;
}

function userAddressEdit(id) {
    return '' + API_VERSION + USERS_ENDPOINT + '/addresses/' + id + '/edit?' + returnTo(window.location);
}

function userAddressAdd() {
    return '' + API_VERSION + USERS_ENDPOINT + '/addresses/add?' + returnTo(window.location);
}

function userEdit() {
    return '' + API_VERSION + USERS_ENDPOINT + '/edit?' + returnToAndForward('login', window.location.pathname);
}

function userConnectCumulus() {
    return '' + API_VERSION + USERS_ENDPOINT + '/connect-cumulus?' + returnToAndForward('login', window.location.pathname);
}

/**
 * Helper meethods needed for the mLogin redirects
 */

var RETURN_TO_PARAM = 'return_to';
var NEXT_PARAM = 'next';
var BASE_URL = window.location.protocol + '//' + window.location.host + '/';

var returnToAndForward = function returnToAndForward(path, query) {
    return __WEBPACK_IMPORTED_MODULE_0_lodash_flowRight___default()(returnTo, toAbsolute)('' + path + nextQuery(query));
};
var toAbsolute = function toAbsolute(path) {
    return '' + BASE_URL + path;
};
var returnTo = function returnTo(url) {
    return RETURN_TO_PARAM + '=' + url;
};
var nextQuery = function nextQuery(query) {
    return encodeURIComponent('?' + NEXT_PARAM + '=' + query);
};

/***/ }),
/* 193 */,
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ROOT", function() { return ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DELIVERY_SEARCH", function() { return DELIVERY_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PRODUCTS_ZURICH", function() { return PRODUCTS_ZURICH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PRODUCTS_BERN", function() { return PRODUCTS_BERN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PRODUCT_DETAIL", function() { return PRODUCT_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHECKOUT", function() { return CHECKOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PROFILE", function() { return PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PROFILE_ORDERS", function() { return PROFILE_ORDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PROFILE_ORDERS_DETAIL", function() { return PROFILE_ORDERS_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PROFILE_CUMULUS_PRODUCTS", function() { return PROFILE_CUMULUS_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FAQ", function() { return FAQ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ABOUT", function() { return ABOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LEGAL", function() { return LEGAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BECOME_PICKER", function() { return BECOME_PICKER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REGION_ZUERICH", function() { return REGION_ZUERICH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REGION_BERN", function() { return REGION_BERN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PARTNER", function() { return PARTNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PRELAUNCH", function() { return PRELAUNCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PRELAUNCH_COUNTER", function() { return PRELAUNCH_COUNTER; });
/**
 * Lookup variables for the page names that should come from the backend route,
 * @type {string}
 */

var ROOT = 'root';

var DELIVERY_SEARCH = 'delivery_search';

var PRODUCTS_ZURICH = 'products_zuerich';
var PRODUCTS_BERN = 'products_bern';
var PRODUCT_DETAIL = 'product_detail';

var CHECKOUT = 'checkout';

var PROFILE = 'profile';
var PROFILE_ORDERS = 'profile_orders';
var PROFILE_ORDERS_DETAIL = 'profile_orders_detail';
var PROFILE_CUMULUS_PRODUCTS = 'profile_cumulus_products';

// content pages
var FAQ = 'faq';
var ABOUT = 'about';
var LEGAL = 'legal';
var BECOME_PICKER = 'become_picker';
var REGION_ZUERICH = 'region_zuerich';
var REGION_BERN = 'region_bern';
var PARTNER = 'partner';

// onboarding and prelaunch
var PRELAUNCH = 'prelaunch';
var PRELAUNCH_COUNTER = 'prelaunch_counter';

/***/ }),
/* 195 */,
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = normaliseTrailingSlash;
var SLASH = '/';

/**
 * Add atrailing slashs to any url string
 * @param {string} url - any usrl
 * @example
 * normaliseTrailingSlash('foo/bar') => 'foo/bar/'
 */
function normaliseTrailingSlash(url) {
  return url[url.length - 1] === SLASH ? url : url + '/';
}

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = staticAssetsPath;
/**
 * Adds the static root to an asset's base path
 * @param {string} url - The asset's base path
 * @return {string} The full url to the static resource
 */
function staticAssetsPath(url) {
  return "" + globals.config.static + url;
}

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = linkToHome;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__link_to_dashboard__ = __webpack_require__(233);


/**
 * Returns the link to the homepage that is different depending on the user region state
 * @param {object} userRegion - current user region
 * @return {string} the path to the homepage
 */
function linkToHome(userRegion) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__link_to_dashboard__["c" /* linkToDashboardByUser */])(userRegion);
}

/***/ }),
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dispatchError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_modal_actions__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_misc_log_error__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_translations__ = __webpack_require__(171);


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };







/**
 * Helper for the modal content
 * @param debug
 * @param message
 * @param url
 * @returns {*}
 */
function getContent(debug, _ref) {
    var data = _ref.data,
        url = _ref.url,
        errorId = _ref.errorId;

    if (!debug) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            data.message ? data.message : data,
            errorId && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { marginTop: 10 } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_translations__["a" /* Trans */], { path: 'error.sentry_reference' }),
                ': ',
                errorId
            )
        );
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            'There was an unkown error on the "',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'mark',
                null,
                url
            ),
            '" url'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            'Error Message dump:'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'pre',
            { style: { width: '100%', padding: 10, background: '#f9fbfb', overflow: 'scroll' } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'code',
                null,
                (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? JSON.stringify(data, null, 2) : data
            )
        ),
        errorId && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            { style: { marginTop: 10 } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_translations__["a" /* Trans */], { path: 'error.sentry_reference' }),
            ': ',
            errorId
        )
    );
}

/**
 * Helper function to dispatch general ajax errors
 * @param {Function} dispatch - redux dispatch funciton
 * @param {String} meta.title - Error title
 * @param {String} meta.description - error properties
 * @param {String} meta.url - error url
 * @param {String} meta.reloadButton - Show the reload button
 */
function dispatchError(dispatch, error, _ref2) {
    var _ref2$title = _ref2.title,
        title = _ref2$title === undefined ? Object(__WEBPACK_IMPORTED_MODULE_4_translations__["f" /* t */])('error.occurred') : _ref2$title,
        _ref2$description = _ref2.description,
        description = _ref2$description === undefined ? Object(__WEBPACK_IMPORTED_MODULE_4_translations__["f" /* t */])('error.unknown') : _ref2$description,
        _ref2$url = _ref2.url,
        url = _ref2$url === undefined ? Object(__WEBPACK_IMPORTED_MODULE_4_translations__["f" /* t */])('error.url_unknown') : _ref2$url,
        _ref2$reloadButton = _ref2.reloadButton,
        reloadButton = _ref2$reloadButton === undefined ? false : _ref2$reloadButton;

    var transKey = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(description, 'data.error.trans_key');
    var message = transKey ? Object(__WEBPACK_IMPORTED_MODULE_4_translations__["f" /* t */])(transKey) : Object(__WEBPACK_IMPORTED_MODULE_4_translations__["f" /* t */])('error.unknown');

    if (error && error.status && error.status === 503) {
        message = Object(__WEBPACK_IMPORTED_MODULE_4_translations__["f" /* t */])('error.service_unavailable');
    }

    var actions = [];

    if (reloadButton) {
        actions.push({
            name: Object(__WEBPACK_IMPORTED_MODULE_4_translations__["f" /* t */])('location.reload'),
            event: function event() {
                location.reload();
            }
        });
    }

    var errorId = error.sentry_event_id;

    if (error.data && error.data.error) {
        errorId = error.data.error.sentry_event_id;
    }

    var content = getContent(globals.config.debug, { data: message, url: url, errorId: errorId });

    dispatch(__WEBPACK_IMPORTED_MODULE_2__modules_modal_actions__["default"].open({
        layout: reloadButton ? 'confirm' : 'alert',
        content: content,
        meta: {
            type: 'error',
            icon: {
                symbol: 'alert',
                size: 'large'
            },
            title: title,
            actions: actions
        }
    }));

    Object(__WEBPACK_IMPORTED_MODULE_3_util_misc_log_error__["a" /* default */])(error);
}

/***/ }),
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = track;
/* global dataLayer */

/**
 * Tracking function avoiding to throw errors if any user plugin will block these kind of tracking javascript events
 * @param {object} data - data to track
 */
function track(data) {
    /*if (globals.config.debug && console.group && console.table) {
        console.group('Debug tracking event');
        console.table(data);
        console.groupEnd();
    }*/
    try {
        return dataLayer.push(data);
    } catch (error) {
        return error;
    }
}

/***/ }),
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__remove_from_cart__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__add_to_cart__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__page_view__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__button_click__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__product_detail__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__product_impression__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__product_click__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__checkout__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__site_search__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__promotion_click__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__promotion_view__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__sale__ = __webpack_require__(1006);














/**
 * Alias for the useful methods we want to export out of this folder
 */
/* harmony default export */ __webpack_exports__["a"] = ({
    removeFromCart: __WEBPACK_IMPORTED_MODULE_0__remove_from_cart__["a" /* default */],
    addToCart: __WEBPACK_IMPORTED_MODULE_1__add_to_cart__["a" /* default */],
    pageView: __WEBPACK_IMPORTED_MODULE_2__page_view__["a" /* default */],
    checkout: __WEBPACK_IMPORTED_MODULE_8__checkout__["a" /* default */],
    sale: __WEBPACK_IMPORTED_MODULE_12__sale__["a" /* default */],
    buttonClick: __WEBPACK_IMPORTED_MODULE_3__button_click__["a" /* default */],
    productDetail: __WEBPACK_IMPORTED_MODULE_4__product_detail__["a" /* default */],
    productImpression: __WEBPACK_IMPORTED_MODULE_5__product_impression__["a" /* default */],
    promotionClick: __WEBPACK_IMPORTED_MODULE_10__promotion_click__["a" /* default */],
    promotionView: __WEBPACK_IMPORTED_MODULE_11__promotion_view__["a" /* default */],
    productClick: __WEBPACK_IMPORTED_MODULE_6__product_click__["a" /* default */],
    form: __WEBPACK_IMPORTED_MODULE_7__form__["a" /* default */],
    siteSearch: __WEBPACK_IMPORTED_MODULE_9__site_search__["a" /* default */]
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CONFIRMED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ASSIGNED_TO_PICKER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PICKED_UP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DELIVERED; });
/* unused harmony export ABORTED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SUCCESS_MODAL_CASES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ERROR_MODAL_CASES; });
/*
 * Order States
 *
 * open
 * This means that the order has been opened and that you can add item to it. Pickers are not yet notified of the order.
 *
 * confirmed
 * When the customer is done adding items and placed the order. This is when pickers are getting notified.
 *
 * assigned-to-picker
 * When the picker is accepted.
 *
 * picked-up
 * When the picker has confirmed the purchase and the order has been picked up.
 * An order can move to the picked-up state only if all of its order items are not in the "todo" state (see below for more details), and the "paid_price" or the "receipt_id" data in the order has been provided.
 *
 * delivered
 * The delivered state means that the customer has accepted the order from the picker.
 *
 * aborted
 * Either when the customer cancels an open order, or when there is a timeout because a picker has not been found.
 *
 * cancelled
 * When the support cancelled an order.
 *
 * @link http://order-api.test-migros.ch/doc/
 */
var OPEN = 'open';
var CONFIRMED = 'confirmed';
var ASSIGNED_TO_PICKER = 'assigned-to-picker';
var PICKED_UP = 'picked-up';
var DELIVERED = 'delivered';
var ABORTED = 'aborted';
var CANCELLED = 'cancelled';

var SUCCESS_MODAL_CASES = [ASSIGNED_TO_PICKER, PICKED_UP, DELIVERED];
var ERROR_MODAL_CASES = [ABORTED, CANCELLED];

/***/ }),
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RESIZE_DEBOUNCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTOSCROLL_DEBOUNCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PRODUCTS_LIST_FETCHING_DEBOUNCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MODAL_RESIZE_DEBOUNCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CART_FOOTER_DEBOUNCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COUNTER_CLICK_DEBOUNCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TOOLTIP_HOVER_INTENT_DEBOUNCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TOOLTIP_HOVER_CLOSE_DEBOUNCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SEARCH_SCROLL_DEBOUNCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return VIDEO_AUTOPLAY_DEBOUNCE; });
var RESIZE_DEBOUNCE = 33;
var AUTOSCROLL_DEBOUNCE = 800;
var PRODUCTS_LIST_FETCHING_DEBOUNCE = 220;
var MODAL_RESIZE_DEBOUNCE = 30;
var CART_FOOTER_DEBOUNCE = 210;
var COUNTER_CLICK_DEBOUNCE = 300;

var TOOLTIP_HOVER_INTENT_DEBOUNCE = 50;
var TOOLTIP_HOVER_CLOSE_DEBOUNCE = 250;
var SEARCH_SCROLL_DEBOUNCE = 200;

var VIDEO_AUTOPLAY_DEBOUNCE = 30;

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export formatPriceFancy */
/* harmony export (immutable) */ __webpack_exports__["b"] = formatPrice;
/**
 * Return a fancy price format if price has no cents
 * @param {Number} value - price to checkk
 * @returns {string}
 */
function formatPriceFancy(number) {
    // add the the –. before the number if it's smaller than 1
    if (number < 1 && number) {
        var defaultFormatting = formatPrice(number);
        return '\u2013.' + defaultFormatting.slice(defaultFormatting.length - 2, defaultFormatting.length);
    }

    return Math.floor(number) === number ? number + '.\u2013' : '' + formatPrice(number);
}

/**
  * Format the products prices
  * @param number
  * @returns {string}
  */
function formatPrice(number) {
    return Number(number) ? Number(number).toFixed(2) : '0.00';
}

/* harmony default export */ __webpack_exports__["a"] = (formatPrice);

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_react_facet__ = __webpack_require__(185);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }








function Sidebar(_ref) {
    var facet = _ref.facet,
        viewportHeight = _ref.viewportHeight,
        isMobile = _ref.isMobile,
        headerHeight = _ref.headerHeight,
        children = _ref.children;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'aside',
        { style: {
                transform: isMobile ? null : 'translateY(' + headerHeight + 'px)',
                height: isMobile ? null : viewportHeight - headerHeight
            }, className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a.apply(undefined, ['main-sidebar'].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_5_util_react_facet__["a" /* default */])(facet, 'main-sidebar')))) },
        children
    );
}

Sidebar.propTypes = {
    viewportHeight: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,
    headerHeight: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,
    isMobile: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
    facet: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array]),
    children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_2_util_redux__["b" /* default */].mapStateToProps({
    isMobile: 'viewport.isMobile',
    viewportHeight: 'viewport.height',
    headerHeight: 'header.height'
}))(Sidebar));

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_loader__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__item__ = __webpack_require__(1236);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var BoosterBar = function (_PureComponent) {
    _inherits(BoosterBar, _PureComponent);

    function BoosterBar() {
        _classCallCheck(this, BoosterBar);

        return _possibleConstructorReturn(this, (BoosterBar.__proto__ || Object.getPrototypeOf(BoosterBar)).apply(this, arguments));
    }

    _createClass(BoosterBar, [{
        key: 'renderContent',
        value: function renderContent() {
            var _props = this.props,
                notifications = _props.notifications,
                isFetching = _props.isFetching,
                remove = _props.remove;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'booster-bar' },
                isFetching ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_loader__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'ul',
                    { className: 'booster-bar--list u-reset' },
                    Object(__WEBPACK_IMPORTED_MODULE_4_looppa__["a" /* default */])(notifications)(function (notification, i) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__item__["a" /* default */], _extends({ onRemove: function onRemove() {
                                return remove({ notification: notification });
                            }, key: i }, notification));
                    })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                notifications = _props2.notifications,
                isFetching = _props2.isFetching,
                isWrapped = _props2.isWrapped,
                isNative = _props2.isNative,
                templateConfig = _props2.templateConfig;

            // no notifications :(

            if (!isFetching && !notifications.length || isNative || templateConfig.boosterbar === 'none') {
                return null;
            }

            if (isWrapped) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'grid' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'grid--container' },
                        this.renderContent()
                    )
                );
            }

            return this.renderContent();
        }
    }]);

    return BoosterBar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

BoosterBar.propTypes = {
    notifications: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
    isFetching: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    remove: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    isNative: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    isWrapped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    templateConfig: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_2_util_redux__["b" /* default */].mapStateToProps({
    notifications: 'notifications.items',
    isFetching: 'notifications.isFetching',
    isNative: 'viewport.isNative',
    templateConfig: 'router.config'
}), __WEBPACK_IMPORTED_MODULE_2_util_redux__["b" /* default */].mapDispatchToProps({
    remove: 'notifications.remove'
}))(BoosterBar));

/***/ }),
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return linkToDashboard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return linkToDashboardByRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return linkToDashboardByUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_flowRight__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_router_registry__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_page_names__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_regions__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__get_region__ = __webpack_require__(305);







/**
 * Returns the link to the specific user dashboard depending on the active region
 * @TODO: this function should be updated as soon as we will have more regions
 * @param {string} regionSlug - any region slug
 * @return {string} path to the user dashboard
 */
function getLink(regionSlug) {
    // assuming the default region is zuerich
    if (__WEBPACK_IMPORTED_MODULE_3_constants_regions__["c" /* DEFAULT_REGION_SLUG */] !== regionSlug) {
        return __WEBPACK_IMPORTED_MODULE_1_router_registry__["get"](__WEBPACK_IMPORTED_MODULE_2_constants_page_names__["PRODUCTS_BERN"]).url;
    }

    return __WEBPACK_IMPORTED_MODULE_1_router_registry__["get"](__WEBPACK_IMPORTED_MODULE_2_constants_page_names__["PRODUCTS_ZURICH"]).url;
}

// compositional functions to get the links properly
var linkToDashboard = __WEBPACK_IMPORTED_MODULE_0_lodash_flowRight___default()(getLink, __WEBPACK_IMPORTED_MODULE_4__get_region__["d" /* getRegionSlugBySlug */]);
var linkToDashboardByRoute = __WEBPACK_IMPORTED_MODULE_0_lodash_flowRight___default()(getLink, __WEBPACK_IMPORTED_MODULE_4__get_region__["c" /* getRegionSlugByCooperative */]);
var linkToDashboardByUser = __WEBPACK_IMPORTED_MODULE_0_lodash_flowRight___default()(getLink, __WEBPACK_IMPORTED_MODULE_4__get_region__["d" /* getRegionSlugBySlug */]);

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PRODUCT_LIST_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PRODUCT_LIST_SEARCH_RESULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PRODUCT_LIST_RECOMMMENDATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PRODUCT_LIST_PRODUCT_SLIDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CART_STEP_1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CART_STEP_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FORM_TYPE_MIGROS_FEEDBACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FORM_TYPE_PICKER_RATING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FORM_TYPE_ZIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPDATE_ZIP_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SUBSCRIBE_EVENT; });
var PRODUCT_LIST_CATEGORY = 'category';
var PRODUCT_LIST_SEARCH_RESULTS = 'search results';
var PRODUCT_LIST_RECOMMMENDATIONS = 'recommendations';
var PRODUCT_LIST_PRODUCT_SLIDER = 'product slider';

var CART_STEP_1 = 1;
var CART_STEP_2 = 2;

var FORM_TYPE_MIGROS_FEEDBACK = 'Feedback';
var FORM_TYPE_PICKER_RATING = 'Bewertung';
var FORM_TYPE_ZIP = 'plz-eingabe';

var UPDATE_ZIP_EVENT = 'plz-aenderung';
var SUBSCRIBE_EVENT = 'anmeldung-formular';

/***/ }),
/* 235 */,
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return headerTooltip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return preHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return side; });
/* unused harmony export regions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return profile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return contentPages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return legalAndPrivacy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return social; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_router_registry__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__page_names__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_misc_normalise_trailing_slash__ = __webpack_require__(196);




var normalisePath = function normalisePath(item) {
    return Object.assign({}, item, { url: Object(__WEBPACK_IMPORTED_MODULE_2_util_misc_normalise_trailing_slash__["a" /* default */])(item.url) });
};

var headerTooltip = function headerTooltip() {
    return [Object(__WEBPACK_IMPORTED_MODULE_0_router_registry__["get"])(__WEBPACK_IMPORTED_MODULE_1__page_names__["ABOUT"]), Object(__WEBPACK_IMPORTED_MODULE_0_router_registry__["get"])(__WEBPACK_IMPORTED_MODULE_1__page_names__["BECOME_PICKER"])].map(normalisePath);
};

/**
 * Pre header menu items that will be shown depending on the current user model state
 * @param { boolean } isAuthenticated - boolean flag that belongs to the user model
 * @param { boolean } hasCumulus - boolean flag that belongs to the user model
 * @returns { array } list of links
 */
var preHeader = function preHeader(_ref) {
    var isAuthenticated = _ref.isAuthenticated,
        hasCumulus = _ref.hasCumulus;

    var menu = [];

    if (isAuthenticated) {
        menu.push(Object(__WEBPACK_IMPORTED_MODULE_0_router_registry__["get"])(__WEBPACK_IMPORTED_MODULE_1__page_names__["PROFILE_ORDERS"]));
    }

    if (hasCumulus) {
        menu.push(Object(__WEBPACK_IMPORTED_MODULE_0_router_registry__["get"])(__WEBPACK_IMPORTED_MODULE_1__page_names__["PROFILE_CUMULUS_PRODUCTS"]));
    }

    return menu.map(normalisePath);
};

/**
 * Menu used for the side menu, it will show conditionally contents depending on some store properties
 * @param { string } currentRouteName - current route name
 * @param { boolean } isAuthenticated - boolean flag that belongs to the user model
 * @param { boolean } hasCumulus - boolean flag that belongs to the user model
 * @returns { array } list of links
 */
var side = function side(_ref2) {
    var currentRouteName = _ref2.currentRouteName,
        isAuthenticated = _ref2.isAuthenticated,
        hasCumulus = _ref2.hasCumulus;

    switch (currentRouteName) {
        case __WEBPACK_IMPORTED_MODULE_1__page_names__["PROFILE"]:
        case __WEBPACK_IMPORTED_MODULE_1__page_names__["PROFILE_ORDERS"]:
        case __WEBPACK_IMPORTED_MODULE_1__page_names__["PROFILE_CUMULUS_PRODUCTS"]:
            return profile();
        default:
            return [Object(__WEBPACK_IMPORTED_MODULE_0_router_registry__["get"])(__WEBPACK_IMPORTED_MODULE_1__page_names__["ROOT"])].concat(preHeader({ isAuthenticated: isAuthenticated, hasCumulus: hasCumulus }));
    }
};

var regions = function regions() {
    return [Object(__WEBPACK_IMPORTED_MODULE_0_router_registry__["get"])(__WEBPACK_IMPORTED_MODULE_1__page_names__["REGION_ZUERICH"]), Object(__WEBPACK_IMPORTED_MODULE_0_router_registry__["get"])(__WEBPACK_IMPORTED_MODULE_1__page_names__["REGION_BERN"])].map(normalisePath);
};

var profile = function profile() {
    return [Object(__WEBPACK_IMPORTED_MODULE_0_router_registry__["get"])(__WEBPACK_IMPORTED_MODULE_1__page_names__["PROFILE"]), Object(__WEBPACK_IMPORTED_MODULE_0_router_registry__["get"])(__WEBPACK_IMPORTED_MODULE_1__page_names__["PROFILE_ORDERS"]), Object(__WEBPACK_IMPORTED_MODULE_0_router_registry__["get"])(__WEBPACK_IMPORTED_MODULE_1__page_names__["PROFILE_CUMULUS_PRODUCTS"])].map(normalisePath);
};

var contentPages = function contentPages() {
    return [Object(__WEBPACK_IMPORTED_MODULE_0_router_registry__["get"])(__WEBPACK_IMPORTED_MODULE_1__page_names__["FAQ"]), Object(__WEBPACK_IMPORTED_MODULE_0_router_registry__["get"])(__WEBPACK_IMPORTED_MODULE_1__page_names__["ABOUT"]), Object(__WEBPACK_IMPORTED_MODULE_0_router_registry__["get"])(__WEBPACK_IMPORTED_MODULE_1__page_names__["BECOME_PICKER"])].concat(regions()).concat([Object(__WEBPACK_IMPORTED_MODULE_0_router_registry__["get"])(__WEBPACK_IMPORTED_MODULE_1__page_names__["PARTNER"])]).map(normalisePath);
};

var legalAndPrivacy = function legalAndPrivacy() {
    return [Object(__WEBPACK_IMPORTED_MODULE_0_router_registry__["get"])(__WEBPACK_IMPORTED_MODULE_1__page_names__["LEGAL"])].map(normalisePath);
};

var social = function social() {
    return [{
        symbol: 's-facebook',
        url: 'https://www.facebook.com/Migros',
        title: 'social.facebook'
    },
    /*
    let's comment this out because never say naver...
    {
        symbol: 's-google',
        url: '#',
        title: 'social.google',
    },
    */
    {
        symbol: 's-twitter',
        url: 'https://twitter.com/migros',
        title: 'social.twitter'
    }, {
        symbol: 's-youtube',
        url: 'https://www.youtube.com/user/MigrosTVSpots',
        title: 'social.youtube'
    }, {
        symbol: 's-instagram',
        url: 'https://www.instagram.com/migros',
        title: 'social.instagram'
    }];
};

/***/ }),
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getProductData;
/* harmony export (immutable) */ __webpack_exports__["b"] = prepareProductsData;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Return all the property we want to track out of an mcart product
 * @param {IProduct} product - product model received from the API
 * @param {object} extraProps - optional tracking properties
 * @returns {object} object containing all the tracking properties we need to communicate to the tracking api
 */
function getProductData(product) {
    var extraProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var data = _extends({}, product, extraProps);
    var price_information = data.price_information;

    return {
        name: data.name,
        id: data.product_id || data.id,
        price: price_information.original_price || price_information.price,
        position: data.position,
        discountedprice: price_information.original_price ? price_information.price : null,
        discountamount: price_information.discount_amount,
        discounttype: price_information.discount_type,
        quantity: data.quantity || data.amount,
        brand: data.brand_name,
        creative: data.creative,
        rubrik: price_information.discount_type,
        laufzeit: price_information.discount_duration,
        category: data.tracking_category,
        variant: data.variant
    };
}

function prepareProductsData(products) {
    products = Object.keys(products).map(function (e) {
        return products[e];
    });
    return products.map(function (i) {
        return Object.assign({}, i.product, { quantity: i.amount });
    });
}

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return accordionSpeed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return accordionEasingFn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return pageLoaderEasingFn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return breadcrumbsSpeed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return breadcrumbsDelay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return breadcrumbsEasingFn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return tooltipSpeed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return tooltipDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return tooltipDelay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return tooltipEasingFn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return snackbarSpeed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return snackbarEasingFn; });
var accordionSpeed = 100;
var accordionEasingFn = 'cubic-bezier(0.25, 0.1, 0.75, 1)';
var pageLoaderEasingFn = 'cubic-bezier(0.25, 0.1, 0.25, 1)';

var breadcrumbsSpeed = 100;
var breadcrumbsDelay = 50;
var breadcrumbsEasingFn = 'cubic-bezier(0.25, 0.1, 0.75, 1)';

var tooltipSpeed = 200;
var tooltipDuration = 2000;
var tooltipDelay = 50;
var tooltipEasingFn = 'cubic-bezier(0.25, 0.1, 0.75, 1)';

var snackbarSpeed = 200;
var snackbarEasingFn = 'cubic-bezier(0.25, 0.1, 0.75, 1)';

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_reject__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_reject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_reject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_noop__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_misc_log_error__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__cms_error__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_page_loader__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__plugin__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_util_react_facet__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_constants_api_urls__ = __webpack_require__(192);




var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var CmsPlaceholder = function (_PureComponent) {
    _inherits(CmsPlaceholder, _PureComponent);

    function CmsPlaceholder(props) {
        _classCallCheck(this, CmsPlaceholder);

        var _this = _possibleConstructorReturn(this, (CmsPlaceholder.__proto__ || Object.getPrototypeOf(CmsPlaceholder)).call(this, props));

        _this.setComponents = function (_ref) {
            var data = _ref.data;

            var placeholder = data.data[_this.props.id];

            _this.props.onLoaded();

            // skip empty object
            // they get sent somehow via backend API ¯\_(ツ)_/¯
            placeholder.plugins = __WEBPACK_IMPORTED_MODULE_0_lodash_reject___default()(placeholder.plugins, __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default.a);

            _this.setState({
                placeholder: placeholder
            });
        };

        _this._isRegistered = false;

        _this.fetch = function () {
            __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get('' + Object(__WEBPACK_IMPORTED_MODULE_15_constants_api_urls__["placeholder"])(_this.props.id), {
                cancelToken: _this.requestCancelSource.token,
                params: {
                    cooperative: _this.props.routerCooperative
                }
            }).then(_this.setComponents).catch(function (error) {
                if (!__WEBPACK_IMPORTED_MODULE_8_axios___default.a.isCancel(error)) {
                    _this.setState({
                        hasErrors: true
                    });
                    _this.props.onLoaded();
                    console && console.warn('placeholder loading aborted');
                }
            });
        };

        _this.requestCancelSource = __WEBPACK_IMPORTED_MODULE_8_axios__["CancelToken"].source();

        _this.state = {
            hasErrors: false,
            placeholder: _this.props.placeholder
        };
        return _this;
    }

    _createClass(CmsPlaceholder, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!this.state.placeholder) {
                this.fetch();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref2) {
            var placeholder = _ref2.placeholder;

            if (placeholder) {
                this.setState({
                    placeholder: placeholder
                });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.props.isCmsEditModeEnabled && this.state.placeholder && !this._isRegistered) {
                this.registerToCMS(this.state.placeholder || this.props.placeholder);
                this._isRegistered = true;
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.requestCancelSource.cancel();
        }
    }, {
        key: 'registerToCMS',
        value: function registerToCMS(placeholder) {
            if (!placeholder || !placeholder.cms) {
                Object(__WEBPACK_IMPORTED_MODULE_6_util_misc_log_error__["a" /* default */])('It was impossible to initialise the frontend editing for the cms placeholder id="' + this.props.id + '"');
                return;
            }

            var _placeholder$cms = _slicedToArray(placeholder.cms, 2),
                name = _placeholder$cms[0],
                data = _placeholder$cms[1];

            window.CMS.$(this.refs.root).data('cms', placeholder);
            window.CMS._plugins.push([name, data]);
            new window.CMS.Plugin(name, data); // eslint-disable-line no-new
        }
    }, {
        key: 'renderContent',
        value: function renderContent(isPrelaunch) {
            var _this2 = this;

            var _props = this.props,
                facet = _props.facet,
                isCmsEditModeEnabled = _props.isCmsEditModeEnabled,
                onEvent = _props.onEvent,
                useRandomIconsLoader = _props.useRandomIconsLoader;


            if (this.state.hasErrors) {
                return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__cms_error__["a" /* default */], null);
            }

            if (!this.state.placeholder && !isPrelaunch) {
                return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_page_loader__["a" /* default */], { useRandomIcon: useRandomIconsLoader });
            }

            return Object(__WEBPACK_IMPORTED_MODULE_10_looppa__["a" /* default */])(this.state.placeholder.plugins)(function (component, i) {
                return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__plugin__["a" /* default */], _extends({
                    isCmsEditModeEnabled: isCmsEditModeEnabled,
                    key: i,
                    index: i,
                    onEvent: onEvent,
                    parent: _this2.state.placeholder,
                    facet: facet
                }, component));
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                facet = _props2.facet,
                isCmsEditModeEnabled = _props2.isCmsEditModeEnabled,
                pathname = _props2.pathname;

            // TODO: remove prelaunch hack

            var isPrelaunch = pathname.includes('prelaunch-counter');

            if (!this.state.placeholder && isPrelaunch) {
                return '';
            }

            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
                'div',
                {
                    ref: 'root',
                    className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()('cms-placeholder', this.props.id ? 'cms-placeholder-' + this.props.id : null, Object(__WEBPACK_IMPORTED_MODULE_14_util_react_facet__["a" /* default */])(facet, 'cms-placeholder'), {
                        'cms-placeholder--plugin__is-blocked': isCmsEditModeEnabled
                    }) },
                this.renderContent(isPrelaunch)
            );
        }
    }]);

    return CmsPlaceholder;
}(__WEBPACK_IMPORTED_MODULE_3_react__["PureComponent"]);

CmsPlaceholder.defaultProps = {
    onLoaded: __WEBPACK_IMPORTED_MODULE_1_lodash_noop___default.a,
    useRandomIconsLoader: true
};
CmsPlaceholder.propTypes = {
    // if the placeholder object will be not defined we will try to fetch it
    placeholder: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
    id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    facet: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    isCmsEditModeEnabled: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
    onEvent: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    useRandomIconsLoader: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
    onLoaded: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
    pathname: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
    routerCooperative: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_5_util_redux__["b" /* default */].mapStateToProps({
    isCmsEditModeEnabled: 'cms.isEditModeEnabled',
    pathname: 'router.location.pathname',
    routerCooperative: 'router.cooperative'
}))(CmsPlaceholder));

/***/ }),
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getViewportData;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return literals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return numerals; });
/* harmony export (immutable) */ __webpack_exports__["e"] = toLiteral;
/* unused harmony export toNumeral */
/* harmony export (immutable) */ __webpack_exports__["c"] = mq;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_invert__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_invert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_invert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sass_to_js__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sass_to_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sass_to_js__);




/**
 * The element to which the mq data is bound
 */
var $dataBridge = document.body;

/**
 * Parses, edits and return the current mq data object
 * @return {Object} - A viewport description object
 */
function getViewportData() {
    var result = __WEBPACK_IMPORTED_MODULE_1_sass_to_js___default()($dataBridge, {
        debug: true,
        pseudoEl: '::before',
        cssProperty: 'content'
    });

    result.width = toNumeral(result.width);
    result.query = toLiteral(result.width);

    return result;
}

/**
 * Utility method to switch from literals to numerals and vice versa
 * @param {Object} from - The source of the translation
 * @param {Object} to - The target of the translation
 * @param {number|string} value - The source value to be translated
 * @return {string|number} - A literal or numeral viewport width descriptor
 */
function translateValue(from, to, value) {
    return from[__WEBPACK_IMPORTED_MODULE_0_lodash_invert___default()(to)[value]];
}

/**
 * Literal values for width media features
 * Useful to access the current config out of an object that has viewport width descriptors as keys
 */
var literals = Object.freeze({
    XS: 'xs',
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
    XL: 'xl',
    XXL: 'xxl'
});

/**
 * Numeral values for width media features
 * Useful to compare a desired viewport width state with the current one
 */
var numerals = Object.freeze({
    XS: 1,
    SM: 2,
    MD: 3,
    LG: 4,
    XL: 5,
    XXL: 6
});

/**
 * Returns the literal value when given a numeral one
 * @param {number} value - A literal viewport width descriptor
 * @return {string} - The corresponding descriptor as number
 */
function toLiteral(value) {
    return translateValue(literals, numerals, value);
}

/**
 * Returns the numeral value when given a literal one
 * @param {string} value - A numeral viewport width descriptor
 * @return {number} - The corresponding descriptor as string
 */
function toNumeral(value) {
    return translateValue(numerals, literals, value);
}

/**
 * Make the mq query accessible in JS with mq('<=md') and so on
 * @param {string} operation - operation description
 * @return {boolean|null}
 */
function mq(operation) {
    var currentWidth = getViewportData().width;
    var mediaQueryName = operation.match(/[a-zA-Z]+/g).pop();
    var comperator = operation.match(/[<>=]+/g).pop();

    var comperators = {
        '<=': function _(a, b) {
            return a <= b;
        },
        '>=': function _(a, b) {
            return a >= b;
        },
        '<': function _(a, b) {
            return a < b;
        },
        '>': function _(a, b) {
            return a > b;
        }
    };

    if (!comperators[comperator]) {
        return null;
    }

    return comperators[comperator](currentWidth, toNumeral(mediaQueryName));
}

/***/ }),
/* 250 */,
/* 251 */,
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var Notification = function Notification(_ref) {
    var facet = _ref.facet,
        children = _ref.children;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'notification notification__' + facet },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'notification--body' },
            children
        )
    );
};

Notification.propTypes = {
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired,
    facet: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Notification);

/***/ }),
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MAX_ITEMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MAX_BAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CURRENCY; });
var MAX_ITEMS = 99;
var MAX_BAGS = 99;
var CURRENCY = 'CHF';

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bianco_query__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bianco_events__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_dom_key_codes__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_dom_is_element_visible__ = __webpack_require__(1091);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * This component will restrict the focus on a specific area of the viewport
 * When the component will be unmounted we will restore the focus on the previous active element
 */








var MAX_TABINDEX = 1000;

var Aria51 = function (_PureComponent) {
    _inherits(Aria51, _PureComponent);

    function Aria51() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Aria51);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Aria51.__proto__ || Object.getPrototypeOf(Aria51)).call.apply(_ref, [this].concat(args))), _this), _this.onElementFocus = function (e) {
            var isActive = _this.props.isActive;


            if (isActive && !_this.refs.root.contains(document.activeElement) && e.keyCode && e.keyCode === __WEBPACK_IMPORTED_MODULE_5_util_dom_key_codes__["f" /* TAB */]) {
                e.preventDefault();
                _this.firstFocusableElement.focus();
            }
        }, _this.updateIframes = function (enable) {
            Object(__WEBPACK_IMPORTED_MODULE_2_bianco_query__["a" /* default */])('iframe').forEach(function (iframe) {
                if (enable) {
                    iframe.removeAttribute('tabindex');
                } else {
                    iframe.setAttribute('tabindex', '-1');
                }
            });
        }, _this.lastElementFocused = null, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Aria51, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (this.props.isActive) {
                this.lastElementFocused = document.activeElement;
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var isActive = this.props.isActive;

            this.props.getRoot(this.refs.root);
            if (isActive) {
                this.autofocus();
                this.addEvent();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref2) {
            var isActive = _ref2.isActive;

            if (isActive && !this.props.isActive) {
                this.addEvent();
                this.autofocus();
            }

            if (this.props.isActive && !isActive) {
                this.removeEvent();
                this.updateIframes(true);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var isActive = this.props.isActive;

            this.updateIframes(true);
            this.removeEvent();

            if (this.lastElementFocused && isActive) {
                this.lastElementFocused.focus();
            }
        }
    }, {
        key: 'removeEvent',
        value: function removeEvent() {
            Object(__WEBPACK_IMPORTED_MODULE_3_bianco_events__["b" /* remove */])(window, 'keyup', this.onElementFocus);
        }
    }, {
        key: 'addEvent',
        value: function addEvent() {
            Object(__WEBPACK_IMPORTED_MODULE_3_bianco_events__["a" /* add */])(window, 'keyup', this.onElementFocus);
        }
    }, {
        key: 'autofocus',
        value: function autofocus() {
            this.updateIframes(false);
            this.firstFocusableElement.focus();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                element = _props.element,
                isActive = _props.isActive,
                children = _props.children,
                getRoot = _props.getRoot,
                rest = _objectWithoutProperties(_props, ['element', 'isActive', 'children', 'getRoot']); // eslint-disable-line


            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                this.props.element,
                _extends({}, rest, { ref: 'root' }),
                children
            );
        }
    }, {
        key: 'firstFocusableElement',
        get: function get() {
            var _this2 = this;

            var focusableElements = Object(__WEBPACK_IMPORTED_MODULE_2_bianco_query__["a" /* default */])('input, textarea, button, a', this.refs.root)
            // filter only the visible ones
            .filter(function (el) {
                return Object(__WEBPACK_IMPORTED_MODULE_6_util_dom_is_element_visible__["a" /* default */])(el, _this2.refs.root);
            })
            // sort the elements via tabIndex
            .sort(function (el1, el2) {
                var tabIndex1 = +(el1.tabIndex || MAX_TABINDEX);
                var tabIndex2 = +(el2.tabIndex || MAX_TABINDEX);

                if (tabIndex1 < tabIndex2) {
                    return -1;
                } else if (tabIndex1 > tabIndex2) {
                    return 1;
                }

                return 0;
            });

            if (focusableElements.length) {
                return focusableElements[0];
            }

            return this.refs.root;
        }
    }]);

    return Aria51;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

Aria51.propTypes = {
    getRoot: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
    isActive: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
    element: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
    children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object]).isRequired
};
Aria51.defaultProps = {
    element: 'div',
    isActive: true,
    getRoot: __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a
};
/* harmony default export */ __webpack_exports__["a"] = (Aria51);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_misc_overlay_tracker__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_bianco_events__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_constants_debounce_delays__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_util_dom_stop_propagation__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_util_dom_prevent_default__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_util_react_facet__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_buttons_group__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_aria_51__ = __webpack_require__(267);



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var Tooltip = function (_PureComponent) {
    _inherits(Tooltip, _PureComponent);

    function Tooltip() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Tooltip);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            xPlacement: 'center', // either "center", "left" or "right"
            yPlacement: 'top', // "top" or "bottom"
            isActive: false
        }, _this.onBodyClick = function (e) {
            var root = _this.refs.root;

            if (root.contains(e.target)) {
                return;
            }

            if (_this.props.timeout) {
                clearTimeout(_this.timer);
            }

            _this.hide();
        }, _this.onClick = function (e) {
            if (_this.props.interactionType !== 'click' && !_this.props.hasTouch || _this.props.interactionType === 'none') {
                return;
            }

            Object(__WEBPACK_IMPORTED_MODULE_13_util_dom_prevent_default__["a" /* default */])(e);

            _this.show();
        }, _this.onMouseEnter = function () {
            if (_this.props.interactionType !== 'hover') {
                return;
            }

            _this.show.cancel(); // Cancel the current show
            _this.onMouseLeave.cancel(); // But also delay the leave
            _this.show();
        }, _this.onMouseLeave = __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default()(function () {
            if (this.props.interactionType !== 'hover' || this.props.timeout) {
                return;
            }

            this.hide();
        }, __WEBPACK_IMPORTED_MODULE_11_constants_debounce_delays__["h" /* TOOLTIP_HOVER_CLOSE_DEBOUNCE */]), _this.setPosition = function (_ref2) {
            var viewportWidth = _ref2.viewportWidth,
                headerHeight = _ref2.headerHeight;

            var _this$refs$tooltip$ge = _this.refs.tooltip.getBoundingClientRect(),
                right = _this$refs$tooltip$ge.right,
                left = _this$refs$tooltip$ge.left,
                height = _this$refs$tooltip$ge.height;

            var _this$refs$root$getBo = _this.refs.root.getBoundingClientRect(),
                rootTop = _this$refs$root$getBo.top,
                rootLeft = _this$refs$root$getBo.left;

            var _this$props = _this.props,
                lateralOffset = _this$props.lateralOffset,
                forcePosition = _this$props.forcePosition,
                position = _this$props.position;

            var xPlacement = 'center';
            var yPlacement = 'top';
            var xInnerOffset = 0;

            if (forcePosition === 'left') {
                xPlacement = 'left';
                xInnerOffset = rootLeft - left;
            } else if (left < lateralOffset) {
                xPlacement = 'left';
                xInnerOffset = rootLeft - left;
            } else if (right + lateralOffset > viewportWidth) {
                xPlacement = 'right';
                xInnerOffset = viewportWidth - (right + lateralOffset);
            }

            if (rootTop - height - headerHeight < 0) {
                yPlacement = 'bottom';
            }

            if (xPlacement === 'left') {
                xInnerOffset = Math.abs(xInnerOffset);
            }

            _this.setState({
                xInnerOffset: xInnerOffset,
                yPlacement: position.y || yPlacement,
                xPlacement: position.x || xPlacement
            });
        }, _this.hide = function () {
            if (!_this.state.isActive && !_this.props.mustShow) {
                return;
            }

            Object(__WEBPACK_IMPORTED_MODULE_9_util_misc_overlay_tracker__["b" /* unsubscribe */])(_this);
            _this.props.onClose();

            Object(__WEBPACK_IMPORTED_MODULE_10_bianco_events__["b" /* remove */])(document.body, 'click', _this.onBodyClick);

            _this.show.cancel();
            _this.setState({
                isActive: false
            });

            // Trigger callback if provided
            _this.props.onHide && _this.props.onHide();

            if (_this.props.timeout) {
                _this.props.setBlocked({ areBlocked: false });
            }
        }, _this.show = __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default()(function () {
            // If it is active, abort
            // If a another tooltip with a delay is active, abort
            if (this.state.isActive || this.props.areBlocked) {
                return;
            }

            Object(__WEBPACK_IMPORTED_MODULE_9_util_misc_overlay_tracker__["a" /* subscribe */])(this, this.hide);

            // React syntetic events do not allow stopPropagation so we are forced to use vanilla events
            Object(__WEBPACK_IMPORTED_MODULE_10_bianco_events__["a" /* add */])(document.body, 'click', this.onBodyClick);

            this.setPosition(this.props);
            this.setState({
                isActive: true
            });

            // Trigger callback if provided
            this.props.onShow && this.props.onShow();

            if (this.props.timeout) {
                clearTimeout(this.timer);
                this.timer = setTimeout(this.hide, this.props.timeout);
                // Block all other tooltip interactions for the duration of the current tooltip
                this.props.setBlocked({ areBlocked: true });
            }
        }, __WEBPACK_IMPORTED_MODULE_11_constants_debounce_delays__["i" /* TOOLTIP_HOVER_INTENT_DEBOUNCE */]), _this.timer = null, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Tooltip, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // https://github.com/kriasoft/react-starter-kit/issues/909#issuecomment-252969542
            this.props.onRef(this);
            this.setPosition(this.props);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref3) {
            var forceOpen = _ref3.forceOpen;

            if (forceOpen !== this.props.forceOpen && forceOpen === true) {
                this.show();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(_ref4) {
            var mustShow = _ref4.mustShow;

            if (this.props.mustShow && !mustShow) {
                this.setPosition(this.props);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearTimeout(this.timer);
            Object(__WEBPACK_IMPORTED_MODULE_10_bianco_events__["b" /* remove */])(document.body, 'click', this.onBodyClick);
            this.show.cancel();
        }

        /**
         * Hide the tooltip if users click anywhere in the DOM
         */


        /**
         * Handle the click events on the tooltips
         * @param {object} e - event object
         */


        /**
         * Show tooltips only for the components having the attribute interaction type == 'hover'
         */


        /**
         * Hide the tooltips on mouse leave for the tooltips having the attribute interaction type == 'hover'
         */


        /**
         * Calculate the tooltip position
         */


        /**
         * Hide the tooltip if previously shown
         */


        /**
         * Tooltip toggle function debounced because we want to avoid a too nervous user interaction
         * @type {Function}
         */

    }, {
        key: 'triggerEvent',
        value: function triggerEvent(eventData, event) {
            if (typeof event === 'function') {
                event();
            }

            Object(__WEBPACK_IMPORTED_MODULE_12_util_dom_stop_propagation__["a" /* default */])(eventData);
            this.hide();
        }
    }, {
        key: 'renderActionsButtons',
        value: function renderActionsButtons(actions) {
            var _this2 = this;

            var buttonsData = actions.map(function (_ref5) {
                var name = _ref5.name,
                    _event = _ref5.event,
                    isHighlighted = _ref5.isHighlighted;

                return {
                    size: 'small',
                    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('tooltip--button', { 'tooltip--button__is-highlighted': isHighlighted }),
                    name: name,
                    event: function event(e) {
                        return _this2.triggerEvent(e, _event);
                    }
                };
            });

            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_buttons_group__["a" /* default */], { actions: buttonsData, className: 'tooltip--buttons-group' });
        }
    }, {
        key: 'renderCloseButton',
        value: function renderCloseButton() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'button',
                { 'aria-label': Object(__WEBPACK_IMPORTED_MODULE_6_translations__["c" /* default */])('accessibility.label.close_tooltip'), className: 'tooltip--close',
                    onClick: function onClick(e) {
                        return Object(__WEBPACK_IMPORTED_MODULE_13_util_dom_prevent_default__["a" /* default */])(e) || Object(__WEBPACK_IMPORTED_MODULE_12_util_dom_stop_propagation__["a" /* default */])(e) && _this3.hide();
                    } },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_icon__["a" /* default */], { symbol: 'cancel-small', size: 'medium' })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _props = this.props,
                facet = _props.facet,
                children = _props.children,
                mustShow = _props.mustShow,
                content = _props.content,
                actions = _props.actions,
                className = _props.className;
            var _state = this.state,
                isActive = _state.isActive,
                yPlacement = _state.yPlacement,
                xPlacement = _state.xPlacement,
                xInnerOffset = _state.xInnerOffset;

            var hasClose = this.props.interactionType === 'click' || this.props.hasClose;

            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                {
                    ref: 'root',
                    onClick: this.onClick,
                    onMouseLeave: function onMouseLeave() {
                        return _this4.onMouseLeave();
                    },
                    onMouseEnter: function onMouseEnter() {
                        return _this4.onMouseEnter();
                    },
                    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('tooltip', Object(__WEBPACK_IMPORTED_MODULE_14_util_react_facet__["a" /* default */])(facet, 'tooltip'), className) },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'div',
                    {
                        ref: 'tooltip',
                        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('tooltip--container', 'tooltip--container__' + yPlacement, 'tooltip--container__' + xPlacement, { 'tooltip--container__is-active': isActive || mustShow }) },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'tooltip--arrow' }),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_16_components_aria_51__["a" /* default */],
                        {
                            tabIndex: isActive ? 0 : -1,
                            role: 'document',
                            'aria-modal': 'true',
                            'aria-hidden': !isActive,
                            isActive: isActive,
                            className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('tooltip--inner', { 'tooltip--inner__has-close': hasClose }),
                            style: { transform: 'translate(' + xInnerOffset + 'px, 0)' } },
                        hasClose ? this.renderCloseButton() : null,
                        content,
                        actions.length ? this.renderActionsButtons(actions) : null
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'div',
                    { className: 'tooltip--content' },
                    children
                )
            );
        }
    }]);

    return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

Tooltip.defaultProps = {
    facet: 'base',
    isVisible: false,
    hasClose: false,
    actions: [],
    lateralOffset: 20,
    xInnerOffset: 0,
    onClose: __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a,
    position: {},
    interactionType: 'hover',
    forceOpen: null,
    onRef: __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a
};
Tooltip.propTypes = {
    facet: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array]),
    mustShow: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
    forcePosition: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    actions: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,
    lateralOffset: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    timeout: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    onShow: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    onHide: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    position: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
    interactionType: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['click', 'hover', 'none']), // select "none" to disable interaction
    areBlocked: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
    setBlocked: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    headerHeight: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
    viewportWidth: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
    viewportHeight: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
    content: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any.isRequired,
    hasClose: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
    onClose: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    hasTouch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
    children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]).isRequired,
    forceOpen: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
    onRef: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_8_util_redux__["b" /* default */].mapStateToProps({
    headerHeight: 'header.height',
    viewportHeight: 'viewport.height',
    viewportWidth: 'viewport.width',
    hasTouch: 'viewport.touchevents',
    areBlocked: 'tooltip.areBlocked'
}), __WEBPACK_IMPORTED_MODULE_8_util_redux__["b" /* default */].mapDispatchToProps({
    setBlocked: 'tooltip.setBlocked'
}))(Tooltip));

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = stopPropagation;
/**
 * Stop the event propagation
 * @param {object} e - event object
 */
function stopPropagation(e) {
    if (e.nativeEvent) {
        e.nativeEvent.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
    }
    e.stopPropagation();

    return true; // Make it chainable with &&
}

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_dom_stop_propagation__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_dom__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants_page_names__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util_misc_normalise_trailing_slash__ = __webpack_require__(196);












function MigrosLoginButton(_ref) {
    var isAuthenticated = _ref.isAuthenticated,
        username = _ref.username,
        login = _ref.login,
        logout = _ref.logout,
        inline = _ref.inline,
        big = _ref.big,
        routerRegistry = _ref.routerRegistry,
        facet = _ref.facet;

    var renderLoginButton = function renderLoginButton() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            { className: 'migros-login-button--greeting u-reset' },
            isAuthenticated && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_icon__["a" /* default */], { className: 'migros-login--icon', size: 'medium', symbol: 'profil' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'migros-login-button-text--greeting' },
                isAuthenticated ? username : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_translations__["a" /* Trans */], { path: 'user.my_account' })
            )
        );
    };
    var renderLoginItem = function renderLoginItem() {
        if (isAuthenticated) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_router_dom__["b" /* Link */],
                { rel: 'nofollow', className: 'u-reset', to: Object(__WEBPACK_IMPORTED_MODULE_10_util_misc_normalise_trailing_slash__["a" /* default */])(routerRegistry.get(__WEBPACK_IMPORTED_MODULE_9_constants_page_names__["PROFILE"]).url) },
                renderLoginButton()
            );
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { onClick: function onClick() {
                    return login();
                } },
            renderLoginButton()
        );
    };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'aside',
        {
            className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('migros-login-button', 'migros-login-button__' + facet, { 'migros-login-button__inline': inline }) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'migros-login-button--row' },
            !inline && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: __WEBPACK_IMPORTED_MODULE_6_util_dom_stop_propagation__["a" /* default */], className: 'migros-login-button--text' },
                renderLoginItem()
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'migros-login-button--button' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    {
                        rel: 'nofollow',
                        onClick: function onClick() {
                            return isAuthenticated ? logout() : login();
                        },
                        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('a-service-login a-service-login--dark a-service-login--lang-de u-reset', { 'a-service-login--big': big })
                    },
                    isAuthenticated ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_translations__["a" /* Trans */], { path: 'user.logout' }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_translations__["a" /* Trans */], { path: 'user.login' })
                )
            )
        )
    );
}

MigrosLoginButton.propTypes = {
    routerRegistry: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    isAuthenticated: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    username: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    login: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    logout: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    inline: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    big: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    facet: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

MigrosLoginButton.defaultProps = {
    facet: 'base'
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_3_util_redux__["b" /* default */].mapStateToProps({
    isAuthenticated: 'user.isAuthenticated',
    username: 'user.username',
    routerRegistry: 'router.registry'
}), __WEBPACK_IMPORTED_MODULE_3_util_redux__["b" /* default */].mapDispatchToProps({
    login: 'user.login',
    logout: 'user.logout'
}))(MigrosLoginButton));

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_swiper__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_icon__ = __webpack_require__(177);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Slider = function (_Component) {
    _inherits(Slider, _Component);

    function Slider() {
        _classCallCheck(this, Slider);

        return _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).apply(this, arguments));
    }

    _createClass(Slider, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            requestAnimationFrame(function () {
                _this2.create(_this2.props);
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.useNativeScroll === nextProps.useNativeScroll) {
                return;
            }

            this.destroy();
            this.create(nextProps);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (prevProps.children !== this.props.children) {
                if (this.swiper) {
                    this.swiper.update();
                }
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.destroy();
        }
    }, {
        key: 'create',
        value: function create(props) {
            var _this3 = this;

            if (props.useNativeScroll === true) {
                return;
            }

            var config = props.config,
                facet = props.facet,
                children = props.children,
                on = props.on; // eslint-disable-line

            this.swiper = new __WEBPACK_IMPORTED_MODULE_3_swiper__["a" /* default */](this.refs.container, _extends({}, config, {
                // remap the on events in order to receive always the swiper instance as first argument
                on: Object.keys(on).reduce(function (acc, key) {
                    acc[key] = function () {
                        return _this3.swiper && on[key](_this3.swiper);
                    };
                    return acc;
                }, {})
            }));

            setTimeout(function () {
                // mitigate the issue on sentry
                if (!_this3.swiper || !_this3.swiper.initialized) {
                    return;
                }

                _this3.swiper.update();
            }, 200);
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            if (this.swiper) {
                this.swiper.destroy(true, true);
                delete this.swiper;
            }
        }
    }, {
        key: 'renderNavigationArrows',
        value: function renderNavigationArrows() {
            var _this4 = this;

            var useNativeScroll = this.props.useNativeScroll;


            return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { ref: 'prevButton',
                    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('swiper-button-prev', useNativeScroll ? 'swiper-button__nativescroll' : null),
                    onClick: function onClick() {
                        return _this4.props.updateOnInteraction ? _this4.swiper.update() : null;
                    },
                    key: 'prev' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_icon__["a" /* default */], { symbol: 'productslider-left', size: this.isCardSlider ? 'large' : 'medium' })
            ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { ref: 'nextButton',
                    onClick: function onClick() {
                        return _this4.props.updateOnInteraction ? _this4.swiper.update() : null;
                    },
                    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('swiper-button-next', useNativeScroll ? 'swiper-button__nativescroll' : null),
                    key: 'next' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_icon__["a" /* default */], { symbol: 'productslider-right', size: this.isCardSlider ? 'large' : 'medium' })
            )];
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                facet = _props.facet,
                config = _props.config,
                useNativeScroll = _props.useNativeScroll;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('slider slider__' + facet, useNativeScroll ? 'slider__nativescroll-slider' : '') },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { ref: 'container', className: 'slider--container swiper-container' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'slider--wrapper swiper-wrapper' },
                        Object(__WEBPACK_IMPORTED_MODULE_2_looppa__["a" /* default */])(children)(function (child, i) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { key: i, className: 'slider--slide swiper-slide' },
                                child
                            );
                        })
                    ),
                    config.pagination ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'slider--pagination swiper-pagination' }) : '',
                    this.renderNavigationArrows()
                )
            );
        }
    }, {
        key: 'isCardSlider',
        get: function get() {
            return this.props.facet === 'card-overlay-slider';
        }
    }]);

    return Slider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Slider.defaultProps = {
    on: {},
    updateOnInteraction: false
};
Slider.propTypes = {
    config: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
    facet: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    on: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    useNativeScroll: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    updateOnInteraction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};


/* harmony default export */ __webpack_exports__["a"] = (Slider);

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FormFieldInput;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_form_form_field__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_translations__ = __webpack_require__(171);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









function Label(_ref) {
    var id = _ref.id,
        text = _ref.text;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'label',
        { className: 'form-field--title-label', htmlFor: id },
        text
    );
}

Label.propTypes = {
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    text: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
};

function FloatingLabel(_ref2) {
    var text = _ref2.text;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        { className: 'form-field--floating-label', 'aria-hidden': 'true' },
        text
    );
}

FloatingLabel.propTypes = {
    text: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
};

function Action(_ref3) {
    var symbol = _ref3.symbol,
        size = _ref3.size,
        type = _ref3.type,
        action = _ref3.action,
        label = _ref3.label;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'form-field--actions' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'button',
            { onClick: action, type: 'button', className: 'form-field--action form-field--action__' + type,
                'aria-label': label },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_icon__["a" /* default */], { symbol: symbol, size: size })
        )
    );
}

Action.propTypes = {
    symbol: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    type: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    size: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    action: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    label: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

Action.defaultProps = {
    symbol: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    size: 'medium',
    action: __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a
};

/**
 * We will compose the following markup using many props coming from the parent component
 * @returns {XML}
 * @constructor
 */

var TextInput = function (_Component) {
    _inherits(TextInput, _Component);

    function TextInput() {
        var _ref4;

        var _temp, _this, _ret;

        _classCallCheck(this, TextInput);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref4 = TextInput.__proto__ || Object.getPrototypeOf(TextInput)).call.apply(_ref4, [this].concat(args))), _this), _this.onClearAction = function () {
            if (typeof _this.props.hasClearAction === 'function') {
                _this.props.hasClearAction();
            }
            _this.props.updateValue('');
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TextInput, [{
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps) {
            var _props = this.props,
                hasFocus = _props.hasFocus,
                setStateClasses = _props.setStateClasses;

            if (nextProps.hasFocus !== hasFocus) {
                setStateClasses({ 'form-field__has-focus': nextProps.hasFocus });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                label = _props2.label,
                id = _props2.id,
                value = _props2.value,
                state = _props2.state,
                type = _props2.type,
                onFocus = _props2.onFocus,
                onKeyPress = _props2.onKeyPress,
                onBlur = _props2.onBlur,
                updateValue = _props2.updateValue,
                placeholder = _props2.placeholder,
                hasFloatingLabel = _props2.hasFloatingLabel,
                actionCount = _props2.actionCount,
                icon = _props2.icon,
                action = _props2.action,
                variant = _props2.variant,
                hasClearAction = _props2.hasClearAction,
                autoFocus = _props2.autoFocus,
                actionLabel = _props2.actionLabel,
                pattern = _props2.pattern,
                autoComplete = _props2.autoComplete;


            return [label ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Label, { key: 'label', id: id, text: label }) : null, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { key: 'content', className: 'form-field--input-container', 'data-action-count': actionCount },
                hasFloatingLabel && label ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(FloatingLabel, { text: label }) : '',
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', _extends({
                    'aria-label': this.props['aria-label']
                }, {
                    autoComplete: autoComplete,
                    className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('form-field--input', this.props.className),
                    type: type,
                    placeholder: placeholder,
                    id: id,
                    name: id,
                    required: state.required,
                    disabled: state.disabled,
                    value: value,
                    pattern: pattern,
                    onChange: function onChange(e) {
                        return updateValue(e.target.value);
                    },
                    autoFocus: autoFocus,
                    onFocus: onFocus,
                    onBlur: onBlur,
                    onKeyPress: onKeyPress
                })),
                hasClearAction && value ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Action, { symbol: 'cancel_input', type: 'clear', size: 'large', action: function action() {
                        return _this2.onClearAction();
                    },
                    label: Object(__WEBPACK_IMPORTED_MODULE_6_translations__["f" /* t */])('form.field_clear') }) : null,
                !value && icon ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Action, { symbol: icon.symbol, type: type, variant: variant, size: icon.size, action: action,
                    label: actionLabel }) : ''
            )];
        }
    }]);

    return TextInput;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

TextInput.propTypes = {
    hasFloatingLabel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    hasFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    setStateClasses: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    onKeyPress: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    actionCount: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
    action: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    icon: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    updateValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    variant: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    hasClearAction: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]),
    type: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
    state: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    label: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    placeholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    messages: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    autoFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    actionLabel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    pattern: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    formClasses: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    'aria-label': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    autoComplete: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};

TextInput.defaultProps = {
    hasClearAction: true,
    autoFocus: false,
    disabled: false,
    autoComplete: 'on'
};

function FormFieldInput(props) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_form_form_field__["a" /* default */], _extends({}, props, { facet: 'input', component: TextInput }));
}

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_misc_uid__ = __webpack_require__(1136);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var FormField = function (_Component) {
    _inherits(FormField, _Component);

    function FormField(props) {
        _classCallCheck(this, FormField);

        var _this = _possibleConstructorReturn(this, (FormField.__proto__ || Object.getPrototypeOf(FormField)).call(this, props));

        _this._id = props.id || 'v-uid-' + Object(__WEBPACK_IMPORTED_MODULE_5_util_misc_uid__["a" /* default */])();
        _this.state = {
            stateClasses: {},
            value: props.value,
            hasFocus: props.state.focus
        };
        return _this;
    }

    _createClass(FormField, [{
        key: 'onBlur',
        value: function onBlur() {
            this.props.onBlur();
            this.setState({ hasFocus: false });
        }
    }, {
        key: 'onFocus',
        value: function onFocus() {
            this.props.onFocus();
            this.setState({ hasFocus: true });
        }
    }, {
        key: 'setStateClasses',
        value: function setStateClasses(stateClasses) {
            this.setState({ stateClasses: stateClasses });
        }
    }, {
        key: 'updateValue',
        value: function updateValue(value) {
            if (this.props.onInput) {
                this.props.onInput(value);
            } else {
                this.setState({ value: value });
            }
        }

        /**
         * The value can be inferred by the props only if an onInput function was defined
         */

    }, {
        key: 'renderMessages',
        value: function renderMessages() {
            var messages = this.props.messages;


            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'form-field--message-container' },
                Object(__WEBPACK_IMPORTED_MODULE_4_looppa__["a" /* default */])(messages.error)(function (error, i) {
                    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'span',
                        { role: 'alert', key: i, className: 'form-field--message form-field--message__error' },
                        error
                    );
                }),
                Object(__WEBPACK_IMPORTED_MODULE_4_looppa__["a" /* default */])(messages.info)(function (info, i) {
                    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'span',
                        { key: i, className: 'form-field--message form-field--message__info' },
                        info
                    );
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                component = _props.component,
                props = _objectWithoutProperties(_props, ['component']);
            // proxy some of the parent method to communicate with the child component


            var childrenProps = Object.assign(props, {
                onFocus: this.onFocus.bind(this),
                onBlur: this.onBlur.bind(this),
                updateValue: this.updateValue.bind(this),
                setStateClasses: this.setStateClasses.bind(this),
                actionCount: this.actionCount,
                formClasses: this.formClasses,
                hasFocus: this.state.hasFocus,
                value: this.value,
                id: this.id
            });

            var facet = (Array.isArray(props.facet) ? props.facet : [props.facet]).map(function (f) {
                return 'form-field__' + f;
            });

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(['form-field', facet, _defineProperty({}, 'form-field__' + props.facet + '-' + props.variant, props.variant), this.state.stateClasses, this.formClasses]) },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(component, childrenProps),
                this.hasMessages ? this.renderMessages() : ''
            );
        }
    }, {
        key: 'actionCount',
        get: function get() {
            var count = 0;
            count += this.props.type === 'date' ? 1 : 0;

            return count;
        }
    }, {
        key: 'formClasses',
        get: function get() {
            var _props2 = this.props,
                state = _props2.state,
                hasFloatingLabel = _props2.hasFloatingLabel,
                placeholder = _props2.placeholder;
            var hasFocus = this.state.hasFocus;

            var classes = {
                'form-field__floating-label': hasFloatingLabel,
                'form-field__is-required': state.required,
                'form-field__is-disabled': state.disabled,
                'form-field__has-error': state.error
            };

            // NOTE: Extend the form clesses adding also the floating variants
            if (hasFloatingLabel) {
                var isFloating = this.value || placeholder || hasFocus || state.disabled;
                classes['form-field__is-floating'] = isFloating;
            }

            return classes;
        }
    }, {
        key: 'hasMessages',
        get: function get() {
            var messages = this.props.messages;

            var hasErrors = Array.isArray(messages.error) && !!messages.error.length;
            return hasErrors || !!messages.info;
        }
    }, {
        key: 'id',
        get: function get() {
            return this._id;
        }
    }, {
        key: 'value',
        get: function get() {
            return this.props.onInput ? this.props.value : this.state.value;
        }
    }]);

    return FormField;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

FormField.defaultProps = {
    facet: '',
    hasFloatingLabel: false,
    type: '',
    id: '',
    value: '',
    label: '',
    placeholder: '',
    onFocus: __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a,
    onBlur: __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a,
    state: {
        error: false,
        required: false,
        disabled: false,
        focus: false
    },
    messages: {
        error: []
    }
};
FormField.propTypes = {
    facet: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
    variant: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    type: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    hasFloatingLabel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array]).isRequired,
    state: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    label: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    placeholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    messages: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    onInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (FormField);

/***/ }),
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registry", function() { return registry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "urls", function() { return urls; });
/* harmony export (immutable) */ __webpack_exports__["add"] = add;
/* harmony export (immutable) */ __webpack_exports__["get"] = get;
/* harmony export (immutable) */ __webpack_exports__["resolve"] = resolve;
/* harmony export (immutable) */ __webpack_exports__["flush"] = flush;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_router_constants__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_misc_log_error__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_misc_clear_object__ = __webpack_require__(1029);




/**
 * Object that will contain all the app routes by name
 *
 * @example
 * registry.product_list = "produkte/liste"
 */
var registry = Object.create(null);

/**
 * Object that will contain all the app route names by url
 *
 * It is used to quickly get the name of an url route
 * @type {{}}
 */
var urls = Object.create(null);

/**
 * Add a new route to the registry
 * @param {string} name - name to identify the route
 * @param {string} url - path to named page
 * @param {string} title - title we want to use for this page
 * @returns {object} the new path object just added
 */
function add(name, url, title) {
    if (registry[name]) {
        Object(__WEBPACK_IMPORTED_MODULE_1_util_misc_log_error__["a" /* default */])(new Error('The template "' + name + '" was already used for another route, please use unique names for each route.'));
    }

    registry[name] = {
        url: url,
        title: title
    };

    urls[url] = name;

    return registry[name];
}

/**
 * Get a raw route from the registry
 * @param {string} name - name of the route object hopefully stored in the registry
 * @returns {string} the path object including all the languages
 */
function get(name) {
    if (!name) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_router_constants__["baseurl"])();
    }

    if (!registry[name]) {
        Object(__WEBPACK_IMPORTED_MODULE_1_util_misc_log_error__["a" /* default */])(new Error('The route name "' + name + '" was not found. Was it defined via CMS?'));
    }

    return registry[name];
}

function resolve(url) {
    if (!url) {
        return urls[Object(__WEBPACK_IMPORTED_MODULE_0_router_constants__["baseurl"])()];
    }

    return urls[url] || '';
}

/**
 * Remove the old cached data
 */
function flush() {
    Object(__WEBPACK_IMPORTED_MODULE_2_util_misc_clear_object__["a" /* default */])(urls);
    Object(__WEBPACK_IMPORTED_MODULE_2_util_misc_clear_object__["a" /* default */])(registry);
}

/* harmony default export */ __webpack_exports__["default"] = (registry);

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subscribe;
/* harmony export (immutable) */ __webpack_exports__["b"] = unsubscribe;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bianco_events__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_dom_key_codes__ = __webpack_require__(59);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();




/**
 * A list of all the open overlays, tooltips, sidebars etc.
 * @type {Map}
 */
var openOverlays = new Map();

/**
 * Add an opened overlay to the queue
 * @param key – Any kind of js instance
 * @param closerFn – A function to allow closing the overlay
 * @returns {Map} - the overlays map
 */
function subscribe(key, closerFn) {
    openOverlays.set(key, closerFn);
    return openOverlays;
}

/**
 * @param key – The instance used to register the overlay close function
 * @returns {boolean}
 */
function unsubscribe(key) {
    var found = openOverlays.has(key);
    if (found) {
        openOverlays.delete(key);
    }
    return found;
}

/**
 * If the esc key is pressed, close the last overlay added to the list
 */
Object(__WEBPACK_IMPORTED_MODULE_0_bianco_events__["a" /* add */])(document, 'keyup', function (_ref) {
    var keyCode = _ref.keyCode;

    if (keyCode === __WEBPACK_IMPORTED_MODULE_1_util_dom_key_codes__["c" /* ESC_KEY */] && openOverlays.size) {
        var _Array$from$pop = Array.from(openOverlays).pop(),
            _Array$from$pop2 = _slicedToArray(_Array$from$pop, 2),
            closerFn = _Array$from$pop2[1];

        closerFn();
    }
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_tracking__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tracking_constants__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants_page_names__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_aria_51__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_constants_debounce_delays__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_util_dom_prevent_default__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_util_misc_format_price__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_cart_products_list__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_button__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__empty__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_cms_placeholder__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_tooltip__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_order_promotion_list__ = __webpack_require__(596);



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

























var tabIndexMap = {
    close: 1,
    clear: 2,
    checkoutButton: 3,
    content: 4
};

function CartFooter(_ref) {
    var facet = _ref.facet,
        estimatedCustomerPrice = _ref.estimatedCustomerPrice,
        customerDeliveryFee = _ref.customerDeliveryFee,
        hasMissingMloginData = _ref.hasMissingMloginData,
        isAuthenticated = _ref.isAuthenticated,
        hasItems = _ref.hasItems,
        login = _ref.login,
        routerRegistry = _ref.routerRegistry;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'footer',
        { className: 'cart--footer cart--footer__' + facet },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'cart--total' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'dl',
                { className: 'cart--total-inner' },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'dt',
                    { className: 'cart--total-text' },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_translations__["a" /* Trans */], { path: 'cart.total' })
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'dd',
                    { className: 'cart--total-shipping' },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_translations__["a" /* Trans */], { path: 'cart.shipping_cost' }),
                    ' ',
                    Object(__WEBPACK_IMPORTED_MODULE_13_util_misc_format_price__["a" /* default */])(customerDeliveryFee)
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'dd',
                    { className: 'cart--total-amount' },
                    'CHF ',
                    Object(__WEBPACK_IMPORTED_MODULE_13_util_misc_format_price__["a" /* default */])(estimatedCustomerPrice)
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_16_components_button__["a" /* default */],
            { tag: 'a',
                tabIndex: tabIndexMap.checkoutButton,
                to: routerRegistry.get(__WEBPACK_IMPORTED_MODULE_9_constants_page_names__["CHECKOUT"]).url,
                onClick: function onClick(e) {
                    // block the link in case the user is not allowed to navigate to the checkout page
                    // @TODO:  move this logic in a reducer in case we will have other buttons or links pointing to this page
                    if (!isAuthenticated || hasMissingMloginData) {
                        Object(__WEBPACK_IMPORTED_MODULE_12_util_dom_prevent_default__["a" /* default */])(e);
                        login(window.location.href.replace(window.location.pathname, routerRegistry.get(__WEBPACK_IMPORTED_MODULE_9_constants_page_names__["CHECKOUT"]).url));
                    }
                },
                className: 'cart--continue',
                size: 'large',
                facet: 'primary',
                disabled: !hasItems },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_translations__["a" /* Trans */], { path: 'cart.continue' })
        )
    );
}

CartFooter.propTypes = {
    login: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
    isAuthenticated: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
    facet: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
    hasMissingMloginData: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
    customerDeliveryFee: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
    estimatedCustomerPrice: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
    hasItems: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
    routerRegistry: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired
};

function Faq(_ref2) {
    var onLoaded = _ref2.onLoaded;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'cart--faq' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_cms_placeholder__["a" /* default */], { onEvent: onLoaded, onLoaded: onLoaded, useRandomIconsLoader: false, id: 'cart_faq',
            facet: 'cart-panel' })
    );
}

Faq.propTypes = {
    onLoaded: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired
};

Faq.defaultProps = {
    onLoaded: __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a
};

function TooltipContent() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'h3',
            { style: { marginBottom: 4 } },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_translations__["a" /* Trans */], { path: 'checkout.tooltip.title' })
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'p',
            null,
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_translations__["a" /* Trans */], { path: 'checkout.tooltip.content' })
        )
    );
}

function CartContents(_ref3) {
    var tabIndex = _ref3.tabIndex,
        items = _ref3.items,
        bagInfo = _ref3.bagInfo,
        shippingPrice = _ref3.shippingPrice,
        promotions = _ref3.promotions,
        onFaqLoaded = _ref3.onFaqLoaded;

    var tooltipActions = [{
        name: 'OK',
        event: function event() {
            // noop
        }
    }];

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'cart--content-inner' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_cart_products_list__["a" /* default */], { tabIndex: tabIndex, products: items }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'cart--overview' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: 'cart--overview-list' },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'dl',
                    { className: 'cart--overview-item' },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'dt',
                        { className: 'cart--overview-item-term' },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_translations__["a" /* Trans */], {
                            path: 'checkout.panel.number_and_value_of_bags',
                            data: { amount: bagInfo.total_bags },
                            amount: bagInfo.total_bags
                        }),
                        '\xA0',
                        Object(__WEBPACK_IMPORTED_MODULE_13_util_misc_format_price__["a" /* default */])(bagInfo.unit_price)
                    ),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'dd',
                        { className: 'cart--overview-item-definition' },
                        Object(__WEBPACK_IMPORTED_MODULE_13_util_misc_format_price__["a" /* default */])(bagInfo.total_bag_price)
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_components_order_promotion_list__["a" /* default */], { promotions: promotions, facet: 'cart' }),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'dl',
                    { className: 'cart--overview-item' },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'dt',
                        { className: 'cart--overview-item-term' },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_translations__["a" /* Trans */], { path: 'cart.shipping_costs' })
                    ),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'dd',
                        { className: 'cart--overview__delivery-cost cart--overview-item-definition' },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_20_components_tooltip__["a" /* default */],
                            { className: 'cart-overview--tooltip',
                                content: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(TooltipContent, null),
                                interactionType: 'click',
                                actions: tooltipActions },
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_icon__["a" /* default */], { symbol: 'information', size: 'large' })
                        ),
                        shippingPrice
                    )
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Faq, { onLoaded: onFaqLoaded })
    );
}

CartContents.propTypes = {
    tabIndex: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,
    items: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
    bagInfo: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
    shippingPrice: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
    promotions: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array.isRequired,
    onFaqLoaded: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired
};

function CartEmpty(_ref4) {
    var onFaqLoaded = _ref4.onFaqLoaded;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'cart--content-inner' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__empty__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Faq, { onLoaded: onFaqLoaded })
    );
}

CartEmpty.propTypes = {
    onFaqLoaded: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired
};

var Cart = function (_PureComponent) {
    _inherits(Cart, _PureComponent);

    function Cart(props) {
        _classCallCheck(this, Cart);

        var _this = _possibleConstructorReturn(this, (Cart.__proto__ || Object.getPrototypeOf(Cart)).call(this, props));

        _this.onContentScroll = function () {
            clearTimeout(_this.scrollTimer);

            if (!_this.state.isScrolling) {
                _this.setState({
                    isScrolling: true
                });
            }

            _this.scrollTimer = setTimeout(function () {
                _this.setState({
                    isScrolling: false
                });
            }, 66);
        };

        _this.setFooterState = __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default()(function () {
            var content = this.refs.content;

            if (content && content.children) {
                this.props.updateFooterState(content.children[0]);
            }
        }, __WEBPACK_IMPORTED_MODULE_11_constants_debounce_delays__["b" /* CART_FOOTER_DEBOUNCE */]);

        _this.state = {
            isScrolling: false
        };
        _this.scrollTimer = null;
        return _this;
    }

    _createClass(Cart, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            __WEBPACK_IMPORTED_MODULE_7_tracking__["a" /* default */].checkout({
                step: __WEBPACK_IMPORTED_MODULE_8_tracking_constants__["a" /* CART_STEP_1 */],
                value: this.props.estimatedCustomerPrice,
                products: this.props.items
            });

            this.setFooterState();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(_ref5) {
            var items = _ref5.items,
                viewportHeight = _ref5.viewportHeight;

            if (this.props.viewportHeight !== viewportHeight || Object.keys(items).length !== Object.keys(this.props.items).length) {
                this.setFooterState();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearTimeout(this.scrollTimer);
            this.setFooterState.cancel();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                isFooterFixed = _props.isFooterFixed,
                login = _props.login,
                closePanel = _props.closePanel,
                hasMissingMloginData = _props.hasMissingMloginData,
                isAuthenticated = _props.isAuthenticated,
                isFetching = _props.isFetching,
                estimatedCustomerPrice = _props.estimatedCustomerPrice,
                shippingPrice = _props.shippingPrice,
                customerDeliveryFee = _props.customerDeliveryFee,
                isCartEmpty = _props.isCartEmpty,
                routerRegistry = _props.routerRegistry;
            var isScrolling = this.state.isScrolling;

            var hasItems = !isCartEmpty;

            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_components_aria_51__["a" /* default */],
                {
                    component: 'section',
                    className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('cart', {
                        'cart__is-fetching': isFetching,
                        'cart__is-footer-fixed': isFooterFixed,
                        'cart__is-scrolling': isScrolling
                    }) },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'header',
                    { className: 'cart--header' },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'div',
                        { className: 'cart--heading' },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            'h1',
                            { className: 'cart--title' },
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_translations__["a" /* Trans */], { path: 'cart.cart' })
                        ),
                        hasItems && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            'div',
                            { className: 'cart--clear-wrapper' },
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_20_components_tooltip__["a" /* default */],
                                { interactionType: 'click', content: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_translations__["a" /* Trans */], { path: 'cart.clear_cart_question' }),
                                    actions: this.actions },
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                    'button',
                                    { className: 'cart--clear', tabIndex: tabIndexMap.clear,
                                        'aria-label': Object(__WEBPACK_IMPORTED_MODULE_15_translations__["c" /* default */])('cart.clear_cart') },
                                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_translations__["a" /* Trans */], { path: 'cart.clear_cart' })
                                )
                            )
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'button',
                        { className: 'cart--close', tabIndex: tabIndexMap.close,
                            'aria-label': Object(__WEBPACK_IMPORTED_MODULE_15_translations__["c" /* default */])('accessibility.label.close_cart'), onClick: closePanel },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_icon__["a" /* default */], { symbol: 'cancel', size: 'medium' })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'div',
                    { onScroll: this.onContentScroll, className: 'cart--content', ref: 'content' },
                    hasItems ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(CartContents, _extends({
                        onFaqLoaded: this.setFooterState.bind(this),
                        tabIndex: tabIndexMap.content }, this.props)) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(CartEmpty, {
                        onFaqLoaded: this.setFooterState.bind(this) }),
                    !isFooterFixed && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(CartFooter, {
                        routerRegistry: routerRegistry,
                        facet: 'inline',
                        login: login,
                        hasItems: hasItems,
                        hasMissingMloginData: hasMissingMloginData,
                        isAuthenticated: isAuthenticated,
                        estimatedCustomerPrice: estimatedCustomerPrice,
                        customerDeliveryFee: customerDeliveryFee })
                ),
                isFooterFixed && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(CartFooter, {
                    routerRegistry: routerRegistry,
                    facet: 'fixed',
                    login: login,
                    hasItems: hasItems,
                    hasMissingMloginData: hasMissingMloginData,
                    isAuthenticated: isAuthenticated,
                    estimatedCustomerPrice: estimatedCustomerPrice,
                    customerDeliveryFee: customerDeliveryFee,
                    shippingPrice: shippingPrice
                })
            );
        }
    }, {
        key: 'actions',
        get: function get() {
            var _this2 = this;

            return [{
                name: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_translations__["a" /* Trans */], { path: 'tooltip.cancel' })
            }, {
                name: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_translations__["a" /* Trans */], { path: 'tooltip.confirm' }),
                isHighlighted: true,
                event: function event() {
                    _this2.props.clearCart();
                }
            }];
        }
    }, {
        key: 'scrollbarOffset',
        get: function get() {
            var scrollbarWidth = this.props.scrollbarWidth;

            return { right: scrollbarWidth + 'px', width: 'calc(100% - ' + scrollbarWidth + 'px)' };
        }
    }]);

    return Cart;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

Cart.propTypes = {
    items: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
    isFetching: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
    closePanel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
    clearCart: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
    updateFooterState: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
    scrollbarWidth: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,
    bagInfo: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
    shippingPrice: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
    customerDeliveryFee: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
    estimatedCustomerPrice: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
    viewportHeight: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,
    viewportMqQuery: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
    isCartEmpty: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
    isFooterFixed: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
    hasMissingMloginData: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
    routerRegistry: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
    isAuthenticated: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
    promotions: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array.isRequired,
    login: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired
};
Cart.defaultProps = {
    promotions: []
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_5_util_redux__["b" /* default */].mapStateToProps({
    items: 'cart.items',
    bagInfo: 'cart.bagInfo',
    isFetching: 'cart.isFetching',
    scrollbarWidth: 'scroll.scrollbarWidth',
    shippingPrice: 'cart.shippingPrice',
    isAuthenticated: 'user.isAuthenticated',
    hasMissingMloginData: 'user.has_missing_mlogin_data',
    customerDeliveryFee: 'cart.customerDeliveryFee',
    estimatedCustomerPrice: 'cart.estimatedCustomerPrice',
    viewportHeight: 'viewport.height',
    viewportMqQuery: 'viewport.mq.query',
    isCartEmpty: 'cart.isEmpty',
    routerRegistry: 'router.registry',
    cartFooterState: 'cart.registry',
    isFooterFixed: 'cart.isFooterFixed',
    promotions: 'cart.promotions'
}), __WEBPACK_IMPORTED_MODULE_5_util_redux__["b" /* default */].mapDispatchToProps({
    closePanel: 'panel.close',
    clearCart: 'cart.clearCart',
    login: 'user.login',
    updateFooterState: 'cart.updateFooterState'
}))(Cart));

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return brandImage; });
/* unused harmony export originalImage */
/* harmony export (immutable) */ __webpack_exports__["c"] = productImage;
/* harmony export (immutable) */ __webpack_exports__["b"] = imageByDpi;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_curryRight__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_curryRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_curryRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_api_images_types__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_dom_image_dpi_resolution__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_misc_static_assets_path__ = __webpack_require__(197);


var _product;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var product = (_product = {}, _defineProperty(_product, __WEBPACK_IMPORTED_MODULE_1_constants_api_images_types__["f" /* TILE */], 'amigos_web_tile'), _defineProperty(_product, __WEBPACK_IMPORTED_MODULE_1_constants_api_images_types__["e" /* THUMB */], 'amigos_web_thumb'), _defineProperty(_product, __WEBPACK_IMPORTED_MODULE_1_constants_api_images_types__["c" /* DETAIL */], 'amigos_web_detail'), _defineProperty(_product, __WEBPACK_IMPORTED_MODULE_1_constants_api_images_types__["a" /* BADGE_DETAIL */], 'amigos_web_badge_detail'), _defineProperty(_product, __WEBPACK_IMPORTED_MODULE_1_constants_api_images_types__["b" /* BADGE_TILE */], 'amigos_web_badge_tile'), _defineProperty(_product, __WEBPACK_IMPORTED_MODULE_1_constants_api_images_types__["d" /* ORIGINAL */], 'original'), _product);

var brand = 'amigos_brands';

var postfix = {
    default: '_1x',
    retina: '_2x'
};

var SIZE_TMP_VAR = '{size}';
var STACK_CHUNK = '{stack}';

/**
 * Generate the proper image source attributes object starting by the image path url received by api
 * @param {string} path - path containing the {stack} that should be replaced
 * @param {string} type - string that must replace the {stack} token
 * @returns {object} - valid image attributes object that can be parsed by image-attributes.js
 */
function pathsByType(path, type) {
    var base = path && path.replace(STACK_CHUNK, '' + type + SIZE_TMP_VAR);
    var fallback = Object(__WEBPACK_IMPORTED_MODULE_3_util_misc_static_assets_path__["a" /* default */])('img/icons/missing-product-image.svg');

    return {
        src: {
            '@1': base ? base.replace(SIZE_TMP_VAR, postfix.default) : fallback,
            '@2': base ? base.replace(SIZE_TMP_VAR, postfix.retina) : fallback
        }
    };
}

var brandImage = __WEBPACK_IMPORTED_MODULE_0_lodash_curryRight___default()(pathsByType)(brand);

// Get the original image from the url received
var originalImage = function originalImage(path) {
    return path.replace(STACK_CHUNK, __WEBPACK_IMPORTED_MODULE_1_constants_api_images_types__["d" /* ORIGINAL */]);
};

function productImage(path, type) {
    if (!product[type]) {
        throw new Error('The product type "' + type + '" has no stack images');
    }

    return pathsByType(path, product[type]);
}

/**
 * Take any of the image sources produced above and returns a unique source attribute based on the screen DPI
 * @param {object} data.src - the return of any of the functions above
 * @returns {string} a clean image path
 */
function imageByDpi(_ref) {
    var src = _ref.src;

    return src['@' + Math.min(Object(__WEBPACK_IMPORTED_MODULE_2_util_dom_image_dpi_resolution__["a" /* default */])(), 2)];
}

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return THUMB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ORIGINAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BADGE_TILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BADGE_DETAIL; });
var TILE = 'tile';
var THUMB = 'thumb';
var DETAIL = 'detail';
var ORIGINAL = 'original';
var BADGE_TILE = 'badge_tile';
var BADGE_DETAIL = 'badge_detail';

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bianco_images_loader__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tracking__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_dom_stop_propagation__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util_misc_normalise_trailing_slash__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_tracking_constants__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_constants_api_images_types__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_util_react_stack_images_path__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_constants_debounce_delays__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_constants_order_states__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_loader__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_cart_counter__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_product_meta__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_constants_category_icons__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_util_react_facet__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_util_dom_channeled_interactionobserver__ = __webpack_require__(308);



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable camelcase */


























var DEFAULT_NAME = 'Loading...';

var assetsCache = new Map();

var ProductTile = function (_Component) {
    _inherits(ProductTile, _Component);

    function ProductTile(props) {
        _classCallCheck(this, ProductTile);

        var _this = _possibleConstructorReturn(this, (ProductTile.__proto__ || Object.getPrototypeOf(ProductTile)).call(this, props));

        _initialiseProps.call(_this);

        var hasImage = props.image ? assetsCache.has(_this.getProductImageSource(props)) : false;

        var amount = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(props, 'cartItems[' + props.id + '].amount', 0);

        _this.state = {
            isLoading: false,
            isVisible: hasImage,
            isLoaded: hasImage,
            amount: amount
        };
        return _this;
    }

    _createClass(ProductTile, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.trackProductImpression(this.state);

            if (!this.state.isLoaded) {
                Object(__WEBPACK_IMPORTED_MODULE_23_util_dom_channeled_interactionobserver__["a" /* register */])(this, 'product-tile', {
                    threshold: 0.05,
                    rootMargin: '200px'
                });
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.state.isVisible && nextProps.image && !this.state.isLoaded && !this.state.isLoading) {
                this.lazyLoad(nextProps);
            }

            if (nextProps.isMobile !== this.props.isMobile) {
                assetsCache.clear();
            }

            var oldAmount = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this.props, 'cartItems[' + this.props.id + '].amount', 0);
            var newAmount = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(nextProps, 'cartItems[' + nextProps.id + '].amount', 0);

            if (oldAmount !== newAmount || this.props.cartErrorId === this.props.id) {
                this.setState({
                    amount: newAmount
                });
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(_ref, _ref2) {
            var fetchingId = _ref.fetchingId,
                id = _ref.id;
            var isLoaded = _ref2.isLoaded,
                amount = _ref2.amount,
                isVisible = _ref2.isVisible,
                isLoading = _ref2.isLoading;

            return isLoaded !== this.state.isLoaded || // was it lazy loaded?
            amount !== this.state.amount || // was its counter updated?
            isVisible !== this.state.isVisible || isLoading !== this.state.isLoading || this.props.fetchingId === id || fetchingId === id // has started/finished fetching?
            ;
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps, nextState) {
            this.trackProductImpression(nextState);

            if (nextState.isVisible && !this.state.isVisible) {
                if (!this.state.isLoaded && this.props.image && !this.state.isLoading) {
                    this.lazyLoad(nextProps);
                }
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.wasUnmounted = true;
            Object(__WEBPACK_IMPORTED_MODULE_23_util_dom_channeled_interactionobserver__["b" /* unregister */])(this);
        }
    }, {
        key: 'getProductImageSource',
        value: function getProductImageSource(props) {
            return Object(__WEBPACK_IMPORTED_MODULE_13_util_react_stack_images_path__["b" /* imageByDpi */])(Object(__WEBPACK_IMPORTED_MODULE_13_util_react_stack_images_path__["c" /* productImage */])(props.image, props.isMobile ? __WEBPACK_IMPORTED_MODULE_12_constants_api_images_types__["e" /* THUMB */] : __WEBPACK_IMPORTED_MODULE_12_constants_api_images_types__["f" /* TILE */]));
        }
    }, {
        key: 'renderProductImage',
        value: function renderProductImage() {
            var _props = this.props,
                image = _props.image,
                id = _props.id,
                fetchingId = _props.fetchingId,
                price_information = _props.price_information;
            var _state = this.state,
                isLoaded = _state.isLoaded,
                isVisible = _state.isVisible;
            var badge = price_information.badge;

            var iconSymbol = this.activeCategory && __WEBPACK_IMPORTED_MODULE_21_constants_category_icons__["a" /* default */][this.activeCategory.id] || __WEBPACK_IMPORTED_MODULE_21_constants_category_icons__["a" /* default */].default;
            var isSubmittingValues = fetchingId && fetchingId === id;

            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { key: 'image', className: 'product-tile--image' },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'div',
                    { className: 'product-tile--image-inner' },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'div',
                        {
                            className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('product-tile--image-content', {
                                'product-tile--image-inner__loaded': isLoaded
                            }),
                            style: {
                                backgroundImage: image && isLoaded ? 'url(\'' + this.getProductImageSource(this.props) + '\')' : 'none'
                            }
                        },
                        !isLoaded && isVisible && iconSymbol && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_loader__["a" /* default */], { facet: 'icon', size: 'large', symbol: iconSymbol }),
                        isSubmittingValues && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            'div',
                            { className: 'product-tile--loader-animator' },
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                'div',
                                { key: 'loader', className: 'product-tile--loader' },
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_loader__["a" /* default */], { size: 'small' })
                            )
                        )
                    )
                ),
                badge && isLoaded && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', { src: Object(__WEBPACK_IMPORTED_MODULE_13_util_react_stack_images_path__["b" /* imageByDpi */])(Object(__WEBPACK_IMPORTED_MODULE_13_util_react_stack_images_path__["c" /* productImage */])(badge, __WEBPACK_IMPORTED_MODULE_12_constants_api_images_types__["b" /* BADGE_TILE */])), className: 'product-tile--badge' })
            );
        }
    }, {
        key: 'renderOverlayLink',
        value: function renderOverlayLink() {
            var _props2 = this.props,
                slug = _props2.slug,
                baseurl = _props2.baseurl,
                isCmsEnabled = _props2.isCmsEnabled;

            // ATTENTION: another dirty hack here to solve https://jira.migros.net/browse/MCART-1481
            // this is dumb hack for a dumb issue due to the messy javascript events generated by django CMS when a user is logged in

            return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(isCmsEnabled ? 'button' : 'a', {
                className: 'product-tile--button product-tile--more-button u-reset',
                'aria-label': Object(__WEBPACK_IMPORTED_MODULE_16_translations__["c" /* default */])('accessibility.label.product_detail'),
                onClick: this.openDetailOverlay,
                href: baseurl + '/' + Object(__WEBPACK_IMPORTED_MODULE_10_util_misc_normalise_trailing_slash__["a" /* default */])(slug)
            }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_icon__["a" /* default */], { symbol: 'product-detail', size: 'large' }));
        }
    }, {
        key: 'renderTileContent',
        value: function renderTileContent() {
            var _props3 = this.props,
                name = _props3.name,
                facet = _props3.facet,
                price_information = _props3.price_information,
                id = _props3.id,
                short_description = _props3.short_description;
            var _state2 = this.state,
                isVisible = _state2.isVisible,
                isLoaded = _state2.isLoaded,
                amount = _state2.amount;
            var add = this.add,
                remove = this.remove;

            var methods = { add: add, remove: remove };

            return [isVisible && id && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { key: 'counter', className: 'product-tile--counter' },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_cart_counter__["a" /* default */], _extends({ productName: name,
                    amount: amount,
                    facet: 'tile-' + facet
                }, methods, {
                    id: id }))
            ), this.renderProductImage(), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_product_meta__["a" /* default */], {
                key: 'meta',
                name: name,
                short_description: short_description,
                price_information: price_information
            }), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { key: 'more', className: 'product-tile--more' },
                isLoaded && this.renderOverlayLink()
            )];
        }
    }, {
        key: 'render',
        value: function render() {
            var _props4 = this.props,
                facet = _props4.facet,
                tileFacet = _props4.tileFacet;
            var isVisible = this.state.isVisible;


            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'article',
                {
                    ref: 'root',
                    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('product-tile', Object(__WEBPACK_IMPORTED_MODULE_22_util_react_facet__["a" /* default */])(facet, 'product-tile'), Object(__WEBPACK_IMPORTED_MODULE_22_util_react_facet__["a" /* default */])(tileFacet, 'product-tile')),
                    itemScope: true,
                    itemType: 'http://schema.org/Product'
                },
                isVisible && this.renderTileContent(),
                !isVisible && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'div',
                    null,
                    '\xA0'
                )
            );
        }
    }]);

    return ProductTile;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

ProductTile.defaultProps = {
    name: DEFAULT_NAME,
    slug: 'undefined',
    list: __WEBPACK_IMPORTED_MODULE_11_tracking_constants__["f" /* PRODUCT_LIST_CATEGORY */],
    skipTests: false,
    has_discount: false,
    position: 0,
    short_description: [],
    tileFacet: [],
    price_information: { price: null, teaser: null }
};
ProductTile.propTypes = {
    name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
    slug: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    id: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    image: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    facet: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
    tileFacet: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array]),
    short_description: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array.isRequired,
    price_information: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    badge: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    productErrorId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    activeRegion: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
    skipTests: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
    openModal: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    setProductAmount: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    cartStatus: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    cartErrorId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    cartItems: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    baseurl: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
    isMobile: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
    fetchingId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    cooperative: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    position: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    isCmsEnabled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
    has_discount: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
    /**
     * This property is only needed for tracking and it reveals the context where the product tile gets used
     */
    list: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired
};

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.onImageLoaded = function (src) {
        if (_this2.wasUnmounted) {
            return;
        }

        assetsCache.set(src, true);

        _this2.setState({
            isLoaded: true
        });
    };

    this.trackProductImpression = function (state) {
        // track a product impression only once
        if (state.isVisible && _this2.props.image && !_this2._wasProductImpressionTracked) {
            __WEBPACK_IMPORTED_MODULE_8_tracking__["a" /* default */].productImpression(_this2.props);
            if (_this2.props.has_discount) {
                __WEBPACK_IMPORTED_MODULE_8_tracking__["a" /* default */].promotionView(_this2.props);
            }
            _this2._wasProductImpressionTracked = true;
        }
    };

    this._wasProductImpressionTracked = false;

    this.setAmount = function (amount) {
        amount = Number(amount);

        // Abort if there is currently a server request
        if (_this2.state.amount === amount) {
            return;
        }

        if (_this2.props.skipTests || _this2.props.activeRegion && _this2.props.activeRegion.cooperative === _this2.props.cooperative && _this2.props.cartStatus === __WEBPACK_IMPORTED_MODULE_15_constants_order_states__["f" /* OPEN */]) {
            _this2.setState({
                amount: amount
            });
        }

        _this2.sendAmount(amount);
    };

    this.add = function () {
        _this2.setAmount(_this2.state.amount + 1);
    };

    this.lazyLoad = function (props) {
        var src = _this2.getProductImageSource(props);
        _this2.setState({ isLoading: true });
        Object(__WEBPACK_IMPORTED_MODULE_5_bianco_images_loader__["a" /* loadImage */])(src).then(function () {
            return _this2.onImageLoaded(src);
        });
    };

    this.openDetailOverlay = function (e) {
        var href = e.currentTarget.getAttribute('href');
        e.preventDefault();
        Object(__WEBPACK_IMPORTED_MODULE_9_util_dom_stop_propagation__["a" /* default */])(e);
        __WEBPACK_IMPORTED_MODULE_8_tracking__["a" /* default */].productClick(_this2.props);

        if (_this2.props.has_discount) {
            __WEBPACK_IMPORTED_MODULE_8_tracking__["a" /* default */].promotionClick(_this2.props, {
                creative: _this2.props.list
            });
        }

        _this2.props.openModal({
            layout: 'product-detail',
            isAsync: true,
            href: href
        });
    };

    this.remove = function () {
        if (_this2.state.amount) {
            _this2.setAmount(_this2.state.amount - 1);
        }
    };

    this.sendAmount = __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default()(function (amount) {
        var setProductAmount = this.props.setProductAmount;


        setProductAmount({ product: this.props, amount: amount });
    }, __WEBPACK_IMPORTED_MODULE_14_constants_debounce_delays__["c" /* COUNTER_CLICK_DEBOUNCE */]);
    this.wasUnmounted = false;
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_6_util_redux__["b" /* default */].mapStateToProps({
    activeRegion: 'region.active',
    fetchingId: 'cart.fetchingId',
    cartErrorId: 'cart.productError.fetchingId',
    cartStatus: 'cart.state',
    cartItems: 'cart.items',
    baseurl: 'router.baseurl',
    isCmsEnabled: 'cms.isEnabled',
    isMobile: 'viewport.isMobile'
}), __WEBPACK_IMPORTED_MODULE_6_util_redux__["b" /* default */].mapDispatchToProps({
    openModal: 'modal.open',
    setProductAmount: 'cart.setProductAmount'
}))(ProductTile));

/* eslint-enable camelcase */

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__footer_tail__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__footer_head__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_misc_static_assets_path__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_page_names__ = __webpack_require__(194);









function MainFooter(_ref) {
    var isMobile = _ref.isMobile,
        templateConfig = _ref.templateConfig,
        isNative = _ref.isNative,
        isMainContentLoaderVisible = _ref.isMainContentLoaderVisible,
        pageName = _ref.pageName;

    var tabIndex = pageName === __WEBPACK_IMPORTED_MODULE_7_constants_page_names__["CHECKOUT"] ? -1 : 0;
    return isMainContentLoaderVisible ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'main-footer skel--footer' },
        !isNative && ['default', 'lite'].includes(templateConfig.footer) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'grid--row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'figure',
                { className: 'main-footer--illustration grid--col' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                    className: 'main-footer--image',
                    src: Object(__WEBPACK_IMPORTED_MODULE_6_util_misc_static_assets_path__["a" /* default */])('img/spacer/img-footer-on-white.png')
                })
            )
        ),
        !isMobile && !isNative && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__footer_head__["a" /* default */], { tabIndex: tabIndex, facet: templateConfig.footer }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__footer_tail__["a" /* default */], { tabIndex: tabIndex, hasAgbLink: pageName !== __WEBPACK_IMPORTED_MODULE_7_constants_page_names__["PRELAUNCH"], hasAdditionalContent: !isNative,
            facet: templateConfig.footer })
    );
}

MainFooter.propTypes = {
    isMainContentLoaderVisible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    isNative: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    isMobile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    pageName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    templateConfig: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_2_util_redux__["b" /* default */].mapStateToProps({
    isMainContentLoaderVisible: 'main-content.isLoaderVisible',
    isMobile: 'viewport.isMobile',
    isNative: 'viewport.isNative',
    templateConfig: 'router.config',
    pageName: 'router.name'
}))(MainFooter));

/***/ }),
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = productsFactoryMiddleware;
/* harmony export (immutable) */ __webpack_exports__["b"] = productFactoryMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isObject__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isObject__);



/**
 * Factory function to append extra properties to the products models
 * @param  {IProduct[]} products - products collection
 * @param {object} data - values that will be used to eventually extend the product object
 * @returns {IProduct[] | ICooperativeProduct[]}
 */
function productsFactoryMiddleware(products) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (Array.isArray(products)) {
        return products.map(function (p) {
            return Object.assign(p, data);
        });
    }

    return products;
}

/**
 * Factory function to append extra properties to the product model
 * @param  {object|object} product - products collection
 * @param {object} data - values that will be used to eventually extend the product object
 */
function productFactoryMiddleware(product) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (__WEBPACK_IMPORTED_MODULE_0_lodash_isObject___default()(product)) {
        return Object.assign(product, data);
    }

    return product;
}

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export COOPERATIVE_KEY */
/* unused harmony export REGION_SLUG_KEY */
/* unused harmony export getRegionSlug */
/* unused harmony export findRegion */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return findRegionByCooperative; });
/* unused harmony export findRegionBySlug */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getRegionSlugByCooperative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getRegionSlugBySlug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCooperativeBySlug; });
/* unused harmony export getCooperativeByCooperative */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_flowRight__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_curry__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_curry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_curry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_regions__ = __webpack_require__(568);



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




var COOPERATIVE_KEY = 'cooperative';
var REGION_SLUG_KEY = 'region_slug';

/**
 * Util function in order to be sure that the we can parse safely objects arguments or just return them raw as they are
 * @param {object|string} source - argument to parse
 * @param {string} key - key that we will eventually use to get the nested value we are looking for
 * @returns {string} hopefully a string we are trying to get
 * @example
 * safeParse({ cooperative: 'gmzh'} , 'cooperative') => 'gmzh'
 *
 * @example
 * safeParse('gmzh' , 'cooperative') => 'gmzh'
 */
function safeParse(source, key) {
  return source && (typeof source === 'undefined' ? 'undefined' : _typeof(source)) === 'object' ? source[key] : source;
}

/**
 * Get the region slug by specific data structures
 * @param {function} regionRetriverFn - function we want to call to find the current region
 * @param {string} prop - property we want to use use as test value
 * @param {object} data - it could be either the user region model or a route node
 * @returns {string}
 */
function getRegionSlug(regionRetriverFn, prop, data) {
  return regionRetriverFn(safeParse(data, prop))[REGION_SLUG_KEY];
}

// simple wrapper function to return the default region
var findRegion = function findRegion(prop, testValue) {
  return __WEBPACK_IMPORTED_MODULE_2_constants_regions__["a" /* AVAILABLE_REGIONS */].find(function (r) {
    return r[prop] === testValue;
  }) || __WEBPACK_IMPORTED_MODULE_2_constants_regions__["b" /* DEFAULT_REGION */];
};

/**
 * Find a region by comparing the cooperative key with a test value
 * @param {string} cooperative - possible region cooperative
 * @example
 * findRegionBySlug('gmzh') => { region_slug: 'zuerich', cooperative: 'gmzh' }
 */
var findRegionByCooperative = __WEBPACK_IMPORTED_MODULE_1_lodash_curry___default()(findRegion)(COOPERATIVE_KEY);
/**
 * find a region by comparing the region_slug key with a test value
 * @param {string} slug - possible region slug
 * @example
 * findRegionBySlug('zuerich') => { region_slug: 'zuerich', cooperative: 'gmzh' }
 */
var findRegionBySlug = __WEBPACK_IMPORTED_MODULE_1_lodash_curry___default()(findRegion)(REGION_SLUG_KEY);

/**
 * Get the region by parsing an object having the `cooperative` key defined, if the region was not available it returns the default slug
 * @param {string|object} cooperative - either directly the cooperative string or an object containing the `cooperative` key
 * @returns {string} - slug of the region found or the default one
 *
 * @example
 * getRegionSlugByCooperative({ cooperative: 'gmzh' }) => 'zuerich';
 *
 * @example
 * getRegionSlugByCooperative('gmaa') => 'bern';
 *
 * @example
 * getRegionSlugByCooperative({ cooperative: 'foo' }) => 'zuerich'; // not available
 */
var getRegionSlugByCooperative = __WEBPACK_IMPORTED_MODULE_1_lodash_curry___default()(getRegionSlug)(findRegionByCooperative, COOPERATIVE_KEY);

/**
 * Get the region by parsing an object having the `region_slug` defined, if the region was not available it returns the default slug
 * @param {string|object} slug - either directly the region_slug string or an object containing the `region_slug` key
 * @returns {string} - slug of the region found or the default one
 *
 * @example
 * getRegionSlugBySlug({ region_slug: 'zuerich' }) => 'zuerich';
 *
 * @example
 * getRegionSlugBySlug('bern') => 'bern';
 *
 * @example
 * getRegionSlugBySlug('milano') => 'zuerich'; // not available
 */
var getRegionSlugBySlug = __WEBPACK_IMPORTED_MODULE_1_lodash_curry___default()(getRegionSlug)(findRegionBySlug, REGION_SLUG_KEY);

/**
 * Get the cooperative value of any region
 * @param {string} slug - test string to find the region cooperative
 * @returns {string} the region cooperative by the slug received
 */
var slugToCooperative = function slugToCooperative(slug) {
  return findRegionBySlug(slug).cooperative;
};

/**
 * Compositional methods to get any region cooperative value
 * @param {string|object} slug - either directly the region_slug string or an object containing the `region_slug` key
 * @returns {string} - cooperative of the region found or the default one
 */
var getCooperativeBySlug = __WEBPACK_IMPORTED_MODULE_0_lodash_flowRight___default()(slugToCooperative, getRegionSlugBySlug);

/**
 * Compositional methods to get any region cooperative value
 * @param {string|object} cooperative - either directly the cooperative string or an object containing the `cooperative` key
 * @returns {string} - cooperative of the region found or the default one
 */
var getCooperativeByCooperative = __WEBPACK_IMPORTED_MODULE_0_lodash_flowRight___default()(slugToCooperative, getRegionSlugByCooperative);

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = preventDefault;
/**
 * Prevent the default event behavior
 * @param {object} e - event object
 * @returns {boolean}
 */
function preventDefault(e) {
    e.preventDefault();
    if (e.nativeEvent) {
        e.nativeEvent.preventDefault();
    }
    return false;
}

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = imageAttributes;
/* harmony export (immutable) */ __webpack_exports__["b"] = lazyImageAttributes;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Prepare the image attributes parsing an object normally generated via backend
 * @param {object} src - object containing the image sources
 * @param {object} rest - additional attributes
 * @returns {object} attributes object for any <img> tags
 */
function imageAttributes(_ref) {
    var src = _ref.src,
        rest = _objectWithoutProperties(_ref, ['src']);

    return _extends({
        src: src['@1'],
        srcSet: src['@1'] + ' 1x, ' + src['@2'] + ' 2x'
    }, rest);
}

/**
 * Prepare the image attributes parsing an object normally generated via backend
 * @param {object} src - object containing the image sources
 * @param {object} rest - additional attributes
 * @returns {object} attributes object for any <img> tags
 */
function lazyImageAttributes(_ref2) {
    var src = _ref2.src,
        rest = _objectWithoutProperties(_ref2, ['src']);

    return _extends({
        'data-src': src['@1'],
        'data-src-set': src['@1'] + ' 1x, ' + src['@2'] + ' 2x'
    }, rest);
}

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return register; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return unregister; });


var observers = new Map();
var domElements = new WeakMap();

/**
 * Get or create interaction observer
 *
 * @param {String} name
 * @param {Object} opt - observer options
 * @return {IntersectionObserver}
 * @private
 */
function _getOrCreate(name, opt) {
    if (!observers.get(name)) {
        observers.set(name, new IntersectionObserver(_checkIntersection(name, opt.triggerThreshold), opt));
    }

    return observers.get(name);
}

/**
 * Callback when interactions occur
 * @return {Function}
 * @param {string} name
 * @param {number} threshold for trigger
 * @private
 */
function _checkIntersection(name) {
    var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    return function (entries) {
        var filteredEntries = entries.filter(function (entry) {
            return entry.intersectionRatio > threshold ? entry : null;
        });

        var observer = observers.get(name);

        filteredEntries.forEach(function (entry) {
            var component = domElements.get(entry.target);

            if (!component) {
                return;
            }

            component.setState({ isVisible: true });

            observer.unobserve(entry.target);
            domElements.delete(entry.target);
        });
    };
}

/**
 * Register new component to be observed
 * @param {Component} component - the reactcomponent to be watched
 * @param {String} name - specific observer to attach the component listener to
 * @param {Object} opt - InteractionObserver options
 * @param {DOMElement} element -  Element to observe
 */
function register(component, name, opt, element) {
    opt = opt || null;
    var observer = _getOrCreate(name, opt);
    var elm = element || component.refs.root;
    observer.observe(elm);
    domElements.set(elm, component);
}

/**
 * Unregister observer for component
 *
 * @param {Component} component
 */
function unregister(component) {
    domElements.delete(component.refs.root);
}



/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scssData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sass_to_js__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sass_to_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sass_to_js__);


/**
 * Export the scss shared data
 * @param {HTMLElement} el - node that will be our bridge between sass and js
 * @returns {object} an object containing the scss shared variables
 */
function scssData(el) {
    return __WEBPACK_IMPORTED_MODULE_0_sass_to_js___default()(el, {
        debug: false,
        pseudoEl: '::before',
        cssProperty: 'content'
    });
}

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var VisibilitySensor = function (_PureComponent) {
    _inherits(VisibilitySensor, _PureComponent);

    function VisibilitySensor() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, VisibilitySensor);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VisibilitySensor.__proto__ || Object.getPrototypeOf(VisibilitySensor)).call.apply(_ref, [this].concat(args))), _this), _this._isVisible = false, _this.checkIntersection = function (entries) {
            var isIntersecting = entries.every(function (e) {
                return e.intersectionRatio > 0 || e.isIntersecting;
            });

            if (isIntersecting === _this._isVisible) {
                return;
            }

            _this.props[isIntersecting ? 'onEnter' : 'onLeave']();
            _this._isVisible = isIntersecting;
            _this.props.onChange(isIntersecting);

            if (_this.props.once && _this._isVisible) {
                _this.observer.unobserve(_this.root);
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(VisibilitySensor, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.root = __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(this); // eslint-disable-line
            this.observer = new IntersectionObserver(this.checkIntersection, this.props.options);
            this.observer.observe(this.root);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.observer) {
                this.observer.disconnect();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
        }
    }]);

    return VisibilitySensor;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

VisibilitySensor.defaultProps = {
    onChange: __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a,
    onLeave: __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a,
    onEnter: __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a,
    once: false,
    options: null
};
VisibilitySensor.propTypes = {
    onChange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    onLeave: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    onEnter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    once: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
    children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object]).isRequired,
    /** @type {IntersectionObserverInit} */
    options: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (VisibilitySensor);

/***/ }),
/* 311 */,
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_redux_index__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_page_loader__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_react_facet__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var MainContent = function (_Component) {
    _inherits(MainContent, _Component);

    function MainContent() {
        _classCallCheck(this, MainContent);

        return _possibleConstructorReturn(this, (MainContent.__proto__ || Object.getPrototypeOf(MainContent)).apply(this, arguments));
    }

    _createClass(MainContent, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                isLoaded = _props.isLoaded,
                facet = _props.facet,
                isWrapped = _props.isWrapped,
                isLoaderVisible = _props.isLoaderVisible,
                dispatch = _props.dispatch,
                props = _objectWithoutProperties(_props, ['children', 'isLoaded', 'facet', 'isWrapped', 'isLoaderVisible', 'dispatch']); // eslint-disable-line


            var layoutFacet = Object(__WEBPACK_IMPORTED_MODULE_5_util_react_facet__["a" /* default */])(facet, 'layout--grid-container');

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'main',
                props,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('layout--grid-container', isWrapped ? 'grid--container' : null, layoutFacet) },
                    isLoaderVisible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_page_loader__["a" /* default */], { useRandomIcon: true }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('layout--page-container', {
                                'layout--page-container__is-loaded': isLoaded
                            }) },
                        children
                    )
                )
            );
        }
    }]);

    return MainContent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

MainContent.defaultProps = {
    facet: [],
    isWrapped: true,
    isLoaderVisible: false
};
MainContent.propTypes = {
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
    facet: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]).isRequired,
    isWrapped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    isLoaded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    isLoaderVisible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_2_util_redux_index__["b" /* default */].mapStateToProps({
    isLoaded: 'main-content.isLoaded',
    isLoaderVisible: 'main-content.isLoaderVisible'
}))(MainContent));

/***/ }),
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MISSING_ADDRESS_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MISSING_DELIVERY_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INVALID_PAYMENT_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TIME_SLOT_EXPIRED; });
//keep these in sync with ICartValidationError
var MISSING_ADDRESS_ID = 'missing_address_id';
var MISSING_DELIVERY_DATE = 'missing_delivery_date';
var INVALID_PAYMENT_METHOD = 'invalid_payment_method';
var TIME_SLOT_EXPIRED = 'time_slot_expired';

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reducers_modules_scroll_actions__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reducers_modules_panel_actions__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_api_urls__ = __webpack_require__(192);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var cachedPanelState = void 0;

/* harmony default export */ __webpack_exports__["default"] = (Object.freeze({
    /**
     * Open modal
     * @param {string} content
     * @param {string} layout
     * @param {string} href
     * @param {any} meta
     * @param {boolean} isAsync
     * @param {boolean} mustRefreshOnClose
     * @return {Function}
     */
    open: function open(_ref) {
        var content = _ref.content,
            layout = _ref.layout,
            href = _ref.href,
            meta = _ref.meta,
            isAsync = _ref.isAsync,
            mustRefreshOnClose = _ref.mustRefreshOnClose;

        return function (dispatch, getState) {
            cachedPanelState = getState().panel;
            if (cachedPanelState.content) {
                dispatch(__WEBPACK_IMPORTED_MODULE_2_reducers_modules_panel_actions__["default"].close());
            }
            dispatch(__WEBPACK_IMPORTED_MODULE_1_reducers_modules_scroll_actions__["default"].lock());
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["OPEN_MODAL"], content: content, layout: layout, href: href, meta: meta, isAsync: isAsync, mustRefreshOnClose: mustRefreshOnClose });
        };
    },
    close: function close() {
        return function (dispatch, getState) {
            var mustRefreshOnClose = getState().modal.mustRefreshOnClose;

            if (!getState().modal.isVisible) {
                return;
            }

            // if this prop is true we need to reload the whole application
            if (mustRefreshOnClose) {
                window.location.href = Object(__WEBPACK_IMPORTED_MODULE_3_constants_api_urls__["login"])(window.location.href); // reload the page forcing the login
            }

            if (cachedPanelState && cachedPanelState.content) {
                dispatch(__WEBPACK_IMPORTED_MODULE_2_reducers_modules_panel_actions__["default"].open(_extends({}, cachedPanelState)));
            } else if (!getState().search.isActive) {
                dispatch(__WEBPACK_IMPORTED_MODULE_1_reducers_modules_scroll_actions__["default"].unlock());
            }

            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["CLOSE_MODAL"] });
        };
    },
    reset: function reset() {
        return function (dispatch) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["RESET_MODAL"] });
        };
    },


    /**
     * Set state
     * @param {boolean} isReady
     * @return {Function}
     */
    setReady: function setReady(_ref2) {
        var isReady = _ref2.isReady;

        return function (dispatch) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_MODAL_READY"], isReady: isReady });
        };
    }
}));

/***/ }),
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reducers_helpers__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_api_urls__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_order_states__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_cart_error_types__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__actions_types__);

/* eslint-disable consistent-return */











var availableCartErrorTypes = [__WEBPACK_IMPORTED_MODULE_7_constants_cart_error_types__["a" /* MISSING_ZIP_CODE */], __WEBPACK_IMPORTED_MODULE_7_constants_cart_error_types__["b" /* ORDER_PENDING */], __WEBPACK_IMPORTED_MODULE_7_constants_cart_error_types__["c" /* PRODUCT_NOT_IN_REGION */]];

var FOOTER_HEIGHT_INLINE = 134;

/**
 * Users can deal with the cart only if they have set a valid zip code
 * @returns {boolean}
 */
function isValid(dispatch, getState, product) {
    var state = getState();
    var activeRegion = state.region.active;
    var hasZip = !!activeRegion;
    var productCooperative = product.cooperative || state.router.cooperative;
    var isInRegion = !productCooperative || activeRegion && activeRegion.cooperative === productCooperative;
    var hasOrdersLookingForAPicker = state.cart.state === __WEBPACK_IMPORTED_MODULE_6_constants_order_states__["c" /* CONFIRMED */];
    var hasErrors = !hasZip || hasOrdersLookingForAPicker || !isInRegion;

    // dispatch the cart error
    if (hasErrors) {
        // block the user in case the zip was not defined
        if (!hasZip) {
            dispatch(setCartError({ error: __WEBPACK_IMPORTED_MODULE_7_constants_cart_error_types__["a" /* MISSING_ZIP_CODE */] }));
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_3_reducers_actions_types__["SET_CART_TEMP_ITEM"], tempItem: product });
            // advise the user that he/she the product is not available in his/her region
        } else if (!isInRegion) {
            dispatch(setCartError({ error: __WEBPACK_IMPORTED_MODULE_7_constants_cart_error_types__["c" /* PRODUCT_NOT_IN_REGION */] }));
        } else if (hasOrdersLookingForAPicker) {
            // block the user because of pending orders
            dispatch(setCartError({ error: __WEBPACK_IMPORTED_MODULE_7_constants_cart_error_types__["b" /* ORDER_PENDING */] }));
        }
    }

    return !hasErrors;
}

/* eslint-disable camelcase */
/**
 * Add one unit of a product to the cart
 * @param product
 * @returns {function(*, *)}
 */
function addProduct(_ref) {
    var product = _ref.product;

    return function (dispatch, getState) {
        var id = product.id;
        var currentState = getState();

        var existingProduct = currentState.cart.items[id];

        if (currentState.cart.tempItem) {
            // reset the temp item if it was set before
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_3_reducers_actions_types__["SET_CART_TEMP_ITEM"], tempItem: null });
        }

        if (!isValid(dispatch, getState, product)) {
            return;
        }

        var amount = existingProduct ? existingProduct.amount + 1 : 1;
        amount = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["d" /* limitAmount */])(amount);

        var data = {
            product_id: id,
            amount: amount
        };

        return Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["f" /* update */])({ data: data, dispatch: dispatch, product: product, currentState: currentState }, getState);
    };
}

/**
 * Change the amount of a product in the cart
 * @param product
 * @param amount
 * @returns {function(*, *)}
 */
function setProductAmount() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        product = _ref2.product,
        amount = _ref2.amount;

    return function (dispatch, getState) {
        if (!isValid(dispatch, getState, product)) {
            return;
        }

        // Limit amount to at least 0
        amount = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["d" /* limitAmount */])(amount);

        var id = product.id;


        var data = {
            product_id: id,
            amount: amount
        };

        return Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["f" /* update */])({ data: data, dispatch: dispatch, product: product, currentState: getState() }, getState);
    };
}

/**
 * Fetch the cart
 * @returns {function(*)}
 */
function fetchCart() {
    return function (dispatch, getState) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["c" /* fetch */])({ dispatch: dispatch }, getState);
    };
}

/**
 * Empty the cart
 * @returns {function(*)}
 */
function clearCart() {
    return function (dispatch, getState) {
        if (getState().cart.isEmpty) {
            return Promise.resolve();
        }

        return Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* clear */])({ dispatch: dispatch });
    };
}

/**
 * Reset the cart
 * @returns {object}
 */
function reset() {
    return { type: __WEBPACK_IMPORTED_MODULE_8__actions_types__["RESET_CART"] };
}

/**
 * Declare on which item there currently is a tooltip shown
 * This is needed to work around the stacking context, unfortunately
 * @returns {function(*)}
 */
function setTooltipId(_ref3) {
    var tooltipId = _ref3.tooltipId;

    return { type: __WEBPACK_IMPORTED_MODULE_3_reducers_actions_types__["SET_CART_TOOLTIP_ID"], tooltipId: tooltipId };
}

/**
 * Set the cart error type
 * @param {string} cartError - cart error type
 * @returns {object} - redux event
 */
function setCartError(_ref4) {
    var error = _ref4.error;

    if (error && !availableCartErrorTypes.includes(error)) {
        throw new Error('The cart error "' + error + '" is not supported. Please use one of the following errors: ' + availableCartErrorTypes.join(',') + ' ');
    }

    return { type: __WEBPACK_IMPORTED_MODULE_3_reducers_actions_types__["SET_CART_ERROR"], error: error };
}

/**
 * Clear the cart errors
 * @returns {object} - redux event
 */
function clearCartError() {
    return setCartError({ error: null });
}

/**
 * Set the mobile dragging tutorial either to true or false
 * @param {boolean} hideDraggingTutorial
 * @returns {{type: string, hideDraggingTutorial: boolean}}
 */
function setDraggingTutorial(_ref5) {
    var hideDraggingTutorial = _ref5.hideDraggingTutorial;

    return { type: __WEBPACK_IMPORTED_MODULE_3_reducers_actions_types__["SET_CART_DRAGGING_TUTORIAL"], hideDraggingTutorial: hideDraggingTutorial };
}

/**
 * Set the footer state
 * @param isFooterFixed
 * @return {{type: *, isFooterFixed: *}}
 */
function setFooterState(isFooterFixed) {
    return { type: __WEBPACK_IMPORTED_MODULE_3_reducers_actions_types__["SET_CART_FOOTER_FIXED"], isFooterFixed: isFooterFixed };
}

/**
 * Set state of footer wether it's fixed or not
 * @param {Element} child
 */
function updateFooterState(child) {
    return function (dispatch, getState) {
        var _getState = getState(),
            viewport = _getState.viewport,
            cart = _getState.cart;

        var height = viewport.height;

        var viewportMqQuery = viewport.mq.query;
        var footerFixed = viewportMqQuery === 'xs' || child.scrollHeight + FOOTER_HEIGHT_INLINE > height;

        if (footerFixed !== cart.isFooterFixed) {
            dispatch(setFooterState(footerFixed));
        }
    };
}

/**
 * Copy an order to the current cart
 * @param {string} orderId
 * @return {Function}
 */
function copyFromOrder(orderId) {
    return function (dispatch, getState) {
        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_5_constants_api_urls__["copyOrder"])(orderId)).then(function (response) {
            /** @var {ICart} */
            var cart = response.data;
            Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["e" /* setCart */])(dispatch, getState, cart);
            return cart;
        }).catch(function (e) {
            var transKey = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(e, 'data.error.trans_key');
            if (transKey) {
                throw new Error(transKey);
            }
            Object(__WEBPACK_IMPORTED_MODULE_4_reducers_helpers__["a" /* dispatchError */])(dispatch, e, {
                url: Object(__WEBPACK_IMPORTED_MODULE_5_constants_api_urls__["copyOrder"])(orderId),
                description: e
            });
            return null;
        });
    };
}

/* harmony default export */ __webpack_exports__["default"] = (Object.freeze({
    addProduct: addProduct,
    copyFromOrder: copyFromOrder,
    setCartError: setCartError,
    clearCartError: clearCartError,
    setProductAmount: setProductAmount,
    fetchCart: fetchCart,
    clearCart: clearCart,
    reset: reset,
    block: __WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* block */],
    setDraggingTutorial: setDraggingTutorial,
    setTooltipId: setTooltipId,
    updateFooterState: updateFooterState
}));

/* eslint-enable camelcase */

/***/ }),
/* 343 */,
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatProductShortDescription;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/**
 * Format the short_description for the products models
 * @param {array} strings - array containing the product description lines
 */
function formatProductShortDescription(strings) {
  var isLastString = function isLastString(index) {
    return index === strings.length - 1;
  };

  return strings.map(function (string, i) {
    return isLastString(i) ? string : [string, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", { key: "br" })];
  });
}

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_loader__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_flip_move__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_misc_random_category_icon__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_transitions_props__ = __webpack_require__(241);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var ANIMATION_DURATION = 1000;

var PageLoader = function (_PureComponent) {
    _inherits(PageLoader, _PureComponent);

    function PageLoader(props) {
        _classCallCheck(this, PageLoader);

        var _this = _possibleConstructorReturn(this, (PageLoader.__proto__ || Object.getPrototypeOf(PageLoader)).call(this, props));

        _this.updateIcon = __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function () {
            this.uid++;
            this.setState({
                currentShowingIcon: Object(__WEBPACK_IMPORTED_MODULE_6_util_misc_random_category_icon__["a" /* default */])(this.state.currentShowingIcon)
            });
        }, ANIMATION_DURATION);


        _this.uid = 0;

        _this.state = {
            currentShowingIcon: Object(__WEBPACK_IMPORTED_MODULE_6_util_misc_random_category_icon__["a" /* default */])()
        };
        return _this;
    }

    _createClass(PageLoader, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.updateIcon();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.updateIcon.cancel();
        }
    }, {
        key: 'renderIconLoader',
        value: function renderIconLoader() {
            var currentShowingIcon = this.state.currentShowingIcon;

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_flip_move__["a" /* default */],
                _extends({
                    className: 'page-loader--swiped',
                    duration: ANIMATION_DURATION,
                    easing: __WEBPACK_IMPORTED_MODULE_7_constants_transitions_props__["f" /* pageLoaderEasingFn */],
                    onFinish: this.updateIcon.bind(this)
                }, this.moveUp),
                currentShowingIcon && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_loader__["a" /* default */], {
                    key: this.uid,
                    symbol: currentShowingIcon,
                    facet: 'icon',
                    size: 'large',
                    pulsate: false })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var useRandomIcon = this.props.useRandomIcon;


            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('page-loader', { 'page-loader--large': useRandomIcon }) },
                useRandomIcon ? this.renderIconLoader() : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_loader__["a" /* default */], null)
            );
        }
    }, {
        key: 'moveUp',
        get: function get() {
            return {
                enterAnimation: {
                    from: {
                        transform: 'translate(0, 200px)',
                        opacity: 0
                    },
                    to: {
                        transform: ''
                    }
                },
                leaveAnimation: {
                    from: {
                        transform: ''
                    },
                    to: {
                        transform: 'translate(0, -200px)',
                        opacity: 0
                    }
                }
            };
        }
    }]);

    return PageLoader;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

PageLoader.propTypes = {
    useRandomIcon: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};
PageLoader.defaultProps = {
    useRandomIcon: false
};


/* harmony default export */ __webpack_exports__["a"] = (PageLoader);

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable camelcase */
/* harmony default export */ __webpack_exports__["a"] = ({
    AMIG_CAT_BroteBacken: 'brot_backen',
    AMIG_CAT_ChipsSnacksAperos: 'chips_snacks_apero',
    AMIG_CAT_FleischFisch: 'fleisch_fisch',
    AMIG_CAT_FruechteGemuese: 'fruechte_gemuese',
    AMIG_CAT_Getraenke: 'getreanke',
    AMIG_CAT_Grundnahrungsmittel: 'grundnahrungsmittel_lebensmittel',
    AMIG_CAT_HaushaltReinigung: 'haushalt_reinigung',
    AMIG_CAT_HygieneGesundheitBaby: 'hygiene_gesundheit_baby',
    AMIG_CAT_MilchprodukteEier: 'milchprodukte',
    AMIG_CAT_MueesliCerealienBrotaufstriche: 'muesli_cerealien_brotaufstriche',
    AMIG_CAT_SchokoladenSuessigkeiten: 'schokolade_suessigkeiten',
    AMIG_DISCOUNTS: 'sale',
    default: 'fruechte_gemuese'
});
/* eslint-enable camelcase */

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CARD; });
/**
 * The names of events to be used in the `onEvent` callback
 * Between placeholders and plugins
 * @type {string}
 */
var CARD = 'card';

/***/ }),
/* 348 */,
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return enter; });
/* unused harmony export space */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return all; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_curry__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_curry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_curry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__key_codes__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stop_propagation__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prevent_default__ = __webpack_require__(306);






/**
 * Helper functions that will allow us to handle the keypress events to make our components accessible to screen readers
 * @returns {boolean}
 */
function isKeycode(keyCode, keyName, e) {
  var isValid = e.keyCode === keyCode || e.key === keyName;

  if (isValid) {
    Object(__WEBPACK_IMPORTED_MODULE_2__stop_propagation__["a" /* default */])(e);
    Object(__WEBPACK_IMPORTED_MODULE_3__prevent_default__["a" /* default */])(e);
  }

  return isValid;
};

/**
 * True if enter was pressed
 */
var enter = __WEBPACK_IMPORTED_MODULE_0_lodash_curry___default()(isKeycode)(__WEBPACK_IMPORTED_MODULE_1__key_codes__["a" /* ENTER */], __WEBPACK_IMPORTED_MODULE_1__key_codes__["b" /* ENTER_KEY_NAME */]);
/**
 * True if space was pressed
 */
var space = __WEBPACK_IMPORTED_MODULE_0_lodash_curry___default()(isKeycode)(__WEBPACK_IMPORTED_MODULE_1__key_codes__["d" /* SPACE */], __WEBPACK_IMPORTED_MODULE_1__key_codes__["e" /* SPACE_KEY_NAME */]);

/**
 * True if space or enter was pressed pressed
 */
var all = function all(e) {
  return [enter, space].some(function (f) {
    return f(e);
  });
};

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_loader__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_redux__ = __webpack_require__(172);






var SearchPanelHeader = function SearchPanelHeader(_ref) {
    var title = _ref.title,
        isSearching = _ref.isSearching,
        isLoading = _ref.isLoading;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'grid--row search-panel-header' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'grid--col' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h1',
                { className: 'search-panel-header--title u-reset' },
                title
            )
        ),
        isSearching || isLoading ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'grid--col' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_loader__["a" /* default */], { size: 'small' })
        ) : null
    );
};

SearchPanelHeader.propTypes = {
    title: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    isSearching: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    isLoading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
};

SearchPanelHeader.defaultProps = {
    isLoading: false
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_4_util_redux__["b" /* default */].mapStateToProps({
    isSearching: 'search.isSearching'
}), __WEBPACK_IMPORTED_MODULE_4_util_redux__["b" /* default */].mapDispatchToProps({}))(SearchPanelHeader));

/***/ }),
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findCategoryByProp;
/* harmony export (immutable) */ __webpack_exports__["b"] = getMainCategorySlug;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tree_model__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tree_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tree_model__);
/**
 * Some helper functions useful to parse the category state
 **/



var tree = new __WEBPACK_IMPORTED_MODULE_0_tree_model___default.a();

/**
 * Tree traverse function to get a category by looking up the value of one of its properties
 * @param {ICategory[]} categories - category where we want to start the search
 * @param {string|number} propValue - value of the property we want to use to find a certain category
 * @param {string} propName - a specific category key, if it's undefined we will assume you want to use the id
 * @return {ICategory}
 */
function findCategoryByProp(categories, propValue) {
  var propName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';

  var root = { type: 'root', children: categories };
  var node = tree.parse(root).first(function (n) {
    return !n.isRoot() && n.model[propName] === propValue;
  });
  return node ? node.model : null;
}

/**
 * Get the main category slug
 * @param {ISlugParams} params
 * @returns {string}
 */
function getMainCategorySlug(params) {
  var level2 = params.level2 ? '/' + params.level2 : '';
  return '' + params.level1 + level2;
}

/***/ }),
/* 396 */,
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(928);



/* harmony default export */ __webpack_exports__["default"] = ({
    add: function add(_ref) {
        var notification = _ref.notification;

        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["ADD_NOTIFICATION"], notification: notification };
    },
    remove: function remove(_ref2) {
        var notification = _ref2.notification;

        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["REMOVE_NOTIFICATION"], notification: notification };
    },
    reset: function reset() {
        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["RESET_NOTIFICATIONS"] };
    },
    set: function set(_ref3) {
        var notifications = _ref3.notifications;

        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_NOTIFICATIONS"], items: notifications };
    },

    fetch: __WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* fetch */]
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reducers_modules_viewport_actions__ = __webpack_require__(532);



/* harmony default export */ __webpack_exports__["default"] = (Object.freeze({
    /**
     * Locking scroll
     * @param {boolean} hasOverlay
     * @return {Function}
     */
    lock: function lock(hasOverlay) {
        return function (dispatch) {
            if (hasOverlay !== false) {
                dispatch(__WEBPACK_IMPORTED_MODULE_1_reducers_modules_viewport_actions__["default"].setOverlay({ hasOverlay: true }));
            }
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["LOCK_SCROLL"] });
        };
    },


    /**
     * Unlock scroll
     * @return {Function}
     */
    unlock: function unlock() {
        return function (dispatch) {
            dispatch(__WEBPACK_IMPORTED_MODULE_1_reducers_modules_viewport_actions__["default"].setOverlay({ hasOverlay: false }));
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["UNLOCK_SCROLL"] });
        };
    },


    /**
     * Set pending autoscroll
     * @param {boolean} mustAutoscroll
     */
    setPendingAutoscroll: function setPendingAutoscroll(_ref) {
        var mustAutoscroll = _ref.mustAutoscroll;

        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_PENDING_AUTOSCROLL"], mustAutoscroll: mustAutoscroll };
    }
}));

/***/ }),
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = update;
/* harmony export (immutable) */ __webpack_exports__["e"] = setCart;
/* harmony export (immutable) */ __webpack_exports__["c"] = fetch;
/* harmony export (immutable) */ __webpack_exports__["b"] = clear;
/* harmony export (immutable) */ __webpack_exports__["a"] = block;
/* harmony export (immutable) */ __webpack_exports__["d"] = limitAmount;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_curry__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_curry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_curry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_misc_log_error__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reducers_helpers__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_cart__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tracking__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_api_urls__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_misc_products_factory_middleware__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util_misc_promises_sequencer__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_constants_order_states__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_debug_promotion_code_logger__ = __webpack_require__(418);

















/* eslint-disable camelcase */

// array that will contain all the product ids queued waiting for an updata
var productsUpdatingIDs = [];

/**
 * Callback triggered when all the products updates are done
 * @returns {Array} - cart items
 */
function onUpdateDone(_ref, res) {
    var getState = _ref.getState,
        dispatch = _ref.dispatch;

    var state = getState();
    productsUpdatingIDs.shift();

    if (!productsUpdatingIDs.length && state.cart.isFetching) {
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_IS_FETCHING_CART"], fetchingId: null, isFetching: false });
    }

    return res;
}

/**
 * Callback called when a product update event goes wrong
 * @param {function} dispatch
 * @param {string} fetchingId
 * @param {function} getState
 * @param {Error} e
 * @returns {Promise} - refetch the cart
 */
function onUpdateError(_ref2, e) {
    var dispatch = _ref2.dispatch,
        fetchingId = _ref2.fetchingId,
        getState = _ref2.getState;

    if (!productsUpdatingIDs.length) {
        return Promise.resolve();
    }

    // clear the queue
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_CART_PRODUCT_ERROR"], error: { fetchingId: fetchingId, exception: e } });
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_IS_FETCHING_CART"], fetchingId: null, isFetching: false });
    productsUpdatingIDs.splice(0, productsUpdatingIDs.length);

    if (e.status && ![400, 404].includes(e.status)) {
        Object(__WEBPACK_IMPORTED_MODULE_4_reducers_helpers__["a" /* dispatchError */])(dispatch, e, {
            url: Object(__WEBPACK_IMPORTED_MODULE_7_constants_api_urls__["cartItems"])(),
            reloadButton: true,
            description: e.statusText
        });
    } else {
        Object(__WEBPACK_IMPORTED_MODULE_4_reducers_helpers__["a" /* dispatchError */])(dispatch, e, {
            url: Object(__WEBPACK_IMPORTED_MODULE_7_constants_api_urls__["cartItems"])(),
            reloadButton: true,
            description: e.message
        });
    }

    return fetch({ dispatch: dispatch }, getState);
}

/**
 * Update the current cart on the server
 * @param {IUpdateData} data - The update to be performed
 * @param {function} dispatch - The action dispatcher
 * @param {Product} product
 * @param {object} currentState
 * @param {function} getState
 * @returns {number} - The new orderId (if it was not yet defined before)
 */
function update(_ref3, getState) {
    var data = _ref3.data,
        dispatch = _ref3.dispatch,
        product = _ref3.product,
        currentState = _ref3.currentState;

    var fetchingId = data ? data.product_id : 0;
    var onDone = __WEBPACK_IMPORTED_MODULE_1_lodash_curry___default()(onUpdateDone)({ getState: getState, dispatch: dispatch });
    var onError = __WEBPACK_IMPORTED_MODULE_1_lodash_curry___default()(onUpdateError)({ fetchingId: fetchingId, dispatch: dispatch, getState: getState });
    var cooperative = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(getState(), 'region.active.cooperative');

    dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_CART_TEMP_ITEM"], tempItem: null }); // Clear the temp item
    productsUpdatingIDs.push(fetchingId);

    Object(__WEBPACK_IMPORTED_MODULE_10_util_misc_promises_sequencer__["a" /* default */])(function () {
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_IS_FETCHING_CART"], fetchingId: fetchingId, isFetching: true });

        return __WEBPACK_IMPORTED_MODULE_9_axios___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_7_constants_api_urls__["cartItems"])(), data).then(function (_ref4) {
            var result = _ref4.data,
                status = _ref4.status;

            if (status > 399) {
                Object(__WEBPACK_IMPORTED_MODULE_3_util_misc_log_error__["a" /* default */])(new Error('Unable to update the cart "status=' + status + '"'));
                return [];
            }

            var _result$items = result.items,
                items = _result$items === undefined ? [] : _result$items;


            items = items.filter(function (item) {
                return item.id !== fetchingId && !productsUpdatingIDs.includes(item.id);
            }); // eslint-disable-line

            var _result$total_items_p = result.total_items_price,
                total_items_price = _result$total_items_p === undefined ? 0 : _result$total_items_p,
                _result$shipping_pric = result.shipping_price,
                shipping_price = _result$shipping_pric === undefined ? 0 : _result$shipping_pric,
                _result$estimated_cus = result.estimated_customer_price,
                estimated_customer_price = _result$estimated_cus === undefined ? 0 : _result$estimated_cus,
                _result$customer_deli = result.customer_delivery_fee,
                customer_delivery_fee = _result$customer_deli === undefined ? 0 : _result$customer_deli,
                _result$bag_informati = result.bag_information,
                bag_information = _result$bag_informati === undefined ? {} : _result$bag_informati,
                _result$promotional_c = result.promotional_code,
                promotional_code = _result$promotional_c === undefined ? null : _result$promotional_c,
                promotions = result.promotions,
                _result$address_id = result.address_id,
                address_id = _result$address_id === undefined ? null : _result$address_id,
                id = result.id,
                state = result.state;


            var oldProduct = currentState.cart.items[product.id];
            var trackingData = Object.assign({}, data, {
                amount: Math.abs(oldProduct ? oldProduct.amount - data.amount : data.amount)
            });

            if (oldProduct && oldProduct.amount > data.amount) {
                __WEBPACK_IMPORTED_MODULE_6_tracking__["a" /* default */].removeFromCart(product, trackingData);
            } else {
                __WEBPACK_IMPORTED_MODULE_6_tracking__["a" /* default */].addToCart(product, trackingData);
            }

            // Order is important here for cart counter to work correctly
            // If order is reversed, and you click the plus or minus button,
            // there will be a flicker of the old number in the amount input
            // as the products-list will pass the old product back in
            dispatch({
                type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["REPLACE_CART"],
                items: items.map(function (item) {
                    //eslint-disable-line
                    item.product = Object(__WEBPACK_IMPORTED_MODULE_8_util_misc_products_factory_middleware__["b" /* productFactoryMiddleware */])(item.product, { cooperative: cooperative });
                    return item;
                }),
                id: id,
                state: state,
                customerDeliveryFee: customer_delivery_fee,
                estimatedCustomerPrice: estimated_customer_price,
                shippingPrice: shipping_price,
                totalItemsPrice: total_items_price,
                bagInfo: bag_information,
                promotionalCode: promotional_code,
                promotions: promotions
            });

            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_ORDER_ADDRESS"], addressId: address_id });
            return result;
        });
    }).then(onDone, onError);
}

/**
 * Set a new cart
 * @param {function} dispatch
 * @param {function} getState
 * @param {ICart} cart
 */
function setCart(dispatch, getState, cart) {
    var cooperative = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(getState(), 'region.active.cooperative');
    var _cart$items = cart.items,
        items = _cart$items === undefined ? [] : _cart$items,
        _cart$total_items_pri = cart.total_items_price,
        total_items_price = _cart$total_items_pri === undefined ? 0 : _cart$total_items_pri,
        _cart$shipping_price = cart.shipping_price,
        shipping_price = _cart$shipping_price === undefined ? 0 : _cart$shipping_price,
        _cart$estimated_custo = cart.estimated_customer_price,
        estimated_customer_price = _cart$estimated_custo === undefined ? 0 : _cart$estimated_custo,
        _cart$customer_delive = cart.customer_delivery_fee,
        customer_delivery_fee = _cart$customer_delive === undefined ? 0 : _cart$customer_delive,
        _cart$bag_information = cart.bag_information,
        bag_information = _cart$bag_information === undefined ? {} : _cart$bag_information,
        promotions = cart.promotions,
        _cart$promotional_cod = cart.promotional_code,
        promotional_code = _cart$promotional_cod === undefined ? null : _cart$promotional_cod,
        id = cart.id,
        state = cart.state;


    if (state === __WEBPACK_IMPORTED_MODULE_11_constants_order_states__["f" /* OPEN */]) {
        dispatch({
            type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["REPLACE_CART"],
            items: items.map(function (item) {
                //eslint-disable-line
                item.product = Object(__WEBPACK_IMPORTED_MODULE_8_util_misc_products_factory_middleware__["b" /* productFactoryMiddleware */])(item.product, { cooperative: cooperative });
                return item;
            }),
            id: id,
            state: state,
            customerDeliveryFee: customer_delivery_fee,
            estimatedCustomerPrice: estimated_customer_price,
            shippingPrice: shipping_price,
            totalItemsPrice: total_items_price,
            bagInfo: bag_information,
            promotionalCode: promotional_code,
            promotions: promotions
        });
    } else {
        dispatch(block({ state: state, id: id }));
    }
}

/**
 * Fetch the current cart from the server
 * @param {function} dispatch - The action dispatcher
 * @param {function} getState - Get state function
 * @returns {number} - The new orderId (if it was not yet defined before)
 */
function fetch(_ref5, getState) {
    var dispatch = _ref5.dispatch;

    dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_IS_FETCHING_CART"], isFetching: true });

    return __WEBPACK_IMPORTED_MODULE_9_axios___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_7_constants_api_urls__["cart"])()).then(function (_ref6) {
        var result = _ref6.data,
            status = _ref6.status;

        if (status > 399) {
            Object(__WEBPACK_IMPORTED_MODULE_3_util_misc_log_error__["a" /* default */])(new Error('Unable to fetch the cart items "status=' + status + '"'));
        }

        Object(__WEBPACK_IMPORTED_MODULE_12__util_debug_promotion_code_logger__["a" /* default */])(result, true, Object(__WEBPACK_IMPORTED_MODULE_7_constants_api_urls__["cart"])());
        setCart(dispatch, getState, result);

        var _result$address_id2 = result.address_id,
            address_id = _result$address_id2 === undefined ? null : _result$address_id2;


        dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_ORDER_ADDRESS"], addressId: address_id });
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_IS_FETCHING_CART"], fetchingId: null, isFetching: false });
    }).catch(function (e) {
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_IS_FETCHING_CART"], isFetching: false });
        // we decided that the empty cart will return the 400 or 404 codes back
        // so technically it shouldn't be an error that we want to display
        if (e.status && [400, 404].includes(e.status)) {
            // cart is blocked
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["RESET_CART"], wasFetched: true });
        } else {
            // hard error
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["RESET_CART"] });
            Object(__WEBPACK_IMPORTED_MODULE_4_reducers_helpers__["a" /* dispatchError */])(dispatch, e, {
                url: Object(__WEBPACK_IMPORTED_MODULE_7_constants_api_urls__["cartItems"])(),
                description: e.message
            });
        }
    });
}

/**
 * Clear the current cart on the server
 * @param data - The update to be performed
 * @param {function} dispatch - The action dispatcher
 * @returns {number} - The new orderId (if it was not yet defined before)
 */
function clear(_ref7) {
    var data = _ref7.data,
        dispatch = _ref7.dispatch;

    dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_IS_FETCHING_CART"], isFetching: true });

    return __WEBPACK_IMPORTED_MODULE_9_axios___default.a.delete(Object(__WEBPACK_IMPORTED_MODULE_7_constants_api_urls__["cartItems"])(), data).then(function () {
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_IS_FETCHING_CART"], isFetching: false });
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["RESET_CART"], wasFetched: true });
    }).catch(function (e) {
        Object(__WEBPACK_IMPORTED_MODULE_4_reducers_helpers__["a" /* dispatchError */])(dispatch, e, {
            url: Object(__WEBPACK_IMPORTED_MODULE_7_constants_api_urls__["cart"])(),
            description: e.message
        });

        dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_IS_FETCHING_CART"], isFetching: false });
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["RESET_CART"] });
    });
}

/**
 * Block the current cart
 * @param {string} state
 * @param {string} id
 * @return {function}
 */
function block(_ref8) {
    var state = _ref8.state,
        id = _ref8.id;

    return function (dispatch) {
        dispatch({
            type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_BLOCKED_CART"],
            id: id,
            state: state
        });
    };
}

/**
 * Limit a number to a maximum of items
 * @param {number} number
 * @return {number}
 */
function limitAmount(number) {
    return Math.max(0, Math.min(__WEBPACK_IMPORTED_MODULE_5_constants_cart__["c" /* MAX_ITEMS */], number));
}

/***/ }),
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = checkDuplicatedPromotions;
/* unused harmony export checkPromotions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniq__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_reduce__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);





/* globals Raven */

/**
 * Check if cart has multiple promotions with same code
 *
 * @param {ICart} cart
 * @param {boolean} receivedFromNetwork - determine whether the data comes from the network or the store
 * @param {string} api - API endpoint
 * @return {boolean}
 */
function checkDuplicatedPromotions(cart) {
    var receivedFromNetwork = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var api = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    if (!__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(cart, 'promotions', null)) {
        return false;
    }

    var promotions = cart.promotions;


    var hasDuplicatedPromos = checkPromotions(promotions);

    if (!hasDuplicatedPromos) {
        return false;
    }

    if (typeof Raven !== 'undefined') {
        Raven.captureException(new Error('multi-promotion-error'), {
            extra: {
                cart: cart,
                receivedFromNetwork: receivedFromNetwork,
                api: api
            }
        });
    }

    return true;
}

/**
 * Check promotion collection
 *
 * @param {Object[]} promotions
 * @return {boolean}
 */
function checkPromotions(promotions) {
    var promotionNames = __WEBPACK_IMPORTED_MODULE_1_lodash_reduce___default()(promotions, function (names, promotion) {
        names.push(promotion.code);
        return names;
    }, []);
    var uniquePromotionNames = __WEBPACK_IMPORTED_MODULE_0_lodash_uniq___default()(promotionNames);
    return uniquePromotionNames.length !== promotionNames.length;
}

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["baseurl"] = baseurl;
/**
 * Gives you what you think.. the application base url
 */
function baseurl() {
  return "/" + globals.config.language;
}

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_flip_move__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ANIMATION_DURATION = 200;

var AnimatedCounter = function (_PureComponent) {
    _inherits(AnimatedCounter, _PureComponent);

    function AnimatedCounter(props) {
        _classCallCheck(this, AnimatedCounter);

        var _this = _possibleConstructorReturn(this, (AnimatedCounter.__proto__ || Object.getPrototypeOf(AnimatedCounter)).call(this, props));

        _this.updateID = 0;

        _this.updateValue = function (amount, oldAmount) {
            _this.setState({
                isHighlighted: true,
                oldAmount: oldAmount,
                value: amount
            });
        };

        _this.state = {
            isHighlighted: false,
            oldAmount: null,
            value: [props.amount]
        };
        return _this;
    }

    _createClass(AnimatedCounter, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.amount !== this.props.amount) {
                this.updateID++;
                this.updateValue(nextProps.amount, this.props.amount);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                amount = _props.amount,
                className = _props.className,
                _onChange = _props.onChange,
                suffix = _props.suffix,
                readonly = _props.readonly,
                facet = _props.facet,
                direction = _props.direction,
                ariaLabel = _props.ariaLabel,
                onFinish = _props.onFinish;
            var _state = this.state,
                value = _state.value,
                isHighlighted = _state.isHighlighted,
                oldAmount = _state.oldAmount;


            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('animated-counter', 'animated-counter__' + facet, className, {
                        'animated-counter__is-highlighted': isHighlighted
                    }) },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
                    'aria-label': ariaLabel,
                    readOnly: readonly,
                    className: 'animated-counter--input',
                    type: 'tel',
                    disabled: true,
                    value: amount,
                    onChange: function onChange(e) {
                        return _onChange && _onChange(e.target.value);
                    }
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_react_flip_move__["a" /* default */],
                    _extends({
                        className: 'animated-counter--animator',
                        duration: ANIMATION_DURATION,
                        onFinish: onFinish,
                        staggerDurationBy: ANIMATION_DURATION
                    }, direction === 'auto' && value > oldAmount || direction === 'up' ? this.moveUp : this.moveDown),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'animated-counter--value', key: this.updateID },
                        value,
                        suffix
                    )
                )
            );
        }
    }, {
        key: 'moveDown',
        get: function get() {
            return {
                enterAnimation: {
                    from: {
                        transform: 'translate(0, -150%)'
                    },
                    to: {
                        transform: 'translate(0, 0)'
                    }
                },
                leaveAnimation: {
                    from: {
                        transform: 'translate(0, 0)'
                    },
                    to: {
                        transform: 'translate(0, 150%)'
                    }
                }
            };
        }
    }, {
        key: 'moveUp',
        get: function get() {
            return {
                enterAnimation: {
                    from: {
                        transform: 'translate(0, 150%)'
                    },
                    to: {
                        transform: 'translate(0, 0)'
                    }
                },
                leaveAnimation: {
                    from: {
                        transform: 'translate(0, 0)'
                    },
                    to: {
                        transform: 'translate(0, -150%)'
                    }
                }
            };
        }
    }]);

    return AnimatedCounter;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

AnimatedCounter.defaultProps = {
    facet: 'base',
    direction: 'auto',
    onFinish: __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a
};
AnimatedCounter.propTypes = {
    amount: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
    onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    direction: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    facet: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    onFinish: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    ariaLabel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    suffix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    readonly: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (AnimatedCounter);

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ButtonsGroup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_button__ = __webpack_require__(187);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






function ButtonsGroup(_ref) {
    var actions = _ref.actions,
        className = _ref.className;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: className },
        Object(__WEBPACK_IMPORTED_MODULE_2_looppa__["a" /* default */])(actions)(function (_ref2, i) {
            var name = _ref2.name,
                event = _ref2.event,
                props = _objectWithoutProperties(_ref2, ['name', 'event']);

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_components_button__["a" /* default */],
                _extends({
                    key: i
                }, props, {
                    onClick: event }),
                name
            );
        })
    );
}

ButtonsGroup.propTypes = {
    className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    actions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
        event: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    })).isRequired
};

/***/ }),
/* 422 */,
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = imageDpiResolution;
var resolutions = ['data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACwAAAAAAQABAAACAkQBADs=', 'data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=', 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAAAAAA6fptVAAAACklEQVQYV2P4DwABAQEAWk1v8QAAAABJRU5ErkJggg=='];
var img = document.createElement('img');
img.src = resolutions[0];
img.srcset = resolutions.map(function (itm, i) {
    return itm + ' ' + (i + 1) + 'x';
}).join(',');

function imageDpiResolution() {
    return resolutions.indexOf(img.currentSrc || img.src) + 1;
}

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getProductPrice;
/**
 * Get the product price out of the price_information object
 * @param {object} price_information - object containing all the product price info
 * @return {string}
 */
function getProductPrice(price_information) {
  return price_information.estimated_piece_price || price_information.price;
}

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_misc_static_assets_path__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);





var ErrorImageEmpty = function ErrorImageEmpty(_ref) {
    var className = _ref.className,
        alt = _ref.alt;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: Object(__WEBPACK_IMPORTED_MODULE_2_util_misc_static_assets_path__["a" /* default */])('img/error/im-empty.png'), alt: alt, className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('error-empty', className) });
};

ErrorImageEmpty.propTypes = {
    className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    alt: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

/* harmony default export */ __webpack_exports__["a"] = (ErrorImageEmpty);

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export pluginList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_misc_log_error__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__image__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__richtext__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__divider__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__article_short__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__teaser__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__iframe__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__section__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pickers__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__title__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__payment_twint__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__countdown__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__regions__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__column_wrapper__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__video_column__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__card_stack__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__faq__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__most_purchased_cumulus__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__favorite_category__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__favorite_category_wrapper__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__faq_info__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__testimonials__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__products_slider__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__start_shopping_button__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__section_right_many__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__mymigros_sliders__ = __webpack_require__(1160);



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
































var pluginList = {
    'article-short': __WEBPACK_IMPORTED_MODULE_9__article_short__["a" /* default */],
    'card-stack': __WEBPACK_IMPORTED_MODULE_20__card_stack__["a" /* default */],
    'column-wrapper': __WEBPACK_IMPORTED_MODULE_18__column_wrapper__["a" /* default */],
    'faq-info': __WEBPACK_IMPORTED_MODULE_25__faq_info__["a" /* default */],
    'most-purchased-cumulus': __WEBPACK_IMPORTED_MODULE_22__most_purchased_cumulus__["a" /* default */],
    'payment-twint': __WEBPACK_IMPORTED_MODULE_15__payment_twint__["a" /* default */],
    'video-column': __WEBPACK_IMPORTED_MODULE_19__video_column__["a" /* default */],
    'products-slider': __WEBPACK_IMPORTED_MODULE_27__products_slider__["a" /* default */],
    'start-shopping-button': __WEBPACK_IMPORTED_MODULE_28__start_shopping_button__["a" /* default */],
    'section-right-many': __WEBPACK_IMPORTED_MODULE_29__section_right_many__["a" /* default */],
    countdown: __WEBPACK_IMPORTED_MODULE_16__countdown__["a" /* default */],
    divider: __WEBPACK_IMPORTED_MODULE_8__divider__["a" /* default */],
    faq: __WEBPACK_IMPORTED_MODULE_21__faq__["a" /* default */],
    favorite_category: __WEBPACK_IMPORTED_MODULE_23__favorite_category__["a" /* default */],
    favorite_category_wrapper: __WEBPACK_IMPORTED_MODULE_24__favorite_category_wrapper__["a" /* default */],
    iframe: __WEBPACK_IMPORTED_MODULE_11__iframe__["a" /* default */],
    image: __WEBPACK_IMPORTED_MODULE_6__image__["a" /* default */],
    pickers: __WEBPACK_IMPORTED_MODULE_13__pickers__["a" /* default */],
    regions: __WEBPACK_IMPORTED_MODULE_17__regions__["a" /* default */],
    richtext: __WEBPACK_IMPORTED_MODULE_7__richtext__["a" /* default */],
    section: __WEBPACK_IMPORTED_MODULE_12__section__["a" /* default */],
    teaser: __WEBPACK_IMPORTED_MODULE_10__teaser__["a" /* default */],
    title: __WEBPACK_IMPORTED_MODULE_14__title__["a" /* default */],
    testimonials: __WEBPACK_IMPORTED_MODULE_26__testimonials__["a" /* default */],
    'mymigros-sliders': __WEBPACK_IMPORTED_MODULE_30__mymigros_sliders__["a" /* default */]

};

var Plugin = function (_Component) {
    _inherits(Plugin, _Component);

    function Plugin() {
        _classCallCheck(this, Plugin);

        return _possibleConstructorReturn(this, (Plugin.__proto__ || Object.getPrototypeOf(Plugin)).apply(this, arguments));
    }

    _createClass(Plugin, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.isCmsEditModeEnabled) {
                this.registerToCMS();
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(_ref) {
            var content = _ref.content;

            return content !== this.props.content;
        }
    }, {
        key: 'registerToCMS',
        value: function registerToCMS() {
            if (!this.props.cms) {
                Object(__WEBPACK_IMPORTED_MODULE_5_util_misc_log_error__["a" /* default */])('It was impossible to initialise the frontend editing for the cms plugin type="' + this.props.type + '"');
                return;
            }

            var _props$cms = _slicedToArray(this.props.cms, 2),
                name = _props$cms[0],
                data = _props$cms[1];

            window.CMS.$(this.refs.root).data('cms', [data]);
            window.CMS._plugins.push([name, data]);
            new window.CMS.Plugin(name, data); // eslint-disable-line no-new
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                type = _props.type,
                content = _props.content,
                cms = _props.cms,
                plugins = _props.plugins,
                isCmsEditModeEnabled = _props.isCmsEditModeEnabled,
                index = _props.index,
                parent = _props.parent,
                onEvent = _props.onEvent;
            var facet = this.props.facet;
            var cmsDataAttrs = this.cmsDataAttrs;


            if (__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(type) || isCmsEditModeEnabled && !cmsDataAttrs['data-cms-plugin-name']) {
                return null;
            }

            if (parent.type === 'section') {
                facet = parent.sectionFacet;
            }

            if (type === 'countdown' && !facet) {
                facet = 'countdown';
            }

            if (!pluginList[type]) {
                Object(__WEBPACK_IMPORTED_MODULE_5_util_misc_log_error__["a" /* default */])('The plugin "' + type + '" has no frontend template, it was not possible to render it');
                return null;
            }

            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                _extends({ ref: 'root'
                }, cmsDataAttrs, {
                    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('cms-placeholder--plugin', cms ? cms[0] : null, 'cms-plugin', 'cms-placeholder--plugin__' + type, {
                        'cms-placeholder--plugin__is-blocked': isCmsEditModeEnabled
                    }) }),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(pluginList[type], _extends({}, content, { plugins: plugins, type: type, cms: cms, index: index, onEvent: onEvent, facet: facet }))
            );
        }
    }, {
        key: 'cmsDataAttrs',
        get: function get() {
            if (this.props.isCmsEditModeEnabled) {
                return {
                    'data-cms-plugin-edit-helper': true,
                    // a safer way to get the plugin name tha apparently is not always sent
                    'data-cms-plugin-name': __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this, 'props.cms[1].plugin_name')
                };
            }

            return {};
        }
    }]);

    return Plugin;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

Plugin.propTypes = {
    type: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    plugins: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,
    cms: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,
    isCmsEditModeEnabled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
    content: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
    index: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
    parent: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
    onEvent: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    facet: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (Plugin);

/***/ }),
/* 427 */,
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_dom_channeled_interactionobserver__ = __webpack_require__(308);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var LazyImage = function (_Component) {
    _inherits(LazyImage, _Component);

    function LazyImage() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, LazyImage);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LazyImage.__proto__ || Object.getPrototypeOf(LazyImage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isVisible: false
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(LazyImage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            Object(__WEBPACK_IMPORTED_MODULE_2_util_dom_channeled_interactionobserver__["a" /* register */])(this, 'lazy-image', {
                threshold: 0.05,
                rootMargin: '200px'
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            Object(__WEBPACK_IMPORTED_MODULE_2_util_dom_channeled_interactionobserver__["b" /* unregister */])(this);
        }
    }, {
        key: 'render',
        value: function render() {
            if (Array.isArray(this.props.children)) {
                debugger;
                var children = this.props.children.map(function (child, index) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, {
                        index: index
                    });
                });

                return { children: children };
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { ref: 'root' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(this.props.children, {
                    src: this.state.isVisible ? this.props.children.props['data-src'] : null,
                    'src-set': this.state.isVisible ? this.props.children.props['data-src-set'] : null
                })
            );
        }
    }]);

    return LazyImage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

LazyImage.propTypes = {
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (LazyImage);
;

/***/ }),
/* 429 */,
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_animated_counter__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_timeformat__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_page_visibility__ = __webpack_require__(431);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var TICKER_DELAY = 1000;

var Countdown = function (_PureComponent) {
    _inherits(Countdown, _PureComponent);

    _createClass(Countdown, null, [{
        key: 'renderCounter',
        value: function renderCounter(value, hasSeparator, translationPath, facet) {
            var nrToString = Math.abs(value) + ''; // eslint-disable-line
            var mustPad = nrToString.length === 1;
            var values = mustPad ? [0, nrToString[0]] : nrToString;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('countdown--display', {
                        'countdown--display__has-separator': hasSeparator
                    }) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'countdown--numbers', 'aria-hidden': 'true' },
                    Object(__WEBPACK_IMPORTED_MODULE_2_looppa__["a" /* default */])(values)(function (v, key, i) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_animated_counter__["a" /* default */], {
                            ariaLabel: Object(__WEBPACK_IMPORTED_MODULE_6_translations__["c" /* default */])(translationPath),
                            key: i,
                            direction: 'up',
                            facet: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(facet),
                            className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('countdown--number', {
                                'countdown--number__has-margin': i !== values.length - 1
                            }),
                            readonly: true,
                            amount: +v
                        });
                    }),
                    hasSeparator && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'countdown--separator' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_translations__["a" /* Trans */], { className: 'countdown--counter-description', path: translationPath })
            );
        }
    }]);

    function Countdown(props) {
        _classCallCheck(this, Countdown);

        var _this = _possibleConstructorReturn(this, (Countdown.__proto__ || Object.getPrototypeOf(Countdown)).call(this, props));

        _this.getDiff = function () {
            var diff = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(_this.deltaTime > TICKER_DELAY ? _this.deltaTime : 0);

            return {
                days: Math.floor(diff.asDays()),
                hours: diff.hours(),
                minutes: diff.minutes(),
                seconds: diff.seconds()
            };
        };

        _this.deltaTime = 0;

        _this.handleVisibilityChange = function (visibilityState) {
            var isVisible = visibilityState === 'visible';
            _this.setState({ visible: isVisible });
        };

        _this.msSinceLastTick = 0;

        _this.parseProps = function (_ref) {
            var endDate = _ref.endDate,
                startDate = _ref.startDate;

            startDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(startDate);
            endDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(endDate);
            _this.deltaTime = endDate.diff(startDate);
            return { startDate: startDate, endDate: endDate };
        };

        _this.stop = function () {
            cancelAnimationFrame(_this.rAF);
            clearTimeout(_this.timer);
        };

        _this.tick = function (immediate) {
            _this.msSinceLastTick = __WEBPACK_IMPORTED_MODULE_1_moment___default()(); // cache the last tick start

            _this.rAF = requestAnimationFrame(function () {
                _this.timer = setTimeout(function () {
                    _this.deltaTime = _this.deltaTime - (__WEBPACK_IMPORTED_MODULE_1_moment___default()() - _this.msSinceLastTick);
                    _this.updateDiff();
                    if (_this.deltaTime > 0) {
                        _this.tick();
                    } else if (!_this.wasCallbackCalled) {
                        _this.wasCallbackCalled = true;
                        _this.props.callback && _this.props.callback();
                    }
                }, immediate ? 0 : TICKER_DELAY);
            });
        };

        _this.timer = null;
        _this.wasCallbackCalled = false;

        _this.updateDiff = function () {
            _this.setState(_this.getDiff());
        };

        _this.updateTimer = function () {
            var startDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1_moment___default()();
            var endDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.endDate;

            _this.stop();

            var newState = _this.parseProps({
                startDate: startDate,
                endDate: endDate
            });

            _this.setState(newState, function () {
                return _this.tick(true);
            });
        };

        _this.state = _this.parseProps(props);
        Object.assign(_this.state, _this.getDiff(), { visible: true }); // extend the initial state adding the diffing time result

        _this.tick(true);
        return _this;
    }

    _createClass(Countdown, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref2) {
            var endDate = _ref2.endDate,
                mustFreeze = _ref2.mustFreeze,
                startDate = _ref2.startDate;

            if (mustFreeze) {
                this.stop();
                return;
            }

            if (this.props.endDate !== endDate || this.props.startDate !== startDate) {
                this.updateTimer(startDate, endDate);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.stop();
        }

        /**
         * Generate the diff time object used to update the counter displays
         * @returns {{days: number, hours: number, minutes: number, seconds: number}}
         */


        // countdown delta


        // cache the milliseconds offset on each timer update


        /**
         * Parse the component immutable props to generate the proper mutable component state counterpart
         * @param {*} endDate  - any valid moment js date
         * @param {*} startDate - any valid moment js date
         * @returns {{endDate: (*|moment.Moment), startDate: (*|moment.Moment)}}
         */


        /**
         * Stop the ticks to restart maybe them afterwords
         */


        /**
         * Loop function that will be triggered every second to update the countdown numbers
         * @param {*} immediate  - Trigger a tick in the next event loop tick (less delayed)
         */


        // timer id that will be paired with to the setTimeout method


        /**
         * It should be triggered on any tick to update the displays values
         */


        /**
         * Invoke an immediate tick after updating and stopping the current timer
         */

    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                days = _state.days,
                hours = _state.hours,
                minutes = _state.minutes,
                seconds = _state.seconds,
                visible = _state.visible;
            var _props = this.props,
                label = _props.label,
                rootFacet = _props.rootFacet;

            var inputValue = __WEBPACK_IMPORTED_MODULE_1_moment___default()().add(this.deltaTime).format(__WEBPACK_IMPORTED_MODULE_7_constants_timeformat__["b" /* DATETIME_LOCAL_MILLIS */]);

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_components_page_visibility__["a" /* default */],
                { onChange: this.handleVisibilityChange },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('countdown', 'countdown__' + rootFacet) },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'datetime-local', className: 'countdown--hidden-input', 'aria-label': label,
                        'aria-readonly': 'true', readOnly: true,
                        value: inputValue }),
                    visible && days ? Countdown.renderCounter(days, true, 'countdown.days', this.props.facet) : null,
                    visible && Countdown.renderCounter(hours, true, 'countdown.hours', this.props.facet),
                    visible && Countdown.renderCounter(minutes, true, 'countdown.minutes', this.props.facet),
                    visible && Countdown.renderCounter(seconds, false, 'countdown.seconds', this.props.facet)
                )
            );
        }
    }]);

    return Countdown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Countdown.propTypes = {
    label: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    mustFreeze: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
    endDate: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
    startDate: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
    callback: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, // Is called when the countdown is done
    rootFacet: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    facet: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};
Countdown.defaultProps = {
    label: '',
    rootFacet: 'base'
};
/* harmony default export */ __webpack_exports__["a"] = (Countdown);

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bianco_events__ = __webpack_require__(53);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var subscriptions = new Set();

Object(__WEBPACK_IMPORTED_MODULE_3_bianco_events__["a" /* add */])(document, 'visibilitychange', function () {
    subscriptions.forEach(function (cmp) {
        cmp.props.onChange(document.visibilityState, document.hidden);
    });
});

var PageVisibility = function (_PureComponent) {
    _inherits(PageVisibility, _PureComponent);

    function PageVisibility() {
        _classCallCheck(this, PageVisibility);

        return _possibleConstructorReturn(this, (PageVisibility.__proto__ || Object.getPrototypeOf(PageVisibility)).apply(this, arguments));
    }

    _createClass(PageVisibility, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            subscriptions.add(this);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            subscriptions.delete(this);
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
        }
    }]);

    return PageVisibility;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

PageVisibility.defaultProps = {
    onChange: __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a
};
PageVisibility.propTypes = {
    onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]).isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (PageVisibility);

/***/ }),
/* 432 */,
/* 433 */,
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ProductsSliderHeader;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_main_title__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_misc_normalise_trailing_slash__ = __webpack_require__(196);








function ProductsSliderHeader(_ref) {
    var title = _ref.title,
        link = _ref.link,
        _ref$link_label_key = _ref.link_label_key,
        link_label_key = _ref$link_label_key === undefined ? 'categories.all' : _ref$link_label_key;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'header',
        { className: 'products-slider-header' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_main_title__["a" /* default */], { className: 'main-title', text: title }),
        link !== null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],
            {
                className: 'products-slider-header--show-all u-reset',
                to: Object(__WEBPACK_IMPORTED_MODULE_6_util_misc_normalise_trailing_slash__["a" /* default */])(link)
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_translations__["a" /* Trans */], { path: link_label_key }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_icon__["a" /* default */], { symbol: 'chevron-right', size: 'small' })
        )
    );
}
ProductsSliderHeader.propTypes = {
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    link: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    link_label_key: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = MainTitle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



function MainTitle(_ref) {
    var text = _ref.text,
        className = _ref.className,
        tag = _ref.tag;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(tag, { className: 'main-title ' + className }, text);
}

MainTitle.propTypes = {
    className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

MainTitle.defaultProps = {
    className: '',
    tag: 'h1'
};

/***/ }),
/* 436 */,
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_tracking_constants__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_product_tile__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_slider__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__slider_config__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_products_slider_header__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_util_dom_mq__ = __webpack_require__(249);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var ProductsSlider = function (_PureComponent) {
    _inherits(ProductsSlider, _PureComponent);

    function ProductsSlider() {
        _classCallCheck(this, ProductsSlider);

        return _possibleConstructorReturn(this, (ProductsSlider.__proto__ || Object.getPrototypeOf(ProductsSlider)).apply(this, arguments));
    }

    _createClass(ProductsSlider, [{
        key: 'numberOfItems',


        /**
         * Calculate the amount of empty slots to fill the slider
         *
         * @param {number} maxItems
         * @param {number} amountPerRow
         * @return {number}
         */
        value: function numberOfItems(maxItems, amountPerRow) {
            var promotionalTileOffset = this.props.promotionalTile ? 1 : 0;
            return amountPerRow - maxItems % amountPerRow - promotionalTileOffset;
        }

        /**
         * Get list of products including fake ones to fill the slider
         *
         * @return {Array<IProduct | null>}
         */

    }, {
        key: 'renderPromotionalTile',
        value: function renderPromotionalTile() {
            var _props = this.props,
                link = _props.link,
                isMobile = _props.isMobile,
                historyPush = _props.historyPush,
                promotionalTile = _props.promotionalTile,
                link_label_key = _props.link_label_key;

            if (!promotionalTile || !link) {
                return null;
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'article',
                {
                    onClick: function onClick() {
                        // on mobile the whole tile surface should be a link
                        if (isMobile) {
                            historyPush(link);
                        }
                    },
                    className: 'products-slider--show-promotions',
                    key: 'show-promotions'
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],
                    { to: link, className: 'products-slider--show-promotions-text u-reset' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_translations__["a" /* Trans */], { path: link_label_key ? link_label_key : 'categories.show_all' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],
                    { to: link, className: 'products-slider--show-promotions-icon u-reset' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_icon__["a" /* default */], { symbol: 'productslider-right', size: 'medium' })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                title = _props2.title,
                link = _props2.link,
                slug = _props2.slug,
                isMobile = _props2.isMobile,
                skipTests = _props2.skipTests,
                isTouch = _props2.isTouch,
                isTablet = _props2.isTablet,
                promotionalTile = _props2.promotionalTile,
                link_label_key = _props2.link_label_key,
                header_link_label_key = _props2.header_link_label_key;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'products-slider' },
                title && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_products_slider_header__["a" /* default */], { title: title, link: link, link_label_key: header_link_label_key || link_label_key }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_9_components_slider__["a" /* default */],
                    {
                        useNativeScroll: isMobile || isTablet && isTouch,
                        facet: 'products-slider',
                        config: __WEBPACK_IMPORTED_MODULE_11__slider_config__["a" /* default */] },
                    Object(__WEBPACK_IMPORTED_MODULE_3_looppa__["a" /* default */])(this.trimmedProducts)(function (product, index) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_product_tile__["a" /* default */], _extends({
                            basePath: slug
                        }, product, {
                            position: index,
                            skipTests: skipTests,
                            facet: product ? 'overview' : 'placeholder',
                            list: __WEBPACK_IMPORTED_MODULE_7_tracking_constants__["g" /* PRODUCT_LIST_PRODUCT_SLIDER */],
                            key: product && product.id ? product.id : index }));
                    }).concat(promotionalTile && link ? [this.renderPromotionalTile()] : [])
                )
            );
        }
    }, {
        key: 'trimmedProducts',
        get: function get() {
            var _props3 = this.props,
                products = _props3.products,
                promotionalTile = _props3.promotionalTile;

            // Render a maximum of 4 rows in slider; row-size depends on the current viewport

            var amountPerRow = __WEBPACK_IMPORTED_MODULE_11__slider_config__["b" /* productTileAmounts */][Object(__WEBPACK_IMPORTED_MODULE_13_util_dom_mq__["a" /* getViewportData */])().query];
            var maxItems = Math.min(amountPerRow * 4 - 1, products.length);
            var promotionalTileOffset = promotionalTile ? 1 : 0;

            // Add placeholders if there are not enough items to fill one row
            if (products.length < amountPerRow - promotionalTileOffset) {
                var numberOfItems = this.numberOfItems(maxItems, amountPerRow);
                var placeholders = Array(numberOfItems).fill(null);
                products = products.slice(0, maxItems).concat(placeholders);
            }

            return products;
        }
    }]);

    return ProductsSlider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

ProductsSlider.propTypes = {
    slug: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    link_label_key: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    header_link_label_key: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    title: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    skipTests: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    promotionalTile: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    link: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    products: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,
    historyPush: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    isMobile: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    isTablet: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    isTouch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    viewportMqWidth: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired
};
ProductsSlider.defaultProps = {
    promotionalTile: true,
    header_link_label_key: null,
    link: null
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_4_util_redux__["b" /* default */].mapStateToProps({
    viewportMqWidth: 'viewport.mq.width',
    isMobile: 'viewport.isMobile',
    isTablet: 'viewport.isTablet',
    isTouch: 'viewport.touchevents',
    historyPush: 'router.history.push'
}))(ProductsSlider));

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_misc_static_assets_path__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_translations__ = __webpack_require__(171);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ActionTeaser = function (_Component) {
    _inherits(ActionTeaser, _Component);

    function ActionTeaser() {
        _classCallCheck(this, ActionTeaser);

        return _possibleConstructorReturn(this, (ActionTeaser.__proto__ || Object.getPrototypeOf(ActionTeaser)).apply(this, arguments));
    }

    _createClass(ActionTeaser, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                imagePath = _props.imagePath,
                titleTranslationKey = _props.titleTranslationKey,
                descriptionTranslationKey = _props.descriptionTranslationKey,
                children = _props.children;

            var image = Object(__WEBPACK_IMPORTED_MODULE_2_util_misc_static_assets_path__["a" /* default */])(imagePath);

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'action-teaser grid' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'action-teaser--row grid--row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'action-teaser--image-col grid--col' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'action-teaser--image', src: image })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'action-teaser--content-col grid--col' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'action-teaser--content-wrapper' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'h2',
                                { className: 'u-reset action-teaser--title' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_translations__["a" /* Trans */], { path: titleTranslationKey })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'p',
                                { className: 'action-teaser--description' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_translations__["a" /* Trans */], { path: descriptionTranslationKey })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'action-teaser--btn-wrapper ' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'action-teaser--btn' },
                                    children
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return ActionTeaser;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ActionTeaser.propTypes = {
    imagePath: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    titleTranslationKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    descriptionTranslationKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (ActionTeaser);

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ContactInfo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_translations__ = __webpack_require__(171);




function ContactInfo(_ref) {
    var tabIndex = _ref.tabIndex;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'article',
        { className: 'contact-info' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            { className: 'contact-info--title u-reset' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_translations__["a" /* Trans */], { path: 'contact.title' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'contact-info--link' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'u-reset', tabIndex: tabIndex, href: 'mailto:' + Object(__WEBPACK_IMPORTED_MODULE_2_translations__["c" /* default */])('amigos.mails.info') },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_translations__["a" /* Trans */], {
                    path: 'amigos.mails.info' })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'contact-info--text',
            dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_2_translations__["d" /* format */])('contact.text') } })
    );
};

ContactInfo.propTypes = {
    tabIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};

ContactInfo.defaultProps = {
    tabIndex: 0
};

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_redux__ = __webpack_require__(172);






var NoSearchHits = function NoSearchHits(_ref) {
    var isSearching = _ref.isSearching;

    if (isSearching) {
        return null;
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'search-panel-no-hits' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_translations__["a" /* Trans */], { path: 'search.no_hits' })
    );
};

NoSearchHits.propTypes = {
    isSearching: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_4_util_redux__["b" /* default */].mapStateToProps({
    isSearching: 'search.isSearching'
}), __WEBPACK_IMPORTED_MODULE_4_util_redux__["b" /* default */].mapDispatchToProps({}))(NoSearchHits));

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_product_info_card__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_buy_box__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_brands_list__ = __webpack_require__(604);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable camelcase */







var ProductDetailsPanel = function (_PureComponent) {
    _inherits(ProductDetailsPanel, _PureComponent);

    function ProductDetailsPanel() {
        _classCallCheck(this, ProductDetailsPanel);

        return _possibleConstructorReturn(this, (ProductDetailsPanel.__proto__ || Object.getPrototypeOf(ProductDetailsPanel)).apply(this, arguments));
    }

    _createClass(ProductDetailsPanel, [{
        key: 'render',
        value: function render() {
            var product = this.props.product;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'section',
                { className: 'product-details-panel grid grid__base' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'grid--container' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_product_info_card__["a" /* default */], product)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_buy_box__["a" /* default */], { product: product }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'grid--container' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_brands_list__["a" /* default */], { brands: product.brands })
                )
            );
        }
    }]);

    return ProductDetailsPanel;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

ProductDetailsPanel.propTypes = {
    product: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ProductDetailsPanel);

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_button__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_loader__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_cart__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_constants_cart__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_util_dom_handle_accessible_key_events__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_form_form_field_select__ = __webpack_require__(443);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var MORE_VALUE = 'more';
var REMOVE_VALUE = 'remove';

var BuyBox = function (_Component) {
    _inherits(BuyBox, _Component);

    function BuyBox() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, BuyBox);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BuyBox.__proto__ || Object.getPrototypeOf(BuyBox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isReady: !!window.styleguide,
            amount: 1,
            autoFocus: false,
            pendingSelectShow: false,
            showSelect: false
        }, _this.onButtonClick = function () {
            var _this$props = _this.props,
                product = _this$props.product,
                onBought = _this$props.onBought;
            var amount = _this.state.amount;

            _this.props.setProductAmount({ product: product, amount: amount });

            if (_this.props.activeRegion) {
                _this.setState({ pendingSelectShow: true });
            }

            onBought();
        }, _this.onChange = function (e) {
            var value = +e.currentTarget.value;

            if (typeof value === 'number' && value >= 0) {
                _this.setState({ amount: value });
            }
        }, _this.onSelectChange = function (value) {
            var onBought = _this.props.onBought;


            switch (value) {
                case REMOVE_VALUE:
                    _this.removeProduct();
                    break;
                case MORE_VALUE:
                    _this.setState({
                        amount: null,
                        showSelect: false,
                        autoFocus: true
                    });
                    break;
                default:
                    _this.props.setProductAmount({ product: _this.props.product, amount: +value });
            }

            onBought();
        }, _this.decrease = function () {
            if (_this.state.amount > 0) {
                _this.setState({ amount: _this.state.amount - 1 });
            }
        }, _this.increase = function () {
            _this.setState({ amount: _this.state.amount + 1 });
        }, _this.removeProduct = function () {
            var _this$props2 = _this.props,
                fetchingId = _this$props2.fetchingId,
                product = _this$props2.product,
                onBought = _this$props2.onBought,
                setProductAmount = _this$props2.setProductAmount;

            var isLoading = fetchingId === product.id;

            if (isLoading) {
                return;
            }

            setProductAmount({ product: product, amount: 0 });
            _this.setState({ showSelect: false });
            onBought();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(BuyBox, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.syncAmount(this.props);
            this.setReadyState(this.props);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.syncAmount(nextProps);

            if (this.state.pendingSelectShow && !nextProps.isFetching || !this.props.items[this.props.product.id] && nextProps.items[this.props.product.id]) {
                this.setState({ pendingSelectShow: false, showSelect: true });
            }

            this.setReadyState(nextProps);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.state.autoFocus) {
                this.refs.input.focus();
                this.setState({ autoFocus: false });
            }
        }
    }, {
        key: 'setReadyState',
        value: function setReadyState(props) {
            // toggle the select on init
            if (props.isCartReady && !this.state.isReady) {
                this.setState({
                    showSelect: props.items[props.product.id],
                    isReady: true
                });
            }
        }
    }, {
        key: 'openCart',
        value: function openCart() {
            this.props.togglePanel({ facet: 'cart', content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_cart__["a" /* default */], null) });
        }
    }, {
        key: 'syncAmount',
        value: function syncAmount(_ref2) {
            var items = _ref2.items,
                product = _ref2.product;

            var cartItem = items[product.id];
            var oldCartItem = this.props.items[product.id];
            var amount = cartItem ? cartItem.amount : this.state.amount;

            if (!cartItem && this.state.showSelect) {
                this.setState({ showSelect: false, amount: 1 });
            } else if (!oldCartItem || !cartItem || oldCartItem.amount !== cartItem.amount) {
                this.setState({ amount: amount });
            }
        }
    }, {
        key: 'renderFooterComponents',
        value: function renderFooterComponents() {
            var _this2 = this;

            var showSelect = this.state.showSelect;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('buy-box--footer', { 'buy-box--footer__has-select': showSelect }) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_components_button__["a" /* default */],
                    { onClick: function onClick() {
                            return _this2.openCart();
                        },
                        className: 'buy-box--link-to-cart u-reset' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_translations__["a" /* Trans */], { path: 'buy_box.to_cart' })
                )
            );
        }
    }, {
        key: 'renderHeaderComponents',
        value: function renderHeaderComponents() {
            var _this3 = this;

            var _props = this.props,
                fetchingId = _props.fetchingId,
                product = _props.product,
                items = _props.items;
            var _state = this.state,
                amount = _state.amount,
                showSelect = _state.showSelect;

            var isLoading = fetchingId === product.id;
            var selectOptions = this.selectOptions;
            var selectedOption = items[product.id] ? selectOptions.find(function (_ref3) {
                var value = _ref3.value;
                return value === String(items[product.id].amount);
            }) : null;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('buy-box--header', { 'buy-box--header__has-select': showSelect }) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'buy-box--header-content' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { 'aria-hidden': showSelect, className: 'buy-box--panel' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_components_button__["a" /* default */],
                            { onClick: this.decrease, className: 'buy-box--lateral-button',
                                'aria-label': Object(__WEBPACK_IMPORTED_MODULE_9_translations__["c" /* default */])('accessibility.label.remove_one', {
                                    product_name: product.name
                                }) },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_icon__["a" /* default */], { symbol: 'basket-remove', size: 'large' })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'buy-box--form-field' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { 'aria-label': Object(__WEBPACK_IMPORTED_MODULE_9_translations__["c" /* default */])('accessibility.label.product_count'), ref: 'input',
                                onKeyUp: function onKeyUp(e) {
                                    return Object(__WEBPACK_IMPORTED_MODULE_11_util_dom_handle_accessible_key_events__["a" /* all */])(e) && amount && _this3.onButtonClick();
                                },
                                className: 'buy-box--input', max: __WEBPACK_IMPORTED_MODULE_10_constants_cart__["c" /* MAX_ITEMS */], type: 'number',
                                onChange: this.onChange,
                                value: amount ? amount.toFixed(0) : '' })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_components_button__["a" /* default */],
                            { onClick: this.increase, className: 'buy-box--lateral-button',
                                'aria-label': Object(__WEBPACK_IMPORTED_MODULE_9_translations__["c" /* default */])('accessibility.label.add_to_cart', {
                                    product_name: product.name
                                }) },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_icon__["a" /* default */], { symbol: 'basket-add', size: 'large' })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'buy-box--elevator' },
                        showSelect ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'buy-box--select-wrapper' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_form_form_field_select__["a" /* default */], {
                                onInput: this.onSelectChange,
                                value: selectedOption ? selectedOption.value : selectOptions[0].value,
                                facet: 'buybox',
                                items: selectOptions }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_5_components_button__["a" /* default */],
                                {
                                    'aria-label': Object(__WEBPACK_IMPORTED_MODULE_9_translations__["c" /* default */])('accessibility.label.delete_product'),
                                    facet: 'primary',
                                    className: 'buy-box--delete-button',
                                    hasFocus: isLoading,
                                    onClick: this.removeProduct },
                                isLoading ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_loader__["a" /* default */], { size: 'small' }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_icon__["a" /* default */], { symbol: 'trash', size: 'medium' })
                            )
                        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_5_components_button__["a" /* default */],
                            {
                                'aria-label': Object(__WEBPACK_IMPORTED_MODULE_9_translations__["c" /* default */])('accessibility.label.add_to_cart', {
                                    product_name: product.name
                                }),
                                disabled: !amount,
                                onClick: this.onButtonClick,
                                className: 'buy-box--add-to-cart u-reset',
                                size: 'large',
                                facet: 'primary' },
                            fetchingId ? '' : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'buy-box--button-text' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_translations__["a" /* Trans */], { path: 'cart.add_to_cart' })
                            ),
                            fetchingId === product.id ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'buy-box--button-loader' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_loader__["a" /* default */], { size: 'small' })
                            ) : null
                        )
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var isReady = this.state.isReady;


            if (!isReady) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_loader__["a" /* default */], null);
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('buy-box', 'buy-box__' + this.props.facet) },
                this.renderHeaderComponents(),
                this.renderFooterComponents()
            );
        }
    }, {
        key: 'selectOptions',
        get: function get() {
            var _props2 = this.props,
                product = _props2.product,
                items = _props2.items;

            var amount = items[product.id] ? items[product.id].amount : this.state.amount;

            var options = Array.from({ length: 9 }, function (e, i) {
                var value = i + 1;
                var label = void 0;

                if (amount === value) {
                    label = Object(__WEBPACK_IMPORTED_MODULE_9_translations__["c" /* default */])('buy_box.items_in_the_cart', { amount: value });
                } else {
                    label = String(i + 1);
                }

                return {
                    label: label,
                    value: String(value)
                };
            });

            if (amount > options.length) {
                options.splice(0, 0, { value: String(amount), label: Object(__WEBPACK_IMPORTED_MODULE_9_translations__["c" /* default */])('buy_box.items_in_the_cart', { amount: amount }) });
            }

            options.push({ label: '10+', value: MORE_VALUE });
            options.push({ label: Object(__WEBPACK_IMPORTED_MODULE_9_translations__["c" /* default */])('buy_box.remove'), value: REMOVE_VALUE }); // add an extra item for design reasons

            return options;
        }
    }]);

    return BuyBox;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

BuyBox.defaultProps = {
    facet: 'base',
    onBought: function onBought() {}
};
BuyBox.propTypes = {
    facet: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    fetchingId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    isCartReady: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    isFetching: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    product: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    activeRegion: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    items: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    isModalVisible: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    addProduct: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    togglePanel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    setProductAmount: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    onBought: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_3_util_redux__["b" /* default */].mapStateToProps({
    items: 'cart.items',
    isFetching: 'cart.isFetching',
    fetchingId: 'cart.fetchingId',
    isCartReady: 'cart.wasFetched',
    isModalVisible: 'modal.isVisible',
    activeRegion: 'region.active'
}), __WEBPACK_IMPORTED_MODULE_3_util_redux__["b" /* default */].mapDispatchToProps({
    addProduct: 'cart.addProduct',
    setProductAmount: 'cart.setProductAmount',
    togglePanel: 'panel.toggle'
}))(BuyBox));

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FormFieldInput;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_form_field__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_icon__ = __webpack_require__(177);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// import looppa from 'looppa';



function Label(_ref) {
    var id = _ref.id,
        text = _ref.text;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'label',
        { className: 'form-field--title-label', htmlFor: id },
        text
    );
}

Label.propTypes = {
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

// function uniqueItems(items, id) {
//     return items.map((item, idx) => {
//         return Object.assign({}, item, {
//             id: `${ id }-${ idx }`,
//             name: `${ id }`,
//         });
//     });
// }

function findValue(data, value) {
    function iterate(a) {
        if (a.value === value) {
            result = a;
            return true;
        }
        return Array.isArray(a.value) && a.value.some(iterate);
    }

    var result;
    data.some(iterate);
    return result;
}

/**
 * We will compose the following markup using many props coming from the parent component
 * @extends Component<IFormFieldSelect>
 * @constructor
 */

var Select = function (_Component) {
    _inherits(Select, _Component);

    function Select() {
        _classCallCheck(this, Select);

        return _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).apply(this, arguments));
    }

    _createClass(Select, [{
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps) {
            var _props = this.props,
                hasFocus = _props.hasFocus,
                setStateClasses = _props.setStateClasses;

            if (nextProps.hasFocus !== hasFocus) {
                setStateClasses({
                    'form-field__has-focus': nextProps.hasFocus,
                    'form-field__is-empty': !nextProps.value
                });
            }
        }
    }, {
        key: 'renderOption',
        value: function renderOption(item) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'option',
                { key: item.id, value: item.value },
                item.label || item.value
            );
        }
    }, {
        key: 'renderOptionGroup',
        value: function renderOptionGroup(options, item, id) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'optgroup',
                { key: id, label: item.label },
                options
            );
        }
    }, {
        key: 'renderOptions',
        value: function renderOptions(items, id) {
            var _this2 = this;

            var select = [];
            items.forEach(function (item, idLevelOne) {
                if (Array.isArray(item.value)) {
                    var options = item.value.map(function (option, idLevelTwo) {
                        return _this2.renderOption(Object.assign({}, option, {
                            id: id + '-' + idLevelOne + '-' + idLevelTwo,
                            name: '' + id
                        }));
                    });
                    select.push(_this2.renderOptionGroup(options, item, id + '-' + idLevelOne));
                } else {
                    select.push(_this2.renderOption(Object.assign({}, item, {
                        id: id + '-' + idLevelOne,
                        name: '' + id
                    })));
                }
            });
            return select;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                label = _props2.label,
                id = _props2.id,
                items = _props2.items,
                value = _props2.value,
                state = _props2.state,
                onFocus = _props2.onFocus,
                onBlur = _props2.onBlur,
                updateValue = _props2.updateValue,
                placeholder = _props2.placeholder,
                actionCount = _props2.actionCount;

            var labelValue = placeholder || items[0].label || items[0].value;

            if (value) {
                var activeItem = findValue(items, value);
                labelValue = activeItem.label || activeItem.value;
            }

            return [label ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { key: 'label', id: id, text: label }) : null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: 'content', className: 'form-field--input-container', 'data-action-count': actionCount + 1 },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'select',
                    {
                        className: 'form-field--select-input',
                        id: id,
                        name: id,
                        disabled: state.disabled,
                        value: value,
                        onChange: function onChange(e) {
                            return updateValue(e.target.value);
                        },
                        onFocus: onFocus,
                        onBlur: onBlur
                    },
                    placeholder ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'option',
                        { disabled: true, defaultValue: true },
                        placeholder
                    ) : '',
                    this.renderOptions(items, id)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    { className: 'form-field--input', htmlFor: id },
                    labelValue
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-field--actions' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'form-field--action form-field--action__arrow' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_icon__["a" /* default */], { symbol: 'chevron-down', size: 'small' })
                    )
                )
            )];
        }
    }]);

    return Select;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Select.propTypes = {
    hasFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    setStateClasses: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    actionCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    updateValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    /** @type {IFormFieldSelectItems} */
    items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    facet: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]),
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]),
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    messages: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

Select.defaultProps = {
    facet: []
};

FormFieldInput.propTypes = {
    facet: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array])
};

FormFieldInput.defaultProps = {
    facet: 'base'
};

function FormFieldInput(props) {
    var facet = props.facet,
        attrs = _objectWithoutProperties(props, ['facet']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_form_form_field__["a" /* default */], _extends({}, attrs, { facet: (Array.isArray(facet) ? facet : [facet]).concat(['input', 'select']),
        component: Select }));
}

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ROOT */
/* unused harmony export DASHBOARD */
/* unused harmony export ONBOARDING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PRODUCTS_OVERVIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PRODUCTS_LIST; });
/* unused harmony export DELIVERY_SEARCH */
/* unused harmony export CHECKOUT */
/* unused harmony export PROFILE */
/* unused harmony export PROFILE_CUMULUS_PRODUCTS */
/* unused harmony export PROFILE_ORDERS */
/* unused harmony export PROFILE_ORDERS_DETAIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PRODUCT_DETAIL; });
/* unused harmony export CONTENT_PAGE */
/* unused harmony export CONTENT_PAGE_NO_CONTAINER */
/* unused harmony export STYLEGUIDE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TOPICS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ERROR_NOT_FOUND; });
/* harmony export (immutable) */ __webpack_exports__["g"] = get;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_lazy_route_index__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_templates_error_index__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_templates_root__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_templates_dashboard__ = __webpack_require__(1235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_templates_onboarding__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_stripe__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_dom_load_script__ = __webpack_require__(1247);
var _templates;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









/* eslint-disable react/display-name */

// template names constants
var ROOT = 'root';
var DASHBOARD = 'dashboard';
var ONBOARDING = 'onboarding';
var PRODUCTS_OVERVIEW = 'products_overview';
var PRODUCTS_LIST = 'products_list';
var DELIVERY_SEARCH = 'delivery_search';
var CHECKOUT = 'checkout';
var PROFILE = 'profile';
var PROFILE_CUMULUS_PRODUCTS = 'profile_cumulus_products';
var PROFILE_ORDERS = 'profile_orders';
var PROFILE_ORDERS_DETAIL = 'profile_orders_detail';
var PRODUCT_DETAIL = 'product_detail';
var CONTENT_PAGE = 'content_page';
var CONTENT_PAGE_NO_CONTAINER = 'content_page_no_container';
var STYLEGUIDE = 'styleguide';
var TOPICS = 'topics';
var ERROR_NOT_FOUND = 'error_not_found';

/**
 * Templates data table
 */
var templates = (_templates = {}, _defineProperty(_templates, ROOT, __WEBPACK_IMPORTED_MODULE_3_templates_root__["a" /* default */]), _defineProperty(_templates, DASHBOARD, __WEBPACK_IMPORTED_MODULE_4_templates_dashboard__["a" /* default */]), _defineProperty(_templates, ONBOARDING, __WEBPACK_IMPORTED_MODULE_5_templates_onboarding__["a" /* default */]), _defineProperty(_templates, TOPICS, function (props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_lazy_route_index__["a" /* default */], _extends({}, props, { component: __webpack_require__.e/* import() */(3/* min-size */).then(__webpack_require__.bind(null, 1248)) }));
}), _defineProperty(_templates, PRODUCTS_OVERVIEW, function (props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_lazy_route_index__["a" /* default */], _extends({}, props, { component: __webpack_require__.e/* import() */(3/* min-size */).then(__webpack_require__.bind(null, 1249)) }));
}), _defineProperty(_templates, PRODUCTS_LIST, function (props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_lazy_route_index__["a" /* default */], _extends({}, props, { component: Promise.all/* import() */([__webpack_require__.e(4), __webpack_require__.e(3)]).then(__webpack_require__.bind(null, 1250)) }));
}), _defineProperty(_templates, DELIVERY_SEARCH, function (props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_lazy_route_index__["a" /* default */], _extends({}, props, { component: Promise.all/* import() */([__webpack_require__.e(4), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, 1256)) }));
}), _defineProperty(_templates, CHECKOUT, function (props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_lazy_route_index__["a" /* default */], _extends({}, props, { component: Object(__WEBPACK_IMPORTED_MODULE_7_util_dom_load_script__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6_constants_stripe__["a" /* STRIPE_JAVASCRIPT_API */]).then(function () {
            return Promise.all/* import() */([__webpack_require__.e(4), __webpack_require__.e(5)]).then(__webpack_require__.bind(null, 1349));
        }) }));
}), _defineProperty(_templates, PROFILE, function (props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_lazy_route_index__["a" /* default */], _extends({}, props, { component: __webpack_require__.e/* import() */(5/* min-size */).then(__webpack_require__.bind(null, 1375)) }));
}), _defineProperty(_templates, PROFILE_CUMULUS_PRODUCTS, function (props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_lazy_route_index__["a" /* default */], _extends({}, props, { component: Promise.all/* import() */([__webpack_require__.e(4), __webpack_require__.e(3)]).then(__webpack_require__.bind(null, 1379)) }));
}), _defineProperty(_templates, PROFILE_ORDERS, function (props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_lazy_route_index__["a" /* default */], _extends({}, props, { component: Promise.all/* import() */([__webpack_require__.e(4), __webpack_require__.e(3)]).then(__webpack_require__.bind(null, 1389)) }));
}), _defineProperty(_templates, PROFILE_ORDERS_DETAIL, function (props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_lazy_route_index__["a" /* default */], _extends({}, props, { component: __webpack_require__.e/* import() */(1/* min-size */).then(__webpack_require__.bind(null, 1394)) }));
}), _defineProperty(_templates, PRODUCT_DETAIL, function (props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_lazy_route_index__["a" /* default */], _extends({}, props, { component: __webpack_require__.e/* import() */(1/* min-size */).then(__webpack_require__.bind(null, 1406)) }));
}), _defineProperty(_templates, CONTENT_PAGE, function (props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_lazy_route_index__["a" /* default */], _extends({}, props, { component: __webpack_require__.e/* import() */(3/* min-size */).then(__webpack_require__.bind(null, 1407)) }));
}), _defineProperty(_templates, CONTENT_PAGE_NO_CONTAINER, function (props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_lazy_route_index__["a" /* default */], _extends({}, props, {
        component: __webpack_require__.e/* import() */(3/* min-size */).then(__webpack_require__.bind(null, 1408)) }));
}), _defineProperty(_templates, STYLEGUIDE, function (props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_lazy_route_index__["a" /* default */], _extends({}, props, { component: __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1409)) }));
}), _defineProperty(_templates, ERROR_NOT_FOUND, function (props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_templates_error_index__["a" /* default */], _extends({}, props, {
        title: 'error.not_found_title',
        subtitle: 'error.not_found_subtitle',
        description: 'error.not_found_description'
    }));
}), _templates);

/**
 * Get a template by its name
 * @param {string} name - a valid template component
 * @returns {React.Component}
 */
function get(name) {
    return templates[name];
}

/* harmony default export */ __webpack_exports__["f"] = (templates);

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_loader__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_constants_category_icons__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_util_misc_link_to_dashboard__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_util_misc_normalise_trailing_slash__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_constants_transitions_props__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_animations__ = __webpack_require__(1238);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var PLACEHOLDER_ICON = __WEBPACK_IMPORTED_MODULE_11_constants_category_icons__["a" /* default */].default;

/**
 * @param {ICategory} category
 */
function isRootCategory(category) {
    return category.level < 1 || category.is_direct_link;
}

/**
 * @param {ICategory} category
 */
function isSubCategory(category) {
    return category.level >= 1 && !isLeafCategory(category);
}

/**
 * @param {ICategory} category
 */
function isLeafCategory(category) {
    return category.level === 2;
}

/**
 * @param {ICategory} category
 */
function hasLeafChildCategories(category) {
    return category.children.length && isLeafCategory(category.children[0]);
}

function Title(_ref) {
    var isFixed = _ref.isFixed,
        category = _ref.category,
        pathname = _ref.pathname,
        routerCooperative = _ref.routerCooperative;

    var overviewLink = '' + Object(__WEBPACK_IMPORTED_MODULE_12_util_misc_link_to_dashboard__["b" /* linkToDashboardByRoute */])(routerCooperative) + category.slug;

    if (hasLeafChildCategories(category)) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h2',
            { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('categories-menu--title', { 'categories-menu--title__fixed': isFixed }) },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { className: 'categories-menu--title-text' },
                category.name
            )
        );
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'h2',
        { className: 'categories-menu--title' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_icon__["a" /* default */], {
            className: 'categories-menu--category-icon',
            symbol: __WEBPACK_IMPORTED_MODULE_11_constants_category_icons__["a" /* default */][category.id] || PLACEHOLDER_ICON,
            size: 'large' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'categories-menu--title-content' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { className: 'categories-menu--title-text' },
                category.name
            ),
            Object(__WEBPACK_IMPORTED_MODULE_13_util_misc_normalise_trailing_slash__["a" /* default */])(pathname) !== Object(__WEBPACK_IMPORTED_MODULE_13_util_misc_normalise_trailing_slash__["a" /* default */])(overviewLink) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_router_dom__["c" /* NavLink */],
                {
                    className: 'categories-menu--show-all u-reset',
                    to: Object(__WEBPACK_IMPORTED_MODULE_13_util_misc_normalise_trailing_slash__["a" /* default */])(overviewLink) },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_translations__["a" /* Trans */], { path: 'categories.show_all' })
            )
        )
    );
}

Title.propTypes = {
    category: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    isFixed: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
    pathname: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    routerCooperative: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};

var CategoriesMenu = function (_PureComponent) {
    _inherits(CategoriesMenu, _PureComponent);

    function CategoriesMenu() {
        var _ref2;

        var _temp, _this, _ret;

        _classCallCheck(this, CategoriesMenu);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = CategoriesMenu.__proto__ || Object.getPrototypeOf(CategoriesMenu)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
            isMobileMenuOpen: false,
            currentActiveCategory: null,
            currentActiveCategories: [],
            animationDirection: 'drill-down'
        }, _this.fetchSubcategories = function (event, category) {
            if (!category.children.length) {
                event.preventDefault();
                var onDone = function onDone() {
                    return _this.props.history.push(Object(__WEBPACK_IMPORTED_MODULE_13_util_misc_normalise_trailing_slash__["a" /* default */])(_this.getCategorySlug(category)));
                };
                _this.props.fetchCategories({ category: category }).then(onDone).catch(onDone);
            }
        }, _this.updateBreadcrumbs = function () {
            if (!_this.props.canUpdateBreadcrumbs) {
                return;
            }

            _this.props.setBreadcrumbs({
                breadcrumbs: [{
                    name: Object(__WEBPACK_IMPORTED_MODULE_8_translations__["f" /* t */])('breadcrumbs.overview'),
                    action: function action() {
                        _this.props.setActiveCategory({ category: null });
                        _this.props.resetBreadcrumbs();
                    }
                }]
            });
        }, _this.setCurrentActiveCategory = __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function (activeCategory) {
            var newState = {
                currentActiveCategory: activeCategory,
                currentActiveCategories: activeCategory ? activeCategory.children : this.props.categories
            };
            this.setAnimationDirection(this.props);
            this.setState(newState);
        }, __WEBPACK_IMPORTED_MODULE_14_constants_transitions_props__["c" /* breadcrumbsDelay */]), _this.getDirectionName = function (activeCategory, oldActiveCategory) {
            if (activeCategory && oldActiveCategory && oldActiveCategory.level < activeCategory.level) {
                return 'drill-up';
            }
            return 'drill-down';
        }, _this.setAnimationDirection = function (_ref3) {
            var activeCategory = _ref3.activeCategory;

            var oldActiveCategory = _this.props.activeCategory;
            var animationDirection = _this.getDirectionName(activeCategory, oldActiveCategory);

            if (animationDirection !== _this.state.animationDirection) {
                _this.setState({ animationDirection: animationDirection });
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CategoriesMenu, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            this.props.fetchCategories().then(function () {
                _this2.setCurrentActiveCategory(_this2.props.activeCategory);
            });

            this.setState({ isMobileMenuOpen: this.props.isCategorylistVisible });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref4) {
            var activeCategory = _ref4.activeCategory;

            if (activeCategory !== this.props.activeCategory) {
                window.scrollTo(0, 0);
                this.setCurrentActiveCategory(activeCategory);
            }
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps) {
            this.setAnimationDirection(nextProps);

            var isCategorylistVisible = nextProps.isCategorylistVisible;

            if (isCategorylistVisible !== this.props.isCategorylistVisible) {
                this.setState({ isMobileMenuOpen: isCategorylistVisible });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.setCurrentActiveCategory.cancel();
        }
    }, {
        key: 'onLinkClick',
        value: function onLinkClick(category, event) {
            switch (true) {
                // just simple menu link
                case category.is_direct_link:
                    this.props.history.push(category.slug);
                    break;
                case isSubCategory(category):
                    this.fetchSubcategories(event, category);
                    break;

                case isRootCategory(category):
                    event.preventDefault();
                    this.updateBreadcrumbs();
                    this.props.setActiveCategory({ category: category });
                    break;
                default:
                    if (!this.props.activeLeaf || this.props.activeLeaf.id !== category.id) {
                        this.props.setPendingAutoscroll({ mustAutoscroll: true });
                        this.props.setActiveLeafCategory({ category: category });
                    }
            }
        }

        /**
         * Fetch all the subcategories of the active main category and browse to its detail page
         * @param {ICategory} category - the current category
         */

    }, {
        key: 'getCategorySlug',


        /**
         * @param {ICategory} category
         * @return {*}
         */
        value: function getCategorySlug(category) {
            var routerCooperative = this.props.routerCooperative;


            if (isSubCategory(category) && category.children.length) {
                return Object(__WEBPACK_IMPORTED_MODULE_12_util_misc_link_to_dashboard__["b" /* linkToDashboardByRoute */])(routerCooperative) + category.children[0].slug;
            }

            return Object(__WEBPACK_IMPORTED_MODULE_12_util_misc_link_to_dashboard__["b" /* linkToDashboardByRoute */])(routerCooperative) + category.slug;
        }

        /**
         * Get name for animation name based on the navigation hierarchy
         * @param {ICategory | null} activeCategory
         * @param {ICategory | null} oldActiveCategory
         * @return {string}
         */


        /**
         * @param {ICategory} activeCategory
         */

    }, {
        key: 'getAnimationName',


        /**
         * Remap the animation direction to transition names
         * @returns {string}
         */
        value: function getAnimationName() {
            var _props = this.props,
                isMobile = _props.isMobile,
                isCategorylistVisible = _props.isCategorylistVisible;
            var isMobileMenuOpen = this.state.isMobileMenuOpen;

            var animationName = this.state.animationDirection === 'drill-down' ? 'slideRight' : 'slideLeft';

            if (isMobile) {
                // only show the slidedown animation if we are on mobile and the menu changes is state between close and open (vice versa)
                if (isMobileMenuOpen !== isCategorylistVisible) {
                    animationName = 'slideDown';
                }
            }

            return animationName;
        }
    }, {
        key: 'renderIcon',
        value: function renderIcon(category) {
            if (this.props.isFetching && this.props.fetchingCategory && this.props.fetchingCategory.id === category.id) {
                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_loader__["a" /* default */], { facet: 'small' });
            }

            return isLeafCategory(category) ? null : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_icon__["a" /* default */], { symbol: 'arrow-right', size: 'small' });
        }
    }, {
        key: 'renderLink',
        value: function renderLink(category) {
            var _this3 = this;

            var icon = this.renderIcon(category);
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_router_dom__["c" /* NavLink */],
                {
                    className: 'categories-menu--link u-reset',
                    exact: true,
                    onClick: function onClick(e) {
                        return _this3.onLinkClick(category, e);
                    },
                    activeClassName: isLeafCategory(category) ? 'categories-menu--link__active' : '',
                    to: Object(__WEBPACK_IMPORTED_MODULE_13_util_misc_normalise_trailing_slash__["a" /* default */])(this.getCategorySlug(category)) },
                isRootCategory(category) ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_icon__["a" /* default */], {
                    className: 'categories-menu--category-icon',
                    symbol: __WEBPACK_IMPORTED_MODULE_11_constants_category_icons__["a" /* default */][category.id] || PLACEHOLDER_ICON,
                    size: 'large' }) : '',
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'categories-menu--text' },
                    category.name
                ),
                icon && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'categories-menu--icon' },
                    icon
                )
            );
        }
    }, {
        key: 'renderMenuContent',
        value: function renderMenuContent() {
            var _this4 = this;

            var _props2 = this.props,
                pathname = _props2.pathname,
                categories = _props2.categories,
                routerCooperative = _props2.routerCooperative;
            var _state = this.state,
                currentActiveCategories = _state.currentActiveCategories,
                currentActiveCategory = _state.currentActiveCategory;


            if (!categories.length) {
                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_loader__["a" /* default */], null);
            }

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { key: currentActiveCategories },
                currentActiveCategory ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Title, {
                    pathname: pathname,
                    routerCooperative: routerCooperative,
                    category: currentActiveCategory }) : '',
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'ul',
                    { className: 'u-reset categories-menu--list' },
                    Object(__WEBPACK_IMPORTED_MODULE_6_looppa__["a" /* default */])(currentActiveCategories)(function (category) {
                        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'li',
                            { key: category.id, className: 'categories-menu--item' },
                            _this4.renderLink(category)
                        );
                    })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                isCategorylistVisible = _props3.isCategorylistVisible,
                isMobile = _props3.isMobile;


            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'categories-menu grid' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'grid--container' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_15_components_animations__["a" /* default */],
                        {
                            animation: this.getAnimationName(),
                            duration: 200,
                            easing: __WEBPACK_IMPORTED_MODULE_14_constants_transitions_props__["d" /* breadcrumbsEasingFn */],
                            'aria-label': 'Side Menu'
                        },
                        (isCategorylistVisible || !isMobile) && this.renderMenuContent()
                    )
                )
            );
        }
    }]);

    return CategoriesMenu;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

CategoriesMenu.propTypes = {
    isCategorylistVisible: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
    categories: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array.isRequired,
    activeCategory: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
    fetchingCategory: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
    activeLeaf: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
    isFetching: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
    setActiveCategory: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    fetchCategories: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    setPendingAutoscroll: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    setActiveLeafCategory: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    routerRegistry: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    canUpdateBreadcrumbs: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
    resetBreadcrumbs: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    routerCooperative: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    isMobile: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
    setBreadcrumbs: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    routeName: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    categoriesCooperative: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    // this property is here just because redux needs to re render this component
    // in case of url updates
    // see also: https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/guides/blocked-updates.md
    pathname: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired
};
CategoriesMenu.defaultProps = {
    canUpdateBreadcrumbs: true
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_4_util_redux__["b" /* default */].mapStateToProps({
    isCategorylistVisible: 'categories.isCategorylistVisible',
    categories: 'categories.items',
    fetchingCategory: 'categories.fetchingCategory',
    activeCategory: 'categories.active',
    routerCooperative: 'router.cooperative',
    isFetching: 'categories.isFetching',
    pathname: 'router.location.pathname',
    routerRegistry: 'router.registry',
    history: 'router.history',
    routeName: 'router.name',
    isMobile: 'viewport.isMobile'
}), __WEBPACK_IMPORTED_MODULE_4_util_redux__["b" /* default */].mapDispatchToProps({
    setActiveCategory: 'categories.setActiveCategory',
    fetchCategories: 'categories.fetchCategories',
    setBreadcrumbs: 'breadcrumbs.set',
    resetBreadcrumbs: 'breadcrumbs.reset',
    setActiveLeafCategory: 'categories.setActiveLeafCategory',
    setPendingAutoscroll: 'scroll.setPendingAutoscroll'
}))(CategoriesMenu));

/***/ }),
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var moduleNameRegex = /\/([^/]+)\/.*?\.js$/;

var contexts = {
    reducers: __webpack_require__(918),
    actions: __webpack_require__(1045)
};

/**
 * Loop through the contexts object defined above
 * and create an object with all the reducers and actions
 */
var loadedContexts = Object.keys(contexts).reduce(function (result, key) {
    var context = contexts[key];
    result[key] = context.keys().reduce(function (modules, moduleString) {
        // Get the name from the moduleString
        var _moduleString$match = moduleString.match(moduleNameRegex),
            _moduleString$match2 = _slicedToArray(_moduleString$match, 2),
            name = _moduleString$match2[1];

        // '.default' is needed for old commonJS files


        modules[name] = context(moduleString).default || context(moduleString);
        return modules;
    }, {});

    result[key] = Object.freeze(result[key]);

    return result;
}, {});

/* harmony default export */ __webpack_exports__["a"] = (Object.freeze(loadedContexts));

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Call any method on the localStorage avoiding to throw errors
 * @param {string} method - method we want to call
 * @param {array} args - serialized params that will be proxied to the method we are going to call
 * @returns {null|string} whatever the method call will return
 */
function tryOrFailSilently(method) {
    try {
        /**
         * Deal with the localStorage avoiding odd issues due to paranoids that have disabled it by default
         */
        var ls = window.localStorage;

        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
        }

        return ls[method].apply(ls, args);
    } catch (e) {
        console && console.error && console.error(e);
        return null;
    }
}

/**
 * Simple object to read get and clear from the localStorage
 */
/* harmony default export */ __webpack_exports__["a"] = ({
    set: function set(item, value) {
        return tryOrFailSilently('setItem', item, value);
    },
    get: function get(item) {
        return tryOrFailSilently('getItem', item);
    },
    clear: function clear() {
        return tryOrFailSilently('clear');
    },
    remove: function remove(item) {
        return tryOrFailSilently('removeItem', item);
    }
});

/***/ }),
/* 529 */,
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addPromoCode;
/* harmony export (immutable) */ __webpack_exports__["c"] = submit;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultErrors; });
/* unused harmony export isTimeSlotExpired */
/* harmony export (immutable) */ __webpack_exports__["d"] = validate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_zip__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_zip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_zip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_checkout_errors__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__notifications_actions__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reducers_modules_cart_helpers__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_api_urls__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reducers_helpers__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modal_actions__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cart_actions__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable camelcase */














/**
 * Set promocode on order
 * @param {string} code
 * @return {function(*=): Promise<AxiosResponse<any> | never>}
 */
function addPromoCode(code) {
    return function (dispatch) {
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["IS_SUBMITTING_PROMOCODE"], isSubmittingPromo: true });
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_6_constants_api_urls__["promoCode"])(), { code: code }).then(function () {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["IS_SUBMITTING_PROMOCODE"], isSubmittingPromo: false });
        }).catch(function (e) {
            if (e.status && ![400].includes(e.status)) {
                Object(__WEBPACK_IMPORTED_MODULE_7_reducers_helpers__["a" /* dispatchError */])(dispatch, e, {
                    url: Object(__WEBPACK_IMPORTED_MODULE_6_constants_api_urls__["promoCode"])(),
                    description: e
                });
            }
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["IS_SUBMITTING_PROMOCODE"], isSubmittingPromo: false });
            throw e;
        });
    };
}

/**
 * Submit order
 * @param {string} stripeToken
 * @return {function(*=, *): Promise<AxiosResponse<any> | never>}
 */
function submit(stripeToken) {
    return function (dispatch, getState) {
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["IS_SUBMITTING_CHECKOUT"], isSubmitting: true });

        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_6_constants_api_urls__["checkout"])(), _extends({}, getState().checkout, {
            stripe_credit_card_token: stripeToken
        })).then(function (_ref) {
            var data = _ref.data;

            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_CHECKOUT_COMPLETE"], isComplete: true });
            dispatch(__WEBPACK_IMPORTED_MODULE_9__cart_actions__["default"].reset());
            dispatch(__WEBPACK_IMPORTED_MODULE_4__notifications_actions__["default"].fetch());
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_reducers_modules_cart_helpers__["a" /* block */])({
                state: data.state,
                id: data.id
            }));
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["IS_SUBMITTING_CHECKOUT"], isSubmitting: false });
        }).catch(function (e) {
            if (e.data) {
                dispatch(__WEBPACK_IMPORTED_MODULE_8__modal_actions__["default"].open({
                    meta: {
                        title: Object(__WEBPACK_IMPORTED_MODULE_10_translations__["f" /* t */])('error.occurred'),
                        description: Object(__WEBPACK_IMPORTED_MODULE_10_translations__["f" /* t */])(e.data.error.trans_key),
                        type: 'error',
                        actions: [{
                            name: Object(__WEBPACK_IMPORTED_MODULE_10_translations__["f" /* t */])('error.confirm'),
                            event: function event() {
                                dispatch(__WEBPACK_IMPORTED_MODULE_8__modal_actions__["default"].close());
                            }
                        }]
                    },
                    layout: 'confirm'
                }));
            } else {
                Object(__WEBPACK_IMPORTED_MODULE_7_reducers_helpers__["a" /* dispatchError */])(dispatch, e, {
                    url: Object(__WEBPACK_IMPORTED_MODULE_6_constants_api_urls__["checkout"])(),
                    description: e
                });
            }
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["IS_SUBMITTING_CHECKOUT"], isSubmitting: false });
        });
    };
}

/** @type {ICartValidationError[]} */
var defaultErrors = [__WEBPACK_IMPORTED_MODULE_3_constants_checkout_errors__["b" /* MISSING_ADDRESS_ID */], __WEBPACK_IMPORTED_MODULE_3_constants_checkout_errors__["c" /* MISSING_DELIVERY_DATE */], __WEBPACK_IMPORTED_MODULE_3_constants_checkout_errors__["a" /* INVALID_PAYMENT_METHOD */], __WEBPACK_IMPORTED_MODULE_3_constants_checkout_errors__["d" /* TIME_SLOT_EXPIRED */]];

/**
 * True if the time slot selected by the user is in the past and or expired according to our "MINUTES_BEFORE_SLOT_EXPIRATION" constant
 * @param {moment.Moment} now - moment instance representing the current time
 * @param {string} deliveryStartDate - the delivery end date selected by the user via time picker
 * @return {boolean} true if the time slot is expired
 */
function isTimeSlotExpired(now, deliveryStartDate) {
    // notice that here we remove the hours offset because we want always to check at beginning of the last time slot selected
    // for example if the last user slot selected is between 16:00 and 17:00 it will be considered expired when `now` is 18:00
    var end = __WEBPACK_IMPORTED_MODULE_11_moment___default()(deliveryStartDate);

    if (now.hour() === end.hour()) {
        return now.isAfter(end.add(1, 'minute'));
    }

    return now.add(1, 'second').isAfter(end);
}

/**
 * Validate cart values
 * @param {object} state - the current cart state
 * @param {moment.Moment} currentTime
 * @returns {ICartValidationResult} if we can submit the checkout data
 */
function validate(state) {
    var currentTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_11_moment___default()();
    var delivery_start_date = state.delivery_start_date,
        delivery_end_date = state.delivery_end_date,
        address_id = state.address_id,
        isPaymentMethodValid = state.isPaymentMethodValid;

    var tests = [address_id, delivery_start_date && delivery_end_date, isPaymentMethodValid, !delivery_end_date || !isTimeSlotExpired(currentTime, delivery_start_date)];

    return {
        isValid: tests.every(function (te) {
            return te;
        }),
        errors: __WEBPACK_IMPORTED_MODULE_0_lodash_zip___default()(tests, defaultErrors).filter(function (_ref2) {
            var _ref3 = _slicedToArray(_ref2, 1),
                isValid = _ref3[0];

            return !isValid;
        }).map(function (_ref4) {
            var _ref5 = _slicedToArray(_ref4, 2),
                error = _ref5[1];

            return error;
        })
    };
}

/***/ }),
/* 531 */,
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);


/* harmony default export */ __webpack_exports__["default"] = (Object.freeze({
    setViewport: function setViewport(_ref) {
        var width = _ref.width,
            height = _ref.height,
            mq = _ref.mq;

        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_VIEWPORT"], width: width, height: height, mq: mq };
    },
    setTitle: function setTitle(_ref2) {
        var title = _ref2.title;

        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_VIEWPORT_TITLE"], title: title };
    },
    setOverlay: function setOverlay(_ref3) {
        var hasOverlay = _ref3.hasOverlay;

        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_VIEWPORT_OVERLAY"], hasOverlay: hasOverlay };
    }
}));

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reducers_modules_scroll_actions__ = __webpack_require__(398);



function _open(_ref, dispatch, getState) {
    var facet = _ref.facet,
        content = _ref.content;

    if (getState().modal.isVisible) {
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["CLOSE_MODAL"] });
    }
    dispatch(__WEBPACK_IMPORTED_MODULE_1_reducers_modules_scroll_actions__["default"].lock());
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["OPEN_PANEL"], facet: facet, content: content });
}

function _close(dispatch, getState) {
    if (!getState().panel.isOpen) {
        return;
    }

    if (!getState().modal.isVisible) {
        dispatch(__WEBPACK_IMPORTED_MODULE_1_reducers_modules_scroll_actions__["default"].unlock());
    }

    dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["CLOSE_PANEL"] });
}

/* harmony default export */ __webpack_exports__["default"] = ({
    open: function open(_ref2) {
        var facet = _ref2.facet,
            content = _ref2.content;

        return _open.bind(null, { facet: facet, content: content });
    },
    reset: function reset() {
        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["RESET_PANEL"] };
    },
    close: function close() {
        return _close;
    },
    toggle: function toggle(_ref3) {
        var facet = _ref3.facet,
            content = _ref3.content;

        return function (dispatch, getState) {
            var isOpen = getState().panel.isOpen;


            if (isOpen) {
                _close(dispatch, getState);
            } else {
                _open({ facet: facet, content: content }, dispatch, getState);
            }
        };
    }
});

/***/ }),
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ORDER_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PRODUCT_NOT_IN_REGION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MISSING_ZIP_CODE; });
var ORDER_PENDING = 'order_pending';
var PRODUCT_NOT_IN_REGION = 'product_not_in_region';
var MISSING_ZIP_CODE = 'missing_zip_code';

/***/ }),
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AVAILABLE_REGIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_REGION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DEFAULT_REGION_SLUG; });
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var AVAILABLE_REGIONS = globals.config.available_regions;

var _AVAILABLE_REGIONS = _slicedToArray(AVAILABLE_REGIONS, 1),
    DEFAULT_REGION = _AVAILABLE_REGIONS[0];



var DEFAULT_REGION_SLUG = DEFAULT_REGION.region_slug;

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__actions_types__);




/* eslint-disable camelcase */
/* harmony default export */ __webpack_exports__["default"] = (Object.freeze({
    submit: __WEBPACK_IMPORTED_MODULE_1__helpers__["c" /* submit */],
    addPromoCode: __WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* addPromoCode */],
    setMessage: function setMessage(_ref) {
        var additional_info = _ref.additional_info;

        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_CHECKOUT_MESSAGE"], additional_info: additional_info };
    },
    setExcludedPickers: function setExcludedPickers(_ref2) {
        var excluded_pickers = _ref2.excluded_pickers;

        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_CHECKOUT_EXCLUDED_PICKERS"], excluded_pickers: excluded_pickers };
    },
    validate: function validate() {
        return function (dispatch, getState) {
            var validationState = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["d" /* validate */])(getState().checkout);

            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_CHECKOUT_VALIDATION"], validationState: validationState });

            return validationState;
        };
    },
    reset: function reset() {
        return function (dispatch) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["RESET_CHECKOUT"] });
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["RESET_DELIVERY"] });
        };
    },
    toggleErrorsVisibility: function toggleErrorsVisibility(_ref3) {
        var areErrorsVisible = _ref3.areErrorsVisible;

        return { type: __WEBPACK_IMPORTED_MODULE_2__actions_types__["TOGGLE_CHECKOUT_ERRORS_VISIBILITY"], areErrorsVisible: areErrorsVisible };
    },


    /**
     * Set delivery time range
     * @param {string | string} delivery_start_date
     * @param {string | null} delivery_end_date
     * @return {{delivery_start_date: *, type: *, delivery_end_date: *}}
     */
    setDates: function setDates(_ref4) {
        var delivery_start_date = _ref4.delivery_start_date,
            delivery_end_date = _ref4.delivery_end_date;

        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_CHECKOUT_DELIVERY_DATES"], delivery_start_date: delivery_start_date, delivery_end_date: delivery_end_date };
    }
}));

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_api_urls__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);





/**
 * Handle fetch
 * @param {IDeliveryState} data
 * @param {function} dispatch
 */
function handleFetch(data, dispatch) {
    var newState = {
        now: data.now,
        date: data.date,
        minDate: data.min_date,
        maxDate: data.max_date,
        status: data.state,
        hasFetched: true
    };

    dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_IS_FETCHING_DELIVERY"], isFetching: false });
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_DELIVERY_STATE"], newState: newState });
}

function handleError(error, dispatch) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_IS_FETCHING_DELIVERY"], isFetching: false });
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_DELIVERY_STATE"], newState: { hasFetched: true } });
}

/* harmony default export */ __webpack_exports__["default"] = (Object.freeze({
    /**
     * set new date on delivery
     * @param {string} date
     * @return {function(*=): Promise<void | never>}
     */
    setDate: function setDate(_ref) {
        var date = _ref.date;

        return function (dispatch) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_IS_FETCHING_DELIVERY"], isFetching: true });
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_1_constants_api_urls__["orderExpiration"])(), { date: date }).then(function (_ref2) {
                var data = _ref2.data;
                return handleFetch(data, dispatch);
            }).catch(function (error) {
                return handleError(error, dispatch);
            });
        };
    },

    /**
     * Set order status
     * @param {string} status
     * @return {{type: *, status: *}}
     */
    setStatus: function setStatus(_ref3) {
        var status = _ref3.status;

        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_DELIVERY_STATUS"], status: status };
    },
    fetchState: function fetchState() {
        return function (dispatch) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_IS_FETCHING_DELIVERY"], isFetching: true });
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_1_constants_api_urls__["orderExpiration"])()).then(function (_ref4) {
                var data = _ref4.data;
                return handleFetch(data, dispatch) || data;
            }).catch(function (error) {
                return handleError(error, dispatch) || Promise.reject(error);
            });
        };
    }
}));

/***/ }),
/* 571 */,
/* 572 */,
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getOrderState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_order_states__ = __webpack_require__(217);


/**
 * Validate the cart status trying to get abstract meaningful information to update properly our app ui
 * @param {string} status - one of the states defined in order-states.js
 * @returns {object} result
 * @returns {boolean} result.isActive - true if the order is still active
 * @returns {boolean} result.isShipped - true if the order was shipped
 * @returns {boolean} result.isFailed -  true if the oder was canceled or not picked
 */
function getOrderState(status) {
    var isShipped = __WEBPACK_IMPORTED_MODULE_0_constants_order_states__["h" /* SUCCESS_MODAL_CASES */].includes(status);
    var isFailed = __WEBPACK_IMPORTED_MODULE_0_constants_order_states__["e" /* ERROR_MODAL_CASES */].includes(status);

    return {
        isActive: !isShipped && !isFailed,
        isShipped: isShipped,
        isFailed: isFailed
    };
}

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page_names__ = __webpack_require__(194);


// these pages require the user to be logged in order to see them
/* harmony default export */ __webpack_exports__["a"] = ([__WEBPACK_IMPORTED_MODULE_0__page_names__["PROFILE"], __WEBPACK_IMPORTED_MODULE_0__page_names__["PROFILE_ORDERS"], __WEBPACK_IMPORTED_MODULE_0__page_names__["PROFILE_CUMULUS_PRODUCTS"], __WEBPACK_IMPORTED_MODULE_0__page_names__["PROFILE_ORDERS_DETAIL"], __WEBPACK_IMPORTED_MODULE_0__page_names__["DELIVERY_SEARCH"], __WEBPACK_IMPORTED_MODULE_0__page_names__["CHECKOUT"]]);

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scrollTop;
/* unused harmony export scrollTopElement */
/**
 * Get the document scroll top position
 * @returns {number} amount in px from the top position
 */
function scrollTop() {
    return Math.max(0, window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0);
}

function scrollTopElement(element) {
    return Math.max(0, element.scrollTop, 0);
}

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_icon_index__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_animated_counter__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_tooltip__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_dom_stop_propagation__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_constants_cart__ = __webpack_require__(266);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var CartCounter = function (_Component) {
    _inherits(CartCounter, _Component);

    _createClass(CartCounter, null, [{
        key: 'isEmpty',
        value: function isEmpty(props) {
            return props.amount <= 0;
        }
    }, {
        key: 'isFull',
        value: function isFull(props) {
            var amount = props.amount,
                totalBags = props.totalBags;

            return amount >= __WEBPACK_IMPORTED_MODULE_10_constants_cart__["c" /* MAX_ITEMS */] || totalBags >= __WEBPACK_IMPORTED_MODULE_10_constants_cart__["b" /* MAX_BAGS */];
        }
    }]);

    function CartCounter(props) {
        _classCallCheck(this, CartCounter);

        var _this = _possibleConstructorReturn(this, (CartCounter.__proto__ || Object.getPrototypeOf(CartCounter)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
            isEmpty: CartCounter.isEmpty(props),
            isFull: CartCounter.isFull(props)
        };
        return _this;
    }

    _createClass(CartCounter, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.amount !== this.props.amount) {
                this.runChecks(nextProps);
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(_ref) {
            var fetchingId = _ref.fetchingId,
                amount = _ref.amount,
                id = _ref.id;

            return fetchingId === id || amount !== this.props.amount;
        }
    }, {
        key: 'renderRemoveButton',
        value: function renderRemoveButton() {
            var _props = this.props,
                productName = _props.productName,
                tabIndex = _props.tabIndex;
            var isEmpty = this.state.isEmpty;
            var isBusy = this.isBusy,
                triggerRemove = this.triggerRemove;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { className: 'cart-counter--remove u-reset',
                    tabIndex: tabIndex,
                    onClick: function onClick(e) {
                        return !isEmpty && !isBusy() && triggerRemove(e);
                    },
                    'aria-label': Object(__WEBPACK_IMPORTED_MODULE_7_translations__["f" /* t */])('accessibility.label.remove_one', {
                        product_name: productName
                    }) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_icon_index__["a" /* default */], { symbol: 'basket-remove', size: 'large' })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                amount = _props2.amount,
                facet = _props2.facet,
                productName = _props2.productName,
                tabIndex = _props2.tabIndex;
            var _state = this.state,
                isEmpty = _state.isEmpty,
                isFull = _state.isFull;
            var runChecks = this.runChecks,
                showTooltip = this.showTooltip,
                hideTooltip = this.hideTooltip,
                enableTooltip = this.enableTooltip;
            /**
             * cart-counter is clickable and increments the amount
             * cart-counter--content is not clickable
             * cart-counter--add is clickable and increments the amount
             * cart-counter--remove is clickable and decrements the amount
             */

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                    tabIndex: tabIndex,
                    'aria-label': Object(__WEBPACK_IMPORTED_MODULE_7_translations__["f" /* t */])('accessibility.label.add_to_cart', {
                        product_name: productName
                    }),
                    role: 'button',
                    className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('cart-counter', _defineProperty({}, 'cart-counter__' + facet, facet), { 'cart-counter__is-empty': isEmpty }, { 'cart-counter__is-filled': !isEmpty }, { 'cart-counter__is-full': isFull }),
                    onClick: this.onAdd
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'cart-counter--content', onClick: function onClick(e) {
                            return e.stopPropagation();
                        } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { tabIndex: tabIndex, className: 'cart-counter--add u-reset', onClick: this.onAdd,
                            'aria-label': Object(__WEBPACK_IMPORTED_MODULE_7_translations__["f" /* t */])('accessibility.label.add_to_cart', {
                                product_name: productName
                            }) },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_icon_index__["a" /* default */], { symbol: 'basket-add', size: 'large' })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_animated_counter__["a" /* default */], { onFinish: function onFinish() {
                            return runChecks(_this2.props);
                        },
                        ariaLabel: Object(__WEBPACK_IMPORTED_MODULE_7_translations__["f" /* t */])('accessibility.label.product_count'),
                        className: 'cart-counter--products-amount',
                        amount: amount }),
                    facet === 'cart' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_8_components_tooltip__["a" /* default */],
                        {
                            interactionType: enableTooltip ? 'click' : 'none',
                            content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_translations__["a" /* Trans */], { path: 'cart.remove_question' }),
                            facet: ['base', 'block'],
                            actions: this.actions,
                            forcePosition: 'left',
                            onShow: showTooltip,
                            onHide: hideTooltip
                        },
                        this.renderRemoveButton()
                    ) : this.renderRemoveButton()
                )
            );
        }
    }, {
        key: 'actions',
        get: function get() {
            var _this3 = this;

            return [{
                name: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_translations__["a" /* Trans */], { path: 'tooltip.cancel' })
            }, {
                name: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_translations__["a" /* Trans */], { path: 'tooltip.confirm' }),
                isHighlighted: true,
                event: function event() {
                    _this3.props.remove();
                }
            }];
        }
    }, {
        key: 'enableTooltip',
        get: function get() {
            var _props3 = this.props,
                amount = _props3.amount,
                facet = _props3.facet;

            return amount === 1 && facet === 'cart';
        }
    }]);

    return CartCounter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

CartCounter.propTypes = {
    id: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    productName: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    amount: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
    totalBags: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
    add: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    tabIndex: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
    fetchingId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    remove: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    setTooltipId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    facet: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};
CartCounter.defaultProps = {
    tabIndex: 0
};

var _initialiseProps = function _initialiseProps() {
    var _this4 = this;

    this.onAdd = function () {
        var add = _this4.props.add;
        var isFull = _this4.state.isFull;
        var isBusy = _this4.isBusy;

        return !isFull && !isBusy() && add();
    };

    this.runChecks = function (props) {
        _this4.setState({
            isEmpty: CartCounter.isEmpty(props),
            isFull: CartCounter.isFull(props)
        });
    };

    this.hideTooltip = function () {
        var _props4 = _this4.props,
            id = _props4.id,
            setTooltipId = _props4.setTooltipId;


        if (id) {
            setTooltipId({ tooltipId: id });
        }
    };

    this.showTooltip = function () {
        var _props5 = _this4.props,
            id = _props5.id,
            setTooltipId = _props5.setTooltipId;


        if (id) {
            setTooltipId({ tooltipId: id });
        }
    };

    this.triggerRemove = function (e) {
        var remove = _this4.props.remove;


        if (_this4.enableTooltip) {
            return; // Let the tooltip be triggered
        }

        Object(__WEBPACK_IMPORTED_MODULE_9_util_dom_stop_propagation__["a" /* default */])(e);
        remove();
    };

    this.isBusy = function () {
        return _this4.props.fetchingId === _this4.props.id;
    };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_4_util_redux__["b" /* default */].mapStateToProps({
    fetchingId: 'cart.fetchingId',
    cartErrorId: 'cart.productError.fetchingId',
    totalBags: 'cart.bagInfo.total_bags'
}), __WEBPACK_IMPORTED_MODULE_4_util_redux__["b" /* default */].mapDispatchToProps({
    setTooltipId: 'cart.setTooltipId'
}))(CartCounter));

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ProductPrice;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_misc_get_product_price__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_misc_format_price__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






function renderContent(price_information, realPrice) {
    if (price_information.original_price) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'div',
            { className: 'product-price--discount' },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                'div',
                { className: 'product-price--price' },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    'span',
                    null,
                    Object(__WEBPACK_IMPORTED_MODULE_3_util_misc_format_price__["a" /* default */])(realPrice)
                )
            ),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                'div',
                { className: 'product-price--old-price' },
                Object(__WEBPACK_IMPORTED_MODULE_2_translations__["c" /* default */])('products.instead_of'),
                ' ',
                Object(__WEBPACK_IMPORTED_MODULE_3_util_misc_format_price__["a" /* default */])(price_information.original_price)
            )
        );
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'div',
        { className: 'product-price--price' },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'span',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_3_util_misc_format_price__["a" /* default */])(realPrice)
        )
    );
}

function ProductPrice(_ref) {
    var price_information = _ref.price_information;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'div',
        { className: 'product-price' },
        renderContent(price_information, Object(__WEBPACK_IMPORTED_MODULE_1_util_misc_get_product_price__["a" /* default */])(price_information))
    );
}

ProductPrice.propTypes = {
    price_information: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CmsRichText;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_react_facet__ = __webpack_require__(185);





function CmsRichText(_ref) {
    var value = _ref.value,
        className = _ref.className,
        facet = _ref.facet;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('cms-richtext', className, Object(__WEBPACK_IMPORTED_MODULE_3__util_react_facet__["a" /* default */])(facet, 'cms-richtext')),
        dangerouslySetInnerHTML: { __html: value } });
}

CmsRichText.propTypes = {
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    facet: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(242);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Section = function (_PureComponent) {
    _inherits(Section, _PureComponent);

    function Section() {
        _classCallCheck(this, Section);

        return _possibleConstructorReturn(this, (Section.__proto__ || Object.getPrototypeOf(Section)).apply(this, arguments));
    }

    _createClass(Section, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                type = _props.type,
                plugins = _props.plugins,
                cms = _props.cms,
                color = _props.color;


            var placeholder = {
                type: type,
                plugins: plugins,
                cms: cms,
                sectionFacet: color
            };

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'section',
                { className: 'cms-section cms-section__' + color },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'grid--container' },
                    plugins && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["a" /* default */], { placeholder: placeholder, facet: type }),
                    this.props.children
                )
            );
        }
    }]);

    return Section;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Section.defaultProps = {
    content: {}
};
Section.propTypes = {
    color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    plugins: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    cms: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (Section);

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bianco_images_loader__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_loader__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_star_rating_component__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_star_rating_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_star_rating_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_button__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_util_misc_get_picker_image__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_util_dom_channeled_interactionobserver__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_constants_transitions_props__ = __webpack_require__(241);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















/* eslint-disable camelcase */

var PickerTile = function (_PureComponent) {
    _inherits(PickerTile, _PureComponent);

    function PickerTile() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PickerTile);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PickerTile.__proto__ || Object.getPrototypeOf(PickerTile)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isLoading: false,
            isLoaded: false,
            isVisible: false,
            tooltipCreated: false
        }, _this.onImageLoaded = function () {
            if (_this.wasUnmounted) {
                return;
            }

            _this.setState({
                isLoaded: true,
                isLoading: false
            });
        }, _this.setExcluded = function (excluded) {
            var person_id = _this.props.person_id;


            _this.props.setExcluded({
                person_id: person_id,
                excluded: excluded
            });

            _this.showTooltip(excluded);
        }, _this.lazyLoad = function () {
            // eslint-disable-line
            _this.setState({ isLoading: true });
            Object(__WEBPACK_IMPORTED_MODULE_4_bianco_images_loader__["a" /* loadImage */])(_this.userImage).then(_this.onImageLoaded);
        }, _this.tooltipHideTimeout = null, _this.showTooltip = __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function (isExcluded) {
            _this.props.addTooltip('picker-slider', _this.refs.root, {
                className: 'picker-tile--tooltip',
                facet: 'smaller-shadow',
                hasClose: false,
                mustShow: true,
                content: _this.getTooltipContent(isExcluded),
                interactionType: 'none'
            });

            if (_this.tooltipHideTimeout) {
                clearTimeout(_this.tooltipHideTimeout);
            }

            _this.tooltipHideTimeout = setTimeout(function () {
                _this.props.removeTooltip('picker-slider', _this.refs.root);
                _this.tooltipHideTimeout = null;
            }, __WEBPACK_IMPORTED_MODULE_14_constants_transitions_props__["j" /* tooltipDuration */]);
        }, 200), _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PickerTile, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!this.state.isLoaded) {
                Object(__WEBPACK_IMPORTED_MODULE_13_util_dom_channeled_interactionobserver__["a" /* register */])(this, 'picker-slider--tile', {
                    threshold: 0.1
                });
            }
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps, nextState) {
            if (!this.state.isVisible && nextState.isVisible === true) {
                if (!this.state.isLoaded && !this.state.isLoading) {
                    this.lazyLoad(nextProps);
                }
            }

            if (this.state.isVisible && nextState.isVisible === false) {
                this.closeTooltip();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.wasUnmounted = true;
            Object(__WEBPACK_IMPORTED_MODULE_13_util_dom_channeled_interactionobserver__["b" /* unregister */])(this, 'picker-slider--tile', null);
        }
    }, {
        key: 'getTooltipContent',
        value: function getTooltipContent(isExcluded) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_translations__["a" /* Trans */], { path: isExcluded ? 'checkout.pickers.excluded_tooltip' : 'checkout.pickers.included_tooltip' });
        }
    }, {
        key: 'renderRating',
        value: function renderRating() {
            var _props = this.props,
                first_name = _props.first_name,
                rating_average = _props.rating_average,
                rating_count = _props.rating_count;

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'picker-tile--rating' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_star_rating_component___default.a, {
                    name: first_name,
                    editing: false,
                    starColor: '#ff6600',
                    emptyStarColor: '#9f9fa1',
                    renderStarIcon: function renderStarIcon() {
                        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            null,
                            '\u2605'
                        );
                    },
                    starCount: 5,
                    value: rating_average
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'picker-tile--rating-average' },
                    rating_count
                )
            );
        }
    }, {
        key: 'renderImage',
        value: function renderImage() {
            var _state = this.state,
                isLoading = _state.isLoading,
                isLoaded = _state.isLoaded;


            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'picker-tile--image' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    {
                        className: 'picker-tile--image-inner',
                        style: { backgroundImage: isLoaded ? 'url(\'' + this.userImage + '\')' : null } },
                    isLoading && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_loader__["a" /* default */], null)
                )
            );
        }
    }, {
        key: 'renderTileContent',
        value: function renderTileContent() {
            var _this2 = this;

            var _props2 = this.props,
                first_name = _props2.first_name,
                excluded = _props2.excluded;


            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'picker-tile--inner',
                    onClick: function onClick() {
                        return _this2.setExcluded(!excluded);
                    } },
                this.renderImage(),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'picker-tile--name' },
                    first_name
                ),
                this.renderRating(),
                this.isHighlight ? null : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'picker-tile--actions' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_9_components_button__["a" /* default */],
                        { tabIndex: '-1', className: 'picker-tile--action picker-tile--exclude',
                            size: 'small',
                            facet: 'bubble' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_icon__["a" /* default */], { symbol: 'basket-remove', size: 'large' })
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_9_components_button__["a" /* default */],
                        { tabIndex: '-1', className: 'picker-tile--action picker-tile--include',
                            size: 'small',
                            facet: 'bubble' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_icon__["a" /* default */], { symbol: 'enable', size: 'large' })
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var excluded = this.props.excluded;
            var isVisible = this.state.isVisible;


            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'article',
                { ref: 'root',
                    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('picker-tile', { 'picker-tile__excluded': excluded }) },
                isVisible && this.renderTileContent()
            );
        }
    }, {
        key: 'isHighlight',
        get: function get() {
            return this.props.facet === 'highlight';
        }
    }, {
        key: 'userImage',
        get: function get() {
            return Object(__WEBPACK_IMPORTED_MODULE_11_util_misc_get_picker_image__["a" /* default */])(this.props);
        }
    }]);

    return PickerTile;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

PickerTile.propTypes = {
    first_name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    rating_average: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
    rating_count: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    person_id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    profile_picture: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    gender: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    excluded: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    isMobile: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    setExcluded: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    addTooltip: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    removeTooltip: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    facet: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_12_util_redux__["b" /* default */].mapStateToProps({
    isMobile: 'viewport.isMobile'
}), __WEBPACK_IMPORTED_MODULE_12_util_redux__["b" /* default */].mapDispatchToProps({
    setExcluded: 'pickers.setExcluded',
    addTooltip: 'tooltip.add',
    removeTooltip: 'tooltip.remove'
}))(PickerTile));

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPickerImage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_assets_path__ = __webpack_require__(197);


var genders = {
    M: 'men',
    F: 'women'
};

var fallbackImages = {
    men: Object(__WEBPACK_IMPORTED_MODULE_0__static_assets_path__["a" /* default */])('img/pickers/men.svg'),
    women: Object(__WEBPACK_IMPORTED_MODULE_0__static_assets_path__["a" /* default */])('img/pickers/women.svg')
};

/**
 * Get a piker image or fallback to one gender specific
 * @param {object} picker - picker model
 * @returns {string} the path to the image
 */
function getPickerImage(picker) {
    var gender = genders[picker.gender];
    var pic = picker.profile_picture;
    return pic || fallbackImages[gender];
}

/***/ }),
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_react_facet__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(173);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Card = function (_PureComponent) {
    _inherits(Card, _PureComponent);

    function Card() {
        _classCallCheck(this, Card);

        return _possibleConstructorReturn(this, (Card.__proto__ || Object.getPrototypeOf(Card)).apply(this, arguments));
    }

    _createClass(Card, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                facet = _props.facet;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'article',
                { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('card', Object(__WEBPACK_IMPORTED_MODULE_4_util_react_facet__["a" /* default */])(facet, 'card')) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'card--background' },
                    children && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'card--inner' },
                        children
                    )
                )
            );
        }
    }]);

    return Card;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Card.defaultProps = {
    facet: 'base'
};
Card.propTypes = {
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
    facet: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};
;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_3_util_redux__["b" /* default */].mapStateToProps({}))(Card));

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_cms_placeholder_richtext__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_dom_image_dpi_resolution__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_misc_static_assets_path__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_player__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_page_visibility__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_visibility_sensor__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_constants_debounce_delays__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_translations__ = __webpack_require__(171);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable camelcase */














var CardContent = function (_PureComponent) {
    _inherits(CardContent, _PureComponent);

    function CardContent(props) {
        _classCallCheck(this, CardContent);

        var _this = _possibleConstructorReturn(this, (CardContent.__proto__ || Object.getPrototypeOf(CardContent)).call(this, props));

        _this.handleElementVisibility = __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function (elVisible) {
            if (this.props.visible) {
                this.play(elVisible);
            }
        }, __WEBPACK_IMPORTED_MODULE_11_constants_debounce_delays__["j" /* VIDEO_AUTOPLAY_DEBOUNCE */]);
        _this.handlePageVisibility = __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function (visibilityState, documentHidden) {
            if (this.props.visible) {
                this.play(!documentHidden);
            }
        });

        _this.play = function (isPlaying) {
            _this.setState(_extends({}, _this.state, {
                video: _extends({}, _this.state.video, {
                    playing: isPlaying
                })
            }));
        };

        _this.state = {
            video: {
                playing: false,
                loop: true,
                controls: false,
                width: '100%',
                height: 'auto',
                className: 'card-content--video'
            },
            id: Math.random()
        };
        return _this;
    }

    _createClass(CardContent, [{
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps) {
            if (this.props.visible !== nextProps.visible) {
                this.play(nextProps.visible);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                title = _props.title,
                video = _props.video,
                text = _props.text,
                link = _props.link,
                fallback_image = _props.fallback_image,
                app_store_buttons_on_last_card = _props.app_store_buttons_on_last_card,
                google_play_link = _props.google_play_link,
                app_store_link = _props.app_store_link,
                firstCard = _props.firstCard;


            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'article',
                { className: 'card-content' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'h3',
                    { className: 'card-content--title u-reset u-reset__h2' },
                    title
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'card-content--video-wrapper' },
                    app_store_buttons_on_last_card ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'card-content--video-placeholder' }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_9_components_page_visibility__["a" /* default */],
                        { onChange: this.handlePageVisibility.bind(this) },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_10_components_visibility_sensor__["a" /* default */],
                            { onChange: this.handleElementVisibility.bind(this) },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_player___default.a, _extends({
                                url: [video.src_webm, video.src],
                                config: {
                                    file: {
                                        attributes: {
                                            poster: fallback_image.src['@' + Math.min(Object(__WEBPACK_IMPORTED_MODULE_6_util_dom_image_dpi_resolution__["a" /* default */])(), 2)],
                                            autoPlay: this.state.video.playing,
                                            playsInline: true,
                                            muted: true
                                        }
                                    }
                                }
                            }, this.state.video))
                        )
                    ),
                    app_store_buttons_on_last_card && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'card-content--app-store' },
                        google_play_link && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'a',
                            {
                                'aria-label': Object(__WEBPACK_IMPORTED_MODULE_12_translations__["c" /* default */])('accessibility.label.buy_on_googleplay'),
                                className: 'card-content--app-store-link u-reset',
                                href: google_play_link,
                                target: '_blank'
                            },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', {
                                className: 'card-content--app-store-img',
                                src: Object(__WEBPACK_IMPORTED_MODULE_7_util_misc_static_assets_path__["a" /* default */])('img/logos/im-googleplay-badge.svg')
                            })
                        ),
                        app_store_link && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'a',
                            {
                                'aria-label': Object(__WEBPACK_IMPORTED_MODULE_12_translations__["c" /* default */])('accessibility.label.buy_on_appstore'),
                                className: 'card-content--app-store-link u-reset',
                                href: app_store_link,
                                target: '_blank'
                            },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', {
                                className: 'card-content--app-store-img',
                                src: Object(__WEBPACK_IMPORTED_MODULE_7_util_misc_static_assets_path__["a" /* default */])('img/logos/im-appstore-badge.svg')
                            })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'card-content--text' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_cms_placeholder_richtext__["a" /* default */], { value: text, className: 'card-content--richtext' })
                ),
                link && firstCard && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'card-content--link' },
                    link.label
                )
            );
        }
    }]);

    return CardContent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

CardContent.propTypes = {
    title: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    video: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    fallback_image: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    link: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    text: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    app_store_link: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    google_play_link: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    app_store_buttons_on_last_card: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    visible: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    firstCard: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_3_util_redux__["b" /* default */].mapStateToProps({}))(CardContent));

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_form_form_field_input__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_loader__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_button__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_email_input__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_bianco_query__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_collapsible__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_collapsible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_collapsible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_util_misc_get_region__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_util_misc_link_to_dashboard__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_tracking__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_tracking_constants__ = __webpack_require__(234);



var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var MAX_ZIP_LENGTH = 4;

var ZipForm = function (_PureComponent) {
    _inherits(ZipForm, _PureComponent);

    _createClass(ZipForm, null, [{
        key: 'getZipFormTitle',


        /**
         * Get the zip form title depending on the active region
         * @param {object} regionActive - active user region
         * @returns {string}
         */
        value: function getZipFormTitle(regionActive) {
            if (regionActive) {
                return 'zip.modal.title.update';
            }

            return 'zip.modal.title.change';
        }
    }, {
        key: 'getSubmitButtonText',
        value: function getSubmitButtonText(regionActive) {
            if (regionActive) {
                return 'zip.form.save';
            }

            return 'zip.form.go';
        }
    }]);

    function ZipForm(props) {
        _classCallCheck(this, ZipForm);

        var _this = _possibleConstructorReturn(this, (ZipForm.__proto__ || Object.getPrototypeOf(ZipForm)).call(this, props));

        _this.onSubmitZip = function (e) {
            var zip = _this.state.zip;

            var hasRegion = !!_this.props.regionActive;
            e.preventDefault();
            if (zip) {
                _this.props.setRegion({ zip: zip }).then(function (_ref) {
                    var enabled = _ref.enabled;

                    if (enabled) {
                        _this.props.onSuccess();
                    }

                    __WEBPACK_IMPORTED_MODULE_17_tracking__["a" /* default */].form({
                        zip: zip,
                        event: hasRegion ? __WEBPACK_IMPORTED_MODULE_18_tracking_constants__["k" /* UPDATE_ZIP_EVENT */] : __WEBPACK_IMPORTED_MODULE_18_tracking_constants__["j" /* SUBSCRIBE_EVENT */],
                        formType: __WEBPACK_IMPORTED_MODULE_18_tracking_constants__["e" /* FORM_TYPE_ZIP */],
                        formStep: enabled ? 'success' : 'error'
                    });
                });
            }
        };

        _this.onSubscribe = function (e) {
            e.preventDefault();

            var zip = _this.state.zip;

            var _$ = Object(__WEBPACK_IMPORTED_MODULE_12_bianco_query__["a" /* default */])('input[type="email"]', _this.refs.root),
                _$2 = _slicedToArray(_$, 1),
                emailInput = _$2[0];

            var value = emailInput.value;
            var isValid = emailInput.checkValidity();

            _this.setState({ isEmailValid: isValid });

            if (!value || !isValid) {
                return;
            }

            // this.props.subscribe({ email: value }).then(() => tracking.form({ email: value }));
            _this.props.subscribe({ email: value, zip: zip });
        };

        _this.onZipInput = function (e) {
            if (e.length <= MAX_ZIP_LENGTH) {
                _this.setState({ zip: e });
            }
        };

        _this.onEmailChange = function (_ref2) {
            var isValid = _ref2.isValid;

            _this.setState({
                isEmailValid: isValid
            });
        };

        _this.freeNavigation = function () {
            _this.props.closeModal();
        };

        var regionActive = props.regionActive;


        _this.state = {
            isEmailValid: false,
            isAccordionOpen: false,
            hasZip: !!(regionActive && regionActive.zip),
            zip: ''
        };
        return _this;
    }

    _createClass(ZipForm, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.props.regionRequested && !this.props.regionRequested.enabled) {
                this.props.onHeightChange();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.resetRequestedRegion();
        }
    }, {
        key: 'renderAccordion',
        value: function renderAccordion() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_14_react_collapsible___default.a,
                { onOpen: this.props.onHeightChange,
                    onClose: __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default()(this.props.onHeightChange, 50), classParentString: 'zip-form--accordion',
                    transitionTime: 5,
                    onOpening: function onOpening() {
                        return _this2.setState({ isAccordionOpen: true });
                    },
                    onClosing: function onClosing() {
                        return _this2.setState({ isAccordionOpen: false });
                    },
                    trigger: this.renderTrigger() },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'div',
                    { className: 'zip-form--accordion-content', 'aria-hidden': !this.state.isAccordionOpen },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'h2',
                        { className: 'zip-form--accordion-title' },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_translations__["a" /* Trans */], { path: 'zip.accordion.title' })
                    ),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'p',
                        { className: 'zip-form--paragraph' },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_translations__["b" /* TransMD */], { path: 'zip.accordion.text' })
                    )
                )
            );
        }
    }, {
        key: 'renderEmailForm',
        value: function renderEmailForm() {
            var _props = this.props,
                subscriptionEmail = _props.subscriptionEmail,
                isSendingSubscription = _props.isSendingSubscription;
            var _state = this.state,
                isEmailValid = _state.isEmailValid,
                zip = _state.zip;

            var errorMessages = Object(__WEBPACK_IMPORTED_MODULE_11_translations__["c" /* default */])('zip.error.invalid_email');

            var isValid = zip && isEmailValid;

            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: 'zip-form--email' },
                subscriptionEmail ? null : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'p',
                    { className: 'zip-form--description zip-form--paragraph' },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_translations__["a" /* Trans */], { path: 'zip.error.not_available' })
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'form',
                    { noValidate: true, className: 'zip-form--email-form', onSubmit: this.onSubscribe },
                    subscriptionEmail ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'p',
                        { className: 'zip-form--success-message zip-form--paragraph' },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_translations__["a" /* Trans */], { path: 'zip.subscribed' })
                    ) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'div',
                        { className: 'zip-form--row' },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            'div',
                            { className: 'zip-form--input-wrapper' },
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_email_input__["a" /* default */], {
                                onChange: this.onEmailChange,
                                messages: { error: errorMessages },
                                label: Object(__WEBPACK_IMPORTED_MODULE_11_translations__["c" /* default */])('zip.email')
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            'div',
                            { className: 'zip-form--button-wrapper' },
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_9_components_button__["a" /* default */],
                                { size: 'medium',
                                    disabled: !isValid,
                                    className: 'zip-form--form-button zip-form--form-button__email',
                                    facet: 'secondary' },
                                isSendingSubscription ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_loader__["a" /* default */], { size: 'small' }) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_translations__["a" /* Trans */], { path: 'zip.send' })
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'p',
                    null,
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],
                        { to: Object(__WEBPACK_IMPORTED_MODULE_16_util_misc_link_to_dashboard__["a" /* linkToDashboard */])(Object(__WEBPACK_IMPORTED_MODULE_15_util_misc_get_region__["c" /* getRegionSlugByCooperative */])()), onClick: this.freeNavigation },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_translations__["a" /* Trans */], {
                            path: 'zip.keep_browsing' })
                    )
                )
            );
        }
    }, {
        key: 'renderTrigger',
        value: function renderTrigger() {
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { tabIndex: '0', role: 'button', 'aria-expanded': this.state.isAccordionOpen,
                    className: 'zip-form--accordion-trigger' },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'div',
                    { className: 'zip-form--accordion-trigger-text' },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_translations__["a" /* Trans */], { path: 'zip.accordion.trigger' })
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_icon__["a" /* default */], { className: 'zip-form--accordion-icon', size: 'small', symbol: 'chevron-down' })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                descriptionPath = _props2.descriptionPath,
                hasAccordion = _props2.hasAccordion,
                regionActive = _props2.regionActive,
                isFetching = _props2.isFetching,
                regionRequested = _props2.regionRequested,
                cartItems = _props2.cartItems,
                autoFocus = _props2.autoFocus;
            var _state2 = this.state,
                zip = _state2.zip,
                hasZip = _state2.hasZip;

            var submitMessagePath = ZipForm.getSubmitButtonText(regionActive);
            var titlePath = ZipForm.getZipFormTitle(regionActive);
            var hasCartEmpty = !Object.keys(cartItems).length;
            var placeholder = hasZip ? 'zip.form.placeholder_change' : 'zip.form.placeholder';

            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { ref: 'root', className: 'zip-form' },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'div',
                    { className: 'zip-form--content' },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'h2',
                        { className: 'zip-form--title' },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_translations__["a" /* Trans */], { path: titlePath })
                    ),
                    descriptionPath && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'p',
                        { className: 'zip-form--description zip-form--paragraph' },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_translations__["a" /* Trans */], { path: descriptionPath })
                    ),
                    hasCartEmpty ? null : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'p',
                        { className: 'zip-form--description zip-form--paragraph' },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_translations__["b" /* TransMD */], { path: 'zip.clear_cart' })
                    ),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'form',
                        { onSubmit: this.onSubmitZip },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            'div',
                            { className: 'zip-form--row' },
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                'div',
                                { className: 'zip-form--input-wrapper' },
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_form_form_field_input__["a" /* default */], { type: 'number',
                                    value: zip,
                                    state: { error: regionRequested && !regionRequested.enabled },
                                    name: 'zip',
                                    autoFocus: autoFocus,
                                    pattern: '[0-9]*',
                                    onInput: this.onZipInput,
                                    hasFloatingLabel: true,
                                    label: Object(__WEBPACK_IMPORTED_MODULE_11_translations__["c" /* default */])(placeholder) })
                            ),
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                'div',
                                { className: 'zip-form--button-wrapper' },
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_9_components_button__["a" /* default */],
                                    { hasFocus: isFetching,
                                        size: 'medium',
                                        className: 'zip-form--form-button zip-form--form-button__zip',
                                        facet: 'primary' },
                                    isFetching ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_loader__["a" /* default */], { size: 'small' }) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_translations__["a" /* Trans */], { path: submitMessagePath })
                                )
                            )
                        )
                    )
                ),
                regionRequested && !regionRequested.enabled && this.renderEmailForm(),
                hasAccordion && this.renderAccordion()
            );
        }
    }]);

    return ZipForm;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

ZipForm.defaultProps = {
    descriptionPath: '',
    hasAccordion: true,
    onHeightChange: __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a,
    autoFocus: false,
    onSuccess: __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a
};
ZipForm.propTypes = {
    descriptionPath: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    hasAccordion: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
    onHeightChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
    isFetching: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,
    subscriptionEmail: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,
    isSendingSubscription: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,
    subscriptionError: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    history: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
    routeName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,
    routerRegistry: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
    regionActive: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
    regionRequested: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
    resetRequestedRegion: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
    subscribe: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
    cartItems: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
    setRegion: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
    onSuccess: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
    closeModal: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
    autoFocus: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_6_util_redux__["b" /* default */].mapStateToProps({
    regionRequested: 'region.requested',
    regionActive: 'region.active',
    subscriptionEmail: 'subscription.email',
    subscriptionError: 'subscription.error',
    isSendingSubscription: 'subscription.isFetching',
    isFetching: 'region.isFetching',
    cartItems: 'cart.items',
    routerRegistry: 'router.registry',
    history: 'router.history',
    routeName: 'router.name',
    isCartEmpty: 'cart.isEmpty'
}), __WEBPACK_IMPORTED_MODULE_6_util_redux__["b" /* default */].mapDispatchToProps({
    resetRequestedRegion: 'region.reset',
    setRegion: 'region.setRegion',
    subscribe: 'subscription.subscribe',
    closeModal: 'modal.close'
}))(ZipForm));

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_form_field_input__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_misc_validate_email__ = __webpack_require__(1137);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var EmailInput = function (_PureComponent) {
    _inherits(EmailInput, _PureComponent);

    function EmailInput(props) {
        _classCallCheck(this, EmailInput);

        var _this = _possibleConstructorReturn(this, (EmailInput.__proto__ || Object.getPrototypeOf(EmailInput)).call(this, props));

        _this.clearEmailInput = function () {
            _this.setState({ email: '', isValid: false });

            if (_this.props.onChange) {
                _this.props.onChange({ email: '', isValid: false });
            }
        };

        _this.handleEmailInput = function (e) {
            var isValid = Object(__WEBPACK_IMPORTED_MODULE_3_util_misc_validate_email__["a" /* default */])(e);
            _this.setState({ email: e, isValid: isValid });

            if (_this.props.onChange) {
                _this.props.onChange({ email: e, isValid: isValid });
            }
        };

        _this.state = {
            isValid: false,
            email: _this.props.value || ''
        };
        return _this;
    }

    _createClass(EmailInput, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                messages = _props.messages,
                label = _props.label,
                tabIndex = _props.tabIndex;
            var email = this.state.email;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_form_form_field_input__["a" /* default */], {
                type: 'email',
                name: 'email',
                value: email,
                hasFloatingLabel: true,
                label: label,
                onInput: this.handleEmailInput,
                tabIndex: tabIndex,
                messages: messages,
                hasClearAction: this.clearEmailInput
            });
        }
    }]);

    return EmailInput;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

EmailInput.defaultProps = {};
EmailInput.propTypes = {
    messages: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    tabIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (EmailInput);

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_form_form_field_input__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_loader__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_button__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_collapsible__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_collapsible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_collapsible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_email_input__ = __webpack_require__(591);



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var PrelaunchForm = function (_PureComponent) {
    _inherits(PrelaunchForm, _PureComponent);

    function PrelaunchForm(props) {
        _classCallCheck(this, PrelaunchForm);

        var _this = _possibleConstructorReturn(this, (PrelaunchForm.__proto__ || Object.getPrototypeOf(PrelaunchForm)).call(this, props));

        _this.onEmailChange = function (_ref) {
            var email = _ref.email,
                isValid = _ref.isValid;

            _this.setState({ email: email, emailIsValid: isValid }, function () {
                return _this.validateForm();
            });
        };

        _this.clearNumberInput = function () {
            _this.setState({ zip: '', numberIsValid: false }, function () {
                return _this.validateForm();
            });
        };

        _this.handleNumberInput = function (e) {
            if (e.length <= 4) {
                _this.setState({ zip: e });
            }
            if (e.length === 4) {
                _this.setState({ numberIsValid: true }, function () {
                    return _this.validateForm();
                });
            }
        };

        _this.handleSubmit = function (e) {
            e.preventDefault();
            var _this$state = _this.state,
                zip = _this$state.zip,
                email = _this$state.email;

            _this.props.subscribe({ email: email, zip: zip }).then(function () {
                _this.setState({ isSent: true });
                _this.props.onHeightChange();
            });
        };

        _this.validateForm = function () {
            if (_this.state.emailIsValid && _this.state.numberIsValid) {
                _this.setState({ valid: true });
            } else {
                _this.setState({ valid: false });
            }
        };

        _this.state = {
            valid: false,
            numberIsValid: false,
            emailIsValid: false,
            zip: '',
            email: '',
            isSent: false
        };
        return _this;
    }

    _createClass(PrelaunchForm, [{
        key: 'renderAccordion',
        value: function renderAccordion() {
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11_react_collapsible___default.a,
                {
                    onOpen: this.props.onHeightChange,
                    onClose: __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default()(this.props.onHeightChange, 50),
                    classParentString: 'prelaunch-form--accordion',
                    transitionTime: 5,
                    trigger: this.renderTrigger()
                },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'div',
                    { className: 'prelaunch-form--accordion-content' },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'h2',
                        { className: 'prelaunch-form--accordion-title' },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_translations__["a" /* Trans */], { path: 'zip.accordion.title' })
                    ),
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'p',
                        { className: 'prelaunch-form--paragraph' },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_translations__["a" /* Trans */], { path: 'zip.accordion.text' })
                    )
                )
            );
        }
    }, {
        key: 'renderTrigger',
        value: function renderTrigger() {
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { className: 'prelaunch-form--accordion-trigger' },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'div',
                    { className: 'prelaunch-form--accordion-trigger-text' },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_translations__["a" /* Trans */], { path: 'zip.accordion.trigger' })
                ),
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_icon__["a" /* default */], { className: 'prelaunch-form--accordion-icon', size: 'small', symbol: 'chevron-down' })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                autoFocus = _props.autoFocus,
                isSendingSubscription = _props.isSendingSubscription;
            var _state = this.state,
                zip = _state.zip,
                email = _state.email,
                isSent = _state.isSent,
                valid = _state.valid;


            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                'div',
                { ref: 'root', className: 'prelaunch-form' },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                    'div',
                    { className: 'prelaunch-form--content' },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'h2',
                        { className: 'prelaunch-form--title' },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_translations__["a" /* Trans */], { path: 'prelaunch.modal.title' })
                    ),
                    isSent ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'div',
                        { className: 'prelaunch-form--success' },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_translations__["a" /* Trans */], { path: 'prelaunch.modal.success' })
                    ) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                        'form',
                        { onSubmit: this.handleSubmit },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            'div',
                            { className: 'prelaunch-form--row' },
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                'div',
                                { className: 'prelaunch-form--col-zip prelaunch-form--input-wrapper' },
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_form_form_field_input__["a" /* default */], {
                                    type: 'number',
                                    name: 'zip',
                                    value: zip,
                                    autoFocus: autoFocus,
                                    hasFloatingLabel: true,
                                    label: Object(__WEBPACK_IMPORTED_MODULE_9_translations__["c" /* default */])('zip.form.placeholder'),
                                    onInput: this.handleNumberInput,
                                    tabIndex: 1,
                                    hasClearAction: this.clearNumberInput
                                })
                            ),
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                'div',
                                { className: 'prelaunch-form--col-email prelaunch-form--input-wrapper' },
                                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_email_input__["a" /* default */], {
                                    onChange: this.onEmailChange,
                                    tabIndex: 2,
                                    value: email,
                                    label: Object(__WEBPACK_IMPORTED_MODULE_9_translations__["c" /* default */])('zip.email')
                                })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                            'div',
                            { className: 'prelaunch-form--row' },
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_components_button__["a" /* default */],
                                {
                                    hasFocus: isSendingSubscription,
                                    size: 'medium',
                                    className: 'prelaunch-form--form-button prelaunch-form--form-button__zip',
                                    facet: 'primary',
                                    disabled: !valid
                                },
                                isSendingSubscription ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_loader__["a" /* default */], { size: 'small' }) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_translations__["a" /* Trans */], { path: 'prelaunch.modal.submit' })
                            )
                        )
                    )
                ),
                this.renderAccordion()
            );
        }
    }]);

    return PrelaunchForm;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

PrelaunchForm.defaultProps = {
    hasAccordion: true,
    onHeightChange: __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a,
    autoFocus: true
};
PrelaunchForm.propTypes = {
    isSendingSubscription: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
    subscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
    onHeightChange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    closeModal: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    autoFocus: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_5_util_redux__["b" /* default */].mapStateToProps({
    isSendingSubscription: 'subscription.isFetching',
    routeName: 'router.name'
}), __WEBPACK_IMPORTED_MODULE_5_util_redux__["b" /* default */].mapDispatchToProps({
    setRegion: 'region.setRegion',
    subscribe: 'subscription.subscribePrelaunch',
    closeModal: 'modal.close'
}))(PrelaunchForm));

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_products_slider_header__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tracking_constants__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_slider__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_product_tile__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_util_dom_mq__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__slider_config_js__ = __webpack_require__(1148);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var ContentPageProductSlider = function (_PureComponent) {
    _inherits(ContentPageProductSlider, _PureComponent);

    function ContentPageProductSlider() {
        _classCallCheck(this, ContentPageProductSlider);

        return _possibleConstructorReturn(this, (ContentPageProductSlider.__proto__ || Object.getPrototypeOf(ContentPageProductSlider)).apply(this, arguments));
    }

    _createClass(ContentPageProductSlider, [{
        key: 'numberOfItems',
        value: function numberOfItems(maxItems, amountPerRow) {
            return amountPerRow - maxItems % amountPerRow;
        }
    }, {
        key: 'renderPromotionTile',
        value: function renderPromotionTile() {
            var _props = this.props,
                link = _props.link,
                isMobile = _props.isMobile,
                historyPush = _props.historyPush;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'article',
                {
                    onClick: function onClick() {
                        // on mobile the whole tile surface should be a link
                        if (isMobile) {
                            historyPush(link);
                        }
                    },
                    className: 'products-slider--show-promotions',
                    key: 'show-promotions'
                },
                link && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */],
                    {
                        to: link,
                        className: 'products-slider--show-promotions-text u-reset' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_translations__["a" /* Trans */], { path: 'categories.show_all' })
                ),
                link && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Link */],
                    {
                        to: link,
                        className: 'products-slider--show-promotions-icon u-reset' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_icon__["a" /* default */], { symbol: 'productslider-right', size: 'medium' })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                title = _props2.title,
                lead = _props2.lead,
                link = _props2.link,
                isMobile = _props2.isMobile,
                appendPromotionTile = _props2.appendPromotionTile,
                isTablet = _props2.isTablet,
                isTouch = _props2.isTouch;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'contentpage-product-slider products-slider' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_products_slider_header__["a" /* default */], {
                    title: title,
                    link: link
                }),
                lead && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'contentpage-product-slider--lead', dangerouslySetInnerHTML: { __html: lead } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_components_slider__["a" /* default */],
                    {
                        useNativeScroll: isMobile || isTablet && isTouch,
                        facet: 'topic-slider',
                        updateOnInteraction: true,
                        config: __WEBPACK_IMPORTED_MODULE_13__slider_config_js__["a" /* default */] },
                    Object(__WEBPACK_IMPORTED_MODULE_3_looppa__["a" /* default */])(this.trimmedProducts)(function (product, index) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_product_tile__["a" /* default */], _extends({}, product, {
                            position: index,
                            facet: product ? 'overview' : 'placeholder',
                            tileFacet: 'contentpage',
                            list: __WEBPACK_IMPORTED_MODULE_4_tracking_constants__["g" /* PRODUCT_LIST_PRODUCT_SLIDER */],
                            key: product && product.id ? product.id : index }));
                    }).concat([appendPromotionTile ? this.renderPromotionTile() : null])
                )
            );
        }
    }, {
        key: 'trimmedProducts',
        get: function get() {
            var products = this.props.products;

            // Render a maximum of 4 rows in slider; row-size depends on the current viewport

            var amountPerRow = __WEBPACK_IMPORTED_MODULE_13__slider_config_js__["b" /* productTileAmounts */][Object(__WEBPACK_IMPORTED_MODULE_12_util_dom_mq__["a" /* getViewportData */])().query];
            var maxItems = Math.min(amountPerRow * 4, products.length);

            // Add placeholders if there are not enough items to fill one row
            if (products.length < amountPerRow - 1) {
                var numberOfItems = this.numberOfItems(maxItems, amountPerRow);
                var placeholders = Array(numberOfItems).fill(null);
                products = products.slice(0, maxItems).concat(placeholders);
            }

            return products;
        }
    }]);

    return ContentPageProductSlider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

ContentPageProductSlider.propTypes = {
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    lead: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    link: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    appendPromotionTile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    products: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,

    historyPush: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    isMobile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    isTouch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    isTablet: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};
ContentPageProductSlider.defaultProps = {
    link: null,
    appendPromotionTile: true
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_10_util_redux__["b" /* default */].mapStateToProps({
    isMobile: 'viewport.isMobile',
    isTablet: 'viewport.isTablet',
    isTouch: 'viewport.touchevents',
    historyPush: 'router.history.push'
}))(ContentPageProductSlider));

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Rating;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_star_rating_component__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_star_rating_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_star_rating_component__);




function Rating(_ref) {
    var name = _ref.name,
        isEditing = _ref.isEditing,
        value = _ref.value;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rating', itemProp: 'aggregateRating', itemScope: true, itemType: 'http://schema.org/AggregateRating' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_star_rating_component___default.a, {
            name: name,
            editing: isEditing,
            starColor: '#ff6600',
            emptyStarColor: '#9f9fa1'
            //renderStarIconHalf={(val) => <div style={{ overflow: 'hidden', width: `${ ((val - value) * -100)}%` }}>&#9733;</div>}
            , renderStarIcon: function renderStarIcon() {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    '\u2605'
                );
            },
            starCount: 5,
            value: value
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta', { itemProp: 'ratingValue', content: value })
    );
}

Rating.propTypes = {
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    reviews: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    isEditing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};

/***/ }),
/* 595 */,
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_misc_log_error__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_debug_promotion_code_logger__ = __webpack_require__(418);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var OrderPromotionList = function (_PureComponent) {
    _inherits(OrderPromotionList, _PureComponent);

    function OrderPromotionList() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, OrderPromotionList);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrderPromotionList.__proto__ || Object.getPrototypeOf(OrderPromotionList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(OrderPromotionList, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            Object(__WEBPACK_IMPORTED_MODULE_6__util_debug_promotion_code_logger__["a" /* default */])({ promotions: this.props.promotions });
        }
    }, {
        key: 'renderPromotion',
        value: function renderPromotion(promotion, key) {
            var translationKey = 'order.promotions.' + promotion.code;
            var translatedPromo = Object(__WEBPACK_IMPORTED_MODULE_1_translations__["f" /* t */])(translationKey);
            var translationExists = translationKey !== translatedPromo;

            if (!translationExists && promotion.code !== promotion.name && promotion.name) {
                translatedPromo = promotion.name;
            } else if (!translationExists) {
                Object(__WEBPACK_IMPORTED_MODULE_5_util_misc_log_error__["a" /* default */])(new Error('Unable to translate promotion with key: \'' + translationKey + '\''), promotion);
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: key, className: 'order-promotion-list--item' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'order-promotion-list--item-label' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'order-products-list--marker-text' },
                        translatedPromo
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'order-promotion-list--item-value' },
                    '-',
                    promotion.amount
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                promotions = _props.promotions,
                facet = _props.facet;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('order-promotion-list', 'order-promotion-list__' + facet) },
                Object(__WEBPACK_IMPORTED_MODULE_3_looppa__["a" /* default */])(promotions)(function (promotion, i) {
                    return _this2.renderPromotion(promotion, i);
                })
            );
        }
    }]);

    return OrderPromotionList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

OrderPromotionList.propTypes = {
    promotions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,
    facet: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (OrderPromotionList);

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_product_tile__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__search_panel_no_hits__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_visibility_sensor__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_loader__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_tracking_constants__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_constants_debounce_delays__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__search_panel_header__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_classnames__);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var SearchPanelProductList = function (_Component) {
    _inherits(SearchPanelProductList, _Component);

    function SearchPanelProductList() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SearchPanelProductList);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchPanelProductList.__proto__ || Object.getPrototypeOf(SearchPanelProductList)).call.apply(_ref, [this].concat(args))), _this), _this.onBottomScroll = function () {
            _this.debouncedScroll();
        }, _this.debouncedScroll = __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function () {
            this.props.loadMore();
        }, __WEBPACK_IMPORTED_MODULE_11_constants_debounce_delays__["g" /* SEARCH_SCROLL_DEBOUNCE */]), _this.loader = function () {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'search-panel-product-list--loader' });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SearchPanelProductList, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                products = _props.products,
                productsTotal = _props.productsTotal,
                isSearching = _props.isSearching,
                isLoadingMore = _props.isLoadingMore;

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__search_panel_header__["a" /* default */], {
                    title: Object(__WEBPACK_IMPORTED_MODULE_13_translations__["f" /* t */])('search.query_result_products_title') + ' ' + (productsTotal > 0 ? '(' + productsTotal + ')' : '')
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    {
                        className: __WEBPACK_IMPORTED_MODULE_14_classnames___default()('search-panel-product-list', {
                            'search-panel-product-list__is-searching': isSearching && !isLoadingMore
                        })
                    },
                    products.length > 0 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'ul',
                            { className: 'search-panel-product-list--collection u-reset' },
                            Object(__WEBPACK_IMPORTED_MODULE_4_looppa__["a" /* default */])(products)(function (item, i) {
                                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    'li',
                                    { className: 'search-panel-product-list--item', key: item.id },
                                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_product_tile__["a" /* default */], _extends({}, item, { position: i, facet: 'list',
                                        list: __WEBPACK_IMPORTED_MODULE_10_tracking_constants__["i" /* PRODUCT_LIST_SEARCH_RESULTS */] }))
                                );
                            })
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_8_components_visibility_sensor__["a" /* default */],
                            { onEnter: this.onBottomScroll },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'div',
                                { className: 'search-panel-product-list--load-more' },
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    'div',
                                    { className: 'search-panel-product-list--loader' },
                                    productsTotal > products.length && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_loader__["a" /* default */], null)
                                )
                            )
                        )
                    ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__search_panel_no_hits__["a" /* default */], null)
                )
            );
        }
    }]);

    return SearchPanelProductList;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

SearchPanelProductList.propTypes = {
    isSearching: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    isLoadingMore: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    loadMore: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    products: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,
    productsTotal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_5_util_redux__["b" /* default */].mapStateToProps({
    isSearching: 'search.isSearching',
    isLoadingMore: 'search.isLoadingMore',
    products: 'search.products',
    productsTotal: 'search.productsTotal'
}), __WEBPACK_IMPORTED_MODULE_5_util_redux__["b" /* default */].mapDispatchToProps({
    loadMore: 'search.loadMore'
}))(SearchPanelProductList));

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tracking_constants__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_product_tile__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__search_panel_no_hits__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__search_panel_header__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_translations__ = __webpack_require__(171);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var SearchPanelFavoriteProductList = function (_Component) {
    _inherits(SearchPanelFavoriteProductList, _Component);

    function SearchPanelFavoriteProductList() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SearchPanelFavoriteProductList);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchPanelFavoriteProductList.__proto__ || Object.getPrototypeOf(SearchPanelFavoriteProductList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isLoading: true
        }, _this._isUnmounted = false, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SearchPanelFavoriteProductList, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.props.populateFavoriteProducts().then(function () {
                if (!_this2._isUnmounted) {
                    _this2.setState({ isLoading: false });
                }
            });
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            if (this.state.isLoading === nextState.isLoading) {
                return false;
            }

            return true;
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this._isUnmounted = true;
        }
    }, {
        key: 'render',
        value: function render() {
            var favoriteProducts = this.props.favoriteProducts;
            var isLoading = this.state.isLoading;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__search_panel_header__["a" /* default */], { title: '' + Object(__WEBPACK_IMPORTED_MODULE_9_translations__["f" /* t */])('search.personalized_products_title'), isLoading: isLoading }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'search-panel-favorite-product-list' },
                    favoriteProducts.length > 0 || isLoading ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'ul',
                            { className: 'search-panel-favorite-product-list--collection u-reset' },
                            Object(__WEBPACK_IMPORTED_MODULE_3_looppa__["a" /* default */])(favoriteProducts)(function (item, i) {
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'li',
                                    { className: 'search-panel-favorite-product-list--item', key: item.id },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_product_tile__["a" /* default */], _extends({}, item, {
                                        skipTests: true,
                                        facet: 'list',
                                        position: i,
                                        list: __WEBPACK_IMPORTED_MODULE_5_tracking_constants__["h" /* PRODUCT_LIST_RECOMMMENDATIONS */] }))
                                );
                            })
                        )
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__search_panel_no_hits__["a" /* default */], null)
                )
            );
        }
    }]);

    return SearchPanelFavoriteProductList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SearchPanelFavoriteProductList.propTypes = {
    favoriteProducts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
    populateFavoriteProducts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_4_util_redux__["b" /* default */].mapStateToProps({
    favoriteProducts: 'user.favoriteProducts'
}), __WEBPACK_IMPORTED_MODULE_4_util_redux__["b" /* default */].mapDispatchToProps({
    populateFavoriteProducts: 'user.populateFavoriteProducts'
}))(SearchPanelFavoriteProductList));

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__search_panel_no_hits__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_misc_normalise_trailing_slash__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_misc_link_to_dashboard__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_misc_find_leaf_category_by_slug__ = __webpack_require__(600);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var SearchPanelCategoryList = function (_PureComponent) {
    _inherits(SearchPanelCategoryList, _PureComponent);

    function SearchPanelCategoryList(props) {
        _classCallCheck(this, SearchPanelCategoryList);

        var _this = _possibleConstructorReturn(this, (SearchPanelCategoryList.__proto__ || Object.getPrototypeOf(SearchPanelCategoryList)).call(this, props));

        _this.onLinkClink = function (slug) {
            _this.props.closeSearch();
            _this.props.reset();
            _this.props.unlockScroll();

            // if we are in a page with leaf categories
            // a click might trigger an autoscroll
            // see also https://jira.migros.net/browse/MCART-2340
            var leafCategorySlug = slug.split('/').pop();
            if (_this.props.activeCategory && leafCategorySlug && _this.props.routeParams && _this.props.routeParams.leafCategory && leafCategorySlug !== _this.props.routeParams.leafCategory) {
                _this.scrollToLeafCategory(leafCategorySlug);
            }
        };

        _this.state = {
            items: props.productsTotal > 0 || props.term.length > 0 ? props.categories : props.commonCategories
        };
        return _this;
    }

    _createClass(SearchPanelCategoryList, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var categories = _ref.categories,
                productsTotal = _ref.productsTotal,
                commonCategories = _ref.commonCategories,
                term = _ref.term;

            if (productsTotal > 0 || term.length > 0) {
                this.setState({ items: categories });
            } else {
                this.setState({ items: commonCategories });
            }
        }
    }, {
        key: 'scrollToLeafCategory',
        value: function scrollToLeafCategory(leafSlug) {
            var activeLeafCategory = Object(__WEBPACK_IMPORTED_MODULE_9_util_misc_find_leaf_category_by_slug__["a" /* default */])(this.props.activeCategory, leafSlug);

            if (activeLeafCategory) {
                this.props.setPendingAutoscroll({ mustAutoscroll: true });
                this.props.setActiveLeafCategory({ category: activeLeafCategory });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var activeRegion = this.props.activeRegion;
            var items = this.state.items;

            var url = Object(__WEBPACK_IMPORTED_MODULE_8_util_misc_link_to_dashboard__["c" /* linkToDashboardByUser */])(activeRegion);
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'grid--row search-panel-category' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'ul',
                    { className: 'grid--col search-panel-category--list u-reset' },
                    items.length > 0 ? Object(__WEBPACK_IMPORTED_MODULE_5_looppa__["a" /* default */])(items)(function (item, i) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'li',
                            { key: i },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],
                                {
                                    onClick: function onClick() {
                                        return _this2.onLinkClink(item.slug);
                                    },
                                    className: 'search-panel-category--link u-reset',
                                    to: Object(__WEBPACK_IMPORTED_MODULE_7_util_misc_normalise_trailing_slash__["a" /* default */])('' + url + item.slug)
                                },
                                item.name
                            )
                        );
                    }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__search_panel_no_hits__["a" /* default */], null)
                )
            );
        }
    }]);

    return SearchPanelCategoryList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

SearchPanelCategoryList.propTypes = {
    categories: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array.isRequired,
    routeParams: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
    activeCategory: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
    categoriesTotal: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
    fetchedCategories: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array.isRequired,
    closeSearch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    commonCategories: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array.isRequired,
    productsTotal: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
    routerRegistry: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    term: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
    setActiveLeafCategory: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    setPendingAutoscroll: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    unlockScroll: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    activeRegion: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
    reset: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_6_util_redux__["b" /* default */].mapStateToProps({
    categories: 'search.categories',
    activeCategory: 'categories.active',
    fetchedCategories: 'categories.items',
    categoriesTotal: 'search.categoriesTotal',
    commonCategories: 'search.commonCategories',
    activeRegion: 'region.active',
    routeParams: 'router.match.params',
    productsTotal: 'search.categoriesTotal',
    routerRegistry: 'router.registry',
    term: 'search.term'
}), __WEBPACK_IMPORTED_MODULE_6_util_redux__["b" /* default */].mapDispatchToProps({
    closeSearch: 'search.close',
    unlockScroll: 'scroll.unlock',
    setActiveLeafCategory: 'categories.setActiveLeafCategory',
    setPendingAutoscroll: 'scroll.setPendingAutoscroll',
    reset: 'search.reset'
}))(SearchPanelCategoryList));

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findLeafBySlug;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__get_last_url_fragment__ = __webpack_require__(601);

/**
 * Find a leaf category from the a category node by slug
 * @param { Object } category - category possibly containing the children leafs
 * @param {string} leafCategorySlug - leaf category slug to find
 * @return {Object|undefined}
 */
function findLeafBySlug(category, leafCategorySlug) {
  return category.children.find(function (c) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__get_last_url_fragment__["a" /* default */])(c.slug) === leafCategorySlug;
  });
};

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getLastUrlFragment;
/**
 * Get the last part of an url path
 * @param {string} url - url path
 * @param {number} offset - the last offset index
 * @return {string} the fragment we want to retrive
 *
 * @example
 * getLastUrlFragment('foo/bar/baz/') // 'baz'
 *
 * @example
 * getLastUrlFragment('foo/bar/baz/', 1) // 'bar'
 *
 * @example
 * getLastUrlFragment('foo/bar/baz/', 2) // 'foo'
 *
 * @example
 * getLastUrlFragment('foo/bar/baz/', 3) // ''
 */
function getLastUrlFragment(url) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var fragments = url.split('/').filter(Boolean);
  var index = fragments.length - (1 + offset);

  return fragments[index] || '';
}

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PaymentPlatforms;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_misc_static_assets_path__ = __webpack_require__(197);




function PaymentPlatforms() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'section',
        { className: 'payment-platforms' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            { className: 'payment-platforms--title u-reset' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_translations__["a" /* Trans */], { path: 'payment.title' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { className: 'payment-platforms--list u-reset' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { className: 'payment-platforms--item' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'payment-platforms--image', width: '62', src: Object(__WEBPACK_IMPORTED_MODULE_2_util_misc_static_assets_path__["a" /* default */])('img/logos/visa.svg'),
                    alt: Object(__WEBPACK_IMPORTED_MODULE_1_translations__["f" /* t */])('payment.visa.image') })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { className: 'payment-platforms--item' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'payment-platforms--image', width: '47', src: Object(__WEBPACK_IMPORTED_MODULE_2_util_misc_static_assets_path__["a" /* default */])('img/logos/mastercard.svg'),
                    alt: Object(__WEBPACK_IMPORTED_MODULE_1_translations__["f" /* t */])('payment.mastercard.image') })
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'payment-platforms--description u-reset' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_translations__["a" /* Trans */], { path: 'payment.description' })
        )
    );
}

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ProductInfoCard;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_rating__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_misc_get_product_price__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_misc_format_price__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_react_format_product_short_description__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_react_stack_images_path__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants_api_images_types__ = __webpack_require__(288);

/* eslint-disable camelcase */












function Price(_ref) {
    var price_information = _ref.price_information;

    var realPrice = Object(__WEBPACK_IMPORTED_MODULE_5_util_misc_get_product_price__["a" /* default */])(price_information);
    var hasBadge = !__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(price_information.badge);
    var hasDiscount = !__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(price_information.original_price);

    if (hasBadge) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'product-info-card--discount', itemProp: 'offers', itemScope: true, itemType: 'http://schema.org/Offer' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'product-info-card--price' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('meta', { itemProp: 'priceCurrency', content: 'CHF' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { itemProp: 'price' },
                    Object(__WEBPACK_IMPORTED_MODULE_6_util_misc_format_price__["a" /* default */])(realPrice)
                )
            ),
            hasDiscount && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'product-info-card--old-price' },
                Object(__WEBPACK_IMPORTED_MODULE_4_translations__["c" /* default */])('products.instead_of'),
                ' ',
                Object(__WEBPACK_IMPORTED_MODULE_6_util_misc_format_price__["a" /* default */])(price_information.original_price)
            )
        );
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'product-info-card--price', itemProp: 'offers', itemScope: true, itemType: 'http://schema.org/Offer' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('meta', { itemProp: 'priceCurrency', content: 'CHF' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { itemProp: 'price' },
            Object(__WEBPACK_IMPORTED_MODULE_6_util_misc_format_price__["a" /* default */])(realPrice)
        )
    );
}

Price.propTypes = {
    short_description: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
    price_information: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};

function ProductInfoCard(_ref2) {
    var name = _ref2.name,
        price_information = _ref2.price_information,
        ratings = _ref2.ratings,
        slug = _ref2.slug,
        short_description = _ref2.short_description;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'article',
        { className: 'product-info-card' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'product-info-card--price-info' },
            price_information.badge ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { className: 'product-info-card--badge',
                src: Object(__WEBPACK_IMPORTED_MODULE_8__util_react_stack_images_path__["b" /* imageByDpi */])(Object(__WEBPACK_IMPORTED_MODULE_8__util_react_stack_images_path__["c" /* productImage */])(price_information.badge, __WEBPACK_IMPORTED_MODULE_9_constants_api_images_types__["a" /* BADGE_DETAIL */])) }) : null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Price, { price_information: price_information })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h1',
            { className: 'product-info-card--title u-reset', itemProp: 'name' },
            name
        ),
        short_description && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            { className: 'product-info-card--paragraph' },
            Object(__WEBPACK_IMPORTED_MODULE_7_util_react_format_product_short_description__["a" /* default */])(short_description)
        ),
        ratings.average_all ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_rating__["a" /* default */], { isEditing: false, value: ratings.average_all, reviews: ratings.count_all,
            name: slug || name }) : ''
    );
}

ProductInfoCard.propTypes = {
    short_description: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
    name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    price_information: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    ratings: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    slug: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = BrandsList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_react_stack_images_path__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_react_image_attributes__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









function BrandsList(_ref) {
    var brands = _ref.brands;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'brands-list' },
        brands.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'brands-list--title u-reset' },
            Object(__WEBPACK_IMPORTED_MODULE_3_translations__["c" /* default */])('brands.title')
        ) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { className: 'brands-list--list u-reset' },
            Object(__WEBPACK_IMPORTED_MODULE_2_looppa__["a" /* default */])(brands)(function (brand, i) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'li',
                    { key: i, className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('brands-list--item', { 'brands-list--item__has-image': !!brand.image }) },
                    brand.image ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', _extends({ className: 'brands-list--image', alt: brand.name }, Object(__WEBPACK_IMPORTED_MODULE_5_util_react_image_attributes__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4_util_react_stack_images_path__["a" /* brandImage */])(brand.image)))) : null,
                    brand.name
                );
            })
        )
    );
}

BrandsList.propTypes = {
    brands: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired
};

BrandsList.defaultProps = {
    brands: []
};

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ProductDetailsContent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_slider__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_product_specs__ = __webpack_require__(1197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_product_info_card__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_buy_box__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_brands_list__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_react_stack_images_path__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_react_image_attributes__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__slider_config__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_constants_api_images_types__ = __webpack_require__(288);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable camelcase */













function renderDetailsPanel(product) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'section',
        { className: 'product-details-panel' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_product_info_card__["a" /* default */], product),
        product.regulated_description ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'product-details-content--paragraph' },
            product.regulated_description
        ) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_brands_list__["a" /* default */], { brands: product.brands })
    );
}

function renderImage(img, key) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'figure',
        { className: 'product-details-content--image-wrapper', key: key || 0 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', _extends({ className: 'product-details-content--image', alt: '' }, Object(__WEBPACK_IMPORTED_MODULE_9_util_react_image_attributes__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8_util_react_stack_images_path__["c" /* productImage */])(img, __WEBPACK_IMPORTED_MODULE_11_constants_api_images_types__["c" /* DETAIL */]))))
    );
}

function ProductDetailsContent(_ref) {
    var product = _ref.product,
        facet = _ref.facet,
        mustIncludeDetailsPanel = _ref.mustIncludeDetailsPanel,
        hasBuyBox = _ref.hasBuyBox;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'product-details-content product-details-content__' + facet },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'product-details-content--inner-content' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'product-details-content--slider' },
                product.images.length > 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_components_slider__["a" /* default */],
                    {
                        facet: 'product-detail',
                        config: __WEBPACK_IMPORTED_MODULE_10__slider_config__["a" /* default */]
                    },
                    Object(__WEBPACK_IMPORTED_MODULE_1_looppa__["a" /* default */])(product.images)(renderImage)
                ) : renderImage(product.image)
            ),
            mustIncludeDetailsPanel ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { className: 'product-details-content--paragraph' },
                product.regulated_description
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'product-details-content--panel' },
            mustIncludeDetailsPanel ? renderDetailsPanel(product) : null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'product-details-content--inner-content' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'product-details-content--tabs' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_product_specs__["a" /* default */], { sections: product.sections })
                )
            )
        ),
        mustIncludeDetailsPanel && hasBuyBox ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_buy_box__["a" /* default */], { product: product, facet: facet === 'modal' ? null : 'fixed' }) : null
    );
}

ProductDetailsContent.propTypes = {
    product: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    facet: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    mustIncludeDetailsPanel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    hasBuyBox: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
};

ProductDetailsContent.defaultProps = {
    facet: 'base'
};

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_page_layout__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_page_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_page_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_main_footer__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_react_facet__ = __webpack_require__(185);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * This is actually the two columns layout grid but without the sidebar
 */

var Webview = function (_Component) {
    _inherits(Webview, _Component);

    function Webview() {
        _classCallCheck(this, Webview);

        return _possibleConstructorReturn(this, (Webview.__proto__ || Object.getPrototypeOf(Webview)).apply(this, arguments));
    }

    _createClass(Webview, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                facet = _props.facet,
                props = _objectWithoutProperties(_props, ['facet']);

            var facetClasses = Object(__WEBPACK_IMPORTED_MODULE_5_util_react_facet__["a" /* default */])(facet, 'layout');

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                _extends({}, props, { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('layout', 'layout__two-cols', facetClasses) }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'layout--row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'main',
                        { className: 'layout--page grid grid__two-cols' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'layout--grid-container grid--container' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'layout--page-container layout--page-container__is-loaded' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_page_layout__["Slot"], { className: 'layout--page-content', name: 'content' }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_main_footer__["a" /* default */], null)
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Webview;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Webview.propTypes = {
    facet: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array])
};
/* harmony default export */ __webpack_exports__["a"] = (Webview);

/***/ }),
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = linkToSiblingRegion;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__get_region__ = __webpack_require__(305);


/**
 * Return a url replacing the slug of the current page region with the user's one
 * @param {object|string} userRegion - current user region
 * @param {object|string} pageRegion - current page region
 * @param {string} url - url to normalize
 * @returns {string} eventually a link to a new page
 * @example
 *
 * linkToSiblingRegion('zuerich', 'bern', 'produkte-bern/lebensmittel/baeckerei-confiserie-backen/brote')
 * // returns => produkte-zuerich/lebensmittel/baeckerei-confiserie-backen/brote
 */
function linkToSiblingRegion(userRegion, pageRegion, url) {
    var userRegionSlug = Object(__WEBPACK_IMPORTED_MODULE_0__get_region__["d" /* getRegionSlugBySlug */])(userRegion);
    var pageRegionSlug = Object(__WEBPACK_IMPORTED_MODULE_0__get_region__["c" /* getRegionSlugByCooperative */])(pageRegion);

    if (userRegionSlug !== pageRegionSlug) {
        return url.replace(pageRegionSlug, userRegionSlug);
    }

    return url;
}

/***/ }),
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bianco_events__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_page_layout__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_page_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_page_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_dom_mq__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_dom_scroll_top__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_constants_debounce_delays__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_side_panel__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_main_header__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_content_overlay__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_modal__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_delivery_notification__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_autologin__ = __webpack_require__(1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_livechat__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_accessibile_alert__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_skiplinks__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_snackbar__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_layouts_webview__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_layouts__ = __webpack_require__(1221);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













// Components






// import Feedbackify from 'components/feedbackify';





// Pages layouts


var currentScrollTop = Object(__WEBPACK_IMPORTED_MODULE_9_util_dom_scroll_top__["a" /* default */])();

var nativeLayouts = Object.keys(__WEBPACK_IMPORTED_MODULE_22_layouts__["a" /* default */]).reduce(function (acc, key) {
    acc[key] = __WEBPACK_IMPORTED_MODULE_21_layouts_webview__["a" /* default */];
    return acc;
}, {});

var Root = function (_Component) {
    _inherits(Root, _Component);

    function Root(props) {
        _classCallCheck(this, Root);

        var _this = _possibleConstructorReturn(this, (Root.__proto__ || Object.getPrototypeOf(Root)).call(this, props));

        _this.onNetworkStateChanged = function () {
            _this.props.setNetworkState({ isOnline: navigator.onLine });
        };

        _this.onScroll = function () {
            if (_this.props.isScrollLocked) {
                return;
            }

            var newScrollTop = Object(__WEBPACK_IMPORTED_MODULE_9_util_dom_scroll_top__["a" /* default */])();
            currentScrollTop = newScrollTop;
        };

        _this.updateViewport = function () {
            _this.props.setViewport({
                width: window.innerWidth,
                height: window.innerHeight,
                mq: Object(__WEBPACK_IMPORTED_MODULE_8_util_dom_mq__["a" /* getViewportData */])()
            });
        };

        _this.renderLiveChat = function () {
            if (_this.state.isPrelaunch || _this.props.isNative) {
                return '';
            }

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_livechat__["a" /* default */], null);
        };

        _this.state = {
            isPrelaunch: window.location.href.indexOf('prelaunch-counter') > -1
        };
        _this.updateViewport();
        return _this;
    }

    _createClass(Root, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            Object(__WEBPACK_IMPORTED_MODULE_2_bianco_events__["a" /* add */])(window, 'resize orientationchange', __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(this.updateViewport, __WEBPACK_IMPORTED_MODULE_10_constants_debounce_delays__["f" /* RESIZE_DEBOUNCE */]), { passive: true });
            Object(__WEBPACK_IMPORTED_MODULE_2_bianco_events__["a" /* add */])(window, 'scroll', this.onScroll, { passive: true });
            Object(__WEBPACK_IMPORTED_MODULE_2_bianco_events__["a" /* add */])(window, 'online offline', this.onNetworkStateChanged, { passive: true });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var _props = this.props,
                isTouch = _props.isTouch,
                isSearchActive = _props.isSearchActive,
                isScrollLocked = _props.isScrollLocked,
                modal = _props.modal,
                scrollbarWidth = _props.scrollbarWidth;

            /**
             * Dirty hacks here sorry...! The MLogin service forces us doing nasty stuff with iframes and modals pfff..
             * There are no better solutions at moment
             * @TODO: give us an interface to manage the users profile info!!!
             */

            if (prevProps.isScrollLocked !== isScrollLocked) {
                var isIframeModal = modal.layout === 'iframe';

                if (isIframeModal) {
                    // no need to remove this class because on close we will trigger a page reload
                    document.documentElement.classList.add('scroll-root__is-locked-iframe');
                } else {
                    var classToToggle = 'scroll-root__is-locked';

                    if (isTouch && isSearchActive && isScrollLocked) {
                        classToToggle = 'scroll-root__is-locked--mobile-touch-search';
                    }

                    document.documentElement.classList[isScrollLocked ? 'add' : 'remove'](classToToggle);
                    if (isScrollLocked) {
                        document.body.style.top = -currentScrollTop + 'px';
                        document.body.style.paddingRight = scrollbarWidth + 'px';
                    } else {
                        document.body.style.top = null;
                        document.body.style.paddingRight = null;
                        window.scrollTo(0, currentScrollTop);
                    }
                }
            }
        }

        /*
        // see MCART-2086
        renderFeedbackify = () => {
            if (this.state.isPrelaunch || this.props.isNative) {
                return '';
            }
            return <Feedbackify/>;
        };
        */

    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                hasViewportOverlay = _props2.hasViewportOverlay,
                modal = _props2.modal,
                children = _props2.children,
                panelFacet = _props2.panelFacet,
                isNative = _props2.isNative;


            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'skel--main' },
                !isNative && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { tabIndex: '-1', id: 'topconent' }),
                !isNative && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_accessibile_alert__["a" /* default */], {
                    messageMobile: Object(__WEBPACK_IMPORTED_MODULE_7_translations__["c" /* default */])('accessibility.alert.site_is_mobile'),
                    messageDesktop: Object(__WEBPACK_IMPORTED_MODULE_7_translations__["c" /* default */])('accessibility.alert.site_is_desktop')
                }),
                !isNative && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_components_skiplinks__["a" /* default */], null),
                !isNative && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_autologin__["a" /* default */], null),
                !isNative && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_main_header__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { 'aria-hidden': hasViewportOverlay, id: 'main', className: 'skel--content', 'aria-live': 'polite' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_react_page_layout__["LayoutProvider"],
                        { layouts: isNative ? nativeLayouts : __WEBPACK_IMPORTED_MODULE_22_layouts__["a" /* default */] },
                        children
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_content_overlay__["a" /* default */], { isVisible: hasViewportOverlay, facet: modal.isVisible || panelFacet === 'cart' ? 'modal' : 'base' }),
                modal.isVisible && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_modal__["a" /* default */], modal),
                !isNative && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_side_panel__["a" /* default */], null),
                !isNative && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_delivery_notification__["a" /* default */], null),
                this.renderLiveChat(),
                !isNative && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_components_snackbar__["a" /* default */], null)
            );
        }
    }]);

    return Root;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Root.propTypes = {
    modal: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
    isScrollLocked: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
    scrollbarWidth: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,
    setViewport: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
    isNative: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
    children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
    isDesktop: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
    location: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
    isCmsEnabled: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
    setNetworkState: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
    hasViewportOverlay: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
    isMobile: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
    isSearchActive: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
    isTouch: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
    panelFacet: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_5_util_redux__["b" /* default */].mapStateToProps({
    isScrollLocked: 'scroll.isLocked',
    scrollbarWidth: 'scroll.scrollbarWidth',
    hasViewportOverlay: 'viewport.hasOverlay',
    isDesktop: 'viewport.isDesktop',
    modal: 'modal',
    isNative: 'viewport.isNative',
    panelFacet: 'panel.facet',
    isCmsEnabled: 'cms.isEnabled',
    isSearchActive: 'search.isActive',
    isMobile: 'viewport.isMobile',
    isTouch: 'viewport.touchevents'
}), __WEBPACK_IMPORTED_MODULE_5_util_redux__["b" /* default */].mapDispatchToProps({
    setViewport: 'viewport.setViewport',
    setNetworkState: 'navigator.setNetworkState'
}))(Root));

/***/ }),
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./address/index.js": 919,
	"./breadcrumbs/index.js": 920,
	"./cart/index.js": 921,
	"./categories/index.js": 922,
	"./checkout/index.js": 925,
	"./cms/index.js": 1012,
	"./delivery/index.js": 1013,
	"./header/index.js": 1014,
	"./main-content/index.js": 1015,
	"./modal/index.js": 1016,
	"./mymigros/index.js": 1017,
	"./navigator/index.js": 1018,
	"./notifications/index.js": 1019,
	"./orders/index.js": 1020,
	"./panel/index.js": 1022,
	"./pickers/index.js": 1023,
	"./poll/index.js": 1024,
	"./product/index.js": 1025,
	"./products/index.js": 1026,
	"./region/index.js": 1027,
	"./router/index.js": 1028,
	"./scroll/index.js": 1030,
	"./search/index.js": 1032,
	"./snackbar/index.js": 1033,
	"./stripe/index.js": 1034,
	"./subscription/index.js": 1035,
	"./tooltip/index.js": 1036,
	"./top-products/index.js": 1037,
	"./user/index.js": 1038,
	"./video-cards/index.js": 1039,
	"./viewport/index.js": 1040
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 918;

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = cartReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



function cartReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        address_id: null,
        addresses: [],
        isFetchingAddresses: false,
        isUpdatingAddresses: false
    };
    var _ref = arguments[1];
    var type = _ref.type,
        addresses = _ref.addresses,
        addressId = _ref.addressId,
        isFetchingAddresses = _ref.isFetchingAddresses,
        isUpdatingAddresses = _ref.isUpdatingAddresses;

    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_ORDER_ADDRESS"]:
            return Object.assign({}, state, { address_id: addressId });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_DEFAULT_ADDRESS"]:
            return Object.assign({}, state, { address_id: addressId });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_USER_ADDRESSES"]:
            return Object.assign({}, state, { addresses: [].concat(_toConsumableArray(addresses)) });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_IS_FETCHING_USER_ADDRESSES"]:
            return Object.assign({}, state, {
                isFetchingAddresses: isFetchingAddresses
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_IS_UPDATING_ADDRESS"]:
            return Object.assign({}, state, {
                isUpdatingAddresses: isUpdatingAddresses
            });
        default:
            return state;
    }
};

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = breadcrumbsReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



function breadcrumbsReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        /** @type {IBreadcrumb[]} */
        items: []
    };
    var _ref = arguments[1];
    var type = _ref.type,
        breadcrumb = _ref.breadcrumb,
        breadcrumbs = _ref.breadcrumbs;

    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["RESET_BREADCRUMBS"]:
            return Object.assign({}, state, { items: [] });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_BREADCRUMBS"]:
            return Object.assign({}, state, { items: [].concat(_toConsumableArray(breadcrumbs)) });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["ADD_BREADCRUMB"]:
            return Object.assign({}, state, { items: [].concat(_toConsumableArray(state.items), [breadcrumb]) });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["REMOVE_BREADCRUMB"]:
            return Object.assign({}, state, {
                items: state.items.reduce(function (acc, item) {
                    if (item.url !== breadcrumb.url) {
                        acc.push(item);
                    }
                    return acc;
                }, [])
            });
        default:
            return state;
    }
};

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = cartReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_misc_local_storage__ = __webpack_require__(528);



var EMPTY_CART_STRUCT = {
    // we will need defaults in case we need to update
    // only partially our cart object
    wasFetched: true,
    wasReset: false,
    isEmpty: true,
    isFetching: false,
    cartError: null,
    productError: null,
    id: null,
    items: {},
    bagInfo: { total_bags: 0 },

    totalPrice: '0.00',
    totalItemsPrice: '0.00',
    shippingPrice: '0.00',
    customerDeliveryFee: '0.00',
    estimatedCustomerPrice: '0.00',
    promotions: []
};

/**
 * Convert the categories into an object
 * @param {Object} initialState - The reducer initialState
 * @param {Object} params - The params for dispatch
 * @returns {{items: array, sumTotal: number}}
 */
function cartReducer() {
    var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        tempItem: null, // A list of temporary items: Used when no zip is defined yet
        items: {},
        wasFetched: false,
        wasReset: false,
        isEmpty: true,
        isOpen: false,
        id: null,

        totalItemsPrice: '0.00',
        shippingPrice: '0.00',
        customerDeliveryFee: '0.00',
        estimatedCustomerPrice: '0.00',
        promotions: [],
        totalPrice: 0,

        hideDraggingTutorial: Boolean(__WEBPACK_IMPORTED_MODULE_1_util_misc_local_storage__["a" /* default */].get('hideDraggingTutorial')) || false,
        isFetching: false,
        fetchingId: null,
        tooltipId: null,
        productError: null,
        cartError: null,
        promotionalCode: '',
        isFooterFixed: false,
        bagInfo: { total_bags: 0 } // eslint-disable-line camelcase
    };
    var _ref = arguments[1];
    var type = _ref.type,
        tempItem = _ref.tempItem,
        items = _ref.items,
        id = _ref.id,
        wasFetched = _ref.wasFetched,
        isFetching = _ref.isFetching,
        fetchingId = _ref.fetchingId,
        totalPrice = _ref.totalPrice,
        shippingPrice = _ref.shippingPrice,
        totalItemsPrice = _ref.totalItemsPrice,
        customerDeliveryFee = _ref.customerDeliveryFee,
        estimatedCustomerPrice = _ref.estimatedCustomerPrice,
        bagInfo = _ref.bagInfo,
        state = _ref.state,
        hideDraggingTutorial = _ref.hideDraggingTutorial,
        tooltipId = _ref.tooltipId,
        isFooterFixed = _ref.isFooterFixed,
        promotions = _ref.promotions,
        error = _ref.error,
        promotionalCode = _ref.promotionalCode;

    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["REPLACE_CART"]:
            return Object.assign({}, initialState, {
                items: items.reduce(function (acc, item) {
                    acc[item.product.id] = item;
                    return acc;
                }, {}),
                wasReset: false,
                productError: null,
                cartError: null,
                id: id,
                isEmpty: items.length === 0,
                // is ready will become true only the first time the cart will be fetched
                wasFetched: true,
                totalPrice: totalPrice,
                state: state,
                bagInfo: bagInfo,
                shippingPrice: shippingPrice,
                totalItemsPrice: totalItemsPrice,
                customerDeliveryFee: customerDeliveryFee,
                estimatedCustomerPrice: estimatedCustomerPrice,
                promotions: promotions,
                promotionalCode: promotionalCode
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_BLOCKED_CART"]:
            return Object.assign({}, initialState, EMPTY_CART_STRUCT, {
                id: id,
                state: state
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_IS_FETCHING_CART"]:
            return Object.assign({}, initialState, {
                isFetching: isFetching,
                fetchingId: fetchingId
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_CART_DRAGGING_TUTORIAL"]:
            return Object.assign({}, initialState, { hideDraggingTutorial: hideDraggingTutorial });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_CART_FOOTER_FIXED"]:
            return Object.assign({}, initialState, { isFooterFixed: isFooterFixed });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_CART_PRODUCT_ERROR"]:
            return Object.assign({}, initialState, { productError: error });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["RESET_CART"]:
            return Object.assign({}, initialState, EMPTY_CART_STRUCT, {
                wasFetched: !!wasFetched,
                wasReset: true
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_CART_ERROR"]:
            return Object.assign({}, initialState, EMPTY_CART_STRUCT, {
                cartError: error,
                id: initialState.id, // avoid to clean up the id
                wasReset: true
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_CART_TOOLTIP_ID"]:
            return Object.assign({}, initialState, { tooltipId: tooltipId });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_CART_TEMP_ITEM"]:
            return Object.assign({}, initialState, { tempItem: tempItem });
        default:
            return initialState;
    }
};

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = categoriesReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(395);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





/**
 * Convert the caregories to an object
 * @param {string} name - name of the category
 * @returns {{name: string, isActive: boolean}}
 */
function createCategory(category, level, parent) {
    if (category.children && category.children.length) {
        category.children = category.children.map(function (c) {
            return createCategory(c, level + 1, category);
        });
    }

    return Object.assign({}, category, {
        parent: parent,
        level: level
    });
}

function categoriesReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],
        active: null,
        activeLeaf: null,
        isFetching: true,
        fetchingCategory: null,
        isCategorylistVisible: false
    };
    var _ref = arguments[1];
    var type = _ref.type,
        categories = _ref.categories,
        category = _ref.category,
        isCategorylistVisible = _ref.isCategorylistVisible;

    var newCategories = void 0;
    var level = void 0;
    var parentNode = void 0;

    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_IS_FETCHING_CATEGORIES"]:
            return Object.assign({}, state, { fetchingCategory: category, isFetching: true });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_CATEGORIES_VISIBILITY"]:
            return Object.assign({}, state, { isCategorylistVisible: isCategorylistVisible });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["FETCH_CATEGORIES"]:
            level = -1;

            if ((typeof category === 'undefined' ? 'undefined' : _typeof(category)) === 'object') {
                level = category.level;
                parentNode = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* findCategoryByProp */])(state.items, category.id, 'id');
            }

            newCategories = categories.map(function (c) {
                return createCategory(c,
                // in case of direct link categories we need to handle the level differently
                // our application categories need three levels and the `direct_link` categories will skip the first level
                // this is a bit a hack and might be optimized in future avoiding a level based navigation
                c.is_direct_link ? 1 : level + 1, category);
            });

            if (parentNode) {
                // Assign the new categories
                Object.assign(parentNode, { children: newCategories });

                // Reassign the items to trigger update
                return Object.assign({}, state, {
                    items: state.items.slice(),
                    isFetching: false,
                    fetchingCategory: null
                });
            }

            return Object.assign({}, state, {
                isFetching: false,
                fetchingCategory: null,
                items: newCategories
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_ACTIVE_CATEGORY"]:
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_ACTIVE_LEAF_CATEGORY"]:
            return Object.assign({}, state, _defineProperty({}, type === __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_ACTIVE_LEAF_CATEGORY"] ? 'activeLeaf' : 'active', category ? Object.assign({}, category) : null));
        default:
            return state;
    }
};

/***/ }),
/* 923 */,
/* 924 */,
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = checkoutReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(530);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* eslint-disable camelcase */



function checkoutReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        isValid: false,
        isComplete: false,
        areErrorsVisible: false,
        isSubmitting: false,
        isUpdatingAddresses: false,
        excluded_pickers: [],
        errors: __WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* defaultErrors */],
        additional_info: '',
        delivery_start_date: null,
        delivery_end_date: null,
        address_id: null,
        isPaymentMethodValid: false,
        isSubmittingPromo: false
    };
    var payload = arguments[1];
    var type = payload.type,
        additional_info = payload.additional_info,
        addressId = payload.addressId,
        delivery_start_date = payload.delivery_start_date,
        delivery_end_date = payload.delivery_end_date,
        isSubmitting = payload.isSubmitting,
        isComplete = payload.isComplete,
        excluded_pickers = payload.excluded_pickers,
        areErrorsVisible = payload.areErrorsVisible,
        isPaymentMethodValid = payload.isPaymentMethodValid,
        isSubmittingPromo = payload.isSubmittingPromo,
        validationState = payload.validationState;

    var validateCheckout = function validateCheckout() {
        return Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["d" /* validate */])(Object.assign({}, state, payload));
    };

    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["RESET_CHECKOUT"]:
            return Object.assign({}, state, {
                isValid: false,
                errors: __WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* defaultErrors */],
                isComplete: false,
                isSubmitting: false,
                areErrorsVisible: false,
                isUpdatingAddresses: false,
                additional_info: '',
                excluded_pickers: [],
                delivery_start_date: null,
                delivery_end_date: null,
                address_id: null
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["TOGGLE_CHECKOUT_ERRORS_VISIBILITY"]:
            return Object.assign({}, state, { areErrorsVisible: areErrorsVisible });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["IS_SUBMITTING_PROMOCODE"]:
            return Object.assign({}, state, { isSubmittingPromo: isSubmittingPromo });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_CHECKOUT_PAYMENT_VALID"]:
            return Object.assign({}, state, { isPaymentMethodValid: isPaymentMethodValid }, validateCheckout());
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_CHECKOUT_EXCLUDED_PICKERS"]:
            return Object.assign({}, state, { excluded_pickers: [].concat(_toConsumableArray(excluded_pickers)) });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_CHECKOUT_MESSAGE"]:
            return Object.assign({}, state, { additional_info: additional_info });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_CHECKOUT_VALIDATION"]:
            return Object.assign({}, state, validationState);
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["IS_SUBMITTING_CHECKOUT"]:
            return Object.assign({}, state, { isSubmitting: isSubmitting });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_CHECKOUT_COMPLETE"]:
            return Object.assign({}, state, { isComplete: isComplete });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_ORDER_ADDRESS"]:
            return Object.assign({}, state, { address_id: addressId }, validateCheckout());
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_CHECKOUT_DELIVERY_DATES"]:
            return Object.assign({}, state, {
                delivery_start_date: delivery_start_date,
                delivery_end_date: delivery_end_date
            }, validateCheckout());
        default:
            return state;
    }
};

/***/ }),
/* 926 */,
/* 927 */,
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reducers_helpers__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_api_urls__ = __webpack_require__(192);





function fetch() {
    return function (dispatch) {
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_IS_FETCHING_NOTIFICATIONS"], isFetching: true });
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_3_constants_api_urls__["notifications"])()).then(
        /**
         * @param {INotification[]} data
         */
        function (_ref) {
            var data = _ref.data;

            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_IS_FETCHING_NOTIFICATIONS"], isFetching: false });
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_NOTIFICATIONS"], items: data });
        }).catch(function (e) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_IS_FETCHING_NOTIFICATIONS"], isFetching: false });
            Object(__WEBPACK_IMPORTED_MODULE_2_reducers_helpers__["a" /* dispatchError */])(dispatch, e, {
                url: Object(__WEBPACK_IMPORTED_MODULE_3_constants_api_urls__["notifications"])(),
                description: e,
                reloadButton: true
            });
        });
    };
}

/***/ }),
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeFromCart;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__get_product_data__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__track__ = __webpack_require__(208);



/**
 * Track whenever a product gets removed from the cart
 * @param {IProduct} product - the product model we want to track
 * @param {object} extraProps - additional tracking data
 */
function removeFromCart(product, extraProps) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__track__["a" /* default */])({
        event: 'removeFromCart',
        ecommerce: {
            remove: {
                products: [Object(__WEBPACK_IMPORTED_MODULE_0__get_product_data__["a" /* default */])(product, extraProps)]
            }
        }
    });
}

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addToCart;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__get_product_data__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__track__ = __webpack_require__(208);



/**
 * Track whenever a product gets added to the cart
 * @param {IProduct} product - the product model we want to track
 * @param {object} extraProps - additional tracking data
 */
function addToCart(product, extraProps) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__track__["a" /* default */])({
        event: 'addToCart',
        ecommerce: {
            currencyCode: 'CHF',
            add: {
                products: [Object(__WEBPACK_IMPORTED_MODULE_0__get_product_data__["a" /* default */])(product, extraProps)]
            }
        }
    });
}

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pageView;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__track__ = __webpack_require__(208);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



/**
 *
 * @param page
 * @param {IBreadcrumb[]} breadcrumbs
 * @param {IUser} user
 * @return {*|*}
 */
function pageView(page, breadcrumbs, user) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__track__["a" /* default */])({
        event: 'pageLoad', // konstant, wird als Trigger in GTM genutzt
        mandant: 'amigos', // jeweiliger Mandant auf dem der Kunde ist (fix)
        pgc: ['amigos'].concat(_toConsumableArray(breadcrumbs.map(function (b) {
            return b.name;
        }))),
        lang: globals.config.language,
        pnam: document.location.pathname, // URL Pfad abbilden
        paid: page.name, //eindeutige SeitenID
        zstr01: document.referrer ? document.referrer.split('/')[2] : '', // zielseite Tracking = HerkunftInfo --> Referral-URL–> URL mit der ich ursprünglich zum Shop gekommen bin ( document.referrer.split('/')[2]; )
        hrco: '200', //alternativ: 200,301,302,500 Responsecodes (welche verfügbar sind)
        eid: globals.config.env, //alternativ: qual - Enviroment der Applikation
        vlst: Boolean(user.isAuthenticated), // true/false ob der Kunde eingeloggt ist.,
        pageType: page.tracking_page_type,
        geschlecht: user.gender,
        yearOfBirth: user.year_of_birth,
        incu: user.incu == null ? null : Boolean(user.incu)
        // video: false, // TODO: true / false --> wenn Videokomponente auf der Seite, wird true mitgeschickt
        // age: user.age, // TODO: 33 (muss berechnet werden)
        // inre: user.inre, // TODO: true | false (der Kunde hat sich neu registriert, aber noch keine Bestellung aufgegeben -> Wert: true) --- (Kunde hat die erste Best. aufgegeben -> Wert: false)
    });
}

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buttonClick;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__track__ = __webpack_require__(208);


/**
 * Track the buttons clicks
 * @param {string} buttonText - button label
 */
function buttonClick(_ref) {
    var buttonText = _ref.buttonText;

    return Object(__WEBPACK_IMPORTED_MODULE_0__track__["a" /* default */])({
        event: 'buttonClick',
        buttonText: buttonText
    });
}

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = productDetail;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__track__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_product_data__ = __webpack_require__(240);



/**
 * Track a product detail page
 * @param {IProduct} product
 */
function productDetail(product) {
    var data = Object(__WEBPACK_IMPORTED_MODULE_1__get_product_data__["a" /* default */])(product);
    // the client doesn't want this value here
    delete data.quantity;
    return Object(__WEBPACK_IMPORTED_MODULE_0__track__["a" /* default */])({
        event: 'productView',
        ecommerce: {
            currencyCode: 'CHF',
            detail: {
                products: [data]
            }
        }
    });
}

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = productImpression;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__track__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__get_product_data__ = __webpack_require__(240);



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var impressions = [];

/**
 * Track a product impression
 * @param {IProduct} product - product model
 */
function productImpression(product) {
    // queue the impressions
    impressions.push(_extends({}, Object(__WEBPACK_IMPORTED_MODULE_3__get_product_data__["a" /* default */])(product), {
        list: product.list
    }));

    // dispatch a deferred event every second
    debouncedTrack();
}

var debouncedTrack = __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default()(function () {
    Object(__WEBPACK_IMPORTED_MODULE_2__track__["a" /* default */])({
        event: 'productImpression',
        ecommerce: {
            currencyCode: 'CHF',
            impressions: __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default()([].concat(impressions), 'position')
        }
    });

    // empty impressions array
    impressions.splice(0, impressions.length);
}, 1000);

/***/ }),
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = productClick;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__track__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_product_data__ = __webpack_require__(240);



/**
 * Track a product click event (basically whenever it will appear in an overlay)
 * @param {IProduct} product - product model
 */
function productClick(product) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__track__["a" /* default */])({
        event: 'productClick',
        ecommerce: {
            actionField: { list: product.list },
            products: [Object(__WEBPACK_IMPORTED_MODULE_1__get_product_data__["a" /* default */])(product)]
        }
    });
}

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formTracking;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__track__ = __webpack_require__(208);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function formTracking(form) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__track__["a" /* default */])(_extends({}, form, {
        DSEakpzeptiert: true
    }));
}

/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = checkout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__track__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_product_data__ = __webpack_require__(240);



/**
 * @param {{products: IProduct[]}} data
 * @return {any}
 */
function checkout(data) {
    // Bug in IE gives you an empty array for Object.values
    var products = Object(__WEBPACK_IMPORTED_MODULE_1__get_product_data__["b" /* prepareProductsData */])(data.products);

    return Object(__WEBPACK_IMPORTED_MODULE_0__track__["a" /* default */])({
        event: 'checkout',
        ecommerce: {
            currencyCode: 'CHF',
            reqDelivery: data.deliveryTime,
            estCartValue: data.value,
            checkout: {
                actionField: {
                    step: data.step,
                    option: 'stripe'
                },
                products: products.map(__WEBPACK_IMPORTED_MODULE_1__get_product_data__["a" /* default */])
            }
        }
    });
}

/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = siteSearch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__track__ = __webpack_require__(208);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Handle the search tracking events
 * @param {ISiteSearchData} search - containing the search keys we want to track
 */
function siteSearch(search) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__track__["a" /* default */])(_extends({
        event: 'siteSearch', // konstant, wird als Trigger in GTM genutzt
        searchType: 'product-search', // Typ der Suche (produkt-search, kategorie-search, etc.)
        suggestSearch: 'false', // Wenn Suggest-Search verwendet wird, bitte auf true, sonst auf false setzen
        siteSearchPage: window.location.pathname, // Seite von der aus die Suche gestartet wurde
        siteSearchQuery: '', // nach was gesucht wurde. bei autosuggestion ist dies das angeklickte query aus der Liste
        siteSearchResultsTotalAmount: '0', // Gesamtanzahl von Suchtreffer
        siteSearchTypedQuery: '', // eingetippte Suchphrase
        siteSearchResults: {} // Die im Array stehende Produktkategorien sollen dynamisch erweitert werden, einsprachig auf Deutsch
    }, search));
}

/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = promotionClick;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__track__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_product_data__ = __webpack_require__(240);



/**
 * Track a product in promotion was clicked
 * @param {IProduct} product - product model
 * @param {object} extraProps - optional tracking properties
 */
function promotionClick(product, extraProps) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__track__["a" /* default */])({
        event: 'promotionClick',
        ecommerce: {
            promoClick: {
                promotions: [Object(__WEBPACK_IMPORTED_MODULE_1__get_product_data__["a" /* default */])(product, extraProps)]
            }
        }
    });
}

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = promotionView;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__track__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__get_product_data__ = __webpack_require__(240);



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var promotions = [];

/**
 * Track a product in promotion
 * @param {IProduct} product - product model
 */
function promotionView(product) {
    // queue the promotions
    promotions.push(_extends({}, Object(__WEBPACK_IMPORTED_MODULE_3__get_product_data__["a" /* default */])(product), {
        // in other context this property is called ".list" ¯\_(ツ)_/¯
        creative: product.list
    }));

    // dispatch a deferred event every second
    debouncedTrack();
}

var debouncedTrack = __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default()(function () {
    Object(__WEBPACK_IMPORTED_MODULE_2__track__["a" /* default */])({
        event: 'promotionView',
        ecommerce: {
            promoView: {
                promotions: __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default()([].concat(promotions), 'position')
            }
        }
    });

    // empty promotions array
    promotions.splice(0, promotions.length);
}, 1000);

/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__track__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_product_data__ = __webpack_require__(240);



/**
 * @param {ISaleEvent} data
 * @return {*|*}
 */
function sale(data) {
    var products = Object(__WEBPACK_IMPORTED_MODULE_1__get_product_data__["b" /* prepareProductsData */])(data.products);

    return Object(__WEBPACK_IMPORTED_MODULE_0__track__["a" /* default */])({
        event: 'sale',
        reqDelivery: data.deliveryTime, //- Bezeichnet das Lieferfenster (zB.: von 19.02.2018 14:32 bis 19.02.2018 17:00)
        shippingMethod: 'amigos', //- Art der Versand (amigos)
        paymentMethod: 'kreditkarte', //- Art der Bezahlung (kreditkarte | twint)
        currency: 'CHF', // - Standard CHF
        estCartValue: data.value, // Geschätzte Warenkorbwert
        ecommerce: {
            purchase: {
                actionField: {
                    id: data.id, // - Standard
                    revenue: data.value, // - Bruttoumsatz - Geschätzter Warenkorbwert
                    shipping: data.shippingPrice // Der Wert des Logistikservice / Picker Kosten
                },
                products: products.map(__WEBPACK_IMPORTED_MODULE_1__get_product_data__["a" /* default */])
            }
        }
    });
}

/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sequence */
/* harmony export (immutable) */ __webpack_exports__["a"] = promisesSequencer;
var sequence = [];

function run(result) {
    if (sequence.length) {
        var asyncJob = sequence.shift();
        return asyncJob().then(run).catch(function (e) {
            // clear the queue and dispatch the error
            // empty the array
            sequence.splice(0, sequence.length);
            return Promise.reject(e);
        });
    }

    return Promise.resolve(result);
}

/**
 * Concatenate multiple promises
 * @param promises
 * @returns {*}
 */
function promisesSequencer() {
    sequence.push.apply(sequence, arguments);
    return run();
}

/***/ }),
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = deliveryReducer;
function deliveryReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        isEnabled: globals.config.is_cms_enabled,
        isEditModeEnabled: globals.config.is_cms_edit_mode_enabled
    };
    var _ref = arguments[1];
    var type = _ref.type;

    switch (type) {
        default:
            return state;
    }
};

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = deliveryReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_order_states__ = __webpack_require__(217);




var initialDate = new Date().toISOString();

function deliveryReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        isFetching: false,
        hasFetched: false,
        now: initialDate,
        minDate: initialDate,
        maxDate: initialDate,
        date: initialDate,
        status: __WEBPACK_IMPORTED_MODULE_1_constants_order_states__["f" /* OPEN */] // the 'state' property in the response, renamed due to ambiguity
    };
    var _ref = arguments[1];
    var type = _ref.type,
        newState = _ref.newState,
        isFetching = _ref.isFetching,
        status = _ref.status;

    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_DELIVERY_STATUS"]:
            return Object.assign({}, state, { status: status });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_DELIVERY_STATE"]:
            return Object.assign({}, state, newState);
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_IS_FETCHING_DELIVERY"]:
            return Object.assign({}, state, { isFetching: isFetching });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["RESET_DELIVERY"]:
            return Object.assign({}, state, { hasFetched: false });
        default:
            return state;
    }
};

/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = headerReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);


function headerReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        height: 100,
        facet: 'default'
    };
    var _ref = arguments[1];
    var type = _ref.type,
        height = _ref.height,
        facet = _ref.facet;

    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_HEADER_HEIGHT"]:
            return Object.assign({}, state, { height: height });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_HEADER_FACET"]:
            return Object.assign({}, state, { facet: facet });
        default:
            return state;
    }
};

/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = mainContentReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__actions_types__);


function mainContentReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        isLoaded: false,
        isLoaderVisible: false
    };
    var _ref = arguments[1];
    var type = _ref.type,
        isLoaded = _ref.isLoaded,
        isLoaderVisible = _ref.isLoaderVisible;

    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_0__actions_types__["SET_MAIN_CONTENT_LOADING"]:
            return Object.assign({}, state, { isLoaded: isLoaded });
        case __WEBPACK_IMPORTED_MODULE_0__actions_types__["SET_MAIN_CONTENT_LOADER_VISIBILITY"]:
            return Object.assign({}, state, { isLoaderVisible: isLoaderVisible });
        default:
            return state;
    }
};

/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = modalReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);


var oldPath = void 0;

function modalReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        content: false,
        layout: null,
        meta: null,
        href: null,
        mustRefreshOnClose: false,
        isAsyc: false,
        isReady: false,
        isVisible: false,
        isPendingRemove: false
    };
    var _ref = arguments[1];
    var type = _ref.type,
        content = _ref.content,
        layout = _ref.layout,
        href = _ref.href,
        isReady = _ref.isReady,
        meta = _ref.meta,
        isAsync = _ref.isAsync,
        mustRefreshOnClose = _ref.mustRefreshOnClose;

    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["OPEN_MODAL"]:
            if (href) {
                oldPath = window.location.pathname;
                history.pushState(null, '', href);
            }

            return Object.assign({}, state, {
                content: content,
                layout: layout,
                href: href,
                meta: meta,
                isPendingRemove: false,
                mustRefreshOnClose: mustRefreshOnClose,
                isReady: !isAsync,
                isVisible: true
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["CLOSE_MODAL"]:
            return Object.assign({}, state, { isPendingRemove: true });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_MODAL_READY"]:
            return Object.assign({}, state, { isReady: isReady });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["RESET_MODAL"]:
            if (state.href && window.location.pathname !== oldPath) {
                history.replaceState(null, '', oldPath);
            }

            return Object.assign({}, state, {
                content: null,
                layout: null,
                meta: null,
                href: null,
                isVisible: false,
                isReady: false,
                isAsyc: false,
                isPendingRemove: false
            });
        default:
            return state;
    }
};

/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = modalReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);


/**
 *
 * @type {IMyMigrosState}
 */
var defaultState = {
    sliders: [],
    isFetching: false
};

function modalReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var _ref = arguments[1];
    var type = _ref.type,
        sliders = _ref.sliders,
        isFetching = _ref.isFetching;

    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["MYMIGROS_SET_SLIDERS"]:
            return Object.assign({}, state, {
                sliders: sliders
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["MYMIGROS_SET_IS_FETCHING"]:
            return Object.assign({}, state, {
                isFetching: isFetching
            });
        default:
            return state;
    }
};

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = modalReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);


function modalReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        isOnline: true
    };
    var _ref = arguments[1];
    var type = _ref.type,
        isOnline = _ref.isOnline;

    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_NAVIGATOR_ONLINE"]:
            return Object.assign({}, state, {
                isOnline: isOnline
            });
        default:
            return state;
    }
};

/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = notificationsReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



function notificationsReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        isFetching: false,
        /** @type {INotification[]} */
        items: []
    };
    var _ref = arguments[1];
    var type = _ref.type,
        isFetching = _ref.isFetching,
        items = _ref.items,
        notification = _ref.notification;

    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_IS_FETCHING_NOTIFICATIONS"]:
            return Object.assign({}, state, {
                isFetching: isFetching
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_NOTIFICATIONS"]:
            return Object.assign({}, state, {
                items: [].concat(_toConsumableArray(items))
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["ADD_NOTIFICATION"]:
            return Object.assign({}, state, {
                items: [notification].concat(_toConsumableArray(state.items))
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["REMOVE_NOTIFICATION"]:
            return Object.assign({}, state, {
                items: state.items.reduce(function (curr, item) {
                    if (notification !== item) {
                        curr.push(item);
                    }
                    return curr;
                }, [])
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["RESET_NOTIFICATIONS"]:
            return Object.assign({}, state, {
                items: []
            });
        default:
            return state;
    }
};

/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = ordersReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_unionBy__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_unionBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_unionBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function ordersReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        pendingOrders: {},
        finishedOrders: {},
        order: {}
    };
    var _ref = arguments[1];
    var type = _ref.type,
        pendingOrders = _ref.pendingOrders,
        finishedOrders = _ref.finishedOrders,
        order = _ref.order;

    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["FETCH_PENDING_ORDERS"]:
            return _extends({}, state, {
                pendingOrders: {
                    orders: __WEBPACK_IMPORTED_MODULE_0_lodash_unionBy___default()(state.pendingOrders.orders, pendingOrders.orders, 'id'),
                    total_count: pendingOrders.total_count
                }
            });
        case __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["FETCH_ORDER"]:
            return _extends({}, state, {
                order: order
            });
        case __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["FETCH_FINISHED_ORDERS"]:
            return _extends({}, state, {
                finishedOrders: {
                    orders: __WEBPACK_IMPORTED_MODULE_0_lodash_unionBy___default()(state.finishedOrders.orders, finishedOrders.orders, 'id'),
                    total_count: finishedOrders.total_count
                }
            });
        case __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["SET_PICKER_RATING"]:
            return _extends({}, state, {
                order: order
            });
        case __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["RESET_ORDERS"]:
            return {
                isFetching: false,
                pendingOrders: {},
                finishedOrders: {}
            };
        case __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["SET_FEEDBACK"]:
        default:
            return state;
    }
}

/***/ }),
/* 1021 */,
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = panelReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);


function panelReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        isOpen: false,
        facet: '',
        content: null
    };
    var _ref = arguments[1];
    var type = _ref.type,
        facet = _ref.facet,
        content = _ref.content;

    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["OPEN_PANEL"]:
            return Object.assign({}, state, { isOpen: true, facet: facet, content: content });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["CLOSE_PANEL"]:
            return Object.assign({}, state, { isOpen: false, facet: null });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["RESET_PANEL"]:
            return Object.assign({}, state, { content: null, facet: null });
        default:
            return state;
    }
};

/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = pickersReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* eslint-disable camelcase */



function pickersReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: [],

        loadedChunkIndexes: [],
        loadedAllChunks: false,
        totalChunks: 0,
        chunkSize: 100,

        total: null,
        isFetching: false
    };
    var _ref = arguments[1];
    var type = _ref.type,
        isFetching = _ref.isFetching,
        items = _ref.items,
        person_id = _ref.person_id,
        excluded = _ref.excluded,
        total = _ref.total,
        loadedChunkIndexes = _ref.loadedChunkIndexes,
        totalChunks = _ref.totalChunks,
        loadedAllChunks = _ref.loadedAllChunks;

    var picker = void 0;
    var pickerIndex = void 0;
    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_IS_FETCHING_PICKERS"]:
            return Object.assign({}, state, {
                isFetching: isFetching
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_PICKERS_LOADED_CHUNK_INDEXES"]:
            return Object.assign({}, state, {
                loadedChunkIndexes: loadedChunkIndexes
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_PICKERS_TOTAL_CHUNKS"]:
            return Object.assign({}, state, {
                totalChunks: totalChunks
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_PICKERS_ALL_CHUNKS_LOADED"]:
            return Object.assign({}, state, {
                loadedAllChunks: loadedAllChunks
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_PICKERS_TOTAL"]:
            return Object.assign({}, state, {
                total: total
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_PICKER_EXCLUDED"]:
            picker = state.items.find(function (item) {
                return item.person_id === person_id;
            }); // eslint-disable-line camelcase
            pickerIndex = state.items.indexOf(picker);

            if (!~pickerIndex) {
                return state;
            }

            picker = Object.assign({}, picker, { excluded: excluded });

            items = state.items.slice();
            items.splice(pickerIndex, 1, picker);

            return Object.assign({}, state, { items: items });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_PICKERS"]:
            return Object.assign({}, state, {
                items: [].concat(_toConsumableArray(items))
            });
        default:
            return state;
    }
};

/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = pollReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);


function pollReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        id: null
    };
    var _ref = arguments[1];
    var type = _ref.type,
        id = _ref.id;

    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_POLLING_ID"]:
            return Object.assign({}, state, { id: id });
        default:
            return state;
    }
};

/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = productReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);


function productReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        isFetching: false,
        item: null
    };
    var _ref = arguments[1];
    var type = _ref.type,
        isFetching = _ref.isFetching,
        product = _ref.product;

    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_PRODUCT"]:
            return Object.assign({}, state, {
                items: Object.assign(state, {
                    item: product
                })
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_IS_FETCHING_PRODUCT"]:
            return Object.assign({}, state, {
                isFetching: isFetching
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["RESET_PRODUCT"]:
            return Object.assign({}, state, {
                item: null
            });
        default:
            return state;
    }
};

/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = productsReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



function productsReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        isFetching: false,
        items: {}
    };
    var _ref = arguments[1];
    var type = _ref.type,
        category = _ref.category,
        isFetching = _ref.isFetching,
        products = _ref.products;

    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["FETCH_PRODUCTS_BY_CATEGORY"]:
            return Object.assign({}, state, {
                items: Object.assign({}, state.items, _defineProperty({}, category.id, products))
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["FLUSH_PRODUCTS"]:
            return Object.assign({}, state, {
                items: {}
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_IS_FETCHING_PRODUCTS"]:
            return Object.assign({}, state, {
                isFetching: isFetching
            });
        default:
            return state;
    }
};

/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = regionReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);


function regionReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        /** @type {IRegion} */
        requested: null,
        isFetching: false,
        isSendingMail: false,
        /** @type {IRegion|boolean} */
        active: globals.config.region
    };
    var _ref = arguments[1];
    var type = _ref.type,
        region = _ref.region,
        isFetching = _ref.isFetching;

    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_IS_FETCHING_REGION"]:
            return Object.assign({}, state, {
                isFetching: isFetching
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["RESET_REQUESTED_REGION"]:
            return Object.assign({}, state, {
                requested: null
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_REGION"]:
            return Object.assign({}, state, {
                requested: region,
                active: region.enabled ? region : state.active
            });
        default:
            return state;
    }
};

/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = routeReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_router_constants__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_router_registry__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_api_urls__ = __webpack_require__(192);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






function getCurrentName() {
    var currentRoute = location.pathname;

    // Append trailing slash if necessary
    if (currentRoute.substr(-1) !== '/') {
        currentRoute += '/';
    }

    return __WEBPACK_IMPORTED_MODULE_2_router_registry__["resolve"](currentRoute);
}

function routeReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        match: {},
        history: _extends({}, history, {
            replace: function replace(url) {
                history.replaceState(null, '', url);
            },
            push: function push(url) {
                history.pushState(null, '', url);
            }
        }),
        mustForceNotFound: !!window.__is_not_found__,
        location: window.location,
        cooperative: null,
        config: {},
        meta: {},
        isFirstRoute: true,
        lastRoute: null,
        baseurl: Object(__WEBPACK_IMPORTED_MODULE_1_router_constants__["baseurl"])(),
        endpoints: __WEBPACK_IMPORTED_MODULE_3_constants_api_urls__,
        registry: __WEBPACK_IMPORTED_MODULE_2_router_registry__,
        name: getCurrentName()
    };
    var _ref = arguments[1];
    var type = _ref.type,
        route = _ref.route,
        lastRoute = _ref.lastRoute,
        cooperative = _ref.cooperative,
        mustForceNotFound = _ref.mustForceNotFound;

    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_ROUTE"]:
            return Object.assign({}, state, _extends({
                isFirstRoute: false,
                name: getCurrentName()
            }, route));
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_FORCE_NOT_FOUND"]:
            return Object.assign({}, state, {
                mustForceNotFound: mustForceNotFound
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_ROUTE_COOPERATIVE"]:
            return Object.assign({}, state, {
                cooperative: cooperative
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_LAST_ROUTE"]:
            return Object.assign({}, state, {
                lastRoute: lastRoute
            });
        default:
            return state;
    }
};

/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clearObject;
/**
 * It does what the name says
 * @param {object} o
 * @returns {object} clean object
 */
function clearObject(o) {
  Object.keys(o).forEach(function (k) {
    return delete o[k];
  });
  return o;
}

/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = scrollReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_dom_scrollbar_width__ = __webpack_require__(1031);



function scrollReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        mustAutoscroll: false,
        isLocked: false,
        scrollbarWidth: Object(__WEBPACK_IMPORTED_MODULE_1_util_dom_scrollbar_width__["a" /* default */])()
    };
    var _ref = arguments[1];
    var type = _ref.type,
        mustAutoscroll = _ref.mustAutoscroll;

    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_PENDING_AUTOSCROLL"]:
            return Object.assign({}, state, { mustAutoscroll: mustAutoscroll });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["LOCK_SCROLL"]:
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["UNLOCK_SCROLL"]:
            return Object.assign({}, state, {
                isLocked: type === __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["LOCK_SCROLL"]
            });
        default:
            return state;
    }
};

/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scrollbarWidth;
var result = void 0;
var scrollStyles = {
    width: '100px',
    height: '100px',
    overflow: 'scroll',
    position: 'fixed',
    opacity: '0'
};

/**
 * Create an element and read it's scrollbar width
 * @link https://davidwalsh.name/detect-scrollbar-width
 */
function readScrollbarWidth() {
    // Create the measurement node
    var scrollDiv = document.createElement('div');
    Object.assign(scrollDiv.style, scrollStyles);
    document.body.appendChild(scrollDiv);

    // Read values
    var offsetWidth = scrollDiv.offsetWidth,
        clientWidth = scrollDiv.clientWidth;

    // Delete helper element

    document.body.removeChild(scrollDiv);

    // Return width
    return offsetWidth - clientWidth;
}

/**
 * Expose a method to return the browser's scrollbar width
 * @return {number} - The browser's scrollbar width
 */
function scrollbarWidth() {
    if (result == null) {
        result = readScrollbarWidth();
    }

    return result;
}

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = scrollReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_unionBy__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_unionBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_unionBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__);


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




function scrollReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        categories: [],
        categoriesTotal: 0,
        commonCategories: [],
        commonCategoriesTotal: 0,
        isActive: false,
        isLoadingMore: false,
        isSearching: false,
        isFuzzy: true,
        term: '',
        limit: 24,
        offset: 0,
        products: [],
        productsTotal: 0
    };
    var _ref = arguments[1];
    var type = _ref.type,
        result = _ref.result,
        isLoadingMore = _ref.isLoadingMore,
        isSearching = _ref.isSearching,
        limit = _ref.limit,
        offset = _ref.offset,
        term = _ref.term,
        isFuzzy = _ref.isFuzzy;

    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["RESET_SEARCH"]:
            return Object.assign({}, state, {
                commonCategories: state.commonCategories,
                commonCategoriesTotal: state.commonCategoriesTotal,
                limit: state.limit,
                categories: [],
                categoriesTotal: 0,
                isLoadingMore: false,
                isSearching: false,
                offset: 0,
                products: [],
                productsTotal: 0,
                term: '',
                rotationPersistedTerm: ''
            });
        case __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["SET_SEARCH_IS_ACTIVE"]:
            return Object.assign({}, state, {
                isActive: true
            });
        case __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["SET_SEARCH_IS_INACTIVE"]:
            return Object.assign({}, state, {
                isActive: false
            });
        case __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["SET_SEARCH_RESULT"]:
            return Object.assign({}, state, {
                categories: [].concat(_toConsumableArray(result.categories.items)),
                categoriesTotal: result.categories.total_hits,
                products: state.isLoadingMore ? __WEBPACK_IMPORTED_MODULE_0_lodash_unionBy___default()(state.products, result.products.items, 'id') : [].concat(_toConsumableArray(result.products.items)),
                productsTotal: result.products.total_hits
            });
        case __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["SET_COMMON_CATEGORIES"]:
            return Object.assign({}, state, {
                commonCategories: [].concat(_toConsumableArray(result)),
                commonCategoriesTotal: [].concat(_toConsumableArray(result)).length
            });
        case __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["SET_IS_SEARCHING"]:
            return Object.assign({}, state, {
                isSearching: isSearching
            });
        case __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["SET_IS_LOADING_MORE"]:
            return Object.assign({}, state, {
                isLoadingMore: isLoadingMore
            });
        case __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["SET_SEARCH_LIMIT"]:
            return Object.assign({}, state, {
                limit: limit
            });
        case __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["SET_SEARCH_TERM"]:
            return Object.assign({}, state, {
                term: term
            });
        case __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["SET_SEARCH_OFFSET"]:
            return Object.assign({}, state, {
                offset: offset
            });
        case __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["SET_SEARCH_FUZZY"]:
            return Object.assign({}, state, {
                isFuzzy: isFuzzy
            });
        default:
            return state;
    }
}

/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = snackbarReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__);


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




/**
 * Make sure that the notifications with the highest priority come always as first
 * @param {array} notifications - notifications list
 * @returns {array} sorted array
 */
var sort = function sort(notifications) {
    return __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default()(notifications, 'priority');
};

function snackbarReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        items: []
    };
    var _ref = arguments[1];
    var type = _ref.type,
        notification = _ref.notification;

    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["ADD_SNACKBAR_NOTIFICATION"]:
            return Object.assign({}, state, {
                items: sort([notification].concat(_toConsumableArray(state.items)))
            });
        case __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["REMOVE_SNACKBAR_NOTIFICATION"]:
            return Object.assign({}, state, {
                items: sort(state.items.reduce(function (curr, item) {
                    if (notification.id !== item.id) {
                        curr.push(item);
                    }
                    return curr;
                }, []))
            });
        default:
            return state;
    }
};

/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = stripeReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);


/**
 * Make sure that the notifications with the highest priority come always as first
 * @param {array} notifications - notifications list
 * @returns {array} sorted array
 */
function stripeReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        error: null,
        isFetching: false
    };
    var _ref = arguments[1];
    var type = _ref.type,
        error = _ref.error,
        isFetching = _ref.isFetching;

    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["STRIPE_IS_FETCHING"]:
            return Object.assign({}, state, { isFetching: isFetching });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["STRIPE_SET_ERROR"]:
            return Object.assign({}, state, { error: error });
        default:
            return state;
    }
};

/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = subscriptionReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);


function subscriptionReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        email: '',
        error: '',
        isFetching: false
    };
    var _ref = arguments[1];
    var type = _ref.type,
        isFetching = _ref.isFetching,
        email = _ref.email,
        error = _ref.error;

    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_SUBSCRIPTION_EMAIL"]:
            return Object.assign({}, state, {
                error: error,
                email: email
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_IS_FETCHING_SUBSCRIPTION"]:
            return Object.assign({}, state, {
                isFetching: isFetching
            });
        default:
            return state;
    }
};

/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = tooltipReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function tooltipReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        areBlocked: false,
        tooltips: {}
    };
    var _ref = arguments[1];
    var type = _ref.type,
        areBlocked = _ref.areBlocked,
        tooltips = _ref.tooltips;

    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_TOOLTIP_BLOCKER"]:
            return Object.assign({}, state, { areBlocked: areBlocked });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_TOOLTIPS"]:
            return Object.assign({}, state, { tooltips: _extends({}, tooltips) });
        default:
            return state;
    }
};

/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = topProductsReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



function topProductsReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        isFetching: false,
        items: {}
    };
    var _ref = arguments[1];
    var type = _ref.type,
        category = _ref.category,
        isFetching = _ref.isFetching,
        products = _ref.products;

    var entries = void 0;

    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["FETCH_TOP_PRODUCTS_BY_CATEGORY"]:
            entries = category.children.reduce(function (result, child, index) {
                result[child.id] = products[index];
                return result;
            }, {});

            return Object.assign({}, state, {
                items: Object.assign({}, state.items, _defineProperty({}, category.id, entries))
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_IS_FETCHING_TOP_PRODUCTS"]:
            return Object.assign({}, state, {
                isFetching: isFetching
            });
        default:
            return state;
    }
};

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = userReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



function userReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object.assign({
        username: '',
        isAuthenticated: false,
        cumulus_connected: false,
        replacementProductsPreferences: null,
        mostPurchasedProducts: [],
        lastPurchasedProducts: [],
        favoriteProducts: [],
        favoriteProductsTotal: 0,
        creditCardInfo: null,
        isFetchingCreditCardInfo: true
    }, (typeof globals === 'undefined' ? 'undefined' : _typeof(globals)) === 'object' ? globals.config.user : {});
    var _ref = arguments[1];
    var type = _ref.type,
        isAuthenticated = _ref.isAuthenticated,
        user = _ref.user,
        products = _ref.products,
        creditCardInfo = _ref.creditCardInfo,
        isFetchingCreditCardInfo = _ref.isFetchingCreditCardInfo,
        replacementProductsPreferences = _ref.replacementProductsPreferences;

    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_USER_AUTHENTICATION"]:
            return Object.assign({}, state, {
                isAuthenticated: isAuthenticated
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_USER_CREDITCARDINFO"]:
            return Object.assign({}, state, {
                creditCardInfo: creditCardInfo
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_USER_FETCHING_CREDITCARDINFO"]:
            return Object.assign({}, state, {
                isFetchingCreditCardInfo: isFetchingCreditCardInfo
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_USER_REPLACEMENT_PRODUCTS_PREFERENCES"]:
            return Object.assign({}, state, {
                replacementProductsPreferences: replacementProductsPreferences
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_USER_FAVORITE_PRODUCTS"]:
            return Object.assign({}, state, {
                favoriteProducts: [].concat(_toConsumableArray(products)),
                favoriteProductsTotal: products.length
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_USER_MOST_PURCHASED_PRODUCTS"]:
            return Object.assign({}, state, {
                mostPurchasedProducts: [].concat(_toConsumableArray(products))
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_USER_LAST_PURCHASED_PRODUCTS"]:
            return Object.assign({}, state, {
                lastPurchasedProducts: [].concat(_toConsumableArray(products))
            });
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["DO_AUTOLOGIN"]:
            return Object.assign({}, state, user);
        default:
            return state;
    }
}

/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = userReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);


function userReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { videosLoadedAmount: 0 };
    var _ref = arguments[1];
    var type = _ref.type;

    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["VIDEO_CARD_RESET"]:
            return Object.assign({}, state, {
                videosLoadedAmount: 0
            });

        case __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["VIDEO_CARD_LOADED"]:
            return Object.assign({}, state, {
                videosLoadedAmount: state.videosLoadedAmount + 1
            });
        default:
            return state;
    }
}

/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = viewportReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modernizr__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modernizr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_modernizr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_dom_mq__ = __webpack_require__(249);




function viewportReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        height: 0,
        width: 0,
        touchevents: __WEBPACK_IMPORTED_MODULE_0_modernizr__["touchevents"],
        hasOverlay: false,
        title: document.title,
        isNative: /is_native/.test(window.location.search) || /\/webview/.test(window.location.href),
        isTablet: null,
        isDesktop: null,
        isMobile: null,
        mq: {}
    };
    var _ref = arguments[1];
    var type = _ref.type,
        width = _ref.width,
        height = _ref.height,
        mq = _ref.mq,
        hasOverlay = _ref.hasOverlay,
        title = _ref.title;

    switch (type) {
        case __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["SET_VIEWPORT_TITLE"]:
            document.title = title;
            return Object.assign({}, state, { title: title });
        case __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["SET_VIEWPORT_OVERLAY"]:
            return Object.assign({}, state, { hasOverlay: hasOverlay });
        case __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["SET_VIEWPORT"]:
            return Object.assign({}, state, {
                width: width,
                height: height,
                mq: mq,
                isMobile: mq.width <= __WEBPACK_IMPORTED_MODULE_2_util_dom_mq__["d" /* numerals */].SM,
                isTablet: mq.width <= __WEBPACK_IMPORTED_MODULE_2_util_dom_mq__["d" /* numerals */].MD && mq.width > __WEBPACK_IMPORTED_MODULE_2_util_dom_mq__["d" /* numerals */].XS,
                isDesktop: mq.width > __WEBPACK_IMPORTED_MODULE_2_util_dom_mq__["d" /* numerals */].SM
            });
        default:
            return state;
    }
};

/***/ }),
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./address/actions.js": 1046,
	"./breadcrumbs/actions.js": 1049,
	"./cart/actions.js": 342,
	"./categories/actions.js": 1050,
	"./checkout/actions.js": 569,
	"./cms/actions.js": 1051,
	"./delivery/actions.js": 570,
	"./header/actions.js": 1052,
	"./main-content/actions.js": 1053,
	"./modal/actions.js": 336,
	"./mymigros/actions.js": 1054,
	"./navigator/actions.js": 1059,
	"./notifications/actions.js": 397,
	"./orders/actions.js": 1060,
	"./panel/actions.js": 533,
	"./pickers/actions.js": 1061,
	"./poll/actions.js": 1066,
	"./product/actions.js": 1067,
	"./products/actions.js": 1068,
	"./region/actions.js": 1069,
	"./router/actions.js": 1071,
	"./scroll/actions.js": 398,
	"./search/actions.js": 1072,
	"./snackbar/actions.js": 1077,
	"./stripe/actions.js": 1078,
	"./subscription/actions.js": 1079,
	"./tooltip/actions.js": 1081,
	"./top-products/actions.js": 1082,
	"./user/actions.js": 1083,
	"./video-cards/actions.js": 1085,
	"./viewport/actions.js": 532
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1045;

/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(1047);


/* harmony default export */ __webpack_exports__["default"] = (Object.freeze({
    fetchAddresses: __WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* fetchAddresses */],
    setDefaultAddress: __WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* setDefaultAddress */],
    getCurrentAddress: __WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* getCurrentAddress */],
    setAddress: __WEBPACK_IMPORTED_MODULE_0__helpers__["c" /* setAddress */]
}));

/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = setAddress;
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchAddresses;
/* harmony export (immutable) */ __webpack_exports__["b"] = getCurrentAddress;
/* harmony export (immutable) */ __webpack_exports__["d"] = setDefaultAddress;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_filter__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_api_urls__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reducers_helpers__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reducers_modules_cart_helpers__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_debug_promotion_code_logger__ = __webpack_require__(418);









/**
 * Set new Address
 * @param {string} address_id
 * @return {function(*=, *=): Promise<>}
 */
function setAddress(_ref) {
    var address_id = _ref.address_id;

    return function (dispatch, getState) {
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_IS_UPDATING_ADDRESS"], isUpdatingAddresses: true });
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_3_constants_api_urls__["orderDeliveryAddresses"])(), { address_id: address_id }).then(function (_ref2) {
            var cart = _ref2.data;

            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_ORDER_ADDRESS"], addressId: address_id });
            Object(__WEBPACK_IMPORTED_MODULE_6_util_debug_promotion_code_logger__["a" /* default */])(cart, true, Object(__WEBPACK_IMPORTED_MODULE_3_constants_api_urls__["orderDeliveryAddresses"])());
            Object(__WEBPACK_IMPORTED_MODULE_5_reducers_modules_cart_helpers__["e" /* setCart */])(dispatch, getState, cart);
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_IS_UPDATING_ADDRESS"], isUpdatingAddresses: false });
        }).catch(function (e) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_IS_UPDATING_ADDRESS"], isUpdatingAddresses: false });
            Object(__WEBPACK_IMPORTED_MODULE_4_reducers_helpers__["a" /* dispatchError */])(dispatch, e, {
                url: Object(__WEBPACK_IMPORTED_MODULE_3_constants_api_urls__["orderDeliveryAddresses"])(),
                description: e
            });
        });
    };
}

/**
 * Fetch remote addresses
 * @return {function(*=): Promise<AxiosResponse<any> | never>}
 */
function fetchAddresses() {
    return function (dispatch) {
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_IS_FETCHING_USER_ADDRESSES"], isFetchingAddresses: true });
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_3_constants_api_urls__["userAddresses"])()).then(
        /**
         *
         * @param {IAddress[]} data
         */
        function (_ref3) {
            var data = _ref3.data;

            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_IS_FETCHING_USER_ADDRESSES"], isFetchingAddresses: false });
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_USER_ADDRESSES"], addresses: data });
        }).catch(function (e) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_IS_FETCHING_USER_ADDRESSES"], isFetchingAddresses: false });
            Object(__WEBPACK_IMPORTED_MODULE_4_reducers_helpers__["a" /* dispatchError */])(dispatch, e, {
                url: Object(__WEBPACK_IMPORTED_MODULE_3_constants_api_urls__["userAddresses"])(),
                description: e
            });
        });
    };
}

/**
 * Getting current address
 * @return {function(*, *): IAddress}
 */
function getCurrentAddress() {
    return function (dispatch, getState) {
        var _getState$address = getState().address,
            address_id = _getState$address.address_id,
            addresses = _getState$address.addresses;

        return __WEBPACK_IMPORTED_MODULE_0_lodash_filter___default()(addresses, { id: address_id }).pop();
    };
}

/**
 * Setting default address
 * @param {string} address_id
 * @return {function(*=): Promise<AxiosResponse<any> | never>}
 */
function setDefaultAddress(_ref4) {
    var address_id = _ref4.address_id;

    return function (dispatch) {
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_IS_UPDATING_ADDRESS"], isUpdatingAddresses: true });
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_3_constants_api_urls__["userAddressSetDefault"])(), { address_id: address_id }).then(function () {
            dispatch(fetchAddresses());
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_IS_UPDATING_ADDRESS"], isUpdatingAddresses: false });
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_DEFAULT_ADDRESS"], addressId: address_id });
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_ORDER_ADDRESS"], addressId: address_id });
        }).catch(function (e) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_IS_UPDATING_ADDRESS"], isUpdatingAddresses: false });
            Object(__WEBPACK_IMPORTED_MODULE_4_reducers_helpers__["a" /* dispatchError */])(dispatch, e, {
                url: Object(__WEBPACK_IMPORTED_MODULE_3_constants_api_urls__["userAddressSetDefault"])(),
                description: e
            });
        });
    };
}

/***/ }),
/* 1048 */,
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_misc_link_to_home__ = __webpack_require__(198);




/* harmony default export */ __webpack_exports__["default"] = ({
    /**
     * Add breadcrumb entry
     * @param {IBreadcrumb} breadcrumb
     * @return {{breadcrumb: *, type: *}}
     */
    add: function add(_ref) {
        var breadcrumb = _ref.breadcrumb;

        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["ADD_BREADCRUMB"], breadcrumb: breadcrumb };
    },


    /**
     * Set breadcrumbs
     * @param {IBreadcrumb[]} breadcrumbs
     * @return {{type: *, breadcrumbs: *}}
     */
    set: function set(_ref2) {
        var breadcrumbs = _ref2.breadcrumbs;

        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_BREADCRUMBS"], breadcrumbs: breadcrumbs };
    },


    /**
     * Remove specific breadcrumb
     * @param {IBreadcrumb} breadcrumb
     * @return {{breadcrumb: *, type: *}}
     */
    remove: function remove(_ref3) {
        var breadcrumb = _ref3.breadcrumb;

        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["REMOVE_BREADCRUMB"], breadcrumb: breadcrumb };
    },
    reset: function reset() {
        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["RESET_BREADCRUMBS"] };
    },


    /**
     * Setting smart back action
     * @param {IBreadcrumb} data
     * @return {Function}
     */
    setSmartBack: function setSmartBack() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return function (dispatch, getState) {
            var lastRoute = getState().router.lastRoute;

            var breadcrumb = {};

            if (lastRoute) {
                Object.assign(breadcrumb, {
                    name: lastRoute.meta.menu_title,
                    url: lastRoute.location.pathname
                }, data);
            } else {
                Object.assign(breadcrumb, {
                    name: Object(__WEBPACK_IMPORTED_MODULE_1_translations__["c" /* default */])('breadcrumbs.overview'),
                    url: Object(__WEBPACK_IMPORTED_MODULE_2_util_misc_link_to_home__["a" /* default */])(getState().region.active)
                }, data);
            }

            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_BREADCRUMBS"], breadcrumbs: [breadcrumb] });
        };
    }
});

/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reducers_helpers__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_api_urls__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);





var fetchRequests = {};

var actions = Object.freeze({
    /**
     *
     * @param {ICategory | null} category
     * @return {function(*=, *): *}
     */
    fetchCategories: function fetchCategories() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            category = _ref.category;

        return function (dispatch, getState) {
            var cooperative = getState().router.cooperative;
            // If no cache is available, fetch the categories

            var url = category ? Object(__WEBPACK_IMPORTED_MODULE_2_constants_api_urls__["category"])(category.id, cooperative) : Object(__WEBPACK_IMPORTED_MODULE_2_constants_api_urls__["categories"])(cooperative);

            if (!fetchRequests[url]) {
                dispatch({
                    category: category,
                    type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_IS_FETCHING_CATEGORIES"]
                });

                fetchRequests[url] = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url).then(
                /**
                 * @param {ICategory[]} categories
                 */
                function (_ref2) {
                    var categories = _ref2.data;

                    dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["FETCH_CATEGORIES"], categories: categories, category: category });

                    if (!categories.length) {
                        Object(__WEBPACK_IMPORTED_MODULE_1_reducers_helpers__["a" /* dispatchError */])(dispatch, null, {
                            url: url
                        });
                    }

                    return categories;
                }).catch(function (e) {
                    if (e.status === 404) {
                        return Promise.reject(e);
                    }

                    Object(__WEBPACK_IMPORTED_MODULE_1_reducers_helpers__["a" /* dispatchError */])(dispatch, e, {
                        url: url,
                        description: e.message,
                        reloadButton: true
                    });

                    return Promise.resolve({});
                });
            }

            return fetchRequests[url];
        };
    },


    /**
     * Set the visibility for the categories list
     * @param {boolean} isVisible
     * @return {{type: *, isCategorylistVisible: *}}
     */
    setCategoriesVisibility: function setCategoriesVisibility(_ref3) {
        var isVisible = _ref3.isVisible;

        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_CATEGORIES_VISIBILITY"], isCategorylistVisible: isVisible };
    },


    /**
     * Set active category
     * @param {ICategory} category
     * @return {{type: *, category: ICategory}}
     */
    setActiveCategory: function setActiveCategory(_ref4) {
        var category = _ref4.category;

        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_ACTIVE_CATEGORY"], category: category };
    },


    /**
     * The leaf categories are the ones that have no children nodes
     * @param {ICategory} category
     * @return {{type: *, category: ICategory}}
     */
    setActiveLeafCategory: function setActiveLeafCategory(_ref5) {
        var category = _ref5.category;

        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_ACTIVE_LEAF_CATEGORY"], category: category };
    }
});

/* harmony default export */ __webpack_exports__["default"] = (actions);

/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (Object.freeze({}));

/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);


/* harmony default export */ __webpack_exports__["default"] = (Object.freeze({
    /**
     * Set header height
     * @param {number} height
     * @return {{type: *, height: *}}
     */
    setHeight: function setHeight(_ref) {
        var height = _ref.height;

        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_HEADER_HEIGHT"], height: height };
    },

    /**
     * Set facet for header
     * @param {string} facet
     * @return {{type: *, facet: *}}
     */
    setFacet: function setFacet(_ref2) {
        var facet = _ref2.facet;

        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_HEADER_FACET"], facet: facet };
    }
}));

/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__actions_types__);


var timer = void 0;
var LOADING_DELAY = 120;

/* harmony default export */ __webpack_exports__["default"] = (Object.freeze({
    setIsLoaded: function setIsLoaded(_ref) {
        var isLoaded = _ref.isLoaded;

        return function (dispatch) {
            clearTimeout(timer);
            // the loader is always in sync
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__actions_types__["SET_MAIN_CONTENT_LOADER_VISIBILITY"], isLoaderVisible: !isLoaded });

            if (isLoaded) {
                timer = setTimeout(function () {
                    return dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__actions_types__["SET_MAIN_CONTENT_LOADING"], isLoaded: isLoaded });
                }, LOADING_DELAY);
            } else {
                dispatch({ type: __WEBPACK_IMPORTED_MODULE_0__actions_types__["SET_MAIN_CONTENT_LOADING"], isLoaded: isLoaded });
            }
        };
    }
}));

/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_modules_mymigros_helpers__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__);



/* harmony default export */ __webpack_exports__["default"] = ({
    /**
     * @param {IMyMigrosSlider} sliders
     * @param {string} apiEndpoint
     * @return {Promise<IProduct[]>}
     */
    fetchSliders: function fetchSliders(sliders, apiEndpoint) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_reducers_modules_mymigros_helpers__["a" /* fetchCategoryProducts */])(sliders, apiEndpoint);
    },


    /**
     * Set sliders in the store
     * @param {IMyMigrosStateSliders} sliders
     */
    setSliders: function setSliders(sliders) {
        return function (dispatch) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["MYMIGROS_SET_SLIDERS"], sliders: sliders });
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["MYMIGROS_SET_IS_FETCHING"], isFetching: false });
        };
    }
});

/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchCategoryProducts;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find__ = __webpack_require__(1056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__);






/**
 * @param {IMyMigrosSlider} slider
 * @return {Function<IMyMigrosFetchedSliders>}
 */
function filterCategoryById(slider) {
    /** @var{IMyMigrosFetchedSliders} fetchedSlider */
    return function (fetchedSlider) {
        if (!fetchedSlider.category || !fetchedSlider.category.id) {
            return false;
        }

        return slider.id === fetchedSlider.category.id;
    };
}

/**
 * We populate the existing sliders that are set initially with the freshly loaded products
 * @param {IMyMigrosSlider[]} sliders
 * @param {IMyMigrosFetchedSliders[]} fetchedSliders
 * @return {IMyMigrosSlider};
 */
function populateSliders(sliders, fetchedSliders) {
    return sliders.map(function (slider) {
        /** @var {IMyMigrosFetchedSliders} fetchedSlider */
        var fetchedSlider = __WEBPACK_IMPORTED_MODULE_0_lodash_find___default()(fetchedSliders, filterCategoryById(slider));
        if (!fetchedSlider) {
            return slider;
        }
        slider.products = fetchedSlider.products;
        return slider;
    });
}

/**
 * Fetch all products
 * @param {IMyMigrosSlider[]} sliders
 * @param {string} apiEndpoint
 * @return {Promise<IMyMigrosSlider[]>}
 */
function fetchCategoryProducts(sliders, apiEndpoint) {
    return function (dispatch) {
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["MYMIGROS_SET_IS_FETCHING"], isFetching: true });
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(apiEndpoint).then(
        /**
         * @param {IMyMigrosFetchedSliders[]} data
         */
        function (_ref) {
            var data = _ref.data;

            var categoryProducts = populateSliders(sliders, data);
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["MYMIGROS_SET_SLIDERS"], sliders: categoryProducts });
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["MYMIGROS_SET_IS_FETCHING"], isFetching: false });
            return categoryProducts;
        });
    };
}

/***/ }),
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);


/* harmony default export */ __webpack_exports__["default"] = (Object.freeze({
    /**
     * Set network state
     * @param {boolean} isOnline
     * @return {{isOnline: *, type: *}}
     */
    setNetworkState: function setNetworkState(_ref) {
        var isOnline = _ref.isOnline;

        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_NAVIGATOR_ONLINE"], isOnline: isOnline };
    }
}));

/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reducers_helpers__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_api_urls__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_misc_log_error__ = __webpack_require__(18);






/* harmony default export */ __webpack_exports__["default"] = (Object.freeze({
    /**
     * Get order by id
     * @param {string} id
     * @return {function(*=): Promise<AxiosResponse<IOrder>>}
     */
    getOrder: function getOrder(id) {
        return function (dispatch) {
            return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_3_constants_api_urls__["order"])(id)).then(
            /**
             * @param {IOrder} data
             */
            function (_ref) {
                var data = _ref.data;

                dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["FETCH_ORDER"], order: data });
                return data;
            }).catch(function (e) {
                // log the error on sentry only if it's not a 404 response
                var shouldLog = e && e.status !== 404;

                if (shouldLog) {
                    Object(__WEBPACK_IMPORTED_MODULE_2_reducers_helpers__["a" /* dispatchError */])(dispatch, e, { url: Object(__WEBPACK_IMPORTED_MODULE_3_constants_api_urls__["pendingOrders"])(), description: e.message });
                }

                return Promise.reject(e);
            });
        };
    },


    /**
     * Get pending orders
     * @param {number} limit
     * @param {number} offset
     * @return {function(*=): Promise<AxiosResponse<IOrderList> | never>}
     */
    getPendingOrders: function getPendingOrders(_ref2) {
        var limit = _ref2.limit,
            offset = _ref2.offset;

        return function (dispatch) {
            return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_3_constants_api_urls__["pendingOrders"])(), {
                params: {
                    limit: limit,
                    offset: offset
                }
            }).then(
            /**
             * @param {IOrderList} data
             */
            function (_ref3) {
                var data = _ref3.data;

                dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["FETCH_PENDING_ORDERS"], pendingOrders: data });
                return data;
            }).catch(function (e) {
                Object(__WEBPACK_IMPORTED_MODULE_2_reducers_helpers__["a" /* dispatchError */])(dispatch, e, {
                    url: Object(__WEBPACK_IMPORTED_MODULE_3_constants_api_urls__["pendingOrders"])(),
                    description: e.message
                });
            });
        };
    },


    /**
     * @param {number} limit
     * @param {number} offset
     * @return {function(*=): Promise<AxiosResponse<IOrderList> | never>}
     */
    getFinishedOrders: function getFinishedOrders(_ref4) {
        var limit = _ref4.limit,
            offset = _ref4.offset;

        return function (dispatch) {
            return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_3_constants_api_urls__["finishedOrders"])(), {
                params: {
                    limit: limit,
                    offset: offset
                }
            }).then(
            /**
             * @param {IOrderList} data
             */
            function (_ref5) {
                var data = _ref5.data;

                dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["FETCH_FINISHED_ORDERS"], finishedOrders: data });
                return data;
            }).catch(function (e) {
                Object(__WEBPACK_IMPORTED_MODULE_2_reducers_helpers__["a" /* dispatchError */])(dispatch, e, {
                    url: Object(__WEBPACK_IMPORTED_MODULE_3_constants_api_urls__["pendingOrders"])(),
                    description: e.message
                });
            });
        };
    },


    /**
     * Set order picker rating
     * @param {number} id - order id
     * @param {IPickerRatingPayload} payload
     * @return {function(*=): Promise<AxiosResponse<any> | never>}
     */
    setPickerRating: function setPickerRating(_ref6) {
        var id = _ref6.id,
            payload = _ref6.payload;

        return function (dispatch) {
            return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_3_constants_api_urls__["orderPickerRating"])(id), payload).then(function (_ref7) {
                var result = _ref7.data,
                    status = _ref7.status;

                if (status > 399) {
                    Object(__WEBPACK_IMPORTED_MODULE_4_util_misc_log_error__["a" /* default */])(new Error('Unable to set picker rating "status=' + status + '"'));
                }
                return result;
            }).catch(function (e) {
                Object(__WEBPACK_IMPORTED_MODULE_2_reducers_helpers__["a" /* dispatchError */])(dispatch, e, {
                    url: Object(__WEBPACK_IMPORTED_MODULE_3_constants_api_urls__["orderPickerRating"])(),
                    description: e.message
                });
            });
        };
    },


    /**
     * Set order feedback
     * @param {string} id - order id
     * @param {IOrderFeedbackPayload} payload
     * @return {function(*=): Promise<AxiosResponse<IOrderFeedbackPayload> | never>}
     */
    setFeedback: function setFeedback(_ref8) {
        var id = _ref8.id,
            payload = _ref8.payload;

        return function (dispatch) {
            return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_3_constants_api_urls__["orderFeedback"])(id), payload).then(
            /**
             * @param {IOrderFeedbackPayload} result
             * @param {number} status
             */
            function (_ref9) {
                var result = _ref9.data,
                    status = _ref9.status;

                if (status > 399) {
                    Object(__WEBPACK_IMPORTED_MODULE_4_util_misc_log_error__["a" /* default */])(new Error('Unable to set picker rating "status=' + status + '"'));
                }
                return result;
            }).catch(function (e) {
                Object(__WEBPACK_IMPORTED_MODULE_2_reducers_helpers__["a" /* dispatchError */])(dispatch, e, {
                    url: Object(__WEBPACK_IMPORTED_MODULE_3_constants_api_urls__["orderFeedback"])(),
                    description: e.message
                });
            });
        };
    },
    reset: function reset() {
        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["RESET_ORDERS"] };
    }
}));

/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(1062);
/* eslint-disable camelcase */



/* harmony default export */ __webpack_exports__["default"] = ({
    fetch: function fetch() {
        return Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* request */])();
    },
    fetchNextChunk: function fetchNextChunk() {
        return Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* fetchNextChunk */])();
    },

    /**
     * Exclude picker
     * @param {string} person_id
     * @param {boolean} excluded
     * @return {{excluded: *, type: *, person_id: *}}
     */
    setExcluded: function setExcluded(_ref) {
        var person_id = _ref.person_id,
            excluded = _ref.excluded;

        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_PICKER_EXCLUDED"], person_id: person_id, excluded: excluded };
    }
});

/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getUniqueRandom */
/* unused harmony export buildChunkIndexes */
/* unused harmony export getNextChunkIndex */
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchNextChunk;
/* harmony export (immutable) */ __webpack_exports__["b"] = request;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sample__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sample___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_sample__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_indexOf__ = __webpack_require__(1065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_indexOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_indexOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reducers_helpers__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_api_urls__ = __webpack_require__(192);








function getUniqueRandom(allChunks) {
    if (allChunks.length <= 0) {
        return null;
    }

    return __WEBPACK_IMPORTED_MODULE_0_lodash_sample___default()(allChunks);
}

function buildChunkIndexes(total, exclude) {
    var chunks = [];
    for (var i = 0; i < total; i++) {
        if (__WEBPACK_IMPORTED_MODULE_1_lodash_indexOf___default()(exclude, i) === -1) {
            chunks.push(i);
        }
    }

    return chunks;
}

function getNextChunkIndex(totalChunks) {
    var loadedChunkIndexes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var allChunks = buildChunkIndexes(totalChunks, loadedChunkIndexes);
    return getUniqueRandom(allChunks);
}

function fetchNextChunk() {
    return function (dispatch, getState) {
        var _getState$pickers = getState().pickers,
            loadedChunkIndexes = _getState$pickers.loadedChunkIndexes,
            totalChunks = _getState$pickers.totalChunks;

        var nextChunk = getNextChunkIndex(totalChunks, loadedChunkIndexes);

        if (nextChunk === null) {
            return null;
        }

        return request(null, nextChunk, true)(dispatch, getState);
    };
}

function request(requestData) {
    var chunkIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var appendResult = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    return function (dispatch, getState) {
        var chunkSize = getState().pickers.chunkSize;
        var _getState$pickers2 = getState().pickers,
            items = _getState$pickers2.items,
            loadedChunkIndexes = _getState$pickers2.loadedChunkIndexes;

        var url = Object(__WEBPACK_IMPORTED_MODULE_5_constants_api_urls__["pickers"])(chunkSize, chunkIndex);

        dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_IS_FETCHING_PICKERS"], isFetching: true });

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a[requestData ? 'post' : 'get'](url, requestData).then(
        /**
         * @param {IPickerLoadResponse} data
         */
        function (_ref) {
            var data = _ref.data;

            var pickerItems = data.pickers;
            var total = data.total_count;
            var totalChunks = data.chunks_total;
            var currentChunkIndex = data.chunk_index;

            if (appendResult) {
                items = items.concat(pickerItems);
            } else {
                items = pickerItems;
                loadedChunkIndexes = [];
            }

            loadedChunkIndexes.push(currentChunkIndex);

            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_PICKERS"], items: items });
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_PICKERS_TOTAL"], total: total });
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_PICKERS_TOTAL_CHUNKS"], totalChunks: totalChunks });
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_PICKERS_LOADED_CHUNK_INDEXES"], loadedChunkIndexes: loadedChunkIndexes });
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_IS_FETCHING_PICKERS"], isFetching: false });

            var loadedAllChunks = loadedChunkIndexes.length >= totalChunks;

            dispatch({
                type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_PICKERS_ALL_CHUNKS_LOADED"],
                loadedAllChunks: loadedAllChunks
            });
        }).catch(function (e) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_IS_FETCHING_PICKERS"], isFetching: false });
            Object(__WEBPACK_IMPORTED_MODULE_4_reducers_helpers__["a" /* dispatchError */])(dispatch, e, {
                url: Object(__WEBPACK_IMPORTED_MODULE_5_constants_api_urls__["pickers"])(),
                description: e.message,
                error: e,
                reloadButton: true
            });
        });
    };
}

/***/ }),
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INTERVAL", function() { return INTERVAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INTERVAL_FAST", function() { return INTERVAL_FAST; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_api_urls__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reducers_modules_delivery_actions__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reducers_modules_checkout_actions__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ruit__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reducers_modules_notifications_actions__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reducers_modules_cart_actions__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_misc_get_order_state__ = __webpack_require__(573);
/* eslint-disable camelcase */










/**
 * The poll interval default which can be overriden from consumers
 */
var INTERVAL = 15000; // 15 seconds
var INTERVAL_FAST = 500; // 500ms


/**
 * The current timer, if the poll is running
 */
var timer = void 0;

/**
 * Handle the polling errors avoiding showing errors
 * @returns {Promise<boolean>}
 */
function onError(_ref, fast) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;

    poll({ dispatch: dispatch, getState: getState }, fast);
    return Promise.resolve(false);
}

/**
 * Success handler triggered after any polling request
 * @returns {Promise<boolean>}
 */
function onSuccess(_ref2, fast) {
    var dispatch = _ref2.dispatch,
        getState = _ref2.getState,
        data = _ref2.data;
    var state = data.state;

    var resolve = function resolve() {
        return Promise.resolve(true);
    };

    var _getOrderState = Object(__WEBPACK_IMPORTED_MODULE_8_util_misc_get_order_state__["a" /* default */])(state),
        isActive = _getOrderState.isActive;

    dispatch(__WEBPACK_IMPORTED_MODULE_2_reducers_modules_delivery_actions__["default"].setStatus({ status: state }));

    if (isActive) {
        poll({ dispatch: dispatch, getState: getState, fast: fast }); // Recursively invoke the timer
        return resolve();
    }

    dispatch(__WEBPACK_IMPORTED_MODULE_3_reducers_modules_checkout_actions__["default"].reset());
    dispatch(__WEBPACK_IMPORTED_MODULE_6_reducers_modules_cart_actions__["default"].reset());

    // get a new order
    return dispatch(actions.requestOrder());
}

/**
 * Ticker function for the polling iterations
 * @returns {Promise<boolean>}
 */
function onTick(_ref3, fast) {
    var getState = _ref3.getState,
        dispatch = _ref3.dispatch;

    var handleError = function handleError() {
        return onError({ dispatch: dispatch, getState: getState }, fast);
    };
    var state = getState();
    var cartId = state.cart.id;
    var isLogged = state.user.isAuthenticated;

    dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_POLLING_ID"], id: cartId });

    if (!cartId || !isLogged) {
        return Promise.resolve(handleError());
    }

    return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_1_constants_api_urls__["poll"])(cartId)).then(function (_ref4) {
        var data = _ref4.data;
        return onSuccess({ dispatch: dispatch, getState: getState, data: data, fast: fast });
    }).catch(handleError);
}

/**
 * Get the current poll update from the server
 * @returns {Promise}
 */
function poll(_ref5) {
    var dispatch = _ref5.dispatch,
        getState = _ref5.getState,
        isInitial = _ref5.isInitial;
    var fast = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    // clear any previous pending polling request
    clear();

    return new Promise(function (resolve) {
        var tick = function tick() {
            return resolve(onTick({ dispatch: dispatch, getState: getState }, fast));
        };

        if (isInitial) {
            tick();
        } else {
            requestAnimationFrame(function () {
                timer = setTimeout(tick, fast ? INTERVAL_FAST : INTERVAL);
            });
        }
    });
}

/**
 * Clear the current timeout
 */
function clear() {
    clearTimeout(timer);
    timer = null;
}

var actions = Object.freeze({
    startPollFast: function startPollFast() {
        return function (dispatch, getState) {
            return poll({ dispatch: dispatch, getState: getState, isInitial: true }, true);
        };
    },
    startPoll: function startPoll() {
        return function (dispatch, getState) {
            return poll({ dispatch: dispatch, getState: getState, isInitial: true }, false);
        };
    },
    requestOrder: function requestOrder() {
        return function (dispatch, getState) {
            var startPolling = function startPolling() {
                return poll({ dispatch: dispatch, getState: getState, isInitial: true }, false);
            };

            return Object(__WEBPACK_IMPORTED_MODULE_4_ruit__["a" /* default */])(function () {
                return dispatch(__WEBPACK_IMPORTED_MODULE_6_reducers_modules_cart_actions__["default"].fetchCart());
            }, function () {
                return dispatch(__WEBPACK_IMPORTED_MODULE_5_reducers_modules_notifications_actions__["default"].fetch());
            }, function () {
                return startPolling();
            }).catch(startPolling);
        };
    },
    stopPoll: function stopPoll() {
        return function (dispatch) {
            clear(dispatch);
        };
    }
});

/* harmony default export */ __webpack_exports__["default"] = (actions);

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_api_urls__ = __webpack_require__(192);




/* harmony default export */ __webpack_exports__["default"] = (Object.freeze({
    /**
     *
     * @param {string} slug
     * @return {function(*): Promise<AxiosResponse<IProductDetail>>}
     */
    fetch: function fetch(slug) {
        return function (dispatch) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_IS_FETCHING_PRODUCT"], isFetching: true });

            return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_2_constants_api_urls__["product"])(slug)).then(
            /**
             * @param {IProductDetail} data
             */
            function (_ref) {
                var data = _ref.data;

                dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_IS_FETCHING_PRODUCT"], isFetching: false });
                dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_PRODUCT"], product: data });
                return data;
            }).catch(function (e) {
                dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_IS_FETCHING_PRODUCT"], isFetching: false });
                return Promise.reject(e);
            });
        };
    },
    reset: function reset() {
        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["RESET_PRODUCT"] };
    }
}));

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reducers_helpers__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_misc_products_factory_middleware__ = __webpack_require__(304);





var pendingRequestsCount = 0;

/**
 * Helper function that will set the isFetching flag to false or true if there are still loading requests in the queue
 * @param { funciton } dispatch - redux dispatch function
 */
function setIsFetching(dispatch) {
    pendingRequestsCount--;
    var isFetching = pendingRequestsCount !== 0;
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_IS_FETCHING_PRODUCTS"], isFetching: isFetching });
}

/**
 * Fetch the products depending on the category
 * @param {ICategory} category
 * @return {Promise<IProduct[]>}
 */
function _fetchProductsByCategory(_ref) {
    var category = _ref.category;

    pendingRequestsCount++;
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(category.products_url).then(function (_ref2) {
        var data = _ref2.data;

        return data;
    });
}

/* harmony default export */ __webpack_exports__["default"] = (Object.freeze({
    /**
     * @param {ICategory} category
     * @return {function: Promise<ICooperativeProduct[]>}
     */
    fetchProductsByCategory: function fetchProductsByCategory(_ref3) {
        var category = _ref3.category;

        return function (dispatch, getState) {
            var cooperative = getState().router.cooperative;
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_IS_FETCHING_PRODUCTS"], isFetching: true });
            return _fetchProductsByCategory({
                category: category
            }).then(
            /**
             *
             * @param {IProduct[]} products
             * @return {ICooperativeProduct[]}
             */
            function (products) {
                return Object(__WEBPACK_IMPORTED_MODULE_3_util_misc_products_factory_middleware__["a" /* default */])(products, { cooperative: cooperative });
            }).then(
            /**
             * @param {ICooperativeProduct[]} products
             * @return {ICooperativeProduct[]}
             */
            function (products) {
                setIsFetching(dispatch);
                dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["FETCH_PRODUCTS_BY_CATEGORY"], products: products, category: category, cooperative: cooperative });
                return products;
            }).catch(function (e) {
                setIsFetching(dispatch);

                if (e.status === 404) {
                    return Promise.reject(e);
                }

                Object(__WEBPACK_IMPORTED_MODULE_2_reducers_helpers__["a" /* dispatchError */])(dispatch, e, {
                    url: category.products_url,
                    description: e.message
                });

                dispatch({
                    type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["FETCH_PRODUCTS_BY_CATEGORY"],
                    products: [],
                    category: category
                });

                return Promise.resolve([]);
            });
        };
    },
    flush: function flush() {
        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["FLUSH_PRODUCTS"] };
    }
}));

/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__actions_types__);



/* harmony default export */ __webpack_exports__["default"] = (Object.freeze({
    /**
     * Set the region
     * @param {string} zip
     * @return {Promise}
     */
    setRegion: function setRegion(_ref) {
        var zip = _ref.zip;

        return Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* setRegion */])({ zip: zip });
    },
    reset: function reset() {
        return { type: __WEBPACK_IMPORTED_MODULE_1__actions_types__["RESET_REQUESTED_REGION"] };
    }
}));

/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setRegion;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_api_urls__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reducers_helpers__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reducers_modules_modal_actions__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reducers_modules_cart_actions__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);







/**
 * Set the user zip code retrieving the region string
 * @param { string } zip
 * @return {function: Promise<IRegion>}
 */
function setRegion(_ref) {
    var zip = _ref.zip;

    return function (dispatch, getState) {
        var url = Object(__WEBPACK_IMPORTED_MODULE_0_constants_api_urls__["zipCode"])(zip);
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_4_reducers_actions_types__["SET_IS_FETCHING_REGION"], isFetching: true });

        return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url).then(
        /**
         * @param {IRegion} data
         * @return {IRegion}
         */
        function (_ref2) {
            var data = _ref2.data;

            dispatch({ type: __WEBPACK_IMPORTED_MODULE_4_reducers_actions_types__["SET_IS_FETCHING_REGION"], isFetching: false });
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_4_reducers_actions_types__["SET_REGION"], region: data });
            if (data.enabled) {
                dispatch(__WEBPACK_IMPORTED_MODULE_2_reducers_modules_modal_actions__["default"].close());
            }

            var tempItem = getState().cart.tempItem;


            if (tempItem) {
                dispatch(__WEBPACK_IMPORTED_MODULE_3_reducers_modules_cart_actions__["default"].addProduct({ product: tempItem }));
            }

            return data;
        }).catch(function (e) {
            Object(__WEBPACK_IMPORTED_MODULE_1_reducers_helpers__["a" /* dispatchError */])(dispatch, e, {
                url: url,
                description: e.message
            });

            dispatch({ type: __WEBPACK_IMPORTED_MODULE_4_reducers_actions_types__["SET_IS_FETCHING_REGION"], isFetching: false });
        });
    };
}

/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);


/* harmony default export */ __webpack_exports__["default"] = (Object.freeze({
    set: function set(_ref) {
        var route = _ref.route;

        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_ROUTE"], route: route };
    },
    setCooperative: function setCooperative(_ref2) {
        var cooperative = _ref2.cooperative;

        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_ROUTE_COOPERATIVE"], cooperative: cooperative };
    },
    setLastRoute: function setLastRoute(_ref3) {
        var lastRoute = _ref3.lastRoute;

        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_LAST_ROUTE"], lastRoute: lastRoute };
    },
    setForceNotFound: function setForceNotFound(_ref4) {
        var mustForceNotFound = _ref4.mustForceNotFound;

        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_FORCE_NOT_FOUND"], mustForceNotFound: mustForceNotFound };
    }
}));

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_reduce__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_api_urls__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reducers_helpers__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tracking__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_search__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_misc_get_region__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_misc_products_factory_middleware__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_emoji_translator__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_emoji_translator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_emoji_translator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_constants_emojis_to_german__ = __webpack_require__(1076);














var flattedEmojis = __WEBPACK_IMPORTED_MODULE_0_lodash_reduce___default()(__WEBPACK_IMPORTED_MODULE_11_constants_emojis_to_german__["a" /* emojis */], function (acc, value) {
    acc[value.emoji] = value.text;
    return acc;
}, {});

var emojiReplacer = __WEBPACK_IMPORTED_MODULE_10_emoji_translator___default()(flattedEmojis);

var queue = [];

/**
 * Get axios request token
 * @param {string} key
 * @return {CancelToken}
 */
var getAxiosToken = function getAxiosToken(key) {
    var a = queue.filter(function (obj) {
        return obj.id === key;
    });
    return a[0].source.token;
};

var cancelPendingRequests = function cancelPendingRequests() {
    queue.map(function (req) {
        req.source.cancel('New search request inbound, clearing queue');
        return req;
    });
    queue = [];
};

/**
 * Search query
 * @param {string} term
 * @param {boolean} loadMore
 * @param {boolean} isEnterPressed
 * @return {function: Promise<ISearch | never>}
 */
var query = function query(_ref) {
    var term = _ref.term,
        loadMore = _ref.loadMore,
        isEnterPressed = _ref.isEnterPressed;

    return function (dispatch, getState) {
        var _getState$search = getState().search,
            offset = _getState$search.offset,
            limit = _getState$search.limit,
            isFuzzy = _getState$search.isFuzzy;
        /** @type {string} */

        var cooperative = Object(__WEBPACK_IMPORTED_MODULE_8_util_misc_get_region__["b" /* getCooperativeBySlug */])(getState().region.active);

        /** @type {string[]} */
        var words = emojiReplacer(term);

        if (words.length < __WEBPACK_IMPORTED_MODULE_7_constants_search__["a" /* SEARCH_KEYWORD_MIN_LENGTH */]) {
            cancelPendingRequests();
            dispatch(reset());
            return null;
        }

        if (!loadMore && !isEnterPressed) {
            cancelPendingRequests();
            dispatch(reset());
        }

        var token = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.CancelToken;

        queue.push({
            id: words,
            source: token.source()
        });

        if (loadMore) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["SET_IS_LOADING_MORE"], isLoadingMore: true });
        }

        dispatch({ type: __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["SET_IS_SEARCHING"], isSearching: true });

        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_3_constants_api_urls__["search"])(words, cooperative), {
            cancelToken: getAxiosToken(words),
            params: {
                offset: offset,
                limit: limit,
                fuzzy: isFuzzy
            }
        }).then(
        /**
         *  @param {ISearch} data
         *  @return {ISearch}
         */
        function (_ref2) {
            var data = _ref2.data;

            if (data.products) {
                data.products.items = Object(__WEBPACK_IMPORTED_MODULE_9_util_misc_products_factory_middleware__["a" /* default */])(data.products.items, { cooperative: cooperative });
            }
            return data;
        }).then(
        /**
         * @param {ISearch} data
         * @return {ISearch}
         */
        function (data) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["SET_SEARCH_TERM"], term: term });
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["SET_SEARCH_RESULT"], result: data });
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["SET_IS_SEARCHING"], isSearching: false });
            if (loadMore) {
                dispatch({ type: __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["SET_IS_LOADING_MORE"], isLoadingMore: false });
            } else {
                __WEBPACK_IMPORTED_MODULE_5_tracking__["a" /* default */].siteSearch(Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["a" /* getCategoriesTrackingData */])(data, words));
                __WEBPACK_IMPORTED_MODULE_5_tracking__["a" /* default */].siteSearch(Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["b" /* getProductsTrackingData */])(data, words));
            }
            return data;
        }).catch(function (e) {
            if (!__WEBPACK_IMPORTED_MODULE_2_axios___default.a.isCancel(e)) {
                Object(__WEBPACK_IMPORTED_MODULE_4_reducers_helpers__["a" /* dispatchError */])(dispatch, e, {
                    url: Object(__WEBPACK_IMPORTED_MODULE_3_constants_api_urls__["search"])(words, cooperative),
                    description: e
                });

                dispatch({ type: __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["SET_IS_LOADING_MORE"], isLoadingMore: false });
                dispatch({ type: __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["SET_IS_SEARCHING"], isSearching: false });
            }
        });
    };
};

/**
 * Populate common categories
 * @return {function(*=, *): Promise<ISearch | never>}
 */
var populateCommonCategories = function populateCommonCategories() {
    return function (dispatch, getState) {
        var cooperative = Object(__WEBPACK_IMPORTED_MODULE_8_util_misc_get_region__["b" /* getCooperativeBySlug */])(getState().region.active);
        var term = '';
        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_3_constants_api_urls__["search"])(term, cooperative)).then(
        /**
         * @param {ISearch} data
         * @return {ISearch}
         */
        function (_ref3) {
            var data = _ref3.data;

            if (data.products) {
                data.products.items = Object(__WEBPACK_IMPORTED_MODULE_9_util_misc_products_factory_middleware__["a" /* default */])(data.products.items, { cooperative: cooperative });
            }
            return data;
        }).then(
        /**
         * @param {ISearch} data
         * @return {ISearch}
         */
        function (data) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["SET_COMMON_CATEGORIES"], result: data.common_categories });
            return data;
        }).catch(function (e) {
            Object(__WEBPACK_IMPORTED_MODULE_4_reducers_helpers__["a" /* dispatchError */])(dispatch, e, {
                url: Object(__WEBPACK_IMPORTED_MODULE_3_constants_api_urls__["search"])(term, cooperative),
                description: e
            });
        });
    };
};

/**
 * Load more items
 * @return {Function}
 */
var loadMore = function loadMore() {
    return function (dispatch, getState) {
        var _getState$search2 = getState().search,
            offset = _getState$search2.offset,
            limit = _getState$search2.limit,
            productsTotal = _getState$search2.productsTotal,
            isLoadingMore = _getState$search2.isLoadingMore,
            term = _getState$search2.term;

        var nextOffset = offset + limit;
        if (nextOffset < productsTotal && !isLoadingMore) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["SET_SEARCH_OFFSET"], offset: nextOffset });
            dispatch(query({ term: term, loadMore: true }));
        }
    };
};

/**
 * Set search term
 * @param {string} term
 * @return {Function}
 */
var persistTerm = function persistTerm(_ref4) {
    var term = _ref4.term;

    return function (dispatch) {
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["SET_SEARCH_TERM"], term: term });
    };
};

/**
 * Set limit
 * @param {number} limit
 * @return {Function}
 */
var setLimit = function setLimit(_ref5) {
    var limit = _ref5.limit;

    return function (dispatch) {
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["SET_SEARCH_LIMIT"], limit: limit });
    };
};

/**
 * Set offset amount
 * @param {number} offset
 * @return {Function}
 */
var setOffset = function setOffset(_ref6) {
    var offset = _ref6.offset;

    return function (dispatch) {
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["SET_SEARCH_OFFSET"], offset: offset });
    };
};

/**
 * Set fuzzyness in search
 * @param {boolean} isFuzzy
 * @return {Function}
 */
var setFuzzy = function setFuzzy(_ref7) {
    var isFuzzy = _ref7.isFuzzy;

    return function (dispatch) {
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["SET_SEARCH_FUZZY"], isFuzzy: isFuzzy });
    };
};

var open = function open() {
    return function (dispatch) {
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["SET_SEARCH_IS_ACTIVE"] });
    };
};

var close = function close() {
    return function (dispatch) {
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["SET_SEARCH_IS_INACTIVE"] });
    };
};

var reset = function reset() {
    return function (dispatch) {
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_1_reducers_actions_types__["RESET_SEARCH"] });
    };
};

/* harmony default export */ __webpack_exports__["default"] = (Object.freeze({
    query: query,
    loadMore: loadMore,
    setLimit: setLimit,
    setOffset: setOffset,
    open: open,
    close: close,
    reset: reset,
    populateCommonCategories: populateCommonCategories,
    setFuzzy: setFuzzy,
    persistTerm: persistTerm
}));

/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCategoriesTrackingData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getProductsTrackingData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_flowRight__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_flowRight__);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Composable function to extract the tacking term
 * @param {ISearch} data - api search response
 * @param {string} query - query string
 * @returns {ISearchTrackingData}
 */
var getTrackingData = function getTrackingData(data, query) {
    return _extends({
        siteSearchQuery: query, // nach was gesucht wurde. bei autosuggestion ist dies das angeklickte query aus der Liste
        siteSearchTypedQuery: query }, data);
};

/**
 * Composed function to track only the categories search items
 */
var getCategoriesTrackingData = __WEBPACK_IMPORTED_MODULE_0_lodash_flowRight___default()(function (_ref) {
    var siteSearchQuery = _ref.siteSearchQuery,
        siteSearchTypedQuery = _ref.siteSearchTypedQuery,
        categories = _ref.categories;

    return {
        searchType: 'kategorie-search', // Typ der Suche (produkt-search, kategorie-search, etc.)
        suggestSearch: 'false', // Wenn Suggest-Search verwendet wird, bitte auf true, sonst auf false setzen
        siteSearchQuery: siteSearchQuery,
        siteSearchTypedQuery: siteSearchTypedQuery,
        siteSearchResultsTotalAmount: categories.total_hits, // Gesamtanzahl von Suchtreffer
        siteSearchResults: categories.items.reduce(function (acc, item) {
            acc[item.id] = 1;
            return acc;
        }, {}) // Die im Array stehende Produktkategorien sollen dynamisch erweitert werden, einsprachig auf Deutsch
    };
}, getTrackingData);

/**
 * Composed function to track only the products search items
 */
var getProductsTrackingData = __WEBPACK_IMPORTED_MODULE_0_lodash_flowRight___default()(function (_ref2) {
    var siteSearchQuery = _ref2.siteSearchQuery,
        siteSearchTypedQuery = _ref2.siteSearchTypedQuery,
        products = _ref2.products;

    return {
        searchType: 'produkt-search', // Typ der Suche (produkt-search, kategorie-search, etc.)
        suggestSearch: 'false', // Wenn Suggest-Search verwendet wird, bitte auf true, sonst auf false setzen
        siteSearchQuery: siteSearchQuery,
        siteSearchTypedQuery: siteSearchTypedQuery,
        siteSearchResultsTotalAmount: products.total_hits, // Gesamtanzahl von Suchtreffer
        siteSearchResults: products.items.reduce(function (acc, item) {
            if (acc[item.tracking_category]) {
                ++acc[item.tracking_category];
            } else {
                acc[item.tracking_category] = 1;
            }
            return acc;
        }, {}) // Die im Array stehende Produktkategorien sollen dynamisch erweitert werden, einsprachig auf Deutsch
    };
}, getTrackingData);

/***/ }),
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SEARCH_KEYWORD_MIN_LENGTH; });
var SEARCH_KEYWORD_MIN_LENGTH = 3;

/***/ }),
/* 1075 */,
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return emojis; });
var emojis = [{
    emoji: '🍏',
    text: 'Apfel'
}, {
    emoji: '🍎',
    text: 'Apfel'
}, {
    emoji: '🍐',
    text: 'Birne'
}, {
    emoji: '🍊',
    text: 'Mandarine'
}, {
    emoji: '🍋',
    text: 'Zitrone'
}, {
    emoji: '🍌',
    text: 'Banane'
}, {
    emoji: '🍉',
    text: 'Wassermelone'
}, {
    emoji: '🍇',
    text: 'Trauben'
}, {
    emoji: '🍓',
    text: 'Erdbeere'
}, {
    emoji: '🍈',
    text: 'Honigmelone'
}, {
    emoji: '🍒',
    text: 'Kirschen'
}, {
    emoji: '🍑',
    text: 'Pfirsich'
}, {
    emoji: '🍍',
    text: 'Ananas'
}, {
    emoji: '🥥',
    text: 'Kokosnuss'
}, {
    emoji: '🥝',
    text: 'Kiwi'
}, {
    emoji: '🍅',
    text: 'Tomate'
}, {
    emoji: '🍆',
    text: 'Aubergine'
}, {
    emoji: '🥑',
    text: 'Avocado'
}, {
    emoji: '🥦',
    text: 'Brokkoli'
}, {
    emoji: '🥒',
    text: 'Gurke'
}, {
    emoji: '🌶',
    text: 'Peperoni'
}, {
    emoji: '🌽',
    text: 'Mais'
}, {
    emoji: '🥕',
    text: 'Karotte'
}, {
    emoji: '🥔',
    text: 'Kartoffel'
}, {
    emoji: '🍠',
    text: 'Kartoffel'
}, {
    emoji: '🥐',
    text: 'Croissant'
}, {
    emoji: '🍞',
    text: 'Brot'
}, {
    emoji: '🥖',
    text: 'Brot'
}, {
    emoji: '🥨',
    text: 'Brezel'
}, {
    emoji: '🧀',
    text: 'Käse'
}, {
    emoji: '🥚',
    text: 'Eier'
}, {
    emoji: '🍳',
    text: 'Eier'
}, {
    emoji: '🥞',
    text: 'Pancake'
}, {
    emoji: '🥓',
    text: 'Bacon'
}, {
    emoji: '🥩',
    text: 'Fleisch'
}, {
    emoji: '🍗',
    text: 'Poulet'
}, {
    emoji: '🍖',
    text: 'Fleisch'
}, {
    emoji: '🌭',
    text: 'Hotdog'
}, {
    emoji: '🍔',
    text: 'Hamburger'
}, {
    emoji: '🍟',
    text: 'Pommes'
}, {
    emoji: '🍕',
    text: 'Pizza'
}, {
    emoji: '🥪',
    text: 'Sandwich'
}, {
    emoji: '🥙',
    text: 'Döner'
}, {
    emoji: '🌮',
    text: 'Taco'
}, {
    emoji: '🌯',
    text: 'Burrito'
}, {
    emoji: '🥗',
    text: 'Salat'
}, {
    emoji: '🥘',
    text: 'Pfannengericht'
}, {
    emoji: '🥫',
    text: 'Konserve'
}, {
    emoji: '🍝',
    text: 'Spaghetti'
}, {
    emoji: '🍜',
    text: 'Suppe'
}, {
    emoji: '🍲',
    text: 'Reis'
}, {
    emoji: '🍛',
    text: 'Reis'
}, {
    emoji: '🍣',
    text: 'Sushi'
}, {
    emoji: '🍱',
    text: 'Sushi'
}, {
    emoji: '🥟',
    text: 'Teig'
}, {
    emoji: '🍤',
    text: 'Crevetten'
}, {
    emoji: '🍙',
    text: 'Reis'
}, {
    emoji: '🍚',
    text: 'Reis'
}, {
    emoji: '🍘',
    text: 'Reis'
}, {
    emoji: '🍥',
    text: 'Fisch'
}, {
    emoji: '🥠',
    text: 'Glückskeks'
}, {
    emoji: '🍢',
    text: 'Spiessli'
}, {
    emoji: '🍡',
    text: 'Spiessli'
}, {
    emoji: '🍧',
    text: 'Glace'
}, {
    emoji: '🍨',
    text: 'Glace'
}, {
    emoji: '🍦',
    text: 'Glace'
}, {
    emoji: '🥧',
    text: 'Kuchen'
}, {
    emoji: '🍰',
    text: 'Torte'
}, {
    emoji: '🎂',
    text: 'Torte'
}, {
    emoji: '🍮',
    text: 'Pudding'
}, {
    emoji: '🍭',
    text: 'Lollypop'
}, {
    emoji: '🍬',
    text: 'Bonbon'
}, {
    emoji: '🍫',
    text: 'Schokolade'
}, {
    emoji: '🍿',
    text: 'Popcorn'
}, {
    emoji: '🍩',
    text: 'Donut'
}, {
    emoji: '🍪',
    text: 'Keks'
}, {
    emoji: '🌰',
    text: 'Kastanie'
}, {
    emoji: '🥜',
    text: 'Erdnuss'
}, {
    emoji: '🍯',
    text: 'Honig'
}, {
    emoji: '🥛',
    text: 'Milch'
}, {
    emoji: '🍼',
    text: 'Milch'
}, {
    emoji: '☕',
    text: 'Kaffe'
}, {
    emoji: '🍵',
    text: 'Tee'
}, {
    emoji: '🥤',
    text: 'Getränk'
}, {
    emoji: '🍶',
    text: 'Sake'
}, {
    emoji: '🍺',
    text: 'Bier'
}, {
    emoji: '🍻',
    text: 'Bier'
}, {
    emoji: '🥂',
    text: 'Champagne'
}, {
    emoji: '🍷',
    text: 'Wein'
}, {
    emoji: '🥃',
    text: 'Getränk'
}, {
    emoji: '🍸',
    text: 'Cocktail'
}, {
    emoji: '🍹',
    text: 'Cocktail'
}, {
    emoji: '🍾',
    text: 'Champagne'
}, {
    emoji: '🥄',
    text: 'Löffel'
}, {
    emoji: '🍴',
    text: 'Besteck'
}, {
    emoji: '🍽',
    text: 'Besteck'
}, {
    emoji: '🥣',
    text: 'Schüssel'
}, {
    emoji: '🥡',
    text: 'Takeaway'
}, {
    emoji: '🥢',
    text: 'Essstäbchen'
}, {
    emoji: '🐶',
    text: 'Hund'
}, {
    emoji: '🐕',
    text: 'Hund'
}, {
    emoji: '🐩',
    text: 'Hund'
}, {
    emoji: '🐱',
    text: 'Katze'
}, {
    emoji: '😺',
    text: 'Katze'
}, {
    emoji: '😸',
    text: 'Katze'
}, {
    emoji: '😹',
    text: 'Katze'
}, {
    emoji: '😻',
    text: 'Katze'
}, {
    emoji: '😼',
    text: 'Katze'
}, {
    emoji: '😽',
    text: 'Katze'
}, {
    emoji: '🙀',
    text: 'Katze'
}, {
    emoji: '😿',
    text: 'Katze'
}, {
    emoji: '😾',
    text: 'Katze'
}, {
    emoji: '🐈',
    text: 'Katze'
}, {
    emoji: '🐭',
    text: 'Nager'
}, {
    emoji: '🐹',
    text: 'Nager'
}, {
    emoji: '🐰',
    text: 'Nager'
}, {
    emoji: '🐇',
    text: 'Nager'
}, {
    emoji: '🐁',
    text: 'Nager'
}, {
    emoji: '🐀',
    text: 'Nager'
}, {
    emoji: '🐦',
    text: 'Vogel'
}, {
    emoji: '🕊️',
    text: 'Vogel'
}, {
    emoji: '💩',
    text: 'Toilette'
}, {
    emoji: '🐷',
    text: 'Schwein'
}, {
    emoji: '🐽',
    text: 'Schwein'
}, {
    emoji: '🐖',
    text: 'Schwein'
}, {
    emoji: '🎉',
    text: 'Party'
}, {
    emoji: '🎊',
    text: 'Party'
}, {
    emoji: '🎁',
    text: 'Geschenk'
}, {
    emoji: '🐮',
    text: 'Rind'
}, {
    emoji: '🐄',
    text: 'Rind'
}, {
    emoji: '🔋',
    text: 'Batterien'
}, {
    emoji: '☀️',
    text: 'Sonne'
}, {
    emoji: '🐟',
    text: 'Fisch'
}, {
    emoji: '🛁',
    text: 'Dusche'
}, {
    emoji: '🍦',
    text: 'Glace'
}, {
    emoji: '🥖',
    text: 'Brot'
}, {
    emoji: '☕️',
    text: 'Kaffee'
}, {
    emoji: '🍯',
    text: 'Honig'
}, {
    emoji: '🥒',
    text: 'Gurke'
}, {
    emoji: '🍗 ',
    text: 'Fleisch'
}, {
    emoji: '🎮',
    text: 'Spiele'
}, {
    emoji: '🎲',
    text: 'Spiele'
}, {
    emoji: '😪',
    text: 'Taschentücher'
}, {
    emoji: '🤧',
    text: 'Taschentücher'
}, {
    emoji: '🤕',
    text: 'Pflaster'
}, {
    emoji: '👶',
    text: 'Baby'
}, {
    emoji: '💅🏻',
    text: 'Nagellack'
}, {
    emoji: '👩🏼‍🌾',
    text: 'Bio'
}, {
    emoji: '👨🏼‍🌾',
    text: 'Bio'
}, {
    emoji: '🐔',
    text: 'Poulet'
}, {
    emoji: '🐥',
    text: 'Poulet'
}, {
    emoji: '🦐',
    text: 'Crevetten'
}, {
    emoji: '🐓',
    text: 'Poulet'
}, {
    emoji: '🎅',
    text: 'Weihnachten'
}, {
    emoji: '🎄',
    text: 'Weihnachten'
}, {
    emoji: '🐑',
    text: 'Schaf'
}, {
    emoji: '🍫',
    text: 'Schokolade'
}, {
    emoji: '✂️',
    text: 'Papeterie'
}, {
    emoji: '✏️',
    text: 'Papeterie'
}, {
    emoji: '📎',
    text: 'Papeterie'
}, {
    emoji: '💊',
    text: 'Vitamin'
}, {
    emoji: '🚽',
    text: 'Toilette'
}];

/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);


/* harmony default export */ __webpack_exports__["default"] = ({
    /**
     * @param {INotification} notification
     * @return {{notification: INotification, type: *}}
     */
    add: function add(_ref) {
        var notification = _ref.notification;

        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["ADD_SNACKBAR_NOTIFICATION"], notification: notification };
    },


    /**
     * @param {INotification} notification
     * @return {{notification: notification, type: *}}
     */
    remove: function remove(_ref2) {
        var notification = _ref2.notification;

        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["REMOVE_SNACKBAR_NOTIFICATION"], notification: notification };
    }
});

/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reducers_helpers__ = __webpack_require__(203);



//@todo create interfaces
function request(stripe) {
    return function (dispatch) {
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["STRIPE_IS_FETCHING"], isFetching: true });

        return stripe.createToken().then(function (response) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_CHECKOUT_PAYMENT_VALID"], isPaymentMethodValid: !response.error });
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["STRIPE_IS_FETCHING"], isFetching: false });

            if (response.error) {
                dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["STRIPE_SET_ERROR"], error: response.error });
                return Promise.reject(false);
            }

            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["STRIPE_SET_ERROR"], error: null });

            if (!response.token) {
                throw new Error('Unexpected response');
            }

            return response.token.id;
        }).catch(function (e) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["STRIPE_IS_FETCHING"], isFetching: false });

            if (e !== false) {
                Object(__WEBPACK_IMPORTED_MODULE_1_reducers_helpers__["a" /* dispatchError */])(dispatch, e, {
                    description: e
                });
            }
        });
    };
}

function setError(error) {
    return function (dispatch) {
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["STRIPE_SET_ERROR"], error: error });
    };
}

/* harmony default export */ __webpack_exports__["default"] = ({
    request: request,
    setError: setError
});

/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(1080);


/* harmony default export */ __webpack_exports__["default"] = (Object.freeze({
    /**
     * @param {string}} email
     * @param {string} zip
     * @return {Promise}
     */
    subscribe: function subscribe(_ref) {
        var email = _ref.email,
            zip = _ref.zip;

        return Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["a" /* subscribe */])({ email: email, zip: zip });
    },

    /**
     * @param {string} email
     * @param {string} zip
     * @return {Promise}
     */
    subscribePrelaunch: function subscribePrelaunch(_ref2) {
        var email = _ref2.email,
            zip = _ref2.zip;

        return Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* subscribePrelaunch */])({ email: email, zip: zip });
    }
}));

/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subscribe;
/* harmony export (immutable) */ __webpack_exports__["b"] = subscribePrelaunch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_api_urls__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reducers_helpers__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);





/**
 * Subscribe an email address in order to receive notification from the application
 * @param { string } email
 * @param { string } zip
 * @returns {function: Promise}
 */
function subscribe(_ref) {
    var email = _ref.email,
        zip = _ref.zip;

    return function (dispatch) {
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_IS_FETCHING_SUBSCRIPTION"], isFetching: true });

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_0_constants_api_urls__["subscribe"])(), { email: email, zip: parseInt(zip) }).then(function () {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_IS_FETCHING_SUBSCRIPTION"], isFetching: false });
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_SUBSCRIPTION_EMAIL"], email: email });
        }).catch(function (e) {
            Object(__WEBPACK_IMPORTED_MODULE_1_reducers_helpers__["a" /* dispatchError */])(dispatch, e, {
                url: Object(__WEBPACK_IMPORTED_MODULE_0_constants_api_urls__["subscribe"])(),
                description: e.message
            });

            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_SUBSCRIPTION_EMAIL"], email: '', error: e.message });
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_IS_FETCHING_SUBSCRIPTION"], isFetching: false });
        });
    };
}

/**
 * TODO: remove after prelaunch
 * Subscribe an email address in order to receive notification from the application
 * @param { string } email
 * @param { string } zip
 * @returns {function: Promise}
 */
function subscribePrelaunch(_ref2) {
    var email = _ref2.email,
        zip = _ref2.zip;

    return function (dispatch) {
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_IS_FETCHING_SUBSCRIPTION"], isFetching: true });

        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_0_constants_api_urls__["subscribe"])(), { email: email, zip: parseInt(zip) }).then(function () {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_IS_FETCHING_SUBSCRIPTION"], isFetching: false });
        }).catch(function (e) {
            Object(__WEBPACK_IMPORTED_MODULE_1_reducers_helpers__["a" /* dispatchError */])(dispatch, e, {
                url: Object(__WEBPACK_IMPORTED_MODULE_0_constants_api_urls__["subscribe"])(),
                description: e.message
            });

            dispatch({ type: __WEBPACK_IMPORTED_MODULE_2_reducers_actions_types__["SET_IS_FETCHING_SUBSCRIPTION"], isFetching: false });
        });
    };
}

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);


var id = 0;
/**
 *
 * @param {string} groupName
 * @param {Document} element
 * @param {object} config
 * @return {Function}
 */
var add = function add(groupName, element, config) {
    return function (dispatch, getState) {
        var tooltips = getState().tooltip.tooltips;


        if (!tooltips[groupName]) {
            tooltips[groupName] = [];
        }

        var group = tooltips[groupName];

        var tooltip = {
            id: id,
            config: config,
            element: element
        };

        var sameTooltips = group.filter(function (_tooltip) {
            return _tooltip.element === element;
        });

        if (sameTooltips.length <= 0) {
            tooltips[groupName].push(tooltip);
            id++;
        } else {
            group = tooltips[groupName].map(function (_tooltip) {
                if (_tooltip.element === element) {
                    _tooltip.config.content = config.content;
                    _tooltip.config.mustShow = config.mustShow;
                }

                return Object.assign({}, _tooltip);
            });
            tooltips[groupName] = group;
        }

        dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_TOOLTIPS"], tooltips: Object.assign({}, tooltips) });
    };
};

/**
 * Remove tooltip
 * @param {string} groupName
 * @param {Element} element
 * @return {Function}
 */
var remove = function remove(groupName, element) {
    return function (dispatch, getState) {
        var tooltips = getState().tooltip.tooltips;


        if (!tooltips[groupName]) {
            return;
        }

        tooltips[groupName] = tooltips[groupName].map(function (tooltip) {
            if (tooltip.element === element) {
                tooltip.config.mustShow = false;
            }

            return Object.assign({}, tooltip);
        });
        //
        // tooltips[groupName] = tooltips[groupName].filter((tooltip) => {
        //     return (tooltip.element !== element);
        // });

        dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_TOOLTIPS"], tooltips: Object.assign({}, tooltips) });
    };
};

/**
 * Remove complete group
 * @param {string} groupName
 * @return {Function}
 */
var removeGroup = function removeGroup(groupName) {
    return function (dispatch, getState) {
        var tooltips = getState().tooltip.tooltips;


        if (!tooltips[groupName]) {
            return;
        }

        tooltips[groupName] = [];

        dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_TOOLTIPS"], tooltips: tooltips });
    };
};

/* harmony default export */ __webpack_exports__["default"] = (Object.freeze({
    setBlocked: function setBlocked(_ref) {
        var areBlocked = _ref.areBlocked;

        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_TOOLTIP_BLOCKER"], areBlocked: areBlocked };
    },

    add: add,
    remove: remove,
    removeGroup: removeGroup
}));

/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_api_urls__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_misc_products_factory_middleware__ = __webpack_require__(304);





var pendingRequestsCount = 0;

/**
 * Helper function that will set the isFetching flag to false or true if there are still loading requests in the queue
 * @param { funciton } dispatch - redux dispatch function
 */
function setIsFetching(dispatch) {
    pendingRequestsCount--;
    var isFetching = pendingRequestsCount !== 0;
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_IS_FETCHING_PRODUCTS"], isFetching: isFetching });
}

/**
 * Fetch the products depending on the category
 * @param {ICategory} category
 * @param {string} cooperative
 */
function fetchTopProducts(_ref, cooperative) {
    var category = _ref.category;

    pendingRequestsCount++;
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_2_constants_api_urls__["topProducts"])(category.id, cooperative)).then(function (_ref2) {
        var data = _ref2.data;

        return data;
    });
}

/* harmony default export */ __webpack_exports__["default"] = (Object.freeze({
    /**
     * @param {ICategory} category
     * @return {function(*=, *): Promise<IProduct[] | ICooperativeProduct[] | never>}
     */
    fetchTopProductsByCategory: function fetchTopProductsByCategory(_ref3) {
        var category = _ref3.category;

        return function (dispatch, getState) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["SET_IS_FETCHING_PRODUCTS"], isFetching: true });
            var categories = category.children;
            var cooperative = getState().router.cooperative;

            return Promise.all(categories.map(function (child) {
                return fetchTopProducts({ category: child }, cooperative);
            })).then(function (products) {
                return Object(__WEBPACK_IMPORTED_MODULE_3_util_misc_products_factory_middleware__["a" /* default */])(products, { cooperative: cooperative });
            }).then(function (products) {
                setIsFetching(dispatch);
                dispatch({ type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["FETCH_TOP_PRODUCTS_BY_CATEGORY"], category: category, products: products });
                return products;
            }).catch(function () {
                setIsFetching(dispatch);
                dispatch({
                    type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["FETCH_TOP_PRODUCTS_BY_CATEGORY"],
                    products: [],
                    category: category
                });
            });
        };
    }
}));

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(1084);



/* harmony default export */ __webpack_exports__["default"] = (Object.freeze({
    login: __WEBPACK_IMPORTED_MODULE_1__helpers__["e" /* login */],
    logout: __WEBPACK_IMPORTED_MODULE_1__helpers__["f" /* logout */],
    fetchCreditCard: __WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* fetchCreditCard */],
    populateFavoriteProducts: __WEBPACK_IMPORTED_MODULE_1__helpers__["g" /* populateFavoriteProducts */],
    populateMostPurchasedProducts: __WEBPACK_IMPORTED_MODULE_1__helpers__["i" /* populateMostPurchasedProducts */],
    populateLastPurchasedProducts: __WEBPACK_IMPORTED_MODULE_1__helpers__["h" /* populateLastPurchasedProducts */],
    fetchMostPurchasedProductsBatch: __WEBPACK_IMPORTED_MODULE_1__helpers__["c" /* fetchMostPurchasedProductsBatch */],
    fetchLatestPurchasedProductsBatch: __WEBPACK_IMPORTED_MODULE_1__helpers__["b" /* fetchLatestPurchasedProductsBatch */],
    fetchReplacementProductPreferences: __WEBPACK_IMPORTED_MODULE_1__helpers__["d" /* fetchReplacementProductPreferences */],
    setReplacementProductsPreferences: __WEBPACK_IMPORTED_MODULE_1__helpers__["k" /* setReplacementProductsPreferences */],
    removeCard: __WEBPACK_IMPORTED_MODULE_1__helpers__["j" /* removeCard */],
    autologin: function autologin(_ref) {
        var user = _ref.user;

        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["DO_AUTOLOGIN"], user: user };
    }
}));

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["j"] = removeCard;
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchCreditCard;
/* harmony export (immutable) */ __webpack_exports__["d"] = fetchReplacementProductPreferences;
/* harmony export (immutable) */ __webpack_exports__["k"] = setReplacementProductsPreferences;
/* harmony export (immutable) */ __webpack_exports__["e"] = login;
/* harmony export (immutable) */ __webpack_exports__["f"] = logout;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return populateFavoriteProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchMostPurchasedProductsBatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchLatestPurchasedProductsBatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return populateMostPurchasedProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return populateLastPurchasedProducts; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_curry__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_curry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_curry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reducers_actions_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_protected_pages__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_api_urls__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_reducers_helpers__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_misc_products_factory_middleware__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_translations__ = __webpack_require__(171);


/* eslint-disable camelcase */












function removeCard() {
    return function (dispatch) {
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_3_reducers_actions_types__["SET_USER_CREDITCARDINFO"], creditCardInfo: null });
    };
}

/**
 * Fetch credit card info
 * @return {function(*=): Promise<AxiosResponse<any> | never>}
 */
function fetchCreditCard() {
    return function (dispatch) {
        dispatch({ type: __WEBPACK_IMPORTED_MODULE_3_reducers_actions_types__["SET_USER_FETCHING_CREDITCARDINFO"], isFetchingCreditCardInfo: true });

        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_5_constants_api_urls__["userCreditCard"])()).then(
        /**
         * @param {ICreditCard}data
         */
        function (_ref) {
            var data = _ref.data;

            dispatch({ type: __WEBPACK_IMPORTED_MODULE_3_reducers_actions_types__["SET_USER_CREDITCARDINFO"], creditCardInfo: data });
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_3_reducers_actions_types__["SET_USER_FETCHING_CREDITCARDINFO"], isFetchingCreditCardInfo: false });
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_3_reducers_actions_types__["SET_CHECKOUT_PAYMENT_VALID"], isPaymentMethodValid: !!data });
        }).catch(function (e) {
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_3_reducers_actions_types__["SET_USER_FETCHING_CREDITCARDINFO"], isFetchingCreditCardInfo: false });
            dispatch({ type: __WEBPACK_IMPORTED_MODULE_3_reducers_actions_types__["SET_CHECKOUT_PAYMENT_VALID"], isPaymentMethodValid: false });

            if (e.status && e.status === 404) {
                dispatch({ type: __WEBPACK_IMPORTED_MODULE_3_reducers_actions_types__["SET_USER_CREDITCARDINFO"], creditCardInfo: null });
                return null;
            }

            Object(__WEBPACK_IMPORTED_MODULE_6_reducers_helpers__["a" /* dispatchError */])(dispatch, e, {
                url: Object(__WEBPACK_IMPORTED_MODULE_5_constants_api_urls__["userCreditCard"])(),
                description: e
            });
            return null;
        });
    };
}

/**
 * Fetch replacement product references
 * @return {function(*=): Promise<AxiosResponse<any> | never>}
 */
function fetchReplacementProductPreferences() {
    return function (dispatch) {
        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_5_constants_api_urls__["replacementProducts"])()).then(
        /**
         * @param {IWantsReplacementsProductsResponse} data
         */
        function (_ref2) {
            var data = _ref2.data;

            dispatch({ type: __WEBPACK_IMPORTED_MODULE_3_reducers_actions_types__["SET_USER_REPLACEMENT_PRODUCTS_PREFERENCES"], replacementProductsPreferences: data });
        }).catch(function (e) {
            Object(__WEBPACK_IMPORTED_MODULE_6_reducers_helpers__["a" /* dispatchError */])(dispatch, e, {
                title: Object(__WEBPACK_IMPORTED_MODULE_8_translations__["f" /* t */])('error.unable_to_fetch_replacement_product_preferences'),
                url: Object(__WEBPACK_IMPORTED_MODULE_5_constants_api_urls__["replacementProducts"])(),
                description: e
            });
        });
    };
}

/**
 * Set replacement product ref
 * @param {boolean} wantsReplacementProducts
 * @return {function(*=, *): Promise<AxiosResponse<any> | never>}
 */
function setReplacementProductsPreferences(_ref3) {
    var wantsReplacementProducts = _ref3.wantsReplacementProducts;

    return function (dispatch, getState) {
        var _getState = getState(),
            user = _getState.user;

        var isOptionActive = function isOptionActive(value) {
            return value === 'on';
        };
        var oldReplacementProductsPreferences = user.replacementProductsPreferences;

        dispatch({ type: __WEBPACK_IMPORTED_MODULE_3_reducers_actions_types__["SET_USER_REPLACEMENT_PRODUCTS_PREFERENCES"], wantsReplacementProducts: null });

        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_5_constants_api_urls__["replacementProducts"])(), {
            wants_replacement_products: isOptionActive(wantsReplacementProducts)
        }).then(function (_ref4) {
            var data = _ref4.data;

            dispatch({ type: __WEBPACK_IMPORTED_MODULE_3_reducers_actions_types__["SET_USER_REPLACEMENT_PRODUCTS_PREFERENCES"], replacementProductsPreferences: data });
        }).catch(function (e) {
            Object(__WEBPACK_IMPORTED_MODULE_6_reducers_helpers__["a" /* dispatchError */])(dispatch, e, {
                title: Object(__WEBPACK_IMPORTED_MODULE_8_translations__["f" /* t */])('error.unable_to_set_replacement_product_preferences'),
                url: Object(__WEBPACK_IMPORTED_MODULE_5_constants_api_urls__["replacementProducts"])(),
                description: e
            });

            dispatch({
                type: __WEBPACK_IMPORTED_MODULE_3_reducers_actions_types__["SET_USER_REPLACEMENT_PRODUCTS_PREFERENCES"],
                replacementProductsPreferences: oldReplacementProductsPreferences
            });
        });
    };
}

/**
 * @param {string} redirectToUrl
 * @return {Function}
 */
function login(redirectToUrl) {
    return function () {
        window.location.href = Object(__WEBPACK_IMPORTED_MODULE_5_constants_api_urls__["login"])(redirectToUrl);
    };
}

function logout() {
    return function (dispatch, getState) {
        var name = getState().router.name;

        window.location.href = Object(__WEBPACK_IMPORTED_MODULE_5_constants_api_urls__["logout"])(__WEBPACK_IMPORTED_MODULE_4_constants_protected_pages__["a" /* default */].includes(name) ? window.location.origin : window.location.href);
    };
}

/**
 * Fetch the user specific products and dispatch an event with the products retrieved
 * @param {string} url - url where we will fetch the products
 * @param {string} eventType - event name to dispatch
 * @param {function} dispatch - retux dispatcher function
 * @returns {Function}
 */
function fetchProducts(url, eventType, dispatch, getState) {
    var cooperative = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(getState(), 'region.active.cooperative');

    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url).then(function (_ref5) {
        var data = _ref5.data;
        return Object(__WEBPACK_IMPORTED_MODULE_7_util_misc_products_factory_middleware__["a" /* default */])(data.products, { cooperative: cooperative });
    }).then(
    /**
     * @param {IProduct[] | ICooperativeProduct[]} products
     */
    function (products) {
        dispatch({ type: eventType, products: products });
    }).catch(function (e) {
        dispatch({ type: eventType, products: [] });
        // TODO: This error is silenced due to weird responses.
        // dispatchError(dispatch, e, {
        //     url: userFavoriteProducts(),
        //     title: 'Unable to get favorite products',
        //     description: e,
        // });
        return Promise.reject(e);
    });
}

/**
 *
 * @param {string} url
 * @param {number} offset
 * @param {number} limit
 * @return {function(*, *): Promise<IProduct[] | ICooperativeProduct[] | never>}
 */
function fetchProductsBatch(url, offset, limit) {
    return function (dispatch, getState) {
        var cooperative = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(getState(), 'region.active.cooperative');

        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url, { params: { offset: offset, limit: limit } }).then(function (_ref6) {
            var data = _ref6.data;
            return Object(__WEBPACK_IMPORTED_MODULE_7_util_misc_products_factory_middleware__["a" /* default */])(data.products, { cooperative: cooperative });
        }).then(
        /**
         * @param {IProduct[] | ICooperativeProduct[]} products
         */
        function (products) {
            return products;
        });
    };
}

var populateFavoriteProducts = __WEBPACK_IMPORTED_MODULE_1_lodash_curry___default()(fetchProducts)(Object(__WEBPACK_IMPORTED_MODULE_5_constants_api_urls__["userFavoriteProducts"])(), __WEBPACK_IMPORTED_MODULE_3_reducers_actions_types__["SET_USER_FAVORITE_PRODUCTS"]);
var fetchMostPurchasedProductsBatch = __WEBPACK_IMPORTED_MODULE_1_lodash_curry___default()(fetchProductsBatch)(Object(__WEBPACK_IMPORTED_MODULE_5_constants_api_urls__["mostPurchasedProducts"])());
var fetchLatestPurchasedProductsBatch = __WEBPACK_IMPORTED_MODULE_1_lodash_curry___default()(fetchProductsBatch)(Object(__WEBPACK_IMPORTED_MODULE_5_constants_api_urls__["lastPurchasedProducs"])());
var populateMostPurchasedProducts = __WEBPACK_IMPORTED_MODULE_1_lodash_curry___default()(fetchProducts)(Object(__WEBPACK_IMPORTED_MODULE_5_constants_api_urls__["mostPurchasedProducts"])(), __WEBPACK_IMPORTED_MODULE_3_reducers_actions_types__["SET_USER_MOST_PURCHASED_PRODUCTS"]);
var populateLastPurchasedProducts = __WEBPACK_IMPORTED_MODULE_1_lodash_curry___default()(fetchProducts)(Object(__WEBPACK_IMPORTED_MODULE_5_constants_api_urls__["lastPurchasedProducs"])(), __WEBPACK_IMPORTED_MODULE_3_reducers_actions_types__["SET_USER_LAST_PURCHASED_PRODUCTS"]);

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__);


/* harmony default export */ __webpack_exports__["default"] = (Object.freeze({
    reset: function reset() {
        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["VIDEO_CARD_RESET"] };
    },
    onLoaded: function onLoaded() {
        return { type: __WEBPACK_IMPORTED_MODULE_0_reducers_actions_types__["VIDEO_CARD_LOADED"] };
    }
}));

/***/ }),
/* 1086 */,
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bianco_events__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_misc_overlay_tracker__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var MENU_FACET_NAME = 'menu';
var CART_FACET_NAME = 'cart';

var SidePanel = function (_PureComponent) {
    _inherits(SidePanel, _PureComponent);

    function SidePanel() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SidePanel);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SidePanel.__proto__ || Object.getPrototypeOf(SidePanel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isOpening: false,
            isClosing: false,
            isOpen: false,
            facet: null
        }, _this.onSwipe = function (e) {
            if (e.type === 'swipeleft' && _this.props.facet === MENU_FACET_NAME || e.type === 'swiperight' && _this.props.facet === CART_FACET_NAME) {
                _this.close();
            }
        }, _this.onAnimationEnd = function (e) {
            if (e.target !== _this.refs.root) {
                return;
            }

            _this.resetPanelState(_this.props.facet);
        }, _this.resetPanelState = function (facet) {
            _this.setState({ isOpen: _this.props.isOpen, isOpening: false, isClosing: false, facet: facet });

            if (!_this.props.isOpen) {
                _this.props.resetPanel();
            }
        }, _this.close = function () {
            _this.props.closePanel();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SidePanel, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            Object(__WEBPACK_IMPORTED_MODULE_2_util_misc_overlay_tracker__["a" /* subscribe */])(this, this.close);
            Object(__WEBPACK_IMPORTED_MODULE_1_bianco_events__["a" /* add */])(this.refs.root, 'swipeleft swiperight', this.onSwipe);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ((nextProps.viewportMqWidth !== this.props.viewportMqWidth || nextProps.pathname !== this.props.pathname || nextProps.modalContent && !this.props.modalContent) && this.props.isOpen) {
                this.close();
            }
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(props, state) {
            if (props.isOpen !== this.props.isOpen) {
                state.isOpening = props.isOpen === true;
                state.isClosing = props.isOpen === false;

                if (props.isOpen === true) {
                    this.setState({
                        facet: props.facet
                    });
                }
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            Object(__WEBPACK_IMPORTED_MODULE_2_util_misc_overlay_tracker__["b" /* unsubscribe */])(this);
            Object(__WEBPACK_IMPORTED_MODULE_1_bianco_events__["b" /* remove */])(this.refs.root, 'swipeleft swiperight', this.onSwipe);
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames;

            var _props = this.props,
                content = _props.content,
                closePanel = _props.closePanel;
            var _state = this.state,
                isOpen = _state.isOpen,
                isOpening = _state.isOpening,
                isClosing = _state.isClosing,
                facet = _state.facet;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                    ref: 'root',
                    onAnimationEnd: this.onAnimationEnd,
                    className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('side-panel', (_classnames = {}, _defineProperty(_classnames, 'side-panel__' + facet, facet), _defineProperty(_classnames, 'side-panel__open', isOpen || isOpening || isClosing), _defineProperty(_classnames, 'side-panel__opening', isOpening), _defineProperty(_classnames, 'side-panel__closing', isClosing), _classnames)),
                    onClick: closePanel
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'side-panel--panel__background' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('side-panel--panel'),
                        onClick: function onClick(e) {
                            return e.stopPropagation();
                        }
                    },
                    content
                )
            );
        }
    }]);

    return SidePanel;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

SidePanel.defaultProps = {
    facet: 'menu'
};
SidePanel.propTypes = {
    pathname: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
    isOpen: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
    modalContent: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
    closePanel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
    resetPanel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
    facet: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    content: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
    viewportMqWidth: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_5_util_redux__["b" /* default */].mapStateToProps({
    viewportMqWidth: 'viewport.mq.width',
    isOpen: 'panel.isOpen',
    facet: 'panel.facet',
    modalContent: 'modal.content',
    content: 'panel.content',
    pathname: 'router.location.pathname'
}), __WEBPACK_IMPORTED_MODULE_5_util_redux__["b" /* default */].mapDispatchToProps({
    closePanel: 'panel.close',
    resetPanel: 'panel.reset'
}))(SidePanel));

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bianco_events__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_breadcrumbs__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__header_cart__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pre_header__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__search__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_side_panel_nav__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_util_misc_static_assets_path__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_util_misc_link_to_home__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_page_loader_bar__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_offline_notification__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_category_navigation_button__ = __webpack_require__(1192);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















function Logo(_ref) {
    var isMobile = _ref.isMobile,
        togglePanel = _ref.togglePanel,
        isMenuOpen = _ref.isMenuOpen,
        userRegion = _ref.userRegion;

    var homeLink = Object(__WEBPACK_IMPORTED_MODULE_14_util_misc_link_to_home__["a" /* default */])(userRegion);
    if (isMobile) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'main-header--logo-inner' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                {
                    'aria-expanded': isMenuOpen,
                    'aria-haspopup': 'true',
                    'aria-label': Object(__WEBPACK_IMPORTED_MODULE_17_translations__["f" /* t */])('accessibility.label.navigation_menu'),
                    'aria-controls': 'menu',
                    onClick: function onClick() {
                        return togglePanel({ facet: 'menu', content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_side_panel_nav__["a" /* default */], null) });
                    },
                    className: __WEBPACK_IMPORTED_MODULE_10_classnames___default()('main-header--menu-button', { 'main-header--menu-button__highlighted': isMenuOpen })
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_icon__["a" /* default */], { className: 'main-header--hamburger', size: 'medium', symbol: isMenuOpen ? 'cancel' : 'burger' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_router_dom__["b" /* Link */],
                { to: homeLink, className: 'main-header--logo-image' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'main-header--logo-img', src: Object(__WEBPACK_IMPORTED_MODULE_13_util_misc_static_assets_path__["a" /* default */])('img/logos/amigos-small.svg'),
                    alt: Object(__WEBPACK_IMPORTED_MODULE_17_translations__["f" /* t */])('amigos.title') })
            )
        );
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'main-header--logo-inner' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_router_dom__["b" /* Link */],
            { to: homeLink, className: 'main-header--logo-image' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'main-header--logo-img', src: Object(__WEBPACK_IMPORTED_MODULE_13_util_misc_static_assets_path__["a" /* default */])('img/logos/amigos-large.svg'),
                alt: Object(__WEBPACK_IMPORTED_MODULE_17_translations__["f" /* t */])('amigos.title') })
        )
    );
}

Logo.propTypes = {
    isMenuOpen: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired,
    isMobile: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired,
    userRegion: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
    togglePanel: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired
};

var MainHeader = function (_PureComponent) {
    _inherits(MainHeader, _PureComponent);

    function MainHeader() {
        var _ref2;

        var _temp, _this, _ret;

        _classCallCheck(this, MainHeader);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = MainHeader.__proto__ || Object.getPrototypeOf(MainHeader)).call.apply(_ref2, [this].concat(args))), _this), _this.closePanel = function () {
            _this.props.closePanel();
        }, _this.openPanel = function () {
            _this.props.openPanel({ facet: 'menu' });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(MainHeader, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (this.refs.headerLogo) {
                Object(__WEBPACK_IMPORTED_MODULE_1_bianco_events__["a" /* add */])(this.refs.headerLogo, 'swiperight', this.openPanel);
                Object(__WEBPACK_IMPORTED_MODULE_1_bianco_events__["a" /* add */])(this.refs.headerLogo, 'swipeleft', this.closePanel);
            }
            requestAnimationFrame(function () {
                _this2.setHeaderHeight();
            });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(_ref3) {
            var _this3 = this;

            var isMobile = _ref3.isMobile,
                templateConfig = _ref3.templateConfig;

            if (isMobile !== this.props.isMobile || !isMobile && templateConfig.header !== this.props.templateConfig.header) {
                requestAnimationFrame(function () {
                    _this3.setHeaderHeight();
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.refs.headerLogo) {
                Object(__WEBPACK_IMPORTED_MODULE_1_bianco_events__["b" /* remove */])(this.refs.headerLogo, 'swiperight', this.openPanel);
                Object(__WEBPACK_IMPORTED_MODULE_1_bianco_events__["b" /* remove */])(this.refs.headerLogo, 'swipeleft', this.closePanel);
            }
        }
    }, {
        key: 'setHeaderHeight',
        value: function setHeaderHeight() {
            if (!this.isNone && this.refs.headerContent) {
                this.props.setHeaderHeight({ height: this.refs.headerContent.offsetHeight });
            }
        }
    }, {
        key: 'renderHeader',
        value: function renderHeader() {
            var _props = this.props,
                isMobile = _props.isMobile,
                togglePanel = _props.togglePanel,
                isMenuOpen = _props.isMenuOpen,
                userRegion = _props.userRegion,
                panelFacet = _props.panelFacet;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'main-header--content' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'main-header--container grid--container grid--container__fluid' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'grid--row main-header--row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { ref: 'headerLogo', className: 'grid--col main-header--col main-header--logo' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Logo, {
                                isMenuOpen: isMenuOpen && panelFacet === 'menu',
                                togglePanel: togglePanel,
                                userRegion: userRegion,
                                isMobile: isMobile })
                        ),
                        this.isReduced || this.isMini ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'grid--col main-header--col main-header--search' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__search__["a" /* default */], { isReduced: isMobile })
                        ),
                        this.isReduced || this.isMini ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'grid--col main-header--col main-header--cart' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'main-header--cart-wrapper' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__header_cart__["a" /* default */], null)
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                isMobile = _props2.isMobile,
                setActiveCategory = _props2.setActiveCategory,
                scrollbarWidth = _props2.scrollbarWidth,
                isScrollLocked = _props2.isScrollLocked,
                panelFacet = _props2.panelFacet,
                isModalOpen = _props2.isModalOpen,
                headerHeight = _props2.headerHeight,
                templateConfig = _props2.templateConfig,
                isLoaderVisible = _props2.isLoaderVisible,
                breadcrumbs = _props2.breadcrumbs;

            var canShowBreadcrumbs = panelFacet !== 'menu';
            var paddingRight = isScrollLocked ? scrollbarWidth : null;
            var hasBreadcrumbs = breadcrumbs.length > 0;

            if (this.isNone) {
                return null;
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { ref: 'root',
                    'aria-hidden': isModalOpen,
                    className: __WEBPACK_IMPORTED_MODULE_10_classnames___default()('skel--header main-header grid main-header__' + templateConfig.header) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'main-header--placeholder', style: { height: headerHeight } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_page_loader_bar__["a" /* default */], { isActive: isLoaderVisible }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_offline_notification__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { ref: 'headerContent', className: 'main-header--content-wrapper grid grid__fluid',
                        style: canShowBreadcrumbs || this.isMini ? { paddingRight: paddingRight } : {
                            height: headerHeight - 44,
                            overflow: 'hidden',
                            paddingRight: paddingRight
                        } },
                    isMobile || this.isReduced ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__pre_header__["a" /* default */], null),
                    (isMobile || !this.isMini) && this.renderHeader(),
                    isMobile && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_category_navigation_button__["a" /* default */], null),
                    !this.isMini && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        {
                            className: __WEBPACK_IMPORTED_MODULE_10_classnames___default()('main-header--breadcrumbs', {
                                'main-header--breadcrumbs__empty': !hasBreadcrumbs,
                                'main-header--breadcrumbs__visible': canShowBreadcrumbs
                            }) },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_breadcrumbs__["a" /* default */], { setActiveCategory: setActiveCategory })
                    )
                )
            );
        }
    }, {
        key: 'isDefault',
        get: function get() {
            return this.props.templateConfig.header === 'default';
        }
    }, {
        key: 'isMini',
        get: function get() {
            return this.props.templateConfig.header === 'mini';
        }
    }, {
        key: 'isNone',
        get: function get() {
            return this.props.templateConfig.header === 'none';
        }
    }, {
        key: 'isReduced',
        get: function get() {
            return this.props.templateConfig.header === 'reduced';
        }
    }]);

    return MainHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

MainHeader.propTypes = {
    pathname: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
    isMenuOpen: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired,
    isScrollLocked: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired,
    isMobile: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired,
    scrollbarWidth: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number.isRequired,
    viewportWidth: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number.isRequired,
    activeCategory: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
    headerHeight: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number.isRequired,
    panelFacet: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    setActiveCategory: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    setHeaderHeight: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    togglePanel: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    isModalOpen: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired,
    openPanel: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    closePanel: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    userRegion: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
    routerRegistry: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired,
    currentRouteName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
    templateConfig: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired,
    isLoaderVisible: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired,
    breadcrumbs: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_12_util_redux__["b" /* default */].mapStateToProps({
    isMobile: 'viewport.isMobile',
    viewportWidth: 'viewport.width',
    headerHeight: 'header.height',
    activeCategory: 'categories.active',
    isModalOpen: 'modal.isVisible',
    isMenuOpen: 'panel.isOpen',
    hasViewportOverlay: 'viewport.hasOverlay',
    panelFacet: 'panel.facet',
    isScrollLocked: 'scroll.isLocked',
    scrollbarWidth: 'scroll.scrollbarWidth',
    pathname: 'router.location.pathname',
    currentRouteName: 'router.name',
    userRegion: 'region.active',
    routerRegistry: 'router.registry',
    templateConfig: 'router.config',
    isLoaderVisible: 'main-content.isLoaderVisible',
    breadcrumbs: 'breadcrumbs.items'
}), __WEBPACK_IMPORTED_MODULE_12_util_redux__["b" /* default */].mapDispatchToProps({
    setHeaderHeight: 'header.setHeight',
    setActiveCategory: 'categories.setActiveCategory',
    togglePanel: 'panel.toggle',
    closePanel: 'panel.close',
    openPanel: 'panel.open',
    setBreadcrumbs: 'breadcrumbs.set'
}))(MainHeader));

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_flip_move__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants_transitions_props__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util_misc_normalise_trailing_slash__ = __webpack_require__(196);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var Breadcrumbs = function (_PureComponent) {
    _inherits(Breadcrumbs, _PureComponent);

    function Breadcrumbs() {
        _classCallCheck(this, Breadcrumbs);

        return _possibleConstructorReturn(this, (Breadcrumbs.__proto__ || Object.getPrototypeOf(Breadcrumbs)).apply(this, arguments));
    }

    _createClass(Breadcrumbs, [{
        key: 'render',
        value: function render() {
            var breadcrumbs = this.props.breadcrumbs;

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'nav',
                { className: 'breadcrumbs grid', 'aria-label': 'Breadcrumbs' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'breadcrumbs--container grid--container' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7_react_flip_move__["a" /* default */],
                        {
                            enterAnimation: this.enterAnimation,
                            leaveAnimation: this.leaveAnimation,
                            typeName: 'ol',
                            maintainContainerHeight: true,
                            delay: __WEBPACK_IMPORTED_MODULE_9_constants_transitions_props__["c" /* breadcrumbsDelay */],
                            duration: __WEBPACK_IMPORTED_MODULE_9_constants_transitions_props__["e" /* breadcrumbsSpeed */],
                            easing: __WEBPACK_IMPORTED_MODULE_9_constants_transitions_props__["d" /* breadcrumbsEasingFn */],
                            className: 'breadcrumbs--list u-reset' },
                        Object(__WEBPACK_IMPORTED_MODULE_6_looppa__["a" /* default */])(breadcrumbs)(function (_ref, i) {
                            var url = _ref.url,
                                name = _ref.name,
                                action = _ref.action;
                            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'li',
                                { itemScope: true, itemType: 'http://data-vocabulary.org/Breadcrumb', className: 'breadcrumbs--item',
                                    key: i },
                                Breadcrumbs.renderLink({ url: url, name: name, action: action || __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a })
                            );
                        })
                    )
                )
            );
        }
    }, {
        key: 'enterAnimation',
        get: function get() {
            return {
                from: {
                    transform: 'translate(32px, 0)',
                    opacity: '0'
                },
                to: {
                    transform: '',
                    opacity: ''
                }
            };
        }
    }, {
        key: 'leaveAnimation',
        get: function get() {
            var _enterAnimation = this.enterAnimation,
                from = _enterAnimation.from,
                to = _enterAnimation.to;


            return {
                from: to,
                to: from
            };
        }
    }], [{
        key: 'renderLink',
        value: function renderLink(_ref2) {
            var action = _ref2.action,
                url = _ref2.url,
                name = _ref2.name;

            var icon = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_icon__["a" /* default */], { className: 'breadcrumbs--icon', symbol: 'chevron-left', size: 'small' });
            if (url) {
                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_react_router_dom__["b" /* Link */],
                    { onClick: action || __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a, className: 'breadcrumbs--link u-reset', itemProp: 'url',
                        to: Object(__WEBPACK_IMPORTED_MODULE_10_util_misc_normalise_trailing_slash__["a" /* default */])(url) },
                    icon,
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'span',
                        { className: 'breadcrumbs--text' },
                        name
                    )
                );
            }

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: action || __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a, className: 'breadcrumbs--link u-reset' },
                icon,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'breadcrumbs--text' },
                    name
                )
            );
        }
    }]);

    return Breadcrumbs;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

Breadcrumbs.propTypes = {
    breadcrumbs: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
        name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any.isRequired,
        url: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
        action: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
    })).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_4_util_redux__["b" /* default */].mapStateToProps({
    breadcrumbs: 'breadcrumbs.items'
}), __WEBPACK_IMPORTED_MODULE_4_util_redux__["b" /* default */].mapDispatchToProps({}))(Breadcrumbs));

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_animated_counter_index__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_cart_index__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_dom_handle_accessible_key_events__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_translations_index__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_misc_format_price__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_constants_cart__ = __webpack_require__(266);













function HeaderCart(_ref) {
    var totalItemsPrice = _ref.totalItemsPrice,
        bagInfo = _ref.bagInfo,
        isDesktop = _ref.isDesktop,
        isPanelOpen = _ref.isPanelOpen,
        panelFacet = _ref.panelFacet,
        togglePanel = _ref.togglePanel;

    var toggleCart = function toggleCart() {
        return togglePanel({ facet: 'cart', content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_cart_index__["a" /* default */], null) });
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { onClick: toggleCart,
            className: 'header-cart grid' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'grid--row header-cart--row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { className: 'header-cart--accessibility-button',
                    'aria-haspopup': 'true',
                    'aria-controls': 'menu',
                    'aria-pressed': isPanelOpen && panelFacet === 'cart',
                    onKeyDown: function onKeyDown(e) {
                        return Object(__WEBPACK_IMPORTED_MODULE_7_util_dom_handle_accessible_key_events__["a" /* all */])(e) && toggleCart(e);
                    } },
                Object(__WEBPACK_IMPORTED_MODULE_8_translations_index__["c" /* default */])('cart.cart')
            ),
            isDesktop ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                    className: 'header-cart--price grid--col' },
                __WEBPACK_IMPORTED_MODULE_10_constants_cart__["a" /* CURRENCY */],
                ' ',
                Object(__WEBPACK_IMPORTED_MODULE_9_util_misc_format_price__["b" /* formatPrice */])(totalItemsPrice)
            ) : null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'header-cart--bags grid--col' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_icon__["a" /* default */], { symbol: 'cart', size: 'large', className: 'header-cart--bag-image' }),
                bagInfo.total_bags ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_animated_counter_index__["a" /* default */], { ariaLabel: Object(__WEBPACK_IMPORTED_MODULE_8_translations_index__["c" /* default */])('accessibility.label.cart_value'), readonly: true, suffix: '\xD7',
                    className: 'header-cart--bag-info',
                    amount: bagInfo.total_bags }) : null
            )
        )
    );
}

HeaderCart.propTypes = {
    isDesktop: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    totalItemsPrice: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    togglePanel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    isPanelOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    panelFacet: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    bagInfo: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    isModalVisible: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    isSearchVisible: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    wasCartFetched: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_3_util_redux__["b" /* default */].mapStateToProps({
    totalItemsPrice: 'cart.totalItemsPrice',
    bagInfo: 'cart.bagInfo',
    isPanelOpen: 'panel.isOpen',
    panelFacet: 'panel.facet',
    isDesktop: 'viewport.isDesktop',
    isModalVisible: 'modal.isVisible',
    wasCartFetched: 'cart.wasFetched',
    isSearchVisible: 'search.isActive'
}), __WEBPACK_IMPORTED_MODULE_3_util_redux__["b" /* default */].mapDispatchToProps({
    togglePanel: 'panel.toggle'
}))(HeaderCart));

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isElementVisible;
/**
 * Check if a DOM element is visible
 * @param el - element to check
 * @param root - root node
 * @returns {Boolean} - true if fisible
 */
function isElementVisible(el) {
    var root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

    if (el === root) {
        return true;
    }

    if (!el || !el.parentNode) {
        return false;
    }

    var style = window.getComputedStyle(el);

    if (!style || style.display === 'none' || style.visibility === 'hidden') {
        return false;
    }

    return isElementVisible(el.parentNode, root);
}

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_flip_move__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__item__ = __webpack_require__(1093);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var ANIMATION_OPTIONS = {
    staggerDelayBy: 50,
    delay: 300,
    duration: 300,
    maintainContainerHeight: true,
    easing: 'cubic-bezier(0.25, 0.1, 0.75, 1)',
    leaveAnimation: {
        from: {
            transform: ''
        },
        to: {
            transform: 'translate(-100%, 0)'
        }
    }
};

/* eslint-disable camelcase */

var CartProductsList = function (_PureComponent) {
    _inherits(CartProductsList, _PureComponent);

    function CartProductsList() {
        _classCallCheck(this, CartProductsList);

        return _possibleConstructorReturn(this, (CartProductsList.__proto__ || Object.getPrototypeOf(CartProductsList)).apply(this, arguments));
    }

    _createClass(CartProductsList, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                products = _props.products,
                tabIndex = _props.tabIndex,
                hideDraggingTutorial = _props.hideDraggingTutorial;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'section',
                { className: 'cart-products-list' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_react_flip_move__["a" /* default */],
                    _extends({
                        className: 'cart-products-list--collection u-reset',
                        typeName: 'ul'
                    }, ANIMATION_OPTIONS),
                    Object(__WEBPACK_IMPORTED_MODULE_4_looppa__["a" /* default */])(products)(function (item, key, i) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__item__["a" /* default */], { tabIndex: i + tabIndex, key: item.product.id,
                            isOpened: i === 0 && !hideDraggingTutorial && Modernizr.touchevents, item: item });
                    })
                )
            );
        }
    }]);

    return CartProductsList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

CartProductsList.propTypes = {
    tabIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
    products: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    hideDraggingTutorial: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_3_util_redux__["b" /* default */].mapStateToProps({
    hideDraggingTutorial: 'cart.hideDraggingTutorial'
}))(CartProductsList));

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_misc_local_storage__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_sliding_door__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_cart_counter__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_cart_products_list_product_info__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_constants_debounce_delays__ = __webpack_require__(223);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var CartProductsListItem = function (_PureComponent) {
    _inherits(CartProductsListItem, _PureComponent);

    function CartProductsListItem(props) {
        _classCallCheck(this, CartProductsListItem);

        var _this = _possibleConstructorReturn(this, (CartProductsListItem.__proto__ || Object.getPrototypeOf(CartProductsListItem)).call(this, props));

        _this.setAmount = function (amount) {
            amount = Number(amount);

            // Abort if there is currently a server request
            if (_this.isFetching || _this.state.amount === amount) {
                return;
            }

            if (_this.props.regionActive) {
                _this.setState({
                    amount: amount
                });
            }

            _this.sendAmount(amount);
        };

        _this.add = function () {
            _this.setAmount(_this.state.amount + 1);
        };

        _this.delete = function () {
            // Abort if there is currently a server request
            if (_this.isFetching) {
                return;
            }

            _this.sendAmount(0);
        };

        _this.remove = function () {
            _this.setAmount(_this.state.amount - 1);
        };

        _this.sendAmount = __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function (amount) {
            var _props = this.props,
                product = _props.item.product,
                setProductAmount = _props.setProductAmount;


            setProductAmount({ product: product, amount: amount });
        }, __WEBPACK_IMPORTED_MODULE_12_constants_debounce_delays__["c" /* COUNTER_CLICK_DEBOUNCE */]);
        _this.tutorialTimer = null;


        _this.state = {
            isOpened: props.isOpened,
            forceClose: false,
            amount: props.item.amount
        };
        return _this;
    }

    _createClass(CartProductsListItem, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (this.state.isOpened) {
                // Disable the dragging tutorial
                __WEBPACK_IMPORTED_MODULE_7_util_misc_local_storage__["a" /* default */].set('hideDraggingTutorial', 'true');
                this.tutorialTimer = setTimeout(function () {
                    _this2.props.setDraggingTutorial({ hideDraggingTutorial: true });
                    _this2.setState({ isOpened: false });
                }, 3000);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var amount = nextProps.item.amount;


            this.setState({ isOpened: false });

            // Do not update amount if currently fetching from the server
            if (nextProps.isFetching) {
                return;
            }

            this.setState({
                amount: amount
            });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            // it was removed so we will need to close the sliding door compoinent
            if (!this.props.products[this.props.item.product.id]) {
                this.setState({ forceClose: true });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearTimeout(this.tutorialTimer);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props2 = this.props,
                item = _props2.item,
                _props2$item$product = _props2.item.product,
                id = _props2$item$product.id,
                name = _props2$item$product.name,
                tooltipId = _props2.tooltipId,
                tabIndex = _props2.tabIndex;
            var setAmount = this.setAmount,
                add = this.add,
                remove = this.remove;
            var forceClose = this.state.forceClose;

            var methods = { setAmount: setAmount, add: add, remove: remove };

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'li',
                { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('cart-products-list--item', { 'cart-products-list--item__has-tooltip': id === tooltipId }) },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_9_components_sliding_door__["a" /* default */],
                    { forceClose: forceClose, className: 'cart-products-list--draggable-wrapper',
                        isOpened: this.state.isOpened,
                        direction: 'left', deltaLimit: 60 },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'cart-products-list--draggable' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_cart_products_list_product_info__["a" /* default */], { item: item, add: add }),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_cart_counter__["a" /* default */], _extends({ tabIndex: tabIndex, productName: name, amount: this.state.amount }, methods, { facet: 'cart', id: id }))
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'button',
                    {
                        tabIndex: tabIndex,
                        'aria-label': Object(__WEBPACK_IMPORTED_MODULE_6_translations__["c" /* default */])('accessibility.label.delete_product'),
                        className: 'cart-products-list--delete-button', onClick: function onClick() {
                            return _this3.delete(item);
                        } },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_icon__["a" /* default */], { className: 'cart-products-list--trash-icon', symbol: 'trash', size: 'medium' })
                )
            );
        }
    }]);

    return CartProductsListItem;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

CartProductsListItem.propTypes = {
    isOpened: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
    tabIndex: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
    item: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    isFetching: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
    regionActive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
    fetchingId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    setProductAmount: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    setDraggingTutorial: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    tooltipId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    products: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_4_util_redux__["b" /* default */].mapStateToProps({
    isFetching: 'cart.isFetching',
    fetchingId: 'cart.fetchingId',
    tooltipId: 'cart.tooltipId',
    regionActive: 'region.active',
    products: 'cart.items'
}), __WEBPACK_IMPORTED_MODULE_4_util_redux__["b" /* default */].mapDispatchToProps({
    setProductAmount: 'cart.setProductAmount',
    setDraggingTutorial: 'cart.setDraggingTutorial'
}))(CartProductsListItem));

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_dom_pointer_event__ = __webpack_require__(1095);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var SlidingDoor = function (_PureComponent) {
    _inherits(SlidingDoor, _PureComponent);

    function SlidingDoor() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SlidingDoor);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SlidingDoor.__proto__ || Object.getPrototypeOf(SlidingDoor)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            cachedX: 0,
            deltaX: 0,
            isDragging: false,
            className: ''
        }, _this.drag = function (e) {
            if (!_this.state.isDragging) {
                return;
            }

            var pointer = Object(__WEBPACK_IMPORTED_MODULE_3_util_dom_pointer_event__["a" /* default */])(e);
            var _this$props = _this.props,
                direction = _this$props.direction,
                deltaLimit = _this$props.deltaLimit;

            var currentX = pointer.pageX;
            var deltaX = _this.state.deltaX + (currentX - _this.state.cachedX);

            var min = -deltaLimit;
            var max = deltaLimit;
            switch (direction) {
                case 'left':
                    min = -deltaLimit;
                    max = 0;
                    break;
                case 'right':
                    min = 0;
                    max = deltaLimit;
                    break;
                default:
                // noop
            }

            if (deltaX < min) {
                deltaX = min;
            } else if (deltaX > max) {
                deltaX = max;
            }

            _this.setState({
                deltaX: deltaX,
                cachedX: currentX
            });
        }, _this.startDrag = function (e) {
            var pointer = Object(__WEBPACK_IMPORTED_MODULE_3_util_dom_pointer_event__["a" /* default */])(e);
            _this.setState({
                isDragging: true,
                cachedX: pointer.pageX
            });
        }, _this.stopDrag = function () {
            var _this$props2 = _this.props,
                direction = _this$props2.direction,
                deltaLimit = _this$props2.deltaLimit;

            var thresholdFactor = 2;

            var deltaX = _this.state.deltaX;

            var min = -deltaLimit / thresholdFactor;
            var max = deltaLimit / thresholdFactor;

            switch (direction) {
                case 'left':
                    min = -deltaLimit / thresholdFactor;
                    max = 0;
                    break;
                case 'right':
                    min = 0;
                    max = deltaLimit / thresholdFactor;
                    break;
                default:
                // noop
            }

            if (deltaX < min) {
                deltaX = min * thresholdFactor;
            } else if (deltaX > max) {
                deltaX = max * thresholdFactor;
            } else {
                deltaX = 0;
            }

            _this.setState({
                deltaX: deltaX,
                isDragging: false
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SlidingDoor, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.toggle(this.props);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.isOpened !== this.props.isOpened) {
                this.toggle(nextProps);
            }

            if (nextProps.forceClose) {
                this.setState({
                    deltaX: 0,
                    isOpened: false,
                    isDragging: false
                });
            }
        }
    }, {
        key: 'toggle',
        value: function toggle(props) {
            var direction = props.direction,
                isOpened = props.isOpened,
                deltaLimit = props.deltaLimit;

            var deltaX = 0;

            if (isOpened) {
                deltaX = direction === 'left' ? -deltaLimit : deltaLimit;
            }

            this.setState({ deltaX: deltaX });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                className = _props.className;
            var _state = this.state,
                deltaX = _state.deltaX,
                isDragging = _state.isDragging;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                    ref: 'root',
                    style: { transform: 'translate(' + deltaX + 'px, 0)' },
                    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('sliding-door ' + className, {
                        'sliding-door__animate': !isDragging
                    }),
                    onTouchStart: this.startDrag,
                    onTouchMove: this.drag,
                    onTouchEnd: this.stopDrag },
                children
            );
        }
    }]);

    return SlidingDoor;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

SlidingDoor.defaultProps = {
    deltaLimit: 40,
    direction: 'both',
    isOpened: false,
    containerStyle: {}
};
SlidingDoor.propTypes = {
    deltaLimit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
    isOpened: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    forceClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (SlidingDoor);

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pointerEvent;
/**
 * Normalize the pointer events in order to get the properties of a single finger touch on touches devices
 * @param {object} - event - event object
 * @returns {object} a single pointer event
 */
function pointerEvent(event) {
  return event.targetTouches ? event.targetTouches[0] : event;
}

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_react_stack_images_path__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_constants_api_images_types__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_loader__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_util_misc_format_price__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_util_react_format_product_short_description__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_product_price__ = __webpack_require__(577);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var CartProductsListProductInfo = function (_PureComponent) {
    _inherits(CartProductsListProductInfo, _PureComponent);

    function CartProductsListProductInfo() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, CartProductsListProductInfo);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CartProductsListProductInfo.__proto__ || Object.getPrototypeOf(CartProductsListProductInfo)).call.apply(_ref, [this].concat(args))), _this), _this.openProductDetailOverlay = function (e) {
            e.stopPropagation();
            e.preventDefault();
            var href = e.currentTarget.getAttribute('href');

            // if href is the same of the current page we can close the panel
            // it means we are already in the right page
            if (_this.props.pathname === href) {
                _this.props.closePanel();
            } else {
                _this.props.openModal({
                    layout: 'product-detail',
                    isAsync: true,
                    href: href
                });
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CartProductsListProductInfo, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                add = _props.add,
                item = _props.item,
                product = _props.item.product,
                fetchingId = _props.fetchingId,
                routerRegistry = _props.routerRegistry;
            var _product$price_inform = product.price_information,
                badge = _product$price_inform.badge,
                original_price = _product$price_inform.original_price;

            var hasDiscount = !__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(original_price);

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'cart-products-list--product', onClick: function onClick() {
                        return add();
                    } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('figure', { className: 'cart-products-list--figure',
                    style: { backgroundImage: 'url(' + Object(__WEBPACK_IMPORTED_MODULE_7_util_react_stack_images_path__["b" /* imageByDpi */])(Object(__WEBPACK_IMPORTED_MODULE_7_util_react_stack_images_path__["c" /* productImage */])(product.image, __WEBPACK_IMPORTED_MODULE_8_constants_api_images_types__["e" /* THUMB */])) + ')' } }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'cart-products-list--detail' },
                    badge ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { className: 'cart-products-list--product-badge',
                        src: Object(__WEBPACK_IMPORTED_MODULE_7_util_react_stack_images_path__["b" /* imageByDpi */])(Object(__WEBPACK_IMPORTED_MODULE_7_util_react_stack_images_path__["c" /* productImage */])(badge, __WEBPACK_IMPORTED_MODULE_8_constants_api_images_types__["b" /* BADGE_TILE */])) }) : null,
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'cart-products-list--detail-inner' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'cart-products-list--product-info' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'h2',
                                { className: 'cart-products-list--product-title u-reset' },
                                product.name
                            ),
                            product.short_description && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'p',
                                { className: 'cart-products-list--product-description' },
                                Object(__WEBPACK_IMPORTED_MODULE_13_util_react_format_product_short_description__["a" /* default */])(product.short_description)
                            ),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'footer',
                                { className: 'cart-products-list--price-info' },
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_product_price__["a" /* default */], { price_information: product.price_information,
                                    rootClass: 'cart-products-list' })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { className: 'cart-products-list--action-bar' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'div',
                                {
                                    className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('cart-products-list--total-price', { 'cart-products-list--total-price__discount': hasDiscount }, { 'cart-products-list--total-price__loader': fetchingId === product.id }) },
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    'span',
                                    { className: 'cart-products-list--loader' },
                                    fetchingId === product.id && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_loader__["a" /* default */], { size: 'small' })
                                ),
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    'span',
                                    { className: 'cart-products-list--total-price-amount' },
                                    Object(__WEBPACK_IMPORTED_MODULE_11_util_misc_format_price__["a" /* default */])(item.total_price)
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_6_react_router_dom__["b" /* Link */],
                                { className: 'cart-products-list--detail-button u-reset',
                                    'aria-label': Object(__WEBPACK_IMPORTED_MODULE_12_translations__["c" /* default */])('accessibility.label.product_detail'),
                                    to: routerRegistry.get() + '/' + product.slug,
                                    onClick: this.openProductDetailOverlay },
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_icon__["a" /* default */], { symbol: 'product-detail', size: 'large',
                                    className: 'cart-products-list--detail-icon' })
                            )
                        )
                    )
                )
            );
        }
    }]);

    return CartProductsListProductInfo;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

CartProductsListProductInfo.propTypes = {
    item: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    fetchingId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    add: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    pathname: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    openModal: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    closePanel: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    routerRegistry: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_4_util_redux__["b" /* default */].mapStateToProps({
    fetchingId: 'cart.fetchingId',
    pathname: 'router.location.pathname',
    routerRegistry: 'router.registry'
}), __WEBPACK_IMPORTED_MODULE_4_util_redux__["b" /* default */].mapDispatchToProps({
    closePanel: 'panel.close',
    openModal: 'modal.open'
}))(CartProductsListProductInfo));

/***/ }),
/* 1097 */,
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_migros_login_button__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_error_image_empty___ = __webpack_require__(425);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










function Loggedout() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'cart--empty-content' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'u-reset cart--empty-title' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_translations__["a" /* Trans */], { path: 'cart.empty_authenticated_title' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'cart--empty-text' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_translations__["a" /* Trans */], { path: 'cart.empty_authenticated_text' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'cart--empty-login' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_migros_login_button__["a" /* default */], { inline: true, big: true })
        )
    );
}

function Loggedin() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'cart--empty-content' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'cart--empty-text' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_translations__["a" /* Trans */], { path: 'cart.empty_default_text' })
        )
    );
}

var CartEmpty = function (_PureComponent) {
    _inherits(CartEmpty, _PureComponent);

    function CartEmpty() {
        _classCallCheck(this, CartEmpty);

        return _possibleConstructorReturn(this, (CartEmpty.__proto__ || Object.getPrototypeOf(CartEmpty)).apply(this, arguments));
    }

    _createClass(CartEmpty, [{
        key: 'render',
        value: function render() {
            var isAuthenticated = this.props.isAuthenticated;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'cart--empty' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_error_image_empty___["a" /* default */], { alt: Object(__WEBPACK_IMPORTED_MODULE_4_translations__["c" /* default */])('cart.empty_default_text'), className: 'cart--empty-img' }),
                isAuthenticated ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Loggedin, null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Loggedout, null)
            );
        }
    }]);

    return CartEmpty;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

CartEmpty.propTypes = {
    isAuthenticated: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_3_util_redux__["b" /* default */].mapStateToProps({
    isAuthenticated: 'user.isAuthenticated'
}))(CartEmpty));

/***/ }),
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CmsError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_notification__ = __webpack_require__(252);




function CmsError() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'cms-error' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_components_notification__["a" /* default */],
            { facet: 'error' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_translations__["a" /* Trans */], { path: 'cms.content.error' })
        )
    );
}

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sample__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sample___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_sample__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_pull__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_pull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_pull__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_category_icons__ = __webpack_require__(346);





/**
 * Get random category icon name
 * @returns {*}
 */
/* harmony default export */ __webpack_exports__["a"] = (function (excludeItem) {
    var icons = Object.values(__WEBPACK_IMPORTED_MODULE_2_constants_category_icons__["a" /* default */]);

    if (excludeItem) {
        icons = __WEBPACK_IMPORTED_MODULE_1_lodash_pull___default()(icons, excludeItem);
    }

    return __WEBPACK_IMPORTED_MODULE_0_lodash_sample___default()(icons);
});

/***/ }),
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CmsImage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_misc_normalise_trailing_slash__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_react_image_attributes__ = __webpack_require__(307);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function renderImage(image) {
    var _imageAttributes = Object(__WEBPACK_IMPORTED_MODULE_5_util_react_image_attributes__["a" /* default */])(image),
        width = _imageAttributes.width,
        height = _imageAttributes.height,
        caption = _imageAttributes.caption,
        attrs = _objectWithoutProperties(_imageAttributes, ['width', 'height', 'caption']); // eslint-disable-line


    var isResponsive = !width;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'figure',
        { style: {
                maxWidth: width || 'inherit'
            }, className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('cms-image', {
                'cms-image__is-responsive': isResponsive
            }) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', _extends({ className: 'cms-image--element' }, attrs)),
        caption && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'figcaption',
            { className: 'cms-image--caption' },
            caption
        )
    );
}

function CmsImage(_ref) {
    var image = _ref.image,
        link = _ref.link;

    if (link.to) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],
            { className: 'u-reset', to: Object(__WEBPACK_IMPORTED_MODULE_4_util_misc_normalise_trailing_slash__["a" /* default */])(link.to) },
            renderImage(image)
        );
    }

    return renderImage(image);
}

CmsImage.propTypes = {
    image: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        src: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
        title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        alt: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    }),
    link: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Divider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);




function Divider(_ref) {
    var kind = _ref.kind;

    if (kind === 'line') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'cms-divider' });
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('cms-divider', 'cms-divider__' + kind), style: { height: 1 } });
}

Divider.propTypes = {
    kind: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ArticleShort;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_button__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_react_image_attributes__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_misc_normalise_trailing_slash__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_lazy_image__ = __webpack_require__(428);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









function ArticleShort(_ref) {
    var title = _ref.title,
        text = _ref.text,
        link = _ref.link,
        image = _ref.image;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'article',
        { className: 'cms-article-short' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'cms-article-short--row grid--row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'cms-article-short--col grid--col' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'figure',
                    { className: 'cms-article-short--figure' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_components_lazy_image__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', _extends({ className: 'cms-article-short--image' }, Object(__WEBPACK_IMPORTED_MODULE_4_util_react_image_attributes__["b" /* lazyImageAttributes */])(image)))
                    )
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'cms-article-short--col grid--col' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h1',
                    { className: 'cms-article-short--title' },
                    title
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cms-article-short--text', dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_3_translations__["d" /* format */])(text) } }),
                link && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'cms-article-short--button' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_components_button__["a" /* default */],
                        { tag: 'a', to: Object(__WEBPACK_IMPORTED_MODULE_5_util_misc_normalise_trailing_slash__["a" /* default */])(link.to), facet: 'primary', size: 'small' },
                        link.text
                    )
                )
            )
        )
    );
}

ArticleShort.propTypes = {
    image: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        src: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
        title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        alt: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    }),
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    link: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    })
};

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Teaser;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_button__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_react_image_attributes__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_misc_normalise_trailing_slash__ = __webpack_require__(196);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function Teaser(_ref) {
    var title = _ref.title,
        link = _ref.link,
        image = _ref.image;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'section',
        { className: 'cms-teaser' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'cms-teaser--content' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                { className: 'cms-teaser--title u-reset' },
                title
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'cms-teaser--button' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_components_button__["a" /* default */],
                    { facet: 'primary', size: 'small', tag: 'a', target: link.external ? '_blank' : '_self', to: Object(__WEBPACK_IMPORTED_MODULE_4_util_misc_normalise_trailing_slash__["a" /* default */])(link.to) },
                    link.text
                )
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', _extends({ className: 'cms-teaser--image' }, Object(__WEBPACK_IMPORTED_MODULE_3_util_react_image_attributes__["a" /* default */])(image)))
    );
}

Teaser.propTypes = {
    image: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        src: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
        title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        alt: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
    }),
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    link: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
        text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
    })
};

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Iframe;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);




function Iframe(_ref) {
    var width = _ref.width,
        height = _ref.height,
        url = _ref.url,
        subtitle = _ref.subtitle,
        title = _ref.title;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('cms-iframe', {
                'cms-iframe__is-responsive': !width && !height
            }) },
        title && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'cms-iframe--title u-reset' },
            title
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'cms-iframe--content-wrapper' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe', {
                className: 'cms-iframe--content',
                width: width,
                height: height,
                src: url, frameBorder: '0',
                allowFullScreen: true
            })
        ),
        subtitle && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'cms-iframe--subtitle' },
            subtitle
        )
    );
}

Iframe.propTypes = {
    width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    subtitle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    title: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    url: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
};

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Pickers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_pickers_slider_highlight__ = __webpack_require__(1114);




function Pickers(_ref) {
    var title = _ref.title,
        text = _ref.text,
        pickers = _ref.pickers;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'cms-pickers' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'cms-pickers--title' },
            title
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'cms-pickers--slider' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_pickers_slider_highlight__["a" /* default */], { pickers: pickers.pickers })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cms-pickers--text', dangerouslySetInnerHTML: { __html: text } })
    );
}

Pickers.propTypes = {
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    pickers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        pickers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
        total_count: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
    })
};

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_loader__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_picker_tile__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_slider__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__slider_config__ = __webpack_require__(1117);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var PickersSliderHighlight = function (_PureComponent) {
    _inherits(PickersSliderHighlight, _PureComponent);

    function PickersSliderHighlight() {
        _classCallCheck(this, PickersSliderHighlight);

        return _possibleConstructorReturn(this, (PickersSliderHighlight.__proto__ || Object.getPrototypeOf(PickersSliderHighlight)).apply(this, arguments));
    }

    _createClass(PickersSliderHighlight, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                pickers = _props.pickers,
                isMainContentLoaded = _props.isMainContentLoaded;


            if (!isMainContentLoaded) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_loader__["a" /* default */], null);
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_components_slider__["a" /* default */],
                { facet: 'pickers-slider-highlight', config: __WEBPACK_IMPORTED_MODULE_8__slider_config__["a" /* default */] },
                Object(__WEBPACK_IMPORTED_MODULE_2_looppa__["a" /* default */])(pickers)(function (picker, idx) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_picker_tile__["a" /* default */], _extends({ facet: 'highlight' }, picker, { key: idx }));
                })
            );
        }
    }]);

    return PickersSliderHighlight;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

PickersSliderHighlight.propTypes = {
    pickers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
    isMobile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    isMainContentLoaded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_4_util_redux__["b" /* default */].mapStateToProps({
    isMainContentLoaded: 'main-content.isLoaded',
    isMobile: 'viewport.isMobile'
}), __WEBPACK_IMPORTED_MODULE_4_util_redux__["b" /* default */].mapDispatchToProps({}))(PickersSliderHighlight));

/***/ }),
/* 1115 */,
/* 1116 */,
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export productTileAmounts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util_dom_scss_data__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bianco_query__ = __webpack_require__(251);
var _breakpoints;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




// Get data from the dom

var _scssData = Object(__WEBPACK_IMPORTED_MODULE_0_util_dom_scss_data__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1_bianco_query__["a" /* default */])('.scss-data-bridge')[0]),
    breakpoints = _scssData.breakpoints,
    productTileAmounts = _scssData['product-tile-amounts'];

function bp(name) {
    return parseInt(breakpoints[name]);
}

/* harmony default export */ __webpack_exports__["a"] = ({
    speed: 450,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    slidesPerView: 'auto',
    spaceBetween: 0,
    breakpoints: (_breakpoints = {}, _defineProperty(_breakpoints, bp('xs'), {
        slidesPerGroup: 1,
        freeMode: true
    }), _defineProperty(_breakpoints, bp('sm'), {
        slidesPerGroup: 4

    }), _breakpoints)
});



/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_es_connect_connect__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_redux__ = __webpack_require__(172);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Title = function (_PureComponent) {
    _inherits(Title, _PureComponent);

    function Title() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Title);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Title.__proto__ || Object.getPrototypeOf(Title)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function () {
            _this.props.openModal({ layout: 'zip-form' });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Title, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                title = _props.title,
                subtitle = _props.subtitle;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'cms-title' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h1',
                    { className: 'cms-title--title u-reset' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'cms-title--title-inner' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: 'cms-title--title-text' },
                            title
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'cms-title--title-inner cms-title--title-inner__shadow' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: 'cms-title--title-shadow' },
                            title
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h2',
                    { className: 'cms-title--subtitle u-reset' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'cms-title--subtitle-inner' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: 'cms-title--subtitle-text' },
                            subtitle
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'cms-title--subtitle-inner cms-title--subtitle-inner__shadow' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: 'cms-title--subtitle-inner cms-title--subtitle-shadow' },
                            subtitle
                        )
                    )
                )
            );
        }
    }]);

    return Title;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Title.propTypes = {
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    subtitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    openModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux_es_connect_connect__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__util_redux__["b" /* default */].mapStateToProps({
    pageName: 'router.name'
}), __WEBPACK_IMPORTED_MODULE_3__util_redux__["b" /* default */].mapDispatchToProps({
    openModal: 'modal.open'
}))(Title));

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PaymentTwint;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_misc_static_assets_path__ = __webpack_require__(197);




function PaymentTwint(_ref) {
    var title = _ref.title,
        text = _ref.text;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'cms-payment' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'cms-payment--title' },
            title
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'cms-payment--body' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'cms-payment--images-list-wrapper' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'cms-payment--images-list' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'cms-payment--image', alt: 'visa', src: Object(__WEBPACK_IMPORTED_MODULE_2_util_misc_static_assets_path__["a" /* default */])('img/logos/visa.svg') }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'cms-payment--image', alt: 'mastercard', src: Object(__WEBPACK_IMPORTED_MODULE_2_util_misc_static_assets_path__["a" /* default */])('img/logos/mastercard.svg') })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cms-payment--text', dangerouslySetInnerHTML: { __html: text } })
        )
    );
}

PaymentTwint.propTypes = {
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Countdown;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_countdown__ = __webpack_require__(430);




function Countdown(_ref) {
    var now = _ref.now,
        deadline = _ref.deadline,
        text = _ref.text,
        facet = _ref.facet;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'cms-countdown' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'cms-countdown--countdown-container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_countdown__["a" /* default */], { endDate: deadline, startDate: now, callback: function callback() {}, facet: facet })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cms-countdown--text', dangerouslySetInnerHTML: { __html: text } })
    );
}

Countdown.propTypes = {
    now: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    deadline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    facet: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Regions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_misc_static_assets_path__ = __webpack_require__(197);



function Regions() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'cms-regions' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'cms-regions--image' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                src: Object(__WEBPACK_IMPORTED_MODULE_1_util_misc_static_assets_path__["a" /* default */])('img/regions/im-pilotregion-bern.png'),
                srcSet: Object(__WEBPACK_IMPORTED_MODULE_1_util_misc_static_assets_path__["a" /* default */])('img/regions/im-pilotregion-bern.png') + ' 1x, ' + Object(__WEBPACK_IMPORTED_MODULE_1_util_misc_static_assets_path__["a" /* default */])('img/regions/im-pilotregion-bern@2x.png') + ' 2x'
            })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'cms-regions--image' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                src: Object(__WEBPACK_IMPORTED_MODULE_1_util_misc_static_assets_path__["a" /* default */])('img/regions/im-pilotregion-zurich.png'),
                srcSet: Object(__WEBPACK_IMPORTED_MODULE_1_util_misc_static_assets_path__["a" /* default */])('img/regions/im-pilotregion-zurich.png') + ' 1x, ' + Object(__WEBPACK_IMPORTED_MODULE_1_util_misc_static_assets_path__["a" /* default */])('img/regions/im-pilotregion-zurich@2x.png') + ' 2x'
            })
        )
    );
};

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_react_facet__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_placeholder_events__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugin__ = __webpack_require__(426);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var ColumnWrapper = function (_PureComponent) {
    _inherits(ColumnWrapper, _PureComponent);

    function ColumnWrapper() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ColumnWrapper);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ColumnWrapper.__proto__ || Object.getPrototypeOf(ColumnWrapper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            extendedContent: {}
        }, _this.onEvent = function (eventName, data) {
            if (eventName === __WEBPACK_IMPORTED_MODULE_7_constants_placeholder_events__["a" /* CARD */]) {
                _this.setState({ extendedContent: data });
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ColumnWrapper, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                style = _props.style,
                isCmsEditModeEnabled = _props.isCmsEditModeEnabled;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('cms-column-wrapper', Object(__WEBPACK_IMPORTED_MODULE_4_util_react_facet__["a" /* default */])(style, 'cms-column-wrapper')) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'cms-column-wrapper--row' },
                    Object(__WEBPACK_IMPORTED_MODULE_6_looppa__["a" /* default */])(this.extendedPlugins)(function (plugin, i) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { key: i, className: 'cms-column-wrapper--col' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__plugin__["a" /* default */], _extends({
                                isCmsEditModeEnabled: isCmsEditModeEnabled,
                                index: i,
                                style: style,
                                onEvent: _this2.onEvent,
                                parent: _this2.props
                            }, plugin))
                        );
                    })
                )
            );
        }
    }, {
        key: 'extendedPlugins',


        /**
         * Add custom data to plugins if so requested by one of the plugins
         * via onEvent
         */
        get: function get() {
            var _this3 = this;

            return this.props.plugins.map(function (plugin) {
                plugin.content = _extends({}, plugin.content, _this3.state.extendedContent);
                return plugin;
            });
        }
    }]);

    return ColumnWrapper;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

ColumnWrapper.propTypes = {
    plugins: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    isCmsEditModeEnabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    cms: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};
ColumnWrapper.defaultProps = {
    plugins: []
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_2_util_redux__["b" /* default */].mapStateToProps({}), __WEBPACK_IMPORTED_MODULE_2_util_redux__["b" /* default */].mapDispatchToProps({}))(ColumnWrapper));

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = VideoColumn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_button__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_player__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_misc_static_assets_path__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_misc_normalise_trailing_slash__ = __webpack_require__(196);
/* eslint-disable camelcase */









var renderLink = function renderLink(link) {
    var to = link.to,
        style = link.style,
        label = link.label;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'cms-video-column--actions' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'cms-video-column--action cms-video-column--action__link' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_components_button__["a" /* default */],
                { tag: 'a', className: 'cms-video-column--link', facet: ['x-large', style],
                    to: Object(__WEBPACK_IMPORTED_MODULE_6_util_misc_normalise_trailing_slash__["a" /* default */])(to) },
                label
            )
        )
    );
};

var renderAppStoreButtons = function renderAppStoreButtons(app_links) {
    var google_play_link = app_links.google_play_link,
        app_store_link = app_links.app_store_link,
        text = app_links.text;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'cms-video-column--app-store' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'cms-video-column--app-store-text' },
            text
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'cms-video-column--app-store-links' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                    'aria-label': Object(__WEBPACK_IMPORTED_MODULE_5_translations__["c" /* default */])('accessibility.label.buy_on_googleplay'),
                    className: 'cms-video-column--app-store-link u-reset', href: google_play_link, target: '_blank' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                    className: 'cms-video-column--app-store-img',
                    src: Object(__WEBPACK_IMPORTED_MODULE_4_util_misc_static_assets_path__["a" /* default */])('img/logos/im-googleplay-badge.svg')
                })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                    'aria-label': Object(__WEBPACK_IMPORTED_MODULE_5_translations__["c" /* default */])('accessibility.label.buy_on_appstore'),
                    className: 'cms-video-column--app-store-link u-reset', href: app_store_link, target: '_blank' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                    className: 'cms-video-column--app-store-img',
                    src: Object(__WEBPACK_IMPORTED_MODULE_4_util_misc_static_assets_path__["a" /* default */])('img/logos/im-appstore-badge.svg')
                })
            )
        )
    );
};

function VideoColumn(_ref) {
    var title = _ref.title,
        link = _ref.link,
        sub_link = _ref.sub_link,
        app_links = _ref.app_links,
        text = _ref.text,
        video = _ref.video;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'cms-video-column' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'cms-video-column--title u-reset' },
            title
        ),
        text && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cms-video-column--text', dangerouslySetInnerHTML: { __html: text } }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'cms-video-column--video-wrapper' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'cms-video-column--video-player' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_player___default.a, { config: {
                        youtube: {
                            playerVars: {
                                autoplay: 0,
                                iv_load_policy: 1,
                                playsinline: 0,
                                modestbranding: 0,
                                controls: 1
                            }
                        }
                    },
                    url: video.url,
                    width: '100%',
                    height: '100%' })
            )
        ),
        link && renderLink(link),
        app_links && renderAppStoreButtons(app_links),
        sub_link && renderLink(sub_link)
    );
}

VideoColumn.propTypes = {
    link: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
        style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
        label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
    }),
    sub_link: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
        style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
        label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
    }),
    app_links: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        app_store_link: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
        play_store_link: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
        text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
    }),
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    video: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

/***/ }),
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__card__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__card_content__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util_misc_static_assets_path__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_tracking__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_constants_placeholder_events__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__card_slider__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__card_content_lite__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_button__ = __webpack_require__(187);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable camelcase */



















var CardStack = function (_PureComponent) {
    _inherits(CardStack, _PureComponent);

    function CardStack() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, CardStack);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CardStack.__proto__ || Object.getPrototypeOf(CardStack)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isOpen: false,
            sliderHeight: false
        }, _this.showPrelaunchModal = function () {
            _this.props.openModal({
                layout: 'prelaunch',
                meta: {
                    titlePath: 'prelaunch.modal.title'
                }
            });
        }, _this.showZipModal = function () {
            _this.props.openModal({
                layout: 'zip-form'
            });
        }, _this.triggerEvent = function () {
            var onEvent = _this.props.onEvent;


            if (onEvent) {
                onEvent(__WEBPACK_IMPORTED_MODULE_12_constants_placeholder_events__["a" /* CARD */], { sliderIsOpen: _this.cardPosition });
                __WEBPACK_IMPORTED_MODULE_11_tracking__["a" /* default */].buttonClick({ buttonText: _this.firstCard ? _this.firstCard.title : 'Open cards' });
            }
        }, _this.renderAppStoreLinks = function () {
            var _this$props = _this.props,
                app_store_link = _this$props.app_store_link,
                google_play_link = _this$props.google_play_link,
                sub_links = _this$props.sub_links,
                show_footer = _this$props.show_footer;


            if (!show_footer) {
                return null;
            }

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'cms-card-stack--actions' },
                google_play_link && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'cms-card-stack--action' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'a',
                        { 'aria-label': Object(__WEBPACK_IMPORTED_MODULE_7_translations__["c" /* default */])('accessibility.label.buy_on_googleplay'),
                            className: 'cms-card-stack--app-store-link u-reset', href: google_play_link, target: '_blank' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', {
                            width: '162',
                            className: 'cms-card-stack--app-store-img',
                            src: Object(__WEBPACK_IMPORTED_MODULE_10_util_misc_static_assets_path__["a" /* default */])('img/logos/im-googleplay-badge.svg')
                        })
                    )
                ),
                app_store_link && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'cms-card-stack--action' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'a',
                        { 'aria-label': Object(__WEBPACK_IMPORTED_MODULE_7_translations__["c" /* default */])('accessibility.label.buy_on_appstore'),
                            className: 'cms-card-stack--app-store-link u-reset', href: app_store_link, target: '_blank' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', {
                            width: '162',
                            className: 'cms-card-stack--app-store-img',
                            src: Object(__WEBPACK_IMPORTED_MODULE_10_util_misc_static_assets_path__["a" /* default */])('img/logos/im-appstore-badge.svg')
                        })
                    )
                ),
                Object(__WEBPACK_IMPORTED_MODULE_6_looppa__["a" /* default */])(sub_links)(function (subLink, index) {
                    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { key: index, className: 'cms-card-stack--action cms-card-stack--action__link' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_15_components_button__["a" /* default */],
                            {
                                tag: 'button',
                                className: 'cms-card-stack--link',
                                facet: ['x-large', subLink.style],
                                onClick: subLink.to === 'email' ? _this.showPrelaunchModal : _this.showZipModal
                            },
                            subLink.label
                        )
                    );
                })
            );
        }, _this.renderCardSub = function () {
            var _this$props2 = _this.props,
                sub_text = _this$props2.sub_text,
                app_store_link = _this$props2.app_store_link,
                google_play_link = _this$props2.google_play_link,
                sub_links = _this$props2.sub_links,
                show_footer = _this$props2.show_footer;


            if (show_footer && (sub_text || app_store_link || google_play_link || sub_links)) {
                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'cms-card-stack--sub' },
                    sub_text && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'cms-card-stack--sub-text' },
                        sub_text
                    ),
                    _this.renderAppStoreLinks()
                );
            }

            return null;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CardStack, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref2) {
            var sliderIsOpen = _ref2.sliderIsOpen,
                isModalOpen = _ref2.isModalOpen,
                onEvent = _ref2.onEvent;

            // close the cards in case an overlay will be opened
            if (isModalOpen && !this.props.isModalOpen) {
                onEvent(__WEBPACK_IMPORTED_MODULE_12_constants_placeholder_events__["a" /* CARD */], { sliderIsOpen: null });
            }

            if (sliderIsOpen !== this.props.sliderIsOpen) {
                if (sliderIsOpen === this.cardPosition) {
                    this.setState({
                        sliderHeight: this.getSliderHeight()
                    });
                } else {
                    this.setState({
                        sliderHeight: false
                    });
                }
            }
        }
    }, {
        key: 'getSliderHeight',
        value: function getSliderHeight() {
            var sliderDOMNode = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this, 'refs.slider-wrapper.childNodes.0.childNodes.0', false);

            if (sliderDOMNode) {
                return sliderDOMNode.offsetHeight;
            }

            return 0;
        }

        /* TODO: Remove after prelaunch is over */

    }, {
        key: 'renderSlider',
        value: function renderSlider() {
            var _props = this.props,
                onEvent = _props.onEvent,
                features = _props.features,
                app_store_link = _props.app_store_link,
                google_play_link = _props.google_play_link;


            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { ref: 'slider-wrapper', className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('cms-card-stack--slider', {
                        'cms-card-stack--slider__is-overlay': this.isOverlay
                    }) },
                this.cards && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__card_slider__["a" /* default */], {
                    ref: 'slider',
                    cards: this.cards,
                    style: this.style,
                    isOpen: this.ownSliderIsOpen,
                    onEvent: onEvent,
                    features: features,
                    app_store_link: app_store_link,
                    google_play_link: google_play_link
                })
            );
        }
    }, {
        key: 'renderCardLite',
        value: function renderCardLite() {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__card_content_lite__["a" /* default */], _extends({}, this.props, { facet: this.cardPosition }));
        }
    }, {
        key: 'renderCardDefault',
        value: function renderCardDefault() {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__card_content__["a" /* default */], _extends({ firstCard: true }, this.firstCard, { visible: true }));
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                title = _props2.title,
                sliderIsOpen = _props2.sliderIsOpen,
                isMobile = _props2.isMobile;
            var sliderHeight = this.state.sliderHeight;

            var isLite = isMobile && !this.isInline;
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                {
                    style: sliderHeight ? {
                        height: sliderHeight
                    } : null,
                    className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('cms-card-stack cms-card-stack__' + this.style + ' cms-card-stack__' + this.cardPosition, { 'cms-card-stack__slider-is-open': sliderIsOpen })
                },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'section',
                    { className: 'cms-card-stack--inner' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'cms-card-stack--base' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'header',
                            { className: 'cms-card-stack--header' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'h2',
                                { className: 'cms-card-stack--title u-reset' },
                                title
                            )
                        ),
                        this.isOverlay && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'button',
                            { 'aria-label': this.firstCard.title, className: 'cms-card-stack--preview',
                                onClick: this.triggerEvent },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_3__card__["a" /* default */],
                                { facet: ['shadow', this.cardPosition] },
                                isLite ? this.renderCardLite() : this.renderCardDefault()
                            )
                        ),
                        this.isInline && this.renderSlider(),
                        this.renderCardSub()
                    ),
                    this.isOverlay && this.renderSlider()
                )
            );
        }
    }, {
        key: 'cardPosition',
        get: function get() {
            return this.props.index ? 'right' : 'left';
        }
    }, {
        key: 'cards',
        get: function get() {
            var cards = this.props.cards;

            return this.isOverlay ? cards.slice(1) : cards;
        }
    }, {
        key: 'firstCard',
        get: function get() {
            return this.props.cards[0];
        }
    }, {
        key: 'isInline',
        get: function get() {
            return this.style === 'inline';
        }
    }, {
        key: 'isOverlay',
        get: function get() {
            return this.style === 'overlay';
        }

        /**
         * Check whether the current slider is open
         * @returns {boolean}
         */

    }, {
        key: 'ownSliderIsOpen',
        get: function get() {
            var sliderIsOpen = this.props.sliderIsOpen;

            return sliderIsOpen === this.cardPosition || this.style === 'inline';
        }
    }, {
        key: 'style',


        /**
         * If we're on a mobile viewport, always return inline as per design
         * @returns {*}
         */
        get: function get() {
            return this.props.style;
        }
    }]);

    return CardStack;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

CardStack.propTypes = {
    title: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    app_store_link: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    google_play_link: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    show_footer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    sub_text: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    cards: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,
    index: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
    sliderIsOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    onEvent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    openModal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    isMobile: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    sub_links: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
    isModalOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    features: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_9_util_redux__["b" /* default */].mapStateToProps({
    isMobile: 'viewport.isMobile',
    isModalOpen: 'modal.isVisible'
}), __WEBPACK_IMPORTED_MODULE_9_util_redux__["b" /* default */].mapDispatchToProps({
    openModal: 'modal.open'
}))(CardStack));

/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TYPE_CARD */
/* unused harmony export TYPE_START_CART */
/* unused harmony export TYPE_NEWSLETTER */
/* unused harmony export TYPE_APP_STORE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_misc_overlay_tracker__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_slider__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_cms_placeholder_card_stack_card__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_cms_placeholder_card_stack_card_content__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__slider_config__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_button__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_zip_form__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_prelaunch_form__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_constants_placeholder_events__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_aria_51__ = __webpack_require__(267);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable camelcase */




















// Card type constants
var TYPE_CARD = 'card';
var TYPE_START_CART = 'start-cart';
var TYPE_NEWSLETTER = 'subscribe';
var TYPE_APP_STORE = 'app_store_buttons_on_last_card';

var CardSlider = function (_PureComponent) {
    _inherits(CardSlider, _PureComponent);

    function CardSlider(props) {
        _classCallCheck(this, CardSlider);

        var _this = _possibleConstructorReturn(this, (CardSlider.__proto__ || Object.getPrototypeOf(CardSlider)).call(this, props));

        _this.handleSlideChangeEnd = function (_ref) {
            var activeIndex = _ref.activeIndex;

            _this.setState({ activeIndex: activeIndex });
        };

        _this.triggerEvent = function () {
            var onEvent = _this.props.onEvent;


            if (onEvent) {
                onEvent(__WEBPACK_IMPORTED_MODULE_14_constants_placeholder_events__["a" /* CARD */], { sliderIsOpen: null });
            }
        };

        _this.state = {
            // HACKS OVER HACKS OVER HACKS HERE sorry :(
            hasFormCard: props.cards.some(function (c) {
                return [TYPE_START_CART, TYPE_NEWSLETTER].includes(c.type);
            }),
            activeIndex: 0,
            sliderIsOpen: false
        };
        return _this;
    }

    _createClass(CardSlider, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            Object(__WEBPACK_IMPORTED_MODULE_5_util_misc_overlay_tracker__["a" /* subscribe */])(this, this.triggerEvent);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref2) {
            var isOpen = _ref2.isOpen;

            if (this.refs.slider.swiper) {
                this.refs.slider.swiper.keyboard[isOpen ? 'enable' : 'disable']();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            Object(__WEBPACK_IMPORTED_MODULE_5_util_misc_overlay_tracker__["b" /* unsubscribe */])(this);
        }
    }, {
        key: 'renderCard',
        value: function renderCard(card, key) {
            var _props = this.props,
                app_store_link = _props.app_store_link,
                google_play_link = _props.google_play_link,
                features = _props.features,
                cards = _props.cards,
                isOpen = _props.isOpen;
            var activeIndex = this.state.activeIndex;


            var lastCard = false;
            if (cards.length - 1 === key) {
                lastCard = true;
            }

            switch (card.type) {
                case TYPE_START_CART:
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'card-slider--zip-form', key: key },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'card-slider--zip-form-inner' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'h1',
                                { className: 'card-slider--zip-title' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_translations__["a" /* Trans */], { path: 'onboarding.zip.title' })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'p',
                                { className: 'card-slider--zip-text' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_translations__["a" /* Trans */], { path: 'onboarding.zip.text' })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'card-slider--close' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_10_components_button__["a" /* default */],
                                    {
                                        'aria-label': Object(__WEBPACK_IMPORTED_MODULE_4_translations__["c" /* default */])('accessibility.label.close_cards'),
                                        tag: 'button',
                                        facet: ['bubble', 'large', 'tertiary'],
                                        onClick: this.triggerEvent
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_icon__["a" /* default */], { symbol: 'cancel', size: 'medium' })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'card-slider--zip-form-card' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_zip_form__["a" /* default */], { autoFocus: false })
                            )
                        )
                    );
                // TODO: remove this case as soon as we go live
                case TYPE_NEWSLETTER:
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'card-slider--zip-form', key: key },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'card-slider--zip-form-inner' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'h1',
                                { className: 'card-slider--zip-title' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_translations__["a" /* Trans */], { path: 'prelaunch.card.form.title' })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'p',
                                { className: 'card-slider--zip-text' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_translations__["a" /* Trans */], { path: 'prelaunch.card.form.description' })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'card-slider--close' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_10_components_button__["a" /* default */],
                                    {
                                        'aria-label': Object(__WEBPACK_IMPORTED_MODULE_4_translations__["c" /* default */])('accessibility.label.close_cards'),
                                        tag: 'button',
                                        facet: ['bubble', 'large', 'tertiary'],
                                        onClick: this.triggerEvent
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_icon__["a" /* default */], { symbol: 'cancel', size: 'medium' })
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'card-slider--zip-form-card' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_prelaunch_form__["a" /* default */], { autoFocus: false })
                            )
                        )
                    );
                case TYPE_CARD:
                // case TYPE_APP_STORE:
                default:
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7_components_cms_placeholder_card_stack_card__["a" /* default */],
                        { key: key, facet: 'slider' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'card-slider--close' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_10_components_button__["a" /* default */],
                                { 'aria-label': Object(__WEBPACK_IMPORTED_MODULE_4_translations__["c" /* default */])('accessibility.label.close_cards'), tag: 'button',
                                    facet: ['bubble', 'large', 'tertiary'], onClick: this.triggerEvent },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_icon__["a" /* default */], { symbol: 'cancel', size: 'medium' })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_cms_placeholder_card_stack_card_content__["a" /* default */], _extends({}, card, {
                            app_store_buttons_on_last_card: features.includes(TYPE_APP_STORE) && lastCard,
                            app_store_link: app_store_link,
                            google_play_link: google_play_link,
                            visible: key === activeIndex && isOpen
                        }))
                    );
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                cards = _props2.cards,
                style = _props2.style,
                isOpen = _props2.isOpen;
            var _state = this.state,
                activeIndex = _state.activeIndex,
                hasFormCard = _state.hasFormCard;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_15_components_aria_51__["a" /* default */],
                { isActive: isOpen,
                    'aria-hidden': !isOpen,
                    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('card-slider card-slider__' + style, {
                        'card-slider__is-visible': isOpen,
                        'card-slider__form': hasFormCard
                    }) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_components_slider__["a" /* default */],
                    { ref: 'slider',
                        facet: this.facet,
                        config: __WEBPACK_IMPORTED_MODULE_9__slider_config__["a" /* default */],
                        on: { slideChangeTransitionEnd: this.handleSlideChangeEnd } },
                    Object(__WEBPACK_IMPORTED_MODULE_2_looppa__["a" /* default */])(cards)(function (card, index) {
                        return _this2.renderCard(card, index, activeIndex);
                    })
                )
            );
        }
    }, {
        key: 'facet',
        get: function get() {
            return 'card-' + this.props.style + '-slider';
        }
    }]);

    return CardSlider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

CardSlider.defaultProps = {
    features: []
};
CardSlider.propTypes = {
    cards: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
    style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    onEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    app_store_link: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    google_play_link: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    features: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};
/* harmony default export */ __webpack_exports__["a"] = (CardSlider);

/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    speed: 500,
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    simulateTouch: false,
    allowTouchMove: true,
    spaceBetween: 300
});

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = uid;
var tmpId = 0;

/**
 * Return a unique number to identify UX elements
 * @returns {number}
 */
function uid() {
  return tmpId++;
}

/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;
var EMAIL_REGEX = /^[-!#$%&'*+/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-?\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
var BEFORE_AT_MAX_LENGTH = 64;
var DOMAINS_PARTS_MAX_LENGTH = 63;
// forked from https://github.com/Sembiance/email-validator
function validate(email) {
    var isAtLeastAMail = email && email.length < 254 && EMAIL_REGEX.test(email);

    if (!isAtLeastAMail) {
        return false;
    }

    // Further checking of some things regex can't handle
    var parts = email.split('@');

    if (parts[0].length > BEFORE_AT_MAX_LENGTH) {
        return false;
    }

    var domainParts = parts[1].split('.');

    if (domainParts.some(function (part) {
        return part.length > DOMAINS_PARTS_MAX_LENGTH;
    })) {
        return false;
    }

    return true;
}

/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_react_facet__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_player__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_dom_image_dpi_resolution__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_constants_debounce_delays__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_page_visibility__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_visibility_sensor__ = __webpack_require__(310);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var CardContentLite = function (_PureComponent) {
    _inherits(CardContentLite, _PureComponent);

    function CardContentLite() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, CardContentLite);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CardContentLite.__proto__ || Object.getPrototypeOf(CardContentLite)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isVisible: false,
            video: {
                loop: true,
                playing: false,
                controls: false,
                width: '220',
                height: '440'
            }
        }, _this.handleElementVisibility = __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function (elVisible) {
            this.toggle(this.props, elVisible);
        }, __WEBPACK_IMPORTED_MODULE_10_constants_debounce_delays__["j" /* VIDEO_AUTOPLAY_DEBOUNCE */]), _this.handlePageVisibility = __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function (visibilityState, documentHidden) {
            this.toggle(this.props, !documentHidden);
        }), _this.toggle = function (props, isVisible) {
            _this.setState(_extends({}, _this.state, {
                isVisible: isVisible,
                video: _extends({}, _this.state.video, {
                    playing: isVisible && _this.canPlay(props)
                })
            }));
        }, _this.canPlay = function (props) {
            return props.videosLoadedAmount >= 2;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CardContentLite, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // on iOS we need to force the load event
            // to get the onReady event firing properly
            var videoElement = this.refs.video.getInternalPlayer();
            videoElement.load();
            this.toggle(this.props, true);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            this.toggle(newProps, true);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.resetVidesoLoaded();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                cover_image = _props.cover_image,
                facet = _props.facet,
                mobile_title = _props.mobile_title,
                cover_video = _props.cover_video,
                onVideoLoaded = _props.onVideoLoaded;


            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('card-content-lite', Object(__WEBPACK_IMPORTED_MODULE_4_util_react_facet__["a" /* default */])(facet, 'card-content-lite')) },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'h3',
                    { className: 'card-content-lite--title' },
                    mobile_title
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_11_components_page_visibility__["a" /* default */],
                    { onChange: this.handlePageVisibility.bind(this) },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_12_components_visibility_sensor__["a" /* default */],
                        { onChange: this.handleElementVisibility.bind(this) },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_player___default.a, _extends({
                            ref: 'video',
                            className: 'card-content-lite--image',
                            onReady: onVideoLoaded,
                            url: [cover_video.src_webm, cover_video.src],
                            config: {
                                file: {
                                    attributes: {
                                        poster: cover_image.src['@' + Math.min(Object(__WEBPACK_IMPORTED_MODULE_7_util_dom_image_dpi_resolution__["a" /* default */])(), 2)],
                                        autoPlay: this.state.video.playing,
                                        playsInline: true,
                                        muted: true
                                    }
                                }
                            }
                        }, this.state.video))
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_translations__["a" /* Trans */], { path: 'cards.mobile.more_link', className: 'card-content-lite--pseudo-link' })
            );
        }
    }]);

    return CardContentLite;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

CardContentLite.propTypes = {
    mobile_title: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    facet: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    cover_image: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    cover_video: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    videosLoadedAmount: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
    onVideoLoaded: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    resetVidesoLoaded: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_9_util_redux__["b" /* default */].mapStateToProps({
    videosLoadedAmount: 'video-cards.videosLoadedAmount'
}), __WEBPACK_IMPORTED_MODULE_9_util_redux__["b" /* default */].mapDispatchToProps({
    resetVidesoLoaded: 'video-cards.reset',
    onVideoLoaded: 'video-cards.onLoaded'
}))(CardContentLite));

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__question__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_misc_normalise_trailing_slash__ = __webpack_require__(196);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












/* eslint-disable camelcase */

var Faq = function (_PureComponent) {
    _inherits(Faq, _PureComponent);

    function Faq() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Faq);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Faq.__proto__ || Object.getPrototypeOf(Faq)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            openedQuestionId: null
        }, _this.onOpen = function (id) {
            _this.props.onEvent('open');
            _this.setState({
                openedQuestionId: id
            });
        }, _this.onClose = function () {
            _this.props.onEvent('close');
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Faq, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                articles = _props.articles,
                title = _props.title,
                link = _props.link,
                has_anchors = _props.has_anchors,
                facet = _props.facet;
            var openedQuestionId = this.state.openedQuestionId;


            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'aside',
                { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('cms-faq', 'cms-faq__' + facet) },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'cms-faq--header' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'h2',
                        { className: 'cms-faq--title' },
                        title
                    ),
                    link ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_react_router_dom__["b" /* Link */],
                        { 'aria-label': title, className: 'cms-faq--link u-reset', to: Object(__WEBPACK_IMPORTED_MODULE_9_util_misc_normalise_trailing_slash__["a" /* default */])(link.to) },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_translations__["a" /* Trans */], { path: 'faq.link.title' }),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_icon__["a" /* default */], { symbol: 'chevron-right',
                            size: 'small' })
                    ) : null
                ),
                Object(__WEBPACK_IMPORTED_MODULE_3_looppa__["a" /* default */])(articles)(function (_ref2) {
                    var id = _ref2.id,
                        props = _objectWithoutProperties(_ref2, ['id']);

                    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__question__["a" /* default */], _extends({ onOpening: function onOpening() {
                            return _this2.onOpen(id);
                        }, has_anchors: has_anchors,
                        onClose: _this2.onClose,
                        mustBeClosed: openedQuestionId !== id, key: id,
                        id: id }, props));
                })
            );
        }
    }]);

    return Faq;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

Faq.defaultProps = {
    articles: []
};
Faq.propTypes = {
    title: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    link: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    onEvent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    has_anchors: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    articles: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,
    facet: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};
Faq.defaultProps = {
    onEvent: __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a
};
/* harmony default export */ __webpack_exports__["a"] = (Faq);

/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Question */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_collapsible__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_collapsible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_collapsible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_dom_offset_top__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_dom_images_loaded__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_constants_transitions_props__ = __webpack_require__(241);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var Question = function (_PureComponent) {
    _inherits(Question, _PureComponent);

    function Question() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Question);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Question.__proto__ || Object.getPrototypeOf(Question)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isOpen: false
        }, _this.onClose = function () {
            _this.setState({ isOpen: false });
            _this.props.onClose();
        }, _this.onClosing = function () {
            _this.props.onClosing();
        }, _this.onOpen = function () {
            _this.props.onOpen();

            if (_this.props.has_anchors) {
                window.location.hash = _this.props.slug;
            }

            _this.setState({ isOpen: true });
        }, _this.onOpening = function () {
            _this.props.onOpening();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Question, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (!this.props.mustBeClosed || this.props.has_anchors && window.location.hash.replace('#', '') === this.props.slug) {
                // hack to check firs when all the images in the current DOM are loaded
                // and then scroll to the right answer position
                Object(__WEBPACK_IMPORTED_MODULE_9_util_dom_images_loaded__["a" /* default */])().then(function () {
                    _this2.timer = setTimeout(function () {
                        window.scroll({
                            top: Object(__WEBPACK_IMPORTED_MODULE_8_util_dom_offset_top__["a" /* default */])(_this2.refs.header) - _this2.props.headerHeight,
                            left: 0,
                            behavior: 'smooth'
                        });
                    }, __WEBPACK_IMPORTED_MODULE_10_constants_transitions_props__["b" /* accordionSpeed */]);
                });

                this.refs.root.openCollapsible();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref2) {
            var mustBeClosed = _ref2.mustBeClosed;

            if (mustBeClosed && this.state.isOpen) {
                this.refs.root.closeCollapsible();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.timer) {
                clearTimeout(this.timer);
            }
        }
    }, {
        key: 'renderAccordionHeader',
        value: function renderAccordionHeader() {
            var question = this.props.question;
            var isOpen = this.state.isOpen;

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { ref: 'header', className: 'cms-faq--question' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'h3',
                    { className: 'u-reset' },
                    question
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_icon__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('cms-faq--icon', {
                        'cms-faq--icon__is-highlighted': isOpen
                    }), symbol: 'chevron-' + (isOpen ? 'up' : 'down'), size: 'small' })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var answer = this.props.answer;


            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_collapsible___default.a,
                {
                    ref: 'root',
                    lazyRender: true,
                    transitionTime: __WEBPACK_IMPORTED_MODULE_10_constants_transitions_props__["b" /* accordionSpeed */],
                    easing: __WEBPACK_IMPORTED_MODULE_10_constants_transitions_props__["a" /* accordionEasingFn */],
                    onOpening: this.onOpening,
                    onClosing: this.onClosing,
                    onOpen: this.onOpen,
                    onClose: this.onClose,
                    className: 'faq-cms--item',
                    openedClassName: 'faq-cms--item faq-cms--item__is-active',
                    trigger: this.renderAccordionHeader() },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'cms-faq--answer', dangerouslySetInnerHTML: { __html: answer } })
            );
        }
    }]);

    return Question;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

Question.defaultProps = {
    onOpen: __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a,
    onClose: __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a,
    onClosing: __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a,
    onOpening: __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a
};
Question.propTypes = {
    id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
    slug: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    answer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    has_anchors: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    mustBeClosed: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    question: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    onOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    onClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    onClosing: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    onOpening: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    headerHeight: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_3_util_redux__["b" /* default */].mapStateToProps({
    headerHeight: 'header.height'
}))(Question));

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = offsetTop;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scroll_top__ = __webpack_require__(575);

/**
 * Get the offset top of any DOM element
 * @param {HTMLElement} el - the element we need to check
 * @returns {number} the element y position in px
 */
function offsetTop(el) {
  return Math.abs(Object(__WEBPACK_IMPORTED_MODULE_0__scroll_top__["a" /* default */])() + el.getBoundingClientRect().top);
}

/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = imagesLoaded;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bianco_query__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bianco_images_loader__ = __webpack_require__(64);



/**
 * Helper function that will query all the current images in the DOM returning a promise resolved when all of them will be loaded
 * @returns {Promise}
 */
function imagesLoaded() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_bianco_images_loader__["b" /* loadImages */])(Object(__WEBPACK_IMPORTED_MODULE_0_bianco_query__["a" /* default */])('img'));
}

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_favourite_products_slider__ = __webpack_require__(1144);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable camelcase */






var CmsMostPurchasedCumulus = function (_PureComponent) {
    _inherits(CmsMostPurchasedCumulus, _PureComponent);

    function CmsMostPurchasedCumulus() {
        _classCallCheck(this, CmsMostPurchasedCumulus);

        return _possibleConstructorReturn(this, (CmsMostPurchasedCumulus.__proto__ || Object.getPrototypeOf(CmsMostPurchasedCumulus)).apply(this, arguments));
    }

    _createClass(CmsMostPurchasedCumulus, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                logged_out_text = _props.logged_out_text,
                cumulus_not_linked_text = _props.cumulus_not_linked_text,
                title = _props.title,
                most_purchased_cumulus = _props.most_purchased_cumulus;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_favourite_products_slider__["a" /* default */], {
                logged_out_text: logged_out_text,
                cumulus_not_linked_text: cumulus_not_linked_text,
                title: title,
                most_purchased_cumulus: most_purchased_cumulus
            });
        }
    }]);

    return CmsMostPurchasedCumulus;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

CmsMostPurchasedCumulus.propTypes = {
    logged_out_text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    cumulus_not_linked_text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    most_purchased_cumulus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        link: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string })
        //products: PropTypes.array,
    }),
    hasCumulus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    isAuthenticated: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    routerRegistry: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    endpoints: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    favoriteProducts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
    populateFavoriteProducts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_2_util_redux__["b" /* default */].mapStateToProps({
    hasCumulus: 'user.cumulus_connected',
    isAuthenticated: 'user.isAuthenticated',
    routerRegistry: 'router.registry',
    endpoints: 'router.endpoints',
    favoriteProducts: 'user.favoriteProducts'
}), __WEBPACK_IMPORTED_MODULE_2_util_redux__["b" /* default */].mapDispatchToProps({
    populateFavoriteProducts: 'user.populateFavoriteProducts'
}))(CmsMostPurchasedCumulus));

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_migros_login_button__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_contentpage_product_slider__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_page_names__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_translations__ = __webpack_require__(171);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










/**
 * @extends Component<IFavouriteProductsSliderComponent>
 */

var FavouriteProductsSlider = function (_Component) {
    _inherits(FavouriteProductsSlider, _Component);

    function FavouriteProductsSlider() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, FavouriteProductsSlider);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FavouriteProductsSlider.__proto__ || Object.getPrototypeOf(FavouriteProductsSlider)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isLoading: true
        }, _this._isUnmounted = false, _this.renderNotification = function () {
            var _this$props = _this.props,
                isAuthenticated = _this$props.isAuthenticated,
                hasCumulus = _this$props.hasCumulus,
                cumulus_not_linked_text = _this$props.cumulus_not_linked_text,
                logged_out_text = _this$props.logged_out_text,
                title = _this$props.title;


            if (isAuthenticated && !hasCumulus) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h1',
                        { className: 'cms-most-purchased-cumulus--title' },
                        title
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
                        className: 'cms-most-purchased-cumulus--cumulus-not-linked',
                        dangerouslySetInnerHTML: { __html: cumulus_not_linked_text }
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'a',
                        { href: _this.props.endpoints.userConnectCumulus(), target: '_blank' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_translations__["a" /* Trans */], { path: 'link.to.cumulus.card.button_dashboard' })
                    )
                );
            }

            if (!isAuthenticated) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h1',
                        { className: 'cms-most-purchased-cumulus--title' },
                        title
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'cms-most-purchased-cumulus--logged-out' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: logged_out_text } }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_migros_login_button__["a" /* default */], { inline: true, big: true })
                        )
                    )
                );
            }

            return null;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(FavouriteProductsSlider, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var _props = this.props,
                isAuthenticated = _props.isAuthenticated,
                hasCumulus = _props.hasCumulus;


            if (!isAuthenticated || !hasCumulus) {
                this.setState({ isLoading: false });
                return;
            }

            this.props.populateFavoriteProducts().then(function () {
                if (!_this2._isUnmounted) {
                    _this2.setState({ isLoading: false });
                }
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this._isUnmounted = true;
        }
    }, {
        key: 'renderProducts',
        value: function renderProducts() {
            var _props2 = this.props,
                title = _props2.title,
                favoriteProducts = _props2.favoriteProducts,
                routerRegistry = _props2.routerRegistry;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'cms-most-purchased-cumulus--products' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_contentpage_product_slider__["a" /* default */], {
                    skipTests: true,
                    title: title,
                    products: favoriteProducts,
                    link: routerRegistry.get(__WEBPACK_IMPORTED_MODULE_6_constants_page_names__["PROFILE_CUMULUS_PRODUCTS"]).url
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                hasCumulus = _props3.hasCumulus,
                isAuthenticated = _props3.isAuthenticated,
                favoriteProducts = _props3.favoriteProducts;

            var couldFetchProducts = hasCumulus && isAuthenticated;
            var hasNotEnoughProducts = couldFetchProducts && favoriteProducts && favoriteProducts.length < 1;

            if (hasNotEnoughProducts) {
                return null;
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'favourite-products-slider' },
                couldFetchProducts ? this.renderProducts() : this.renderNotification()
            );
        }
    }]);

    return FavouriteProductsSlider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

FavouriteProductsSlider.propTypes = {
    logged_out_text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    cumulus_not_linked_text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    most_purchased_cumulus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        link: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string })
        //products: PropTypes.array,
    }),

    // Redux data
    hasCumulus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    isAuthenticated: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    routerRegistry: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    endpoints: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    favoriteProducts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
    populateFavoriteProducts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_2_util_redux__["b" /* default */].mapStateToProps({
    hasCumulus: 'user.cumulus_connected',
    isAuthenticated: 'user.isAuthenticated',
    routerRegistry: 'router.registry',
    endpoints: 'router.endpoints',
    favoriteProducts: 'user.favoriteProducts'
}), __WEBPACK_IMPORTED_MODULE_2_util_redux__["b" /* default */].mapDispatchToProps({
    populateFavoriteProducts: 'user.populateFavoriteProducts'
}))(FavouriteProductsSlider));

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_product_meta_product_meta_grid__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_misc_get_product_price__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ProductMeta = function (_PureComponent) {
    _inherits(ProductMeta, _PureComponent);

    function ProductMeta() {
        _classCallCheck(this, ProductMeta);

        return _possibleConstructorReturn(this, (ProductMeta.__proto__ || Object.getPrototypeOf(ProductMeta)).apply(this, arguments));
    }

    _createClass(ProductMeta, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                name = _props.name,
                price_information = _props.price_information,
                short_description = _props.short_description;
            var badge = price_information.badge,
                teaser = price_information.teaser,
                original_price = price_information.original_price;

            var realPrice = Object(__WEBPACK_IMPORTED_MODULE_2_util_misc_get_product_price__["a" /* default */])(price_information);

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_product_meta_product_meta_grid__["a" /* default */], {
                title: name,
                short_description: short_description,
                original_price: original_price,
                hasBadge: !!badge,
                price: realPrice,
                teaser: teaser
            });
        }
    }]);

    return ProductMeta;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

ProductMeta.propTypes = {
    name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
    short_description: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array.isRequired,
    price_information: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    facet: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired
};
ProductMeta.defaultProps = {
    facet: 'grid'
};
/* harmony default export */ __webpack_exports__["a"] = (ProductMeta);

/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_misc_truncate__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_misc_format_price__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_cart__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_react_format_product_short_description__ = __webpack_require__(344);


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var TRUNCATE_LIMIT = 32;

var ProductMetaGrid = function (_PureComponent) {
    _inherits(ProductMetaGrid, _PureComponent);

    function ProductMetaGrid() {
        _classCallCheck(this, ProductMetaGrid);

        return _possibleConstructorReturn(this, (ProductMetaGrid.__proto__ || Object.getPrototypeOf(ProductMetaGrid)).apply(this, arguments));
    }

    _createClass(ProductMetaGrid, [{
        key: 'formatDiscount',
        value: function formatDiscount(original_price) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { className: 'product-meta--price-discount' },
                Object(__WEBPACK_IMPORTED_MODULE_7_translations__["c" /* default */])('products.instead_of'),
                ' ',
                Object(__WEBPACK_IMPORTED_MODULE_4_util_misc_format_price__["b" /* formatPrice */])(original_price)
            );
        }
    }, {
        key: 'formatPrice',
        value: function formatPrice(price) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { className: 'product-meta--price-primary', itemProp: 'price' },
                Object(__WEBPACK_IMPORTED_MODULE_4_util_misc_format_price__["b" /* formatPrice */])((typeof price === 'undefined' ? 'undefined' : _typeof(price)) === 'object' ? price.price : price)
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                title = _props.title,
                price = _props.price,
                teaser = _props.teaser,
                short_description = _props.short_description,
                original_price = _props.original_price,
                hasBadge = _props.hasBadge;

            var hasTeaser = teaser !== null;
            var hasPrice = !__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(price);
            var hasDiscount = !__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(original_price);

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { key: 'meta', className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('product-meta', {
                        'product-meta__is-ready': hasPrice
                    }) },
                hasPrice && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    {
                        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('product-meta--price', { 'product-meta--price__discounted': hasBadge }),
                        itemProp: 'priceSpecification',
                        itemScope: true,
                        itemType: 'PriceSpecification'
                    },
                    hasPrice && this.formatPrice(price),
                    hasDiscount && this.formatDiscount(original_price)
                ),
                title && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'h1',
                    { itemProp: 'name', className: 'u-reset product-meta--name', title: title },
                    Object(__WEBPACK_IMPORTED_MODULE_3_util_misc_truncate__["a" /* default */])(title, TRUNCATE_LIMIT)
                ),
                hasTeaser ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('meta', { itemProp: 'priceCurrency', content: __WEBPACK_IMPORTED_MODULE_5_constants_cart__["a" /* CURRENCY */] }) : null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    {
                        className: 'product-meta--short-description' },
                    Object(__WEBPACK_IMPORTED_MODULE_8_util_react_format_product_short_description__["a" /* default */])(short_description)
                )
            );
        }
    }]);

    return ProductMetaGrid;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

ProductMetaGrid.propTypes = {
    title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,
    original_price: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    short_description: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array.isRequired,
    hasBadge: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    price: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
    teaser: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (ProductMetaGrid);

/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = truncate;
/**
 * Truncate a string if it's too long
 * @param {string} string - input string
 * @param {number} limit - limit to start truncating the text
 * @param {string} postfix - postfix to append to the truncated string
 * @returns {*}
 */
function truncate(string, limit) {
    var postfix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '...';

    if (limit && string.length > limit) {
        return '' + string.substr(0, limit).trim() + postfix;
    }

    return string;
}

/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return productTileAmounts; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util_dom_scss_data__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bianco_query__ = __webpack_require__(251);
var _breakpoints;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




// Get data from the dom

var _scssData = Object(__WEBPACK_IMPORTED_MODULE_0_util_dom_scss_data__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1_bianco_query__["a" /* default */])('.scss-data-bridge')[0]),
    breakpoints = _scssData.breakpoints,
    productTileAmounts = _scssData['contentpage-product-tile-amounts'];

/**
 * Get the width of a breakpoint by name
 * @param name
 * @returns {Number}
 */


function bp(name) {
    return parseInt(breakpoints[name]);
}

/* harmony default export */ __webpack_exports__["a"] = ({
    speed: 450,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    slidesPerView: 'auto',
    spaceBetween: 0,
    allowTouchMove: false,
    breakpoints: (_breakpoints = {}, _defineProperty(_breakpoints, bp('xs'), {
        slidesPerGroup: productTileAmounts['xs'],
        freeMode: true
    }), _defineProperty(_breakpoints, bp('sm'), {
        slidesPerGroup: productTileAmounts['sm']
    }), _defineProperty(_breakpoints, bp('md'), {
        slidesPerGroup: productTileAmounts['md']
    }), _defineProperty(_breakpoints, bp('lg'), {
        slidesPerGroup: productTileAmounts['lg']
    }), _defineProperty(_breakpoints, bp('xl'), {
        slidesPerGroup: productTileAmounts['xl']
    }), _defineProperty(_breakpoints, 'max', { // anything else
        slidesPerGroup: productTileAmounts['xxl']
    }), _breakpoints)
});



/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_misc_normalise_trailing_slash__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_misc_link_to_dashboard__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_lazy_image__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_dom_channeled_interactionobserver__ = __webpack_require__(308);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var CmsFavoriteCategory = function (_Component) {
    _inherits(CmsFavoriteCategory, _Component);

    function CmsFavoriteCategory() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, CmsFavoriteCategory);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CmsFavoriteCategory.__proto__ || Object.getPrototypeOf(CmsFavoriteCategory)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isVisible: false
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CmsFavoriteCategory, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            Object(__WEBPACK_IMPORTED_MODULE_9_util_dom_channeled_interactionobserver__["a" /* register */])(this, 'fav-category', {
                threshold: 0.05
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            Object(__WEBPACK_IMPORTED_MODULE_9_util_dom_channeled_interactionobserver__["b" /* unregister */])(this);
        }
    }, {
        key: 'getBackgroundImage',
        value: function getBackgroundImage(image) {
            if (!this.state.isVisible) {
                return null;
            }

            return 'url(' + image.src['@2'] + ')';
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                title = _props.title,
                icon = _props.icon,
                image = _props.image,
                category = _props.category,
                activeRegion = _props.activeRegion;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { ref: 'root' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* NavLink */],
                    {
                        className: 'cms-favorite-category u-reset',
                        to: Object(__WEBPACK_IMPORTED_MODULE_5_util_misc_normalise_trailing_slash__["a" /* default */])('' + Object(__WEBPACK_IMPORTED_MODULE_6_util_misc_link_to_dashboard__["c" /* linkToDashboardByUser */])(activeRegion) + category),
                        style: { backgroundImage: this.getBackgroundImage(image) } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        {
                            className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('cms-favorite-category--overlay', { 'cms-favorite-category--overlay__longtext': title.length > 12 }) },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_8_components_lazy_image__["a" /* default */],
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'cms-favorite-category--icon', 'data-src': icon })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'cms-favorite-category--title' },
                            title
                        )
                    )
                )
            );
        }
    }]);

    return CmsFavoriteCategory;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

CmsFavoriteCategory.propTypes = {
    title: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    category: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    icon: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    activeRegion: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    image: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
        title: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
        src: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
            '@1': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
            '@2': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
        }),
        alt: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
    }),
    routerRegistry: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_3_util_redux__["b" /* default */].mapStateToProps({
    activeRegion: 'region.active',
    routerRegistry: 'router.registry'
}), null)(CmsFavoriteCategory));

/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(173);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var CmsFavoriteCategoryWrapper = function (_PureComponent) {
    _inherits(CmsFavoriteCategoryWrapper, _PureComponent);

    function CmsFavoriteCategoryWrapper() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, CmsFavoriteCategoryWrapper);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CmsFavoriteCategoryWrapper.__proto__ || Object.getPrototypeOf(CmsFavoriteCategoryWrapper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            extendedContent: {}
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CmsFavoriteCategoryWrapper, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                type = _props.type,
                plugins = _props.plugins,
                cms = _props.cms,
                title = _props.title;

            var placeholder = {
                type: type,
                plugins: this.extendedPlugins,
                cms: cms
            };

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'cms-favorite-category-wrapper' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h1',
                    { className: 'cms-favorite-category-wrapper--title' },
                    title
                ),
                plugins && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["a" /* default */], { placeholder: placeholder, facet: type, onEvent: this.onEvent })
            );
        }
    }, {
        key: 'extendedPlugins',


        /**
         * Add custom data to plugins if so requested by one of the plugins
         * via onEvent
         */
        get: function get() {
            var _this2 = this;

            return this.props.plugins.map(function (plugin) {
                plugin.content = _extends({}, plugin.content, _this2.state.extendedContent);
                return plugin;
            });
        }
    }]);

    return CmsFavoriteCategoryWrapper;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

CmsFavoriteCategoryWrapper.defaultProps = {
    plugins: []
};
CmsFavoriteCategoryWrapper.propTypes = {
    plugins: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    cms: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_3_util_redux__["b" /* default */].mapStateToProps({}), __WEBPACK_IMPORTED_MODULE_3_util_redux__["b" /* default */].mapDispatchToProps({}))(CmsFavoriteCategoryWrapper));

/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CmsFaqInfo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_icon_index__ = __webpack_require__(177);




function CmsFaqInfo(_ref) {
    var text = _ref.text,
        title = _ref.title;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'cms-faq-info' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            { className: 'cms-faq-info--title' },
            title
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'cms-faq-info--body' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'cms-faq-info--icon' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_icon_index__["a" /* default */], { symbol: 'faq', size: 'x-large' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cms-faq-info--text', dangerouslySetInnerHTML: { __html: text } })
        )
    );
}

CmsFaqInfo.propTypes = {
    text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Pickers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_testimonial_slider__ = __webpack_require__(1153);




function Pickers(_ref) {
    var title = _ref.title,
        pickers = _ref.pickers,
        subtitle = _ref.subtitle;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'cms-pickers' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'cms-pickers--title' },
            title
        ),
        subtitle && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'cms-pickers--subtitle' },
            subtitle
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'cms-pickers--slider' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_testimonial_slider__["a" /* default */], { pickers: pickers.pickers })
        )
    );
}

Pickers.propTypes = {
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    subtitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    pickers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
        pickers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired
    })
};

/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_testimonial_tile__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__slider__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__slider_config__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_redux__ = __webpack_require__(172);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var TestimonialSlider = function (_PureComponent) {
    _inherits(TestimonialSlider, _PureComponent);

    function TestimonialSlider() {
        _classCallCheck(this, TestimonialSlider);

        return _possibleConstructorReturn(this, (TestimonialSlider.__proto__ || Object.getPrototypeOf(TestimonialSlider)).apply(this, arguments));
    }

    _createClass(TestimonialSlider, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                pickers = _props.pickers,
                isMobile = _props.isMobile,
                isMainContentLoaded = _props.isMainContentLoaded,
                isTablet = _props.isTablet,
                isTouch = _props.isTouch;


            if (!isMainContentLoaded) {
                return null;
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4__slider__["a" /* default */],
                {
                    facet: 'testimonial-slider',

                    useNativeScroll: isMobile || isTablet && isTouch,
                    config: __WEBPACK_IMPORTED_MODULE_5__slider_config__["a" /* default */]
                },
                Object(__WEBPACK_IMPORTED_MODULE_2_looppa__["a" /* default */])(pickers)(function (picker, i) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_testimonial_tile__["a" /* default */], _extends({
                        key: i
                    }, picker));
                })
            );
        }
    }]);

    return TestimonialSlider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

TestimonialSlider.propTypes = {
    isMobile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    isTablet: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    isTouch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    isMainContentLoaded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    pickers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_7_util_redux__["b" /* default */].mapStateToProps({
    isMobile: 'viewport.isMobile',
    isTablet: 'viewport.isTablet',
    isTouch: 'viewport.touchevents',
    isMainContentLoaded: 'main-content.isLoaded'
}))(TestimonialSlider));

/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_rating__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_lazy_image__ = __webpack_require__(428);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var TestimonialTile = function (_PureComponent) {
    _inherits(TestimonialTile, _PureComponent);

    function TestimonialTile() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, TestimonialTile);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TestimonialTile.__proto__ || Object.getPrototypeOf(TestimonialTile)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isLoaded: false,
            isVisible: true
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TestimonialTile, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                name = _props.name,
                testimonial = _props.testimonial,
                profile_picture = _props.profile_picture,
                rating_average = _props.rating_average,
                rating_count = _props.rating_count;
            var isVisible = this.state.isVisible;


            if (!isVisible) {
                return null;
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'testimonial-tile' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'testimonial-tile--header' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'testimonial-tile--header-image-wrapper' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_components_lazy_image__["a" /* default */],
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                                alt: name,
                                className: 'testimonial-tile--header-image',
                                'data-src': profile_picture })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'testimonial-tile--header-title' },
                        name
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'testimonial-tile--header-rating' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_rating__["a" /* default */], { name: name, reviews: rating_average, isEditing: false, value: rating_average }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: 'testimonial-tile--rating-average' },
                            rating_count
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'testimonial-tile--body' },
                    '\xAB',
                    testimonial,
                    '\xBB'
                )
            );
        }
    }]);

    return TestimonialTile;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

TestimonialTile.propTypes = {
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    profile_picture: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    rating_average: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    testimonial: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    rating_count: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (TestimonialTile);

/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    speed: 450,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    allowTouchMove: false,
    slidesPerView: 'auto',
    spaceBetween: 0
});

/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CmsTopicSlider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_contentpage_product_slider__ = __webpack_require__(593);




function CmsTopicSlider(_ref) {
    var title = _ref.title,
        products = _ref.products,
        link = _ref.link,
        lead = _ref.lead;

    var _link = link ? link.to : null;

    if (!products || products.length === 0) {
        return null;
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_contentpage_product_slider__["a" /* default */], {
        skipTests: true,
        title: title,
        lead: lead,
        products: products,
        link: _link,
        appendPromotionTile: !!(link && link.to)
    });
}

CmsTopicSlider.propTypes = {
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    lead: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    link: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    products: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_button__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_redux__ = __webpack_require__(172);






function StartShoppingButton(_ref) {
    var label = _ref.label,
        openModal = _ref.openModal;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'start-shopping-button' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_components_button__["a" /* default */],
            { onClick: function onClick() {
                    openModal({
                        layout: 'zip-form'
                    });
                }, size: 'large', facet: ['call-to-action', 'tertiary', 'onboarding'] },
            label
        )
    );
}

StartShoppingButton.propTypes = {
    openModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

StartShoppingButton.defaultProps = {
    label: 'Lorem Ipsum'
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(null, __WEBPACK_IMPORTED_MODULE_4_util_redux__["b" /* default */].mapDispatchToProps({
    openModal: 'modal.open'
}))(StartShoppingButton));

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_placeholder_events__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_cms_placeholder_plugin__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__const__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_dom_mq__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util_react_facet__ = __webpack_require__(185);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var SectionRightMany = function (_PureComponent) {
    _inherits(SectionRightMany, _PureComponent);

    function SectionRightMany() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SectionRightMany);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SectionRightMany.__proto__ || Object.getPrototypeOf(SectionRightMany)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            extendedContent: {}
        }, _this.onEvent = function (eventName, data) {
            if (eventName === __WEBPACK_IMPORTED_MODULE_6_constants_placeholder_events__["a" /* CARD */]) {
                _this.setState({ extendedContent: data });
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SectionRightMany, [{
        key: 'renderDesktop',
        value: function renderDesktop() {
            var _this2 = this;

            var isCmsEditModeEnabled = this.props.isCmsEditModeEnabled;

            var plugins = this.extendedPlugins;
            var largePlugin = plugins.shift();

            return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'cms-section-right-many--col cms-section-right-many--col-left', key: 'large-plugin' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_cms_placeholder_plugin__["a" /* default */], _extends({
                    isCmsEditModeEnabled: isCmsEditModeEnabled,
                    index: 0,
                    key: 0,
                    onEvent: this.onEvent,
                    parent: this.props
                }, largePlugin))
            ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'cms-section-right-many--col cms-section-right-many--col-right', key: 'small-plugin' },
                Object(__WEBPACK_IMPORTED_MODULE_5_looppa__["a" /* default */])(plugins)(function (plugin, i) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_cms_placeholder_plugin__["a" /* default */], _extends({
                        isCmsEditModeEnabled: isCmsEditModeEnabled,
                        facet: 'onboarding',
                        index: i + 1,
                        onEvent: _this2.onEvent,
                        parent: _this2.props,
                        key: i + 1
                    }, plugin));
                })
            )];
        }
    }, {
        key: 'renderMobile',
        value: function renderMobile() {
            var _this3 = this;

            var isCmsEditModeEnabled = this.props.isCmsEditModeEnabled;

            var plugins = this.extendedPlugins;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                Object(__WEBPACK_IMPORTED_MODULE_5_looppa__["a" /* default */])(plugins)(function (plugin, i) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'cms-section-right-many--col', key: i + 1 },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_cms_placeholder_plugin__["a" /* default */], _extends({
                            isCmsEditModeEnabled: isCmsEditModeEnabled,
                            index: i + 1,
                            onEvent: _this3.onEvent,
                            parent: _this3.props
                        }, plugin))
                    );
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var size_class = this.props.size_class;


            var content = null;

            if (size_class === __WEBPACK_IMPORTED_MODULE_8__const__["a" /* SIZE_DESKTOP */] && Object(__WEBPACK_IMPORTED_MODULE_9_util_dom_mq__["c" /* mq */])('>=lg')) {
                content = this.renderDesktop();
            } else if (size_class === __WEBPACK_IMPORTED_MODULE_8__const__["b" /* SIZE_MOBILE */] && Object(__WEBPACK_IMPORTED_MODULE_9_util_dom_mq__["c" /* mq */])('<lg')) {
                content = this.renderMobile();
            } else {
                return null;
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('cms-section-right-many', 'grid grid__base', Object(__WEBPACK_IMPORTED_MODULE_10_util_react_facet__["a" /* default */])(size_class, 'cms-section-right-many')) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'cms-section-right-many--row' },
                    content
                )
            );
        }
    }, {
        key: 'extendedPlugins',


        /**
         * Add custom data to plugins if so requested by one of the plugins
         * via onEvent
         */
        get: function get() {
            var _this4 = this;

            return this.props.plugins.map(function (plugin) {
                plugin.content = _extends({}, plugin.content, _this4.state.extendedContent);
                return plugin;
            });
        }
    }]);

    return SectionRightMany;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

SectionRightMany.propTypes = {
    plugins: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
    size_class: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    isCmsEditModeEnabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    cms: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};
SectionRightMany.defaultProps = {
    plugins: []
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_2_util_redux__["b" /* default */].mapStateToProps({
    viewportWidth: 'viewport.width'
}), __WEBPACK_IMPORTED_MODULE_2_util_redux__["b" /* default */].mapDispatchToProps({}))(SectionRightMany));

/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SIZE_DESKTOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SIZE_MOBILE; });
var SIZE_DESKTOP = 'desktop';
var SIZE_MOBILE = 'mobile';

/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CMSMyMigrosSliders;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_mymigros_sliders__ = __webpack_require__(1161);




/**
 * @param {string} api_endpoint
 * @param {IMyMigrosSlider[]} sliders
 */
function CMSMyMigrosSliders(_ref) {
    var api_endpoint = _ref.api_endpoint,
        sliders = _ref.sliders,
        onboarding_link = _ref.onboarding_link;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'cms-mymigros-sliders' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_mymigros_sliders__["a" /* default */], {
            apiEndpoint: api_endpoint,
            onboardingLink: onboarding_link,
            sliders: sliders
        })
    );
}

CMSMyMigrosSliders.propTypes = {
    api_endpoint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    onboarding_link: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    sliders: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired
};

/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_mymigros_sliders_mymigros_slider__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_action_teaser__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_migros_login_button__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router_dom_es_NavLink__ = __webpack_require__(507);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














/**
 * @extends React.Component<IMyMigrosSlidersPlugin>
 */

var MyMigrosSliders = function (_PureComponent) {
    _inherits(MyMigrosSliders, _PureComponent);

    function MyMigrosSliders() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, MyMigrosSliders);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MyMigrosSliders.__proto__ || Object.getPrototypeOf(MyMigrosSliders)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            sliders: []
        }, _this.loadSliders = function () {
            var sliders = _this.props.sliders.map(function (slider) {
                slider.products = [];
                return slider;
            });

            _this.props.fetchSliders(__WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default()(sliders), _this.props.apiEndpoint);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(MyMigrosSliders, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                isAuthenticated = _props.isAuthenticated,
                cumulus_connected = _props.cumulus_connected;


            if (!isAuthenticated || !cumulus_connected) {
                return;
            }

            this.loadSliders();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (!this.props.fetchedSliders || this.props.fetchedSliders.length === 0) {
                this.props.setSliders(this.props.sliders);
            }

            if (this.props.isAuthenticated && prevProps.isAuthenticated !== this.props.isAuthenticated || this.props.cumulus_connected && prevProps.cumulus_connected !== this.props.cumulus_connected) {
                this.loadSliders();
            }
        }
    }, {
        key: 'renderOnboardingLink',
        value: function renderOnboardingLink() {
            var onboardingLink = this.props.onboardingLink;


            if (!onboardingLink) {
                return null;
            }

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11_react_router_dom_es_NavLink__["a" /* default */],
                { className: 'u-reset mymigros-sliders--onboarding-link', to: onboardingLink.to },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_translations__["a" /* Trans */], { path: 'mymigros.onboardin_link_label' })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                isAuthenticated = _props2.isAuthenticated,
                endpoints = _props2.endpoints,
                isFetchingSliders = _props2.isFetchingSliders,
                cumulus_connected = _props2.cumulus_connected,
                fetchedSliders = _props2.fetchedSliders;


            if (!isAuthenticated) {
                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'mymigros-sliders' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_7_components_action_teaser__["a" /* default */],
                        {
                            imagePath: 'img/login-teaser/img_rabbit.svg',
                            titleTranslationKey: 'mymigros.login_title',
                            descriptionTranslationKey: 'mymigros.login_body'
                        },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_migros_login_button__["a" /* default */], {
                            inline: true,
                            big: true,
                            facet: 'inline-block' }),
                        this.renderOnboardingLink()
                    )
                );
            }

            if (!cumulus_connected) {
                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_components_action_teaser__["a" /* default */],
                    {
                        imagePath: 'img/cumulus-teaser/img_happy_products.svg',
                        titleTranslationKey: 'mymigros.cumulus_connect_title',
                        descriptionTranslationKey: 'mymigros.cumulus_connect_body'
                    },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'a',
                        { className: 'btn btn__primary btn__teaser',
                            href: endpoints.userConnectCumulus() },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_translations__["a" /* Trans */], { path: 'mymigros.cumulus_connect_action' })
                    )
                );
            }

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                {
                    className: __WEBPACK_IMPORTED_MODULE_10_classnames__('mymigros-sliders', isFetchingSliders ? 'mymigros-sliders__is-fetching' : null) },
                Object(__WEBPACK_IMPORTED_MODULE_3_looppa__["a" /* default */])(fetchedSliders)(function (slider, idx) {
                    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_mymigros_sliders_mymigros_slider__["a" /* default */], {
                        hasFetchedData: !isFetchingSliders,
                        category: slider.category,
                        key: idx,
                        link: slider.link,
                        kind: slider.kind,
                        cumulus_connected: cumulus_connected,
                        title_key: slider.title_key,
                        header_link_label_key: 'mymigros.header_showall_link_label',
                        products: slider.products });
                })
            );
        }
    }]);

    return MyMigrosSliders;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

MyMigrosSliders.propTypes = {
    apiEndpoint: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    /** @type {IMyMigrosSlider[]} */
    sliders: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,
    /** @type {ILink | null} */
    onboardingLink: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,

    // Redux
    isFetchingSliders: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    cumulus_connected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    isAuthenticated: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    fetchedSliders: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
    fetchSliders: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    setSliders: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    endpoints: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_5_util_redux__["b" /* default */].mapStateToProps({
    isFetchingSliders: 'mymigros.isFetching',
    fetchedSliders: 'mymigros.sliders',
    hasCumulus: 'user.cumulus_connected',
    isAuthenticated: 'user.isAuthenticated',
    cumulus_connected: 'user.cumulus_connected',
    endpoints: 'router.endpoints'
}), __WEBPACK_IMPORTED_MODULE_5_util_redux__["b" /* default */].mapDispatchToProps({
    fetchSliders: 'mymigros.fetchSliders',
    setSliders: 'mymigros.setSliders'
}))(MyMigrosSliders));

/***/ }),
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_products_slider__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_mymigros_sliders_empty_category_slider__ = __webpack_require__(1183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_category_icons__ = __webpack_require__(346);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var PLACEHOLDER_ICON = __WEBPACK_IMPORTED_MODULE_5_constants_category_icons__["a" /* default */].default;

/**
 * @extends React.Component<IMyMigrosSliderPlugin>
 */

var MyMigrosSlider = function (_Component) {
    _inherits(MyMigrosSlider, _Component);

    function MyMigrosSlider() {
        _classCallCheck(this, MyMigrosSlider);

        return _possibleConstructorReturn(this, (MyMigrosSlider.__proto__ || Object.getPrototypeOf(MyMigrosSlider)).apply(this, arguments));
    }

    _createClass(MyMigrosSlider, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                title_key = _props.title_key,
                products = _props.products,
                link = _props.link,
                category = _props.category,
                hasFetchedData = _props.hasFetchedData,
                header_link_label_key = _props.header_link_label_key;

            var categoryIcon = category ? __WEBPACK_IMPORTED_MODULE_5_constants_category_icons__["a" /* default */][category.id] : null;

            //const hasProducts = false;
            var hasProducts = products.length > 0;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'mymigros-slider' },
                !hasProducts && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_mymigros_sliders_empty_category_slider__["a" /* default */], {
                    link: link.to,
                    link_label_key: link.label_key,
                    header_link_label_key: header_link_label_key,
                    title: Object(__WEBPACK_IMPORTED_MODULE_2_translations__["c" /* default */])(title_key),
                    show_description: hasFetchedData,
                    icon_key: categoryIcon || PLACEHOLDER_ICON }),
                hasProducts && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_products_slider__["a" /* default */], {
                    link: link.to,
                    link_label_key: link.label_key,
                    header_link_label_key: header_link_label_key,
                    skipTests: true,
                    products: products,
                    title: Object(__WEBPACK_IMPORTED_MODULE_2_translations__["c" /* default */])(title_key)
                })
            );
        }
    }]);

    return MyMigrosSlider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

MyMigrosSlider.propTypes = {
    hasFetchedData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    title_key: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    header_link_label_key: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,

    category: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

    /** @type {IProduct[]} */
    products: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,

    /** @type {ICategoryLink} */
    link: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
MyMigrosSlider.defaultProps = {
    hasFetchedData: false,
    category: null
};
/* harmony default export */ __webpack_exports__["a"] = (MyMigrosSlider);
;

/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return productTileAmounts; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util_dom_scss_data__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bianco_query__ = __webpack_require__(251);
var _breakpoints;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




// Get data from the dom

var _scssData = Object(__WEBPACK_IMPORTED_MODULE_0_util_dom_scss_data__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1_bianco_query__["a" /* default */])('.scss-data-bridge')[0]),
    breakpoints = _scssData.breakpoints,
    productTileAmounts = _scssData['product-tile-amounts'];

/**
 * Get the width of a breakpoint by name
 * @param name
 * @returns {Number}
 */


function bp(name) {
    return parseInt(breakpoints[name]);
}

/* harmony default export */ __webpack_exports__["a"] = ({
    speed: 450,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    slidesPerView: 'auto',
    spaceBetween: 0,
    allowTouchMove: false,
    breakpoints: (_breakpoints = {}, _defineProperty(_breakpoints, bp('xs'), {
        slidesPerGroup: productTileAmounts['xs'],
        freeMode: true
    }), _defineProperty(_breakpoints, bp('sm'), {
        slidesPerGroup: productTileAmounts['sm']
    }), _defineProperty(_breakpoints, bp('md'), {
        slidesPerGroup: productTileAmounts['md']
    }), _defineProperty(_breakpoints, bp('lg'), {
        slidesPerGroup: productTileAmounts['lg']
    }), _defineProperty(_breakpoints, bp('xl'), {
        slidesPerGroup: productTileAmounts['xl']
    }), _defineProperty(_breakpoints, 'max', { // anything else
        slidesPerGroup: productTileAmounts['xxl']
    }), _breakpoints)
});



/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_products_slider_header__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_misc_normalise_trailing_slash__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var EmptyCategorySlider = function (_Component) {
    _inherits(EmptyCategorySlider, _Component);

    function EmptyCategorySlider() {
        _classCallCheck(this, EmptyCategorySlider);

        return _possibleConstructorReturn(this, (EmptyCategorySlider.__proto__ || Object.getPrototypeOf(EmptyCategorySlider)).apply(this, arguments));
    }

    _createClass(EmptyCategorySlider, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                title = _props.title,
                link = _props.link,
                link_label_key = _props.link_label_key,
                icon_key = _props.icon_key,
                show_description = _props.show_description,
                header_link_label_key = _props.header_link_label_key;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                    className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('empty-category-slider', show_description ? null : 'empty-category-slider__loading') },
                title && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_products_slider_header__["a" /* default */], { title: title, link: link, link_label_key: header_link_label_key }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'empty-category-slider--content-wrapper' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'empty-category-slider--content' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_icon__["a" /* default */], { className: 'empty-category-slider--icon', symbol: icon_key, size: 'large' }),
                        show_description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            { className: 'u-reset empty-category-slider--description' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_translations__["a" /* Trans */], { path: 'mymigros.no_products_in_category' })
                        ),
                        show_description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_6_react_router_dom__["b" /* Link */],
                            {
                                className: 'empty-category-slider--link u-reset',
                                to: Object(__WEBPACK_IMPORTED_MODULE_5_util_misc_normalise_trailing_slash__["a" /* default */])(link)
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_translations__["a" /* Trans */], { path: link_label_key })
                        )
                    )
                )
            );
        }
    }]);

    return EmptyCategorySlider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

EmptyCategorySlider.propTypes = {
    icon_key: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    link: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    link_label_key: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    header_link_label_key: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    show_description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
EmptyCategorySlider.defaultProps = {
    show_description: true
};
/* harmony default export */ __webpack_exports__["a"] = (EmptyCategorySlider);

/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_migros_login_button__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_tooltip__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__header_tooltip__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_constants_menus__ = __webpack_require__(236);












function PreHeader(_ref) {
    var openModal = _ref.openModal,
        userRegion = _ref.userRegion,
        isAuthenticated = _ref.isAuthenticated,
        hasCumulus = _ref.hasCumulus,
        isModalOpen = _ref.isModalOpen;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'pre-header' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'grid--container pre-header--container grid--container__fluid' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'grid--row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    {
                        'aria-haspopup': 'true',
                        'aria-expanded': isModalOpen,
                        'aria-label': userRegion ? Object(__WEBPACK_IMPORTED_MODULE_6_translations__["f" /* t */])('accessibility.label.update_zip') : Object(__WEBPACK_IMPORTED_MODULE_6_translations__["f" /* t */])('zip.form.placeholder'),
                        className: 'pre-header--location grid--col',
                        onClick: function onClick() {
                            return openModal({
                                layout: 'zip-form'
                            });
                        } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'pre-header--link' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_icon__["a" /* default */], { className: 'pre-header--icon', symbol: 'location', size: 'medium' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            userRegion ? userRegion.zip : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_translations__["a" /* Trans */], { path: 'zip.header.link' })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'nav',
                    { className: 'pre-header--menu grid--col' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'ul',
                        { className: 'pre-header--list u-reset grid--row' },
                        Object(__WEBPACK_IMPORTED_MODULE_10_constants_menus__["d" /* preHeader */])({
                            isAuthenticated: isAuthenticated,
                            hasCumulus: hasCumulus
                        }).map(function (link, i) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'li',
                                { className: 'pre-header--item', key: i },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],
                                    { exact: true, activeClassName: 'pre-header--link__is-active',
                                        className: 'pre-header--link u-reset',
                                        to: link.url },
                                    link.title
                                )
                            );
                        }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'li',
                            { className: 'pre-header--item' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_8_components_tooltip__["a" /* default */],
                                { facet: 'header-tooltip', interactionType: 'click', content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__header_tooltip__["a" /* default */], null) },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'pre-header--tooltip pre-header--link' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_translations__["a" /* Trans */], { path: 'menus.help' }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_icon__["a" /* default */], { className: 'pre-header--icon', symbol: 'chevron-down', size: 'small' })
                                )
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'grid--col' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_migros_login_button__["a" /* default */], null)
                )
            )
        )
    );
}

PreHeader.propTypes = {
    userRegion: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
    openModal: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    isAuthenticated: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
    isModalOpen: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
    hasCumulus: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
    pathname: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired // this prop is needed to let this component update :(
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_4_util_redux__["b" /* default */].mapStateToProps({
    isAuthenticated: 'user.isAuthenticated',
    hasCumulus: 'user.cumulus_connected',
    isModalOpen: 'modal.isVisible',
    userRegion: 'region.active',
    pathname: 'router.location.pathname'
}), __WEBPACK_IMPORTED_MODULE_4_util_redux__["b" /* default */].mapDispatchToProps({
    openModal: 'modal.open'
}))(PreHeader));

/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_page_names__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_button__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_contact_info__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_constants_menus__ = __webpack_require__(236);













function HeaderTooltip(_ref) {
    var routerRegistry = _ref.routerRegistry;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'aside',
        { className: 'header-tooltip' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            { className: 'header-tooltip--title u-reset' },
            routerRegistry.get(__WEBPACK_IMPORTED_MODULE_6_constants_page_names__["FAQ"]).title
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_components_button__["a" /* default */],
            { tag: 'a', to: routerRegistry.get(__WEBPACK_IMPORTED_MODULE_6_constants_page_names__["FAQ"]).url, className: 'header-tooltip--button', facet: 'primary', size: 'small' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_translations__["a" /* Trans */], { path: 'header.tooltip.questions.button' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_contact_info__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { className: 'header-tooltip--menu u-reset' },
            Object(__WEBPACK_IMPORTED_MODULE_1_looppa__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_10_constants_menus__["b" /* headerTooltip */])())(function (item, i) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'li',
                    { className: 'header-tooltip--menu-item', key: i },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],
                        { className: 'header-tooltip--menu-link u-reset', to: item.url },
                        item.title
                    )
                );
            })
        )
    );
}

HeaderTooltip.propTypes = {
    routerRegistry: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_5_util_redux__["b" /* default */].mapStateToProps({
    routerRegistry: 'router.registry'
}))(HeaderTooltip));

/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_misc_overlay_tracker__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_form_form_field_input__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__search_panel__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__search_panel_mobile__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_aria_51__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_util_dom_prevent_default__ = __webpack_require__(306);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var Search = function (_PureComponent) {
    _inherits(Search, _PureComponent);

    function Search(props) {
        _classCallCheck(this, Search);

        var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props));

        _this.onClearAction = function () {
            _this.props.reset();
            _this.setState({ term: '' });
        };

        _this.onFocus = function () {
            _this.activateSearch();
        };

        _this.onBlur = function () {
            if (!_this.state.term) {
                _this.deactivateSearch();
            }
        };

        _this.onSubmit = function (e) {
            Object(__WEBPACK_IMPORTED_MODULE_12_util_dom_prevent_default__["a" /* default */])(e);
            var search = _this.props.search;
            var term = _this.state.term;


            _this.props.setFuzzy({ isFuzzy: false });
            search({ term: term, isEnterPressed: true });
        };

        _this.onInput = function (value) {
            if (!_this.props.isActive) {
                _this.activateSearch();
            }

            _this.props.setFuzzy({ isFuzzy: true });

            if (value !== _this.state.term) {
                _this.props.setOffset({ offset: 0 });
            }

            var term = value;
            _this.setState({ term: term });
            var _this$props = _this.props,
                reset = _this$props.reset,
                setLimit = _this$props.setLimit,
                search = _this$props.search;

            // if user clears input with backspace action, clear results

            if (term.length <= 0) {
                reset();
            } else {
                setLimit({ limit: 20 });
                search({ term: term });
            }

            _this.props.persistTerm({ term: term });
        };

        _this.activateSearch = function () {
            Object(__WEBPACK_IMPORTED_MODULE_2_util_misc_overlay_tracker__["a" /* subscribe */])(_this, _this.closePanel);
            _this.props.openSearch();
            _this.props.lockScroll();
        };

        _this.deactivateSearch = function () {
            var _this$props2 = _this.props,
                closeSearch = _this$props2.closeSearch,
                unlockScroll = _this$props2.unlockScroll,
                reset = _this$props2.reset;

            closeSearch();
            unlockScroll();
            reset();
            _this.setState({ term: '' });
            _this.props.persistTerm({ term: '' });
        };

        _this.closePanel = function () {
            Object(__WEBPACK_IMPORTED_MODULE_2_util_misc_overlay_tracker__["b" /* unsubscribe */])(_this);
            _this.props.closeSearch();
            _this.props.unlockScroll();
            _this.setState({ term: '' });
            _this.blurElement();
        };

        _this.state = {
            term: props.term
        };
        return _this;
    }

    /*
    * LifeCycle
    */


    _createClass(Search, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var isScrollLocked = _ref.isScrollLocked,
                isActive = _ref.isActive,
                commonCategories = _ref.commonCategories,
                activeRegion = _ref.activeRegion,
                term = _ref.term;

            this.setState({ term: term });

            if (this.props.isScrollLocked && !isScrollLocked) {
                this.deactivateSearch();
            }

            if (isActive && !this.state.hasTerm && !commonCategories.length || this.props.activeRegion && activeRegion.cooperative !== this.props.activeRegion.cooperative) {
                this.props.populateCommonCategories();
            }
        }
    }, {
        key: 'blurElement',
        value: function blurElement() {
            var el = document.activeElement;

            if (el) {
                el.blur();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                isActive = _props.isActive,
                isMobile = _props.isMobile;
            var _state = this.state,
                term = _state.term,
                hasTerm = _state.hasTerm;

            if (isMobile) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8_components_aria_51__["a" /* default */],
                    { isActive: isActive, className: 'main-header--search-button-container' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { className: 'main-header--search-button', onClick: function onClick() {
                                return _this2.activateSearch();
                            } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_icon__["a" /* default */], { size: 'medium', symbol: 'search' })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__search_panel_mobile__["a" /* default */], { isActive: isActive && isMobile })
                );
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_components_aria_51__["a" /* default */],
                {
                    isActive: isActive,
                    className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('search', {
                        'search__is-active': isActive
                    })
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'form',
                    { role: 'search', onSubmit: this.onSubmit },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_form_form_field_input__["a" /* default */], {
                        'aria-label': Object(__WEBPACK_IMPORTED_MODULE_11_translations__["f" /* t */])('search.search'),
                        placeholder: Object(__WEBPACK_IMPORTED_MODULE_11_translations__["f" /* t */])('search.placeholder'),
                        actionLabel: Object(__WEBPACK_IMPORTED_MODULE_11_translations__["f" /* t */])('search.search'),
                        hasClearAction: this.onClearAction,
                        className: 'main-header--search-field',
                        type: 'search',
                        value: term,
                        onInput: this.onInput,
                        onFocus: this.onFocus,
                        icon: { size: 'medium', symbol: 'search' },
                        variant: 'search'
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'search--results' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__search_panel__["a" /* default */], { hasTerm: hasTerm })
                )
            );
        }
    }]);

    return Search;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Search.propTypes = {
    closeSearch: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
    isActive: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
    isMobile: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
    isScrollLocked: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
    lockScroll: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
    openSearch: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
    populateCommonCategories: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
    reset: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
    activeRegion: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
    search: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
    commonCategories: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array.isRequired,
    setLimit: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
    setOffset: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
    unlockScroll: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
    setFuzzy: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
    persistTerm: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
    term: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_10_util_redux__["b" /* default */].mapStateToProps({
    isActive: 'search.isActive',
    isMobile: 'viewport.isMobile',
    isScrollLocked: 'scroll.isLocked',
    activeRegion: 'region.active',
    commonCategories: 'search.commonCategories',
    rotationPersistedTerm: 'search.rotationPersistedTerm',
    term: 'search.term'
}), __WEBPACK_IMPORTED_MODULE_10_util_redux__["b" /* default */].mapDispatchToProps({
    closeSearch: 'search.close',
    lockScroll: 'scroll.lock',
    openSearch: 'search.open',
    populateCommonCategories: 'search.populateCommonCategories',
    reset: 'search.reset',
    search: 'search.query',
    setLimit: 'search.setLimit',
    setOffset: 'search.setOffset',
    setFuzzy: 'search.setFuzzy',
    unlockScroll: 'scroll.unlock',
    persistTerm: 'search.persistTerm'
}))(Search));

/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__search_panel_product_list__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__search_panel_favorite_product_list__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__search_panel_category_list__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__search_panel_header__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_action_teaser__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_migros_login_button__ = __webpack_require__(270);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var SearchPanel = function (_PureComponent) {
    _inherits(SearchPanel, _PureComponent);

    function SearchPanel() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SearchPanel);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchPanel.__proto__ || Object.getPrototypeOf(SearchPanel)).call.apply(_ref, [this].concat(args))), _this), _this.closeSearch = function () {
            _this.props.closeSearch();
            _this.props.unlockScroll();
        }, _this.hasInput = function () {
            return _this.props.term ? _this.props.term.length > 0 : false;
        }, _this.renderCategoryBlock = function () {
            var _this$props = _this.props,
                commonCategoriesTotal = _this$props.commonCategoriesTotal,
                categoriesTotal = _this$props.categoriesTotal;

            var title = Object(__WEBPACK_IMPORTED_MODULE_5_translations__["f" /* t */])('search.common_categories_title') + ' ' + (commonCategoriesTotal > 0 ? '(' + commonCategoriesTotal + ')' : '');
            if (_this.hasInput()) {
                title = Object(__WEBPACK_IMPORTED_MODULE_5_translations__["f" /* t */])('search.query_result_categories_title') + ' ' + (categoriesTotal > 0 ? '(' + categoriesTotal + ')' : '');
            }
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'search-panel--categories' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__search_panel_header__["a" /* default */], { title: title }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__search_panel_category_list__["a" /* default */], null)
            );
        }, _this.renderProductBlock = function () {
            var _this$props2 = _this.props,
                isAuthenticated = _this$props2.isAuthenticated,
                hasCumulus = _this$props2.hasCumulus,
                endpoints = _this$props2.endpoints;


            if (!_this.hasInput()) {
                if (!isAuthenticated) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'mymigros-sliders' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_11_components_action_teaser__["a" /* default */],
                            {
                                imagePath: 'img/login-teaser/img_rabbit.svg',
                                titleTranslationKey: 'mymigros.login_title',
                                descriptionTranslationKey: 'mymigros.login_body'
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_migros_login_button__["a" /* default */], {
                                inline: true,
                                big: true,
                                facet: 'inline-block' })
                        )
                    );
                }

                if (isAuthenticated && !hasCumulus) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_11_components_action_teaser__["a" /* default */],
                        {
                            imagePath: 'img/cumulus-teaser/img_happy_products.svg',
                            titleTranslationKey: 'mymigros.cumulus_connect_title',
                            descriptionTranslationKey: 'mymigros.cumulus_connect_body'
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'a',
                            { className: 'btn btn__primary btn__teaser',
                                href: endpoints.userConnectCumulus() },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_translations__["a" /* Trans */], { path: 'mymigros.cumulus_connect_action' })
                        )
                    );
                }

                if (isAuthenticated && hasCumulus) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'search-panel--products', ref: 'productList' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__search_panel_favorite_product_list__["a" /* default */], null)
                    );
                }
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'search-panel--products', ref: 'productList', onClick: function onClick(e) {
                        return e.stopPropagation();
                    } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__search_panel_product_list__["a" /* default */], null)
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SearchPanel, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref2) {
            var term = _ref2.term;

            if (term === this.props.term) {
                return;
            }
            if (this.refs.resultList) {
                this.refs.resultList.scrollTop = 0;
            }
        }

        /*
        * Helpers
        */

        /*
        * Conditional Rendering
        */

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var isMobile = this.props.isMobile;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'aside',
                { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('search-panel', { 'search-panel__mobile': isMobile }) },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'search-panel--background_dismiss', onClick: function onClick() {
                        return _this2.closeSearch();
                    } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'search-panel--container' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { 'aria-label': Object(__WEBPACK_IMPORTED_MODULE_5_translations__["f" /* t */])('accessibility.label.close_search'),
                            className: 'search-panel--close-action',
                            onClick: function onClick() {
                                return _this2.closeSearch();
                            } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_icon__["a" /* default */], { symbol: 'cancel', size: 'medium' })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'search-panel--results', ref: 'resultList' },
                        this.renderCategoryBlock(),
                        this.renderProductBlock()
                    )
                )
            );
        }
    }]);

    return SearchPanel;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

SearchPanel.propTypes = {
    categoriesTotal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    commonCategoriesTotal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    closeSearch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    hasCumulus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    isAuthenticated: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    isLoadingMore: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    isMobile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    isSearching: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    productsTotal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    scrollbarWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    term: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    unlockScroll: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    endpoints: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_4_util_redux__["b" /* default */].mapStateToProps({
    categoriesTotal: 'search.categoriesTotal',
    commonCategoriesTotal: 'search.commonCategoriesTotal',
    favoriteProductsTotal: 'user.favoriteProductsTotal',
    hasCumulus: 'user.cumulus_connected',
    isActive: 'search.isActive',
    isAuthenticated: 'user.isAuthenticated',
    isLoadingMore: 'search.isLoadingMore',
    isMobile: 'viewport.isMobile',
    isSearching: 'search.isSearching',
    productsTotal: 'search.productsTotal',
    scrollbarWidth: 'scroll.scrollbarWidth',
    term: 'search.term',
    endpoints: 'router.endpoints'
}), __WEBPACK_IMPORTED_MODULE_4_util_redux__["b" /* default */].mapDispatchToProps({
    closeSearch: 'search.close',
    unlockScroll: 'scroll.unlock'
}))(SearchPanel));

/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_form_form_field_input__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__search_panel_product_list__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__search_panel_favorite_product_list__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__search_panel_category_list__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__search_panel_header__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_bianco_events__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_util_dom_handle_accessible_key_events__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_action_teaser__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_migros_login_button__ = __webpack_require__(270);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var SearchPanelMobile = function (_PureComponent) {
    _inherits(SearchPanelMobile, _PureComponent);

    function SearchPanelMobile(props) {
        _classCallCheck(this, SearchPanelMobile);

        var _this = _possibleConstructorReturn(this, (SearchPanelMobile.__proto__ || Object.getPrototypeOf(SearchPanelMobile)).call(this, props));

        _this.onClearAction = function () {
            _this.props.reset();
        };

        _this.onInput = function (value) {
            var term = value;
            _this.props.setLimit({ limit: 16 });
            _this.setState({ term: term });
            _this.props.search({ term: term });
            _this.props.persistTerm({ term: term });
            _this.refs.results.scrollTop = 0;
        };

        _this.onKeyPress = function (e) {
            var isEnterPressed = Object(__WEBPACK_IMPORTED_MODULE_13_util_dom_handle_accessible_key_events__["b" /* enter */])(e);
            _this.props.setFuzzy({ isFuzzy: !isEnterPressed });

            if (isEnterPressed) {
                var search = _this.props.search;
                var term = _this.state.term;

                search({ term: term });
            }
        };

        _this.onScroll = function () {
            var el = document.activeElement;
            if (el.tagName === 'INPUT') {
                el.blur();
            }
        };

        _this.onSearchPanelClick = function () {
            _this.setState({ term: '' });
            _this.props.persistTerm({ term: '' });
        };

        _this.closePanel = function () {
            _this.props.closeSearch();
            _this.props.unlockScroll();
            _this.setState({ term: '' });
            _this.props.persistTerm({ term: '' });
        };

        _this.hasInput = function () {
            return _this.state.term.length > 0;
        };

        _this.hasResults = function () {
            var _this$props = _this.props,
                productsTotal = _this$props.productsTotal,
                favoriteProductsTotal = _this$props.favoriteProductsTotal;

            return productsTotal > 0 || favoriteProductsTotal > 0;
        };

        _this.renderCategoryBlock = function () {
            var _this$props2 = _this.props,
                commonCategoriesTotal = _this$props2.commonCategoriesTotal,
                categoriesTotal = _this$props2.categoriesTotal;

            var title = Object(__WEBPACK_IMPORTED_MODULE_7_translations__["f" /* t */])('search.common_categories_title') + ' ' + (commonCategoriesTotal > 0 ? '(' + commonCategoriesTotal + ')' : '');

            if (_this.hasInput()) {
                title = Object(__WEBPACK_IMPORTED_MODULE_7_translations__["f" /* t */])('search.query_result_categories_title') + ' ' + (categoriesTotal > 0 ? '(' + categoriesTotal + ')' : '');
            }
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'search-panel-mobile--categories' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__search_panel_header__["a" /* default */], { title: title }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__search_panel_category_list__["a" /* default */], null)
            );
        };

        _this.renderProductBlock = function () {
            var _this$props3 = _this.props,
                isAuthenticated = _this$props3.isAuthenticated,
                hasCumulus = _this$props3.hasCumulus,
                endpoints = _this$props3.endpoints;


            if (!_this.hasInput()) {
                if (!isAuthenticated) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'search-panel-mobile--action-teaser-wrapper' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_14_components_action_teaser__["a" /* default */],
                            {
                                imagePath: 'img/login-teaser/img_rabbit.svg',
                                titleTranslationKey: 'mymigros.login_title',
                                descriptionTranslationKey: 'mymigros.login_body'
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_migros_login_button__["a" /* default */], {
                                inline: true,
                                big: true,
                                facet: 'inline-block' })
                        )
                    );
                }

                if (isAuthenticated && !hasCumulus) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'search-panel-mobile--action-teaser-wrapper' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_14_components_action_teaser__["a" /* default */],
                            {
                                imagePath: 'img/cumulus-teaser/img_happy_products.svg',
                                titleTranslationKey: 'mymigros.cumulus_connect_title',
                                descriptionTranslationKey: 'mymigros.cumulus_connect_body'
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'a',
                                { className: 'btn btn__primary btn__teaser',
                                    href: endpoints.userConnectCumulus() },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_translations__["a" /* Trans */], { path: 'mymigros.cumulus_connect_action' })
                            )
                        )
                    );
                }

                if (isAuthenticated && hasCumulus) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'search-panel-mobile--products' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__search_panel_favorite_product_list__["a" /* default */], null)
                    );
                }
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'search-panel-mobile--products' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__search_panel_product_list__["a" /* default */], null)
            );
        };

        _this.state = {
            term: props.term
        };
        return _this;
    }

    _createClass(SearchPanelMobile, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            Object(__WEBPACK_IMPORTED_MODULE_12_bianco_events__["a" /* add */])(document.body, 'touchmove', this.onScroll, { passive: true });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            Object(__WEBPACK_IMPORTED_MODULE_12_bianco_events__["b" /* remove */])(document.body, 'touchmove');
        }

        /*
        * Event Handling
        */

        /*
        * Helpers
        */

        /*
        * Conditional Rendering
        */

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var term = this.state.term;
            var isActive = this.props.isActive;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('search-panel-mobile', {
                        'search-panel-mobile__is-active': isActive,
                        'search-panel-mobile__is-inactive': !isActive,
                        'search-panel-mobile__has-results': this.hasResults()
                    })
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'search-panel-mobile--header' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'search-panel-mobile--back' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'button',
                            { className: 'search-panel-mobile--back-button', onClick: this.closePanel },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_icon__["a" /* default */], { symbol: 'arrow-back', size: 'medium' })
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'search-panel-mobile--input' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_form_form_field_input__["a" /* default */], {
                            hasClearAction: this.onClearAction,
                            placeholder: Object(__WEBPACK_IMPORTED_MODULE_7_translations__["f" /* t */])('search.placeholder'),
                            className: 'search-panel-mobile--search-field',
                            type: 'search',
                            value: term,
                            onInput: this.onInput,
                            onKeyPress: this.onKeyPress
                            // onFocus={this.onFocus}
                            // onBlur={this.onBlur}
                            , variant: 'search-mobile'
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'search-panel-mobile--results', ref: 'results' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { onClick: function onClick(e) {
                                return _this2.onSearchPanelClick(e);
                            } },
                        this.renderCategoryBlock()
                    ),
                    this.renderProductBlock()
                )
            );
        }
    }]);

    return SearchPanelMobile;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

SearchPanelMobile.propTypes = {
    categoriesTotal: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
    closeSearch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    commonCategoriesTotal: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
    favoriteProductsTotal: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
    hasCumulus: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
    isActive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
    isAuthenticated: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
    isSearching: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,
    productsTotal: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
    reset: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    scrollbarWidth: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
    search: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    setLimit: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    unlockScroll: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    setFuzzy: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    persistTerm: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    term: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
    endpoints: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired

};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_6_util_redux__["b" /* default */].mapStateToProps({
    categoriesTotal: 'search.categoriesTotal',
    commonCategoriesTotal: 'search.commonCategoriesTotal',
    favoriteProductsTotal: 'user.favoriteProductsTotal',
    hasCumulus: 'user.cumulus_connected',
    isAuthenticated: 'user.isAuthenticated',
    isMobile: 'viewport.isMobile',
    isScrollLocked: 'scroll.isLocked',
    isSearching: 'search.isSearching',
    productsTotal: 'search.productsTotal',
    scrollbarWidth: 'scroll.scrollbarWidth',
    rotationPersistedTerm: 'search.rotationPersistedTerm',
    term: 'search.term',
    endpoints: 'router.endpoints'
}), __WEBPACK_IMPORTED_MODULE_6_util_redux__["b" /* default */].mapDispatchToProps({
    closeSearch: 'search.close',
    lockScroll: 'scroll.lock',
    openSearch: 'search.open',
    reset: 'search.reset',
    search: 'search.query',
    setLimit: 'search.setLimit',
    unlockScroll: 'scroll.unlock',
    setFuzzy: 'search.setFuzzy',
    persistTerm: 'search.persistTerm'
}))(SearchPanelMobile));

/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_menus__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_aria_51__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_migros_login_button__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_contact_info__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_payment_platforms__ = __webpack_require__(602);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var SidePanelNav = function (_PureComponent) {
    _inherits(SidePanelNav, _PureComponent);

    function SidePanelNav() {
        _classCallCheck(this, SidePanelNav);

        return _possibleConstructorReturn(this, (SidePanelNav.__proto__ || Object.getPrototypeOf(SidePanelNav)).apply(this, arguments));
    }

    _createClass(SidePanelNav, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                isAuthenticated = _props.isAuthenticated,
                openModal = _props.openModal,
                userRegion = _props.userRegion,
                currentRouteName = _props.currentRouteName,
                hasCumulus = _props.hasCumulus,
                login = _props.login,
                logout = _props.logout,
                isModalOpen = _props.isModalOpen;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_components_aria_51__["a" /* default */],
                { className: 'side-panel-nav' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'nav',
                    { className: 'side-panel-nav--nav' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'ul',
                        { className: 'side-panel-nav--list u-reset' },
                        Object(__WEBPACK_IMPORTED_MODULE_1_looppa__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6_constants_menus__["f" /* side */])({ currentRouteName: currentRouteName, isAuthenticated: isAuthenticated, hasCumulus: hasCumulus }))(function (item, i) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'li',
                                { key: i, className: 'side-panel-nav--item' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* NavLink */],
                                    {
                                        exact: true,
                                        activeClassName: 'side-panel-nav--link__is-active',
                                        className: 'side-panel-nav--link u-reset',
                                        to: item.url
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_translations__["a" /* Trans */], { path: item.title })
                                )
                            );
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'side-panel-nav--user-status' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'ul',
                        { className: 'side-panel-nav--list u-reset' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'li',
                            {
                                className: 'side-panel-nav--item side-panel-nav--item__highlighted',
                                onClick: function onClick() {
                                    return openModal({
                                        layout: 'zip-form'
                                    });
                                }
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_icon__["a" /* default */], { className: 'side-panel-nav--list-icon', size: 'medium', symbol: 'location' }),
                            userRegion ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_translations__["a" /* Trans */], { path: 'user.my_zip_code' }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_translations__["a" /* Trans */], { className: 'side-panel-nav--zip-link', path: 'zip.header.link' }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'button',
                                {
                                    'aria-haspopup': 'true',
                                    'aria-expanded': isModalOpen,
                                    'aria-label': userRegion ? Object(__WEBPACK_IMPORTED_MODULE_7_translations__["c" /* default */])('accessibility.label.update_zip') : Object(__WEBPACK_IMPORTED_MODULE_7_translations__["c" /* default */])('zip.form.placeholder'),
                                    className: 'side-panel-nav--list-action' },
                                userRegion ? userRegion.zip : null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_icon__["a" /* default */], { size: 'medium', className: 'side-panel-nav--action-icon', symbol: 'pen' })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'li',
                            { className: 'side-panel-nav--item side-panel-nav--item__highlighted side-panel-nav--item__migros-login',
                                onClick: function onClick() {
                                    return isAuthenticated ? logout() : login();
                                } },
                            !isAuthenticated && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_icon__["a" /* default */], { className: 'side-panel-nav--list-icon', size: 'medium', symbol: 'profil' }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_migros_login_button__["a" /* default */], { facet: 'side-panel-nav' })
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'nav',
                    { className: 'side-panel-nav--nav' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'ul',
                        { className: 'side-panel-nav--list u-reset' },
                        Object(__WEBPACK_IMPORTED_MODULE_1_looppa__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6_constants_menus__["a" /* contentPages */])())(function (item, i) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'li',
                                { key: i, className: 'side-panel-nav--item' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* NavLink */],
                                    {
                                        exact: true,
                                        activeClassName: 'side-panel-nav--link__is-active',
                                        className: 'side-panel-nav--link u-reset',
                                        to: item.url
                                    },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_translations__["a" /* Trans */], { path: item.title })
                                )
                            );
                        })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'side-panel-nav--section' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_contact_info__["a" /* default */], null)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'side-panel-nav--section' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_payment_platforms__["a" /* default */], null)
                )
            );
        }
    }]);

    return SidePanelNav;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

SidePanelNav.propTypes = {
    openModal: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
    isAuthenticated: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
    userRegion: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
    currentRouteName: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    isModalOpen: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
    hasCumulus: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,
    login: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,
    logout: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_5_util_redux__["b" /* default */].mapStateToProps({
    userRegion: 'region.active',
    isModalOpen: 'modal.isVisible',
    isAuthenticated: 'user.isAuthenticated',
    hasCumulus: 'user.cumulus_connected',
    currentRouteName: 'router.name'
}), __WEBPACK_IMPORTED_MODULE_5_util_redux__["b" /* default */].mapDispatchToProps({
    openModal: 'modal.open',
    login: 'user.login',
    logout: 'user.logout'
}))(SidePanelNav));

/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var DELAY = 200;

var PageLoaderBar = function (_PureComponent) {
    _inherits(PageLoaderBar, _PureComponent);

    function PageLoaderBar() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PageLoaderBar);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PageLoaderBar.__proto__ || Object.getPrototypeOf(PageLoaderBar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            showLoader: false
        }, _this.delayToggleLoader = __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function (showLoader) {
            this.setState({
                showLoader: showLoader
            });
        }, DELAY), _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PageLoaderBar, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref2) {
            var isActive = _ref2.isActive;

            if (isActive === false) {
                this.delayToggleLoader(isActive);
            } else {
                this.cleanupTimers();
                this.setState({ showLoader: isActive });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.cleanupTimers();
        }
    }, {
        key: 'cleanupTimers',
        value: function cleanupTimers() {
            this.delayToggleLoader.cancel();
        }
    }, {
        key: 'render',
        value: function render() {
            var showLoader = this.state.showLoader;


            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('page-loader-bar-container', {
                        'page-loader-bar-container__is-active': showLoader
                    }) },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'page-loader-bar' })
            );
        }
    }]);

    return PageLoaderBar;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

PageLoaderBar.propTypes = {
    isActive: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};
PageLoaderBar.defaultProps = {
    isActive: false
};


/* harmony default export */ __webpack_exports__["a"] = (PageLoaderBar);

/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_icon__ = __webpack_require__(177);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var OfflineNotification = function (_PureComponent) {
    _inherits(OfflineNotification, _PureComponent);

    function OfflineNotification() {
        _classCallCheck(this, OfflineNotification);

        return _possibleConstructorReturn(this, (OfflineNotification.__proto__ || Object.getPrototypeOf(OfflineNotification)).apply(this, arguments));
    }

    _createClass(OfflineNotification, [{
        key: 'render',
        value: function render() {
            var isOnline = this.props.isOnline;


            if (isOnline) {
                return null;
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'offline-notification grid' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'offline-notification--container grid--container offline-notification__fluid' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'browser-support--inner' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'offline-notification--content' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_icon__["a" /* default */], { size: 'medium', className: 'offline-notification--icon', symbol: 'alert-small' }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'browser-support--message' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_translations__["a" /* Trans */], { path: 'error.is_offline' })
                            )
                        )
                    )
                )
            );
        }
    }]);

    return OfflineNotification;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

OfflineNotification.propTypes = {
    isOnline: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_2__util_redux__["b" /* default */].mapStateToProps({
    isOnline: 'navigator.isOnline'
}))(OfflineNotification));

/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_flip_move__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_transitions_props__ = __webpack_require__(241);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var ANIMATION_OFFSET = -50;

var CategoryNavigationButton = function (_Component) {
    _inherits(CategoryNavigationButton, _Component);

    function CategoryNavigationButton() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, CategoryNavigationButton);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CategoryNavigationButton.__proto__ || Object.getPrototypeOf(CategoryNavigationButton)).call.apply(_ref, [this].concat(args))), _this), _this.onToggleClicked = function () {
            var _this$props = _this.props,
                setCategoriesVisibility = _this$props.setCategoriesVisibility,
                isCategorylistVisible = _this$props.isCategorylistVisible;

            setCategoriesVisibility({ isVisible: !isCategorylistVisible });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CategoryNavigationButton, [{
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps) {
            var oldIsCategorylistVisible = this.props.isCategorylistVisible;
            var isCategorylistVisible = nextProps.isCategorylistVisible;


            if (oldIsCategorylistVisible !== isCategorylistVisible && isCategorylistVisible) {
                //window.scrollTo(0, 0);
                window.scroll({ top: 0, left: 0, behavior: 'smooth' });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                breadcrumbs = _props.breadcrumbs,
                isCategorylistVisible = _props.isCategorylistVisible;

            var symbolName = isCategorylistVisible ? 'basket-remove' : 'basket-add';
            var translationPath = 'category_menu.toggle.' + (isCategorylistVisible ? 'close' : 'open');

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_flip_move__["a" /* default */],
                {
                    duration: __WEBPACK_IMPORTED_MODULE_7_constants_transitions_props__["e" /* breadcrumbsSpeed */],
                    easing: __WEBPACK_IMPORTED_MODULE_7_constants_transitions_props__["d" /* breadcrumbsEasingFn */],
                    appearAnimation: this.animations.in,
                    enterAnimation: this.animations.in,
                    leaveAnimation: this.animations.out,
                    className: 'category-navigation-button'
                },
                breadcrumbs.length === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { className: 'category-navigation-button--btn', onClick: this.onToggleClicked },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_translations__["a" /* Trans */], { path: translationPath }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_icon__["a" /* default */], { className: 'category-navigation-button--symbol', symbol: symbolName, size: 'small' })
                )
            );
        }
    }, {
        key: 'animations',
        get: function get() {
            var defaultState = {
                transform: 'translateY(0px)',
                opacity: ''
            };

            return {
                in: {
                    from: {
                        transform: 'translateY(' + ANIMATION_OFFSET + 'px)'
                    },
                    to: _extends({}, defaultState)
                },

                out: {
                    from: _extends({}, defaultState),
                    to: {
                        transform: 'translateY(' + ANIMATION_OFFSET + 'px)'
                    }
                }
            };
        }
    }]);

    return CategoryNavigationButton;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

CategoryNavigationButton.propTypes = {
    isCategorylistVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,
    setCategoriesVisibility: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
    breadcrumbs: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_4_util_redux__["b" /* default */].mapStateToProps({
    isCategorylistVisible: 'categories.isCategorylistVisible',
    breadcrumbs: 'breadcrumbs.items',
    isMobile: 'viewport.isMobile'
}), __WEBPACK_IMPORTED_MODULE_4_util_redux__["b" /* default */].mapDispatchToProps({
    setCategoriesVisibility: 'categories.setCategoriesVisibility'
}))(CategoryNavigationButton));

/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ContentOverlay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);




function ContentOverlay(_ref) {
    var isVisible = _ref.isVisible,
        facet = _ref.facet;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { 'aria-hidden': 'true', className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('content-overlay', 'content-overlay__' + facet, { 'content-overlay__active': isVisible }) });
}

ContentOverlay.propTypes = {
    facet: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    isVisible: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
};

/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HEIGHT_OFFSET */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_page_layout__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_page_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_page_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bianco_query__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_aria_51__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util_misc_overlay_tracker__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_util_dom_stop_propagation__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_util_dom_mq__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_constants_debounce_delays__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_loader__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__simple__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__product_detail__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__confirm__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__blank__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__alert__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__zip_form__ = __webpack_require__(1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__prelaunch__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__iframe__ = __webpack_require__(1207);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



























var layouts = {
    alert: __WEBPACK_IMPORTED_MODULE_20__alert__["a" /* default */],
    blank: __WEBPACK_IMPORTED_MODULE_19__blank__["a" /* default */],
    simple: __WEBPACK_IMPORTED_MODULE_16__simple__["a" /* default */],
    confirm: __WEBPACK_IMPORTED_MODULE_18__confirm__["a" /* default */],
    iframe: __WEBPACK_IMPORTED_MODULE_23__iframe__["a" /* default */],
    'product-detail': __WEBPACK_IMPORTED_MODULE_17__product_detail__["a" /* default */],
    'zip-form': __WEBPACK_IMPORTED_MODULE_21__zip_form__["a" /* default */],
    prelaunch: __WEBPACK_IMPORTED_MODULE_22__prelaunch__["a" /* default */]
};

var HEIGHT_OFFSET = 88;

var Modal = function (_PureComponent) {
    _inherits(Modal, _PureComponent);

    function Modal() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Modal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isSticky: false,
            isLoaderVisible: true
        }, _this.updateHeight = function () {
            // unfortunately we can't use refs in sub-templates so we query the DOM elements here
            var scroller = Object(__WEBPACK_IMPORTED_MODULE_8_bianco_query__["a" /* default */])('.modal--scroller', _this.root)[0];
            var modalContent = Object(__WEBPACK_IMPORTED_MODULE_8_bianco_query__["a" /* default */])('.modal--content', _this.refs.wrapper)[0];
            var offset = _this.isMobile ? 0 : HEIGHT_OFFSET;
            var newHeight = _this.props.viewportHeight - offset;

            if (!scroller || !modalContent) {
                return;
            }

            var contentHeight = modalContent.offsetHeight;
            var isSticky = contentHeight > _this.props.viewportHeight - offset;

            _this.refs.wrapper.style.height = (isSticky && contentHeight > newHeight ? newHeight : contentHeight) + 'px';

            if (_this.state.isSticky !== isSticky) {
                _this.setState({ isSticky: isSticky });
            }
        }, _this.updateHeightDebounced = __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function () {
            this.updateHeight();
        }, __WEBPACK_IMPORTED_MODULE_14_constants_debounce_delays__["d" /* MODAL_RESIZE_DEBOUNCE */]), _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Modal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            Object(__WEBPACK_IMPORTED_MODULE_10_util_misc_overlay_tracker__["a" /* subscribe */])(this, this.props.closeModal);
            this.updateHeight();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.isModalReady && !this.props.isModalReady) {
                this.updateHeightDebounced();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.updateHeightDebounced();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            Object(__WEBPACK_IMPORTED_MODULE_10_util_misc_overlay_tracker__["b" /* unsubscribe */])(this);
            this.updateHeightDebounced.cancel();
        }
    }, {
        key: 'getModalRoleAttributeBy',
        value: function getModalRoleAttributeBy(layout) {
            switch (layout) {
                case 'confirm':
                case 'alert':
                    return 'alertdialog';
                case 'product-detail':
                case 'zip-form':
                    return 'document';
                default:
                    return 'dialog';
            }
        }
    }, {
        key: 'renderCloseButton',
        value: function renderCloseButton() {
            var _props = this.props,
                layout = _props.layout,
                closeModal = _props.closeModal,
                scrollbarWidth = _props.scrollbarWidth;
            var isSticky = this.state.isSticky;


            if (layout === 'iframe') {
                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'modal__iframe--header' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'button',
                        { className: 'modal--close-button',
                            role: 'button',
                            style: { marginRight: isSticky ? scrollbarWidth : null },
                            onClick: closeModal,
                            'aria-label': Object(__WEBPACK_IMPORTED_MODULE_7_translations__["c" /* default */])('accessibility.label.close_iframe_modal') },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_icon__["a" /* default */], { className: 'modal--close-button-icon', symbol: 'arrow-back', size: 'medium' }),
                        Object(__WEBPACK_IMPORTED_MODULE_7_translations__["c" /* default */])('modal.label.close_iframe_modal')
                    )
                );
            }
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'modal--close-button',
                    role: 'button',
                    style: { marginRight: isSticky ? scrollbarWidth : null },
                    onClick: closeModal },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'button',
                    { 'aria-label': Object(__WEBPACK_IMPORTED_MODULE_7_translations__["c" /* default */])('accessibility.label.close_modal') },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_icon__["a" /* default */], { symbol: 'cancel', size: 'medium' })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                layout = _props2.layout,
                content = _props2.content,
                meta = _props2.meta,
                closeModal = _props2.closeModal,
                resetModal = _props2.resetModal,
                isPendingRemove = _props2.isPendingRemove,
                scrollbarWidth = _props2.scrollbarWidth,
                isModalReady = _props2.isModalReady;
            var _state = this.state,
                isSticky = _state.isSticky,
                isLoaderVisible = _state.isLoaderVisible;


            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_components_aria_51__["a" /* default */],
                {
                    getRoot: function getRoot(root) {
                        _this2.root = root;
                    },
                    onClick: closeModal,
                    tabIndex: 0,
                    'aria-modal': 'true',
                    role: this.getModalRoleAttributeBy(layout),
                    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('modal', 'modal__' + layout, {
                        'modal__is-closing': isPendingRemove,
                        'modal__is-sticky': isSticky,
                        'modal__is-ready': isModalReady
                    }) },
                isLoaderVisible && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { onTransitionEnd: function onTransitionEnd() {
                            return isModalReady && _this2.setState({ isLoaderVisible: false });
                        },
                        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('modal--loader', {
                            'modal--loader__is-visible': !isModalReady
                        }) },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_loader__["a" /* default */], null)
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { ref: 'wrapper',
                        className: 'modal--wrap',
                        onClick: __WEBPACK_IMPORTED_MODULE_11_util_dom_stop_propagation__["a" /* default */],
                        onAnimationEnd: function onAnimationEnd() {
                            return isPendingRemove && resetModal();
                        } },
                    this.renderCloseButton(),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_react_page_layout__["LayoutProvider"],
                        { layouts: layouts },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_react_page_layout__["Page"],
                            { isDesktop: this.isDesktop,
                                scrollbarWidth: scrollbarWidth,
                                updateHeight: this.updateHeight,
                                isSticky: this.state.isSticky,
                                layout: layout,
                                meta: meta,
                                content: content },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_3_react_page_layout__["Section"],
                                { slot: 'content' },
                                content
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: 'isDesktop',
        get: function get() {
            return this.props.viewportMqWidth > __WEBPACK_IMPORTED_MODULE_13_util_dom_mq__["d" /* numerals */].SM;
        }
    }, {
        key: 'isMobile',
        get: function get() {
            return this.props.viewportMqWidth < __WEBPACK_IMPORTED_MODULE_13_util_dom_mq__["d" /* numerals */].SM;
        }
    }, {
        key: 'isTablet',
        get: function get() {
            return this.props.viewportMqWidth === __WEBPACK_IMPORTED_MODULE_13_util_dom_mq__["d" /* numerals */].SM;
        }
    }]);

    return Modal;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

Modal.defaultProps = {
    layout: 'simple'
};
Modal.propTypes = {
    content: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    meta: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    isPanelOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    viewportMqWidth: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
    isPendingRemove: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    layout: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    viewportHeight: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
    closeModal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    resetModal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    isModalReady: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    scrollbarWidth: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_6_util_redux__["b" /* default */].mapStateToProps({
    viewportMqWidth: 'viewport.mq.width',
    isPanelOpen: 'panel.isOpen',
    viewportHeight: 'viewport.height',
    isPendingRemove: 'modal.isPendingRemove',
    isModalReady: 'modal.isReady',
    scrollbarWidth: 'scroll.scrollbarWidth'
}), __WEBPACK_IMPORTED_MODULE_6_util_redux__["b" /* default */].mapDispatchToProps({
    closeModal: 'modal.close',
    resetModal: 'modal.reset'
}))(Modal));

/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Simple;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_page_layout__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_page_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_page_layout__);



function Simple() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'modal--inner' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'modal--scroller' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'modal--content-wrapper' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'modal--grid grid grid__condensed' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'modal--container grid--container' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_page_layout__["Slot"], { component: 'section', className: 'modal--content', name: 'content' })
                    )
                )
            )
        )
    );
}

/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_debounce_delays__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tracking__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_product_details_panel__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_product_details_content__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_buy_box__ = __webpack_require__(442);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var HEIGHT_OFFSET = 88;

function getProductSlug(href) {
    var nomalisedHref = href.replace(/\/$/, ''); // remove trailing slashes
    return nomalisedHref.split('/').pop();
}

var ProductDetail = function (_PureComponent) {
    _inherits(ProductDetail, _PureComponent);

    function ProductDetail() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ProductDetail);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProductDetail.__proto__ || Object.getPrototypeOf(ProductDetail)).call.apply(_ref, [this].concat(args))), _this), _this.onProductBought = function () {
            _this.props.closeModal();
        }, _this.debouncedHeightUpdate = __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function (props) {
            this.updateHeights(props);
        }, __WEBPACK_IMPORTED_MODULE_5_constants_debounce_delays__["d" /* MODAL_RESIZE_DEBOUNCE */]), _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ProductDetail, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.props.fetch(getProductSlug(this.props.href)).catch(function () {
                window.location.href = _this2.props.href;
            });

            if (this.props.product) {
                this.onProductReady(this.props.product);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.viewportHeight !== this.props.viewportHeight || nextProps.product && !this.props.product) {
                this.debouncedHeightUpdate(nextProps.viewportHeight - HEIGHT_OFFSET);
            }

            if (nextProps.product && !this.props.product) {
                this.onProductReady(nextProps.product);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.debouncedHeightUpdate.cancel();
            this.props.reset();
        }
    }, {
        key: 'onProductReady',
        value: function onProductReady(product) {
            this.props.setReady({ isReady: true });
            __WEBPACK_IMPORTED_MODULE_6_tracking__["a" /* default */].productDetail(product);
        }
    }, {
        key: 'updateElHeight',
        value: function updateElHeight(el, newHeight) {
            if (el.style.height) {
                el.style.height = null;
            }

            if (this.props.isDesktop) {
                el.style.height = el.scrollHeight > newHeight ? newHeight + 'px' : null;
            }
        }
    }, {
        key: 'updateHeights',
        value: function updateHeights(newHeight) {
            if (this.refs.main) {
                this.updateElHeight(this.refs.main, newHeight);
            }

            if (this.refs.sidebar) {
                this.updateElHeight(this.refs.sidebar, newHeight);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                product = _props.product,
                isDesktop = _props.isDesktop,
                isSticky = _props.isSticky,
                scrollbarWidth = _props.scrollbarWidth;


            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'modal--inner' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'modal--scroller' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'modal--content-wrapper' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'div',
                            { ref: 'main', className: 'grid modal--grid grid__condensed' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                'div',
                                { className: 'modal--container grid--container' },
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                                    'div',
                                    { className: 'modal--content' },
                                    product && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_product_details_content__["a" /* default */], {
                                        hasBuyBox: false,
                                        facet: 'modal',
                                        mustIncludeDetailsPanel: !isDesktop,
                                        product: product })
                                )
                            )
                        ),
                        product && isDesktop ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'aside',
                            { ref: 'sidebar', className: 'modal--sidebar' },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_product_details_panel__["a" /* default */], { product: product })
                        ) : null
                    )
                ),
                !isDesktop && product && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'modal--footer',
                        style: { width: isSticky ? 'calc(100% - ' + scrollbarWidth + 'px)' : null } },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_buy_box__["a" /* default */], { product: product, onBought: this.onProductBought })
                )
            );
        }
    }]);

    return ProductDetail;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

ProductDetail.propTypes = {
    isDesktop: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    viewportHeight: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
    scrollbarWidth: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
    isSticky: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    product: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    href: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    fetch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    reset: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    setReady: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    closeModal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_4_util_redux__["b" /* default */].mapStateToProps({
    product: 'product.item',
    href: 'modal.href',
    viewportHeight: 'viewport.height'
}), __WEBPACK_IMPORTED_MODULE_4_util_redux__["b" /* default */].mapDispatchToProps({
    fetch: 'product.fetch',
    reset: 'product.reset',
    setReady: 'modal.setReady',
    closeModal: 'modal.close'
}))(ProductDetail));

/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ProductSpecs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__richtext__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__table__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__definitions_list__ = __webpack_require__(1200);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable camelcase */








var components = {
    richtext: __WEBPACK_IMPORTED_MODULE_3__richtext__["a" /* default */],
    table: __WEBPACK_IMPORTED_MODULE_4__table__["a" /* default */],
    'definitions-list': __WEBPACK_IMPORTED_MODULE_5__definitions_list__["a" /* default */]
};

function ProductSpecs(_ref) {
    var sections = _ref.sections;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'article',
        { className: 'product-specs' },
        Object(__WEBPACK_IMPORTED_MODULE_2_looppa__["a" /* default */])(sections)(function (section, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'section',
                { className: 'product-specs--section', key: i },
                components[section.type] ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(components[section.type], _extends({}, section.data, {
                    notes: section.notes,
                    title_key: section.title_key
                })) : null
            );
        })
    );
}

ProductSpecs.propTypes = {
    sections: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired
};

/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = RichTextProductSpecs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_translations__ = __webpack_require__(171);
/* eslint-disable camelcase */




function RichTextProductSpecs(_ref) {
    var title_key = _ref.title_key,
        html = _ref.html,
        notes = _ref.notes;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'product-specs--richtext' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'product-specs--title' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_translations__["a" /* Trans */], { path: title_key })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: html } }),
        notes ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            { className: 'product-specs--notes' },
            notes
        ) : null
    );
}

RichTextProductSpecs.propTypes = {
    html: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    title_key: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    notes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = TableProductSpecs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_translations__ = __webpack_require__(171);
/* eslint-disable camelcase */






function TableProductSpecs(_ref) {
    var title_key = _ref.title_key,
        tbody = _ref.tbody,
        thead = _ref.thead,
        notes = _ref.notes;

    var tableTitle = thead.title && thead.title.length && thead.title[0];

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'product-specs--table-wrapper' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'product-specs--title__table' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_translations__["a" /* Trans */], { path: title_key })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'product-specs--table' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'thead',
                null,
                tableTitle ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { colSpan: thead.data.length + 1, className: 'product-specs--table-ceil product-specs--table-th product-specs--table-th__main' },
                        tableTitle
                    )
                ) : null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'product-specs--table-ceil product-specs--table-th' },
                        '\xA0'
                    ),
                    Object(__WEBPACK_IMPORTED_MODULE_2_looppa__["a" /* default */])(thead.data)(function (th, i) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'th',
                            { className: 'product-specs--table-ceil product-specs--table-th', key: i },
                            th
                        );
                    })
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tbody',
                null,
                Object(__WEBPACK_IMPORTED_MODULE_2_looppa__["a" /* default */])(tbody)(function (rows, key) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'tr',
                        { className: 'product-specs--table--row', key: key },
                        Object(__WEBPACK_IMPORTED_MODULE_2_looppa__["a" /* default */])(rows.data)(function (value, j) {
                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'td',
                                {
                                    className: 'product-specs--table-td product-specs--table-ceil ' + (rows.has_border && 'product-specs--table-ceil__border'),
                                    key: j
                                },
                                value
                            );
                        })
                    );
                })
            )
        ),
        notes ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            { className: 'product-specs--notes' },
            notes
        ) : null
    );
}

TableProductSpecs.propTypes = {
    tbody: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
    thead: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    notes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    title_key: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DefinitionsListSpecs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_translations__ = __webpack_require__(171);
/* eslint-disable camelcase */






function DefinitionsListSpecs(_ref) {
    var title_key = _ref.title_key,
        definitions = _ref.definitions,
        notes = _ref.notes;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'product-specs--definitions-list' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'product-specs--title' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_translations__["a" /* Trans */], { path: title_key })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'dl',
            { className: 'product-specs--dl' },
            Object(__WEBPACK_IMPORTED_MODULE_2_looppa__["a" /* default */])(definitions)(function (_ref2, i) {
                var description = _ref2.description,
                    title = _ref2.title;
                return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'dt',
                    { key: i + '-title', className: 'product-specs--dl-title' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_translations__["a" /* Trans */], { path: title })
                ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'dd',
                    { key: i + '-description', className: 'product-specs--dl-description' },
                    description
                )];
            })
        ),
        notes ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            { className: 'product-specs--notes' },
            notes
        ) : null
    );
}

DefinitionsListSpecs.propTypes = {
    definitions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
    title_key: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    notes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    slidesPerView: 'auto',
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    keyboard: true
});

/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Confirm;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_page_layout__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_page_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_page_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_buttons_group__ = __webpack_require__(421);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








function Confirm(_ref) {
    var _classnames;

    var isSticky = _ref.isSticky,
        scrollbarWidth = _ref.scrollbarWidth,
        meta = _ref.meta,
        content = _ref.content;
    var icon = meta.icon,
        title = meta.title,
        description = meta.description,
        type = meta.type;

    var actions = meta.actions.map(function (_ref2) {
        var name = _ref2.name,
            event = _ref2.event,
            facet = _ref2.facet;

        return {
            event: event,
            facet: facet || 'primary',
            className: 'modal--button',
            name: name,
            size: 'small'
        };
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'modal--inner' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'modal--scroller' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'modal--content-wrapper' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'modal--grid grid grid__condensed' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'modal--container grid--container' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('modal--content', (_classnames = {}, _defineProperty(_classnames, 'modal--content__' + type, type), _defineProperty(_classnames, 'modal--content__single', actions.length === 1), _classnames)) },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'grid--row modal--title-wrapper' },
                                icon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_icon__["a" /* default */], _extends({ className: 'modal--icon' }, icon)),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'h2',
                                    { className: 'modal--title' },
                                    title
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'grid--row' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'grid--col' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'p',
                                        { className: 'modal--paragraph' },
                                        description
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_2_react_page_layout__["Slot"],
                                { name: 'content' },
                                content
                            )
                        )
                    )
                )
            )
        ),
        actions.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'modal--footer',
                style: { width: isSticky ? 'calc(100% - ' + scrollbarWidth + 'px)' : null } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'modal--grid grid grid__condensed' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'modal--container grid--container' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'modal--buttons-wrapper' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_buttons_group__["a" /* default */], { actions: actions, className: 'modal--buttons' })
                    )
                )
            )
        ) : null
    );
}

Confirm.propTypes = {
    meta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    content: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
    isSticky: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    scrollbarWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};

Confirm.defaultProps = {
    meta: {
        actions: []
    }
};

/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Blank;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_page_layout__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_page_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_page_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);




function Blank(_ref) {
    var content = _ref.content;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'modal--inner' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'modal--scroller' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_page_layout__["Slot"],
                { name: 'content' },
                content
            )
        )
    );
}

Blank.propTypes = {
    content: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any
};

/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Alert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_page_layout__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_page_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_page_layout__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







function Alert(_ref) {
    var meta = _ref.meta,
        content = _ref.content;
    var icon = meta.icon,
        title = meta.title,
        description = meta.description,
        type = meta.type;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'modal--inner' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'modal--scroller' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'modal--content-wrapper' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'modal--grid grid grid__condensed' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'modal--container grid--container' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal--content', _defineProperty({}, 'modal--content__' + type, type)) },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'grid--row modal--title-wrapper' },
                                icon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_icon__["a" /* default */], _extends({ className: 'modal--icon' }, icon)),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'h2',
                                    { className: 'modal--title' },
                                    title
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'grid--row' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'grid--col' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'p',
                                        { className: 'modal--paragraph' },
                                        description
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_4_react_page_layout__["Slot"],
                                { name: 'content' },
                                content
                            )
                        )
                    )
                )
            )
        )
    );
}

Alert.propTypes = {
    meta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    content: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ZipFormModal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_page_layout__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_page_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_page_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_zip_form__ = __webpack_require__(590);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






function ZipFormModal(_ref) {
    var content = _ref.content,
        meta = _ref.meta,
        updateHeight = _ref.updateHeight;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'modal--inner' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'modal--scroller' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'modal--content' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_zip_form__["a" /* default */], _extends({ onHeightChange: updateHeight }, meta)),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_page_layout__["Slot"],
                    { name: 'content' },
                    content
                )
            )
        )
    );
}

ZipFormModal.propTypes = {
    updateHeight: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    content: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    meta: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any
};

/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PrelaunchModal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_page_layout__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_page_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_page_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_prelaunch_form__ = __webpack_require__(592);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






function PrelaunchModal(_ref) {
    var content = _ref.content,
        meta = _ref.meta,
        updateHeight = _ref.updateHeight;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'modal--inner' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'modal--scroller' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'modal--content' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_prelaunch_form__["a" /* default */], _extends({ onHeightChange: updateHeight }, meta)),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1_react_page_layout__["Slot"],
                    { name: 'content' },
                    content
                )
            )
        )
    );
}

PrelaunchModal.propTypes = {
    updateHeight: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    content: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    meta: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any
};

/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Iframe;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_page_layout__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_page_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_page_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);




function Iframe(_ref) {
    var content = _ref.content;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'modal--inner' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_page_layout__["Slot"],
            { className: 'modal--iframe-wrapper', name: 'content' },
            content
        )
    );
}

Iframe.propTypes = {
    content: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any
};

/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_misc_get_order_state__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_cart__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_page_names__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_misc_link_to_home__ = __webpack_require__(198);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var DeliveryNotification = function (_PureComponent) {
    _inherits(DeliveryNotification, _PureComponent);

    function DeliveryNotification() {
        _classCallCheck(this, DeliveryNotification);

        return _possibleConstructorReturn(this, (DeliveryNotification.__proto__ || Object.getPrototypeOf(DeliveryNotification)).apply(this, arguments));
    }

    _createClass(DeliveryNotification, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var status = _ref.status;
            var oldStatus = this.props.status;

            // Status changed

            if (status !== oldStatus) {
                this.dispatchModal(status);
            }
        }

        /**
         * Check if the status change requires the dispatching of a modal screen
         * @param status
         */

    }, {
        key: 'dispatchModal',
        value: function dispatchModal(status) {
            var _getOrderState = Object(__WEBPACK_IMPORTED_MODULE_4_util_misc_get_order_state__["a" /* default */])(status),
                isShipped = _getOrderState.isShipped,
                isFailed = _getOrderState.isFailed;

            if (isShipped) {
                this.successModal();
            } else if (isFailed) {
                this.errorModal();
            }
        }
    }, {
        key: 'successModal',
        value: function successModal() {
            var _this2 = this;

            this.props.openModal({
                meta: {
                    title: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_translations__["a" /* Trans */], { path: 'delivery.success_title' }),
                    description: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_translations__["a" /* Trans */], { path: 'delivery.success_description' }),
                    type: 'success',
                    icon: {
                        size: 'large',
                        symbol: 'success'
                    },
                    actions: [{
                        name: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_translations__["a" /* Trans */], { path: 'delivery.goto_home' }),
                        facet: 'secondary',
                        event: function event() {
                            _this2.props.history.replace(Object(__WEBPACK_IMPORTED_MODULE_8_util_misc_link_to_home__["a" /* default */])(_this2.props.activeRegion));
                            _this2.props.closeModal();
                        }
                    }, {
                        name: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_translations__["a" /* Trans */], { path: 'delivery.goto_order_details' }),
                        event: function event() {
                            _this2.props.history.replace(_this2.props.routerRegistry.get(__WEBPACK_IMPORTED_MODULE_7_constants_page_names__["PROFILE_ORDERS"]).url);
                            _this2.props.closeModal();
                        }
                    }]
                },
                layout: 'confirm'
            });
        }
    }, {
        key: 'errorModal',
        value: function errorModal() {
            var _this3 = this;

            this.props.openModal({
                meta: {
                    title: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_translations__["a" /* Trans */], { path: 'delivery.timeout_title' }),
                    description: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_translations__["a" /* Trans */], { path: 'delivery.timeout_description' }),
                    type: 'error',
                    icon: {
                        size: 'large',
                        symbol: 'alert'
                    },
                    actions: [{
                        name: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_translations__["a" /* Trans */], { path: 'delivery.goto_home' }),
                        facet: 'secondary',
                        event: function event() {
                            _this3.props.history.replace(Object(__WEBPACK_IMPORTED_MODULE_8_util_misc_link_to_home__["a" /* default */])(_this3.props.activeRegion));
                            _this3.props.closeModal();
                        }
                    }, {
                        name: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_translations__["a" /* Trans */], { path: 'delivery.goto_cart' }),
                        event: function event() {
                            _this3.props.history.replace(Object(__WEBPACK_IMPORTED_MODULE_8_util_misc_link_to_home__["a" /* default */])(_this3.props.activeRegion));
                            _this3.props.closeModal();
                            requestAnimationFrame(function () {
                                _this3.props.openPanel({ facet: 'cart', content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_cart__["a" /* default */], null) });
                            });
                        }
                    }]
                },
                layout: 'confirm'
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);

    return DeliveryNotification;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

DeliveryNotification.propTypes = {
    closeModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    openModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    openPanel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    routerRegistry: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    setStatus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    status: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    activeRegion: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_3_util_redux__["b" /* default */].mapStateToProps({
    status: 'delivery.status',
    history: 'router.history',
    routerRegistry: 'router.registry',
    activeRegion: 'region.active'
}), __WEBPACK_IMPORTED_MODULE_3_util_redux__["b" /* default */].mapDispatchToProps({
    openModal: 'modal.open',
    closeModal: 'modal.close',
    setStatus: 'delivery.setStatus',
    openPanel: 'panel.open'
}))(DeliveryNotification));

/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bianco_events__ = __webpack_require__(53);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Autologin = function (_PureComponent) {
    _inherits(Autologin, _PureComponent);

    function Autologin() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Autologin);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Autologin.__proto__ || Object.getPrototypeOf(Autologin)).call.apply(_ref, [this].concat(args))), _this), _this.onMessage = function (e) {
            var payload = void 0;
            try {
                payload = JSON.parse(e.data);
            } catch (o_0) {
                return;
            }

            if (payload.dpdata) {
                _this.props.fetchCart().then(function () {
                    _this.props.autologin({ user: payload.dpdata });
                });
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Autologin, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            Object(__WEBPACK_IMPORTED_MODULE_4_bianco_events__["a" /* add */])(window, 'message', this.onMessage);
        }
    }, {
        key: 'render',
        value: function render() {
            var isUserAuthenticated = this.props.isUserAuthenticated;

            // no need to autologin if we were authenticated

            if (isUserAuthenticated) {
                return null;
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe', { ref: 'root', hidden: true, src: '/autologin' });
        }
    }]);

    return Autologin;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Autologin.propTypes = {
    isUserAuthenticated: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    autologin: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    fetchCart: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_3_util_redux__["b" /* default */].mapStateToProps({
    isUserAuthenticated: 'user.isAuthenticated'
}), __WEBPACK_IMPORTED_MODULE_3_util_redux__["b" /* default */].mapDispatchToProps({
    fetchCart: 'cart.fetchCart',
    autologin: 'user.autologin'
}))(Autologin));

/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_page_names__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_livechat_livechat_mock__ = __webpack_require__(1211);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var LiveChat = function (_Component) {
    _inherits(LiveChat, _Component);

    function LiveChat(props) {
        _classCallCheck(this, LiveChat);

        // this.onActivateWidget();
        var _this = _possibleConstructorReturn(this, (LiveChat.__proto__ || Object.getPrototypeOf(LiveChat)).call(this, props));

        _this.state = {
            isReady: false,
            hideMock: false
        };

        _this.onActivateWidget = function () {
            return new Promise(function (resolve) {
                // Code provided by the 3rd party service
                /* eslint-disable */
                window.$zopim || function (d, s) {
                    var z = window.$zopim = function (c) {
                        z._.push(c);
                    },
                        $ = z.s = d.createElement(s),
                        e = d.getElementsByTagName(s)[0];
                    z.set = function (o) {
                        z.set._.push(o);
                    };
                    z._ = [];
                    z.set._ = [];
                    $.async = !0;
                    $.setAttribute('charset', 'utf-8');
                    $.src = '//v2.zopim.com/?5g4as0sXLH3blBL5Cw53HSjbZwiSZvI2';
                    z.s.onload = function () {
                        _this.setState({
                            hideMock: true,
                            isReady: true
                        });
                        resolve();
                    };
                    z.t = +new Date();
                    $.type = 'text/javascript';
                    e.parentNode.insertBefore($, e);
                }(document, 'script');
                /* eslint-enable */
            });
        };

        _this.onWidgetClicked = function () {
            _this.onActivateWidget().then(function () {
                window.$zopim.livechat.window.toggle();
            });
        };

        return _this;
    }

    _createClass(LiveChat, [{
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps) {
            if (!this.state.isReady) {
                return;
            }

            if (LiveChat.shouldHide(nextProps)) {
                this.hide();
            } else {
                this.show();
            }
        }
    }, {
        key: 'hide',
        value: function hide() {
            window.$zopim.livechat.hideAll();
        }
    }, {
        key: 'show',
        value: function show() {
            window.$zopim.livechat.window.hide();
        }
    }, {
        key: 'render',
        value: function render() {
            if (LiveChat.shouldHide(this.props) || this.state.hideMock) {
                return null;
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_livechat_livechat_mock__["a" /* default */], { activate: this.onWidgetClicked });
        }
    }]);

    return LiveChat;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

LiveChat.propTypes = {
    pageName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    isMobile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    panelFacet: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    isPanelOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    isScrollLocked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};
LiveChat.defaultProps = {};

LiveChat.shouldHide = function (_ref) {
    var isMobile = _ref.isMobile,
        pageName = _ref.pageName,
        isPanelOpen = _ref.isPanelOpen,
        isScrollLocked = _ref.isScrollLocked,
        panelFacet = _ref.panelFacet;

    // we have different rules for this component depending on the viewport size see https://jira.migros.net/browse/MCART-2086
    return isMobile && (isPanelOpen || isScrollLocked || [__WEBPACK_IMPORTED_MODULE_4_constants_page_names__["PRODUCT_DETAIL"], __WEBPACK_IMPORTED_MODULE_4_constants_page_names__["CHECKOUT"]].includes(pageName)) || isPanelOpen && panelFacet === 'cart';
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_2_util_redux__["b" /* default */].mapStateToProps({
    isMobile: 'viewport.isMobile',
    isScrollLocked: 'scroll.isLocked',
    isPanelOpen: 'panel.isOpen',
    panelFacet: 'panel.facet',
    pageName: 'router.name'
}))(LiveChat));

/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_translations__ = __webpack_require__(171);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var LiveChatMock = function (_Component) {
    _inherits(LiveChatMock, _Component);

    function LiveChatMock() {
        _classCallCheck(this, LiveChatMock);

        return _possibleConstructorReturn(this, (LiveChatMock.__proto__ || Object.getPrototypeOf(LiveChatMock)).apply(this, arguments));
    }

    _createClass(LiveChatMock, [{
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { className: 'livechat-mock', onClick: this.props.activate },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'livechat-mock--icon-wrapper' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_icon__["a" /* default */], { symbol: 'speech', size: 'small' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    { className: 'u-reset livechat-mock--label' },
                    Object(__WEBPACK_IMPORTED_MODULE_3_translations__["c" /* default */])('chatwidget.label')
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    { className: 'livechat-mock--label livechat-mock--label__mobile' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_translations__["a" /* Trans */], { path: 'chatwidget.label_mobile' })
                )
            );
        }
    }]);

    return LiveChatMock;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

LiveChatMock.propTypes = {
    activate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (LiveChatMock);

/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_dom_mq__ = __webpack_require__(249);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * Please don't touch this file unless you know what you are doing!!!
 * Jaws is really inconsistent in dispatching alert messages and here we need to work with timers in order
 * to let it dispatch properly the user messages
 */

var AccessibleAlert = function (_PureComponent) {
    _inherits(AccessibleAlert, _PureComponent);

    function AccessibleAlert() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, AccessibleAlert);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AccessibleAlert.__proto__ || Object.getPrototypeOf(AccessibleAlert)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            canBeRendered: false,
            currentMq: null
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(AccessibleAlert, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(_ref2) {
            var mq = _ref2.mq;

            if (mq.width !== this.state.currentMq) {
                this.setState({ currentMq: mq.width });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var currentMq = this.state.currentMq;
            var _props = this.props,
                messageMobile = _props.messageMobile,
                messageDesktop = _props.messageDesktop;


            if (currentMq > __WEBPACK_IMPORTED_MODULE_4_util_dom_mq__["d" /* numerals */].SM) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    {
                        tabIndex: 0,
                        className: 'accessible-alert' },
                    messageDesktop
                );
            }

            //mobile
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                {
                    tabIndex: 0,
                    className: 'accessible-alert' },
                messageMobile
            );
        }
    }]);

    return AccessibleAlert;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

AccessibleAlert.propTypes = {
    messageDesktop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    messageMobile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    mq: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_2_util_redux__["b" /* default */].mapStateToProps({
    mq: 'viewport.mq'
}))(AccessibleAlert));

/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_translations__ = __webpack_require__(171);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Skiplinks = function (_PureComponent) {
    _inherits(Skiplinks, _PureComponent);

    function Skiplinks() {
        _classCallCheck(this, Skiplinks);

        return _possibleConstructorReturn(this, (Skiplinks.__proto__ || Object.getPrototypeOf(Skiplinks)).apply(this, arguments));
    }

    _createClass(Skiplinks, [{
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'skiplinks u-reset', href: '#main' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_translations__["a" /* Trans */], { path: 'accessibility.goto_main' })
            );
        }
    }]);

    return Skiplinks;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Skiplinks);

/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_react_facet__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__notifications_bags_progressbar__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_flip_move__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_constants_snackbar_notifications__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants_transitions_props__ = __webpack_require__(241);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












var notificationsComponents = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_8_constants_snackbar_notifications__["a" /* CART */].type, __WEBPACK_IMPORTED_MODULE_6__notifications_bags_progressbar__["a" /* default */]);

var Snackbar = function (_PureComponent) {
    _inherits(Snackbar, _PureComponent);

    function Snackbar() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Snackbar);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Snackbar.__proto__ || Object.getPrototypeOf(Snackbar)).call.apply(_ref, [this].concat(args))), _this), _this.timer = null, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Snackbar, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref2) {
            var notifications = _ref2.notifications,
                wasCartReset = _ref2.wasCartReset,
                bagInfo = _ref2.bagInfo,
                customerDeliveryFee = _ref2.customerDeliveryFee,
                addNotification = _ref2.addNotification;

            var firstNotification = Snackbar.getFirstNotification(notifications);
            var oldNotification = Snackbar.getFirstNotification(this.props.notifications);

            // cart notifications should be handled a bit differently
            this.handleCartNotifications({ bagInfo: bagInfo, wasCartReset: wasCartReset, addNotification: addNotification, customerDeliveryFee: customerDeliveryFee });

            // handle any new notification, cart notifications included
            if (firstNotification && (!oldNotification || firstNotification.id !== oldNotification.id)) {
                this.setNotificationTimer(firstNotification);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.clearTimer();
        }
    }, {
        key: 'handleCartNotifications',
        value: function handleCartNotifications(_ref3) {
            var bagInfo = _ref3.bagInfo,
                wasCartReset = _ref3.wasCartReset,
                addNotification = _ref3.addNotification,
                customerDeliveryFee = _ref3.customerDeliveryFee;
            var non_full_bag_percentage = bagInfo.non_full_bag_percentage;
            var wasCartFetched = this.props.wasCartFetched;

            var cartNotification = Object.assign({
                bagInfo: bagInfo,
                price: customerDeliveryFee,
                oldBagInfo: this.props.bagInfo
            }, __WEBPACK_IMPORTED_MODULE_8_constants_snackbar_notifications__["a" /* CART */]);

            if (wasCartFetched && !wasCartReset && non_full_bag_percentage !== this.props.bagInfo.non_full_bag_percentage) {
                addNotification({ notification: cartNotification });
            }

            this.setNotificationTimer(cartNotification);
        }
    }, {
        key: 'setNotificationTimer',
        value: function setNotificationTimer(notification) {
            var _this2 = this;

            this.clearTimer();

            this.timer = setTimeout(function () {
                _this2.props.removeNotification({ notification: notification });
            }, notification.delay);
        }
    }, {
        key: 'clearTimer',
        value: function clearTimer() {
            clearTimeout(this.timer);
        }
    }, {
        key: 'render',
        value: function render() {
            var notifications = this.props.notifications;

            var notification = Snackbar.getFirstNotification(notifications);

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { ref: 'root', className: 'snackbar' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_7_react_flip_move__["a" /* default */],
                    _extends({
                        typeName: 'ol',
                        className: 'snackbar--list u-reset',
                        maintainContainerHeight: true,
                        staggerDelayBy: __WEBPACK_IMPORTED_MODULE_9_constants_transitions_props__["h" /* snackbarSpeed */],
                        duration: __WEBPACK_IMPORTED_MODULE_9_constants_transitions_props__["h" /* snackbarSpeed */],
                        easing: __WEBPACK_IMPORTED_MODULE_9_constants_transitions_props__["g" /* snackbarEasingFn */]
                    }, this.transitions),
                    notification && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'li',
                        { key: notification.id, className: 'snackbar--item' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            {
                                className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('snackbar--notification', Object(__WEBPACK_IMPORTED_MODULE_5_util_react_facet__["a" /* default */])(notification.type, 'snackbar--notification')) },
                            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(notificationsComponents[notification.type], _extends({}, notification))
                        )
                    )
                )
            );
        }
    }, {
        key: 'transitions',
        get: function get() {
            return {
                enterAnimation: {
                    from: {
                        transform: 'translate(0, 100%)'
                    },
                    to: {
                        transform: 'translate(0, 0)'
                    }
                },
                leaveAnimation: {
                    from: {
                        transform: 'translate(0, 0)'
                    },
                    to: {
                        transform: 'translate(0, 100%)'
                    }
                }
            };
        }
    }], [{
        key: 'getFirstNotification',
        value: function getFirstNotification(collection) {
            return collection.length ? collection[0] : null;
        }
    }]);

    return Snackbar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Snackbar.propTypes = {
    wasCartReset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    wasCartFetched: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    customerDeliveryFee: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    bagInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    removeNotification: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    addNotification: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    notifications: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_3_util_redux__["b" /* default */].mapStateToProps({
    bagInfo: 'cart.bagInfo',
    customerDeliveryFee: 'cart.customerDeliveryFee',
    wasCartReset: 'cart.wasReset',
    wasCartFetched: 'cart.wasFetched',
    notifications: 'snackbar.items'
}), __WEBPACK_IMPORTED_MODULE_3_util_redux__["b" /* default */].mapDispatchToProps({
    removeNotification: 'snackbar.remove',
    addNotification: 'snackbar.add'
}))(Snackbar));

/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_misc_wait__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ruit__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_misc_format_price__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_cart__ = __webpack_require__(266);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










/* eslint-disable camelcase */
var ANIMATION_DELAY = 1000;

var BagsProgressbar = function (_PureComponent) {
    _inherits(BagsProgressbar, _PureComponent);

    function BagsProgressbar(props) {
        _classCallCheck(this, BagsProgressbar);

        var _this = _possibleConstructorReturn(this, (BagsProgressbar.__proto__ || Object.getPrototypeOf(BagsProgressbar)).call(this, props));

        _this.clearAsync = function () {
            if (_this.timer) {
                _this.timer.cancel();
            }
        };

        _this.runAnimationQueue = function (_ref) {
            var total_bags = _ref.total_bags,
                oldTotalBags = _ref.oldTotalBags;

            return Object(__WEBPACK_IMPORTED_MODULE_4_ruit__["a" /* default */])(_this.clearAsync(), _this.setState({
                perc: total_bags > oldTotalBags ? 100 : 0,
                isAnimated: true
            }), _this.wait(ANIMATION_DELAY), function () {
                return _this.setState({
                    isAnimated: false,
                    perc: total_bags > oldTotalBags ? 0 : 100
                });
            }, _this.wait(ANIMATION_DELAY), function () {
                return _this.setState({
                    isAnimated: true,
                    perc: _this.currentPerc
                });
            }).then(function () {
                _this.timer = null;
            });
        };

        _this.timer = null;

        _this.wait = function (delay) {
            _this.timer = Object(__WEBPACK_IMPORTED_MODULE_3_util_misc_wait__["a" /* default */])(delay)();
            return _this.timer;
        };

        _this.currentPerc = props.oldBagInfo.non_full_bag_percentage;

        _this.state = {
            isAnimated: true,
            perc: _this.currentPerc
        };
        return _this;
    }

    _createClass(BagsProgressbar, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.handleBagsTransition(this.props.bagInfo, this.props.oldBagInfo);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            this.handleBagsTransition(newProps.bagInfo, this.props.bagInfo);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.clearAsync();
        }
    }, {
        key: 'handleBagsTransition',
        value: function handleBagsTransition(newBagInfo, oldBagInfo) {
            var non_full_bag_percentage = newBagInfo.non_full_bag_percentage,
                total_bags = newBagInfo.total_bags;
            var oldTotalBags = oldBagInfo.total_bags,
                oldPerc = oldBagInfo.non_full_bag_percentage;

            // cache the current percentage to have it always updated

            this.currentPerc = non_full_bag_percentage || 0;

            if (non_full_bag_percentage !== oldPerc) {
                // defer the update
                if (oldTotalBags && total_bags && total_bags !== oldTotalBags) {
                    this.runAnimationQueue({ total_bags: total_bags, oldTotalBags: oldTotalBags });
                } else if (!this.timer) {
                    this.setState({
                        isAnimated: true,
                        perc: non_full_bag_percentage
                    });
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                bagInfo = _props.bagInfo,
                price = _props.price;
            var _state = this.state,
                perc = _state.perc,
                isAnimated = _state.isAnimated;

            var total_bags = bagInfo.total_bags || 0;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'bags-progressbar' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h2',
                    { className: 'bags-progressbar--title u-reset' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_translations__["a" /* Trans */], { path: 'snackbar.cart.title', amount: total_bags,
                        data: { amount: total_bags } })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'bags-progressbar--row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        { className: 'bags-progressbar--description' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_translations__["a" /* Trans */], { path: 'snackbar.cart.description',
                            data: { price: Object(__WEBPACK_IMPORTED_MODULE_6_util_misc_format_price__["b" /* formatPrice */])(price), currency: __WEBPACK_IMPORTED_MODULE_7_constants_cart__["a" /* CURRENCY */] } })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        { className: 'bags-progressbar--optional-text bags-progressbar--optional-text__top' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_translations__["a" /* Trans */], {
                            path: 'snackbar.cart.optional_text' })
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'bags-progressbar--bar' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { ref: 'bar',
                        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('bags-progressbar--value', { 'bags-progressbar--value__is-animated': isAnimated }),
                        style: { width: perc + '%' } })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    { className: 'bags-progressbar--optional-text bags-progressbar--optional-text__bottom' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_translations__["a" /* Trans */], {
                        path: 'snackbar.cart.optional_text' })
                )
            );
        }
    }]);

    return BagsProgressbar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

BagsProgressbar.defaultProps = {
    bagInfo: {},
    oldBagInfo: {}
};
BagsProgressbar.propTypes = {
    price: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    oldBagInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    bagInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (BagsProgressbar);

/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wait;
/**
 * Advanced async (cancellable/abortable) `setTimeout` helper
 */
function wait(delay) {
    return function (val) {
        var timer = void 0;
        var abort = void 0;

        var p = new Promise(function (resolve, reject) {
            abort = reject;
            timer = setTimeout(function () {
                return resolve(val);
            }, delay);
        });

        p.cancel = function () {
            return clearTimeout(timer);
        };
        p.abort = function (reason) {
            return p.cancel() || abort(reason);
        };

        return p;
    };
}

/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HIGH_PRIORITY */
/* unused harmony export MEDIUM_PRIORITY */
/* unused harmony export LOW_PRIORITY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CART; });
/**
 * Snack notifications priorities - we will use these values to sort them
 * @type {number}
 */
var HIGH_PRIORITY = 0;
var MEDIUM_PRIORITY = 1;
var LOW_PRIORITY = 2;

var CART = {
    priority: HIGH_PRIORITY,
    id: 0,
    type: 'cart',
    delay: 4000
};

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FooterTail;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util_misc_static_assets_path__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_menus__ = __webpack_require__(236);









function FooterTail(_ref) {
    var hasAdditionalContent = _ref.hasAdditionalContent,
        hasAgbLink = _ref.hasAgbLink,
        tabIndex = _ref.tabIndex;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'footer',
        { className: 'footer-tail' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'footer-tail--row grid--row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'footer-tail--col footer-tail--logo grid--col' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'figure',
                    { className: 'footer-tail--figure' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: Object(__WEBPACK_IMPORTED_MODULE_6_util_misc_static_assets_path__["a" /* default */])('img/logos/logo_87x16_migros.svg'), alt: Object(__WEBPACK_IMPORTED_MODULE_5_translations__["f" /* t */])('migros.title') })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'small',
                    { className: 'footer-tail--copyright' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_translations__["a" /* Trans */], { path: 'footer.copyright',
                        data: { year: new Date().getFullYear() } })
                )
            ),
            hasAdditionalContent && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'nav',
                { className: 'footer-tail--col footer-tail--social grid--col' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'ul',
                    { className: 'footer-tail--social-list u-reset' },
                    Object(__WEBPACK_IMPORTED_MODULE_1_looppa__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7_constants_menus__["g" /* social */])())(function (_ref2) {
                        var url = _ref2.url,
                            title = _ref2.title,
                            symbol = _ref2.symbol;
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'li',
                            { className: 'footer-tail--social-item', key: symbol },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'a',
                                { tabIndex: tabIndex, className: 'footer-tail--social-link u-reset', href: url,
                                    title: Object(__WEBPACK_IMPORTED_MODULE_5_translations__["f" /* t */])(title), target: '_blank',
                                    rel: 'noreferrer noopener' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_icon__["a" /* default */], { symbol: symbol, size: 'large' })
                            )
                        );
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'footer-tail--row grid--row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'nav',
                        { className: 'footer-tail--links-wrapper grid--col' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'ul',
                            { className: 'footer-tail--links-list u-reset' },
                            hasAgbLink && Object(__WEBPACK_IMPORTED_MODULE_1_looppa__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7_constants_menus__["c" /* legalAndPrivacy */])())(function (_ref3, i) {
                                var url = _ref3.url,
                                    title = _ref3.title;
                                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'li',
                                    { className: 'footer-tail--links-item', key: i },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* NavLink */],
                                        { target: '_blank', tabIndex: tabIndex, activeClassName: 'footer-tail--link__is-active',
                                            className: 'footer-tail--link u-reset', exact: true, to: url },
                                        title
                                    )
                                );
                            }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'li',
                                { className: 'footer-tail--links-item' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'a',
                                    { tabIndex: tabIndex, className: 'footer-tail--link u-reset', href: Object(__WEBPACK_IMPORTED_MODULE_5_translations__["f" /* t */])('privacy.url'),
                                        target: '_blank' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_translations__["a" /* Trans */], { path: 'privacy.title' })
                                )
                            )
                        )
                    )
                )
            )
        )
    );
}

FooterTail.propTypes = {
    tabIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
    hasAdditionalContent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    hasAgbLink: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
};

/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FooterHead;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_payment_platforms__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_contact_info__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__amigos_menu__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);






function FooterHead(_ref) {
    var facet = _ref.facet,
        tabIndex = _ref.tabIndex;

    if (facet === 'lite') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'aside',
            { className: 'footer-head grid--row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'footer-head--col grid--col' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_contact_info__["a" /* default */], { tabIndex: tabIndex })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'footer-head--col grid--col' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'footer-head--col grid--col' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_payment_platforms__["a" /* default */], null)
            )
        );
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'aside',
        { className: 'footer-head grid--row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'footer-head--col grid--col' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__amigos_menu__["a" /* default */], { tabIndex: tabIndex })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'footer-head--col grid--col' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_contact_info__["a" /* default */], { tabIndex: tabIndex })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'footer-head--col grid--col' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_payment_platforms__["a" /* default */], { tabIndex: tabIndex })
        )
    );
}

FooterHead.propTypes = {
    tabIndex: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,
    facet: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired
};

FooterHead.defaultProps = {
    facet: 'default'
};

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AmigosMenu;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_menus__ = __webpack_require__(236);







function AmigosMenu(_ref) {
    var tabIndex = _ref.tabIndex;

    return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h1',
        { key: 'title', className: 'footer-head--title u-reset' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_translations__["a" /* Trans */], { path: 'footer.menu.title' })
    ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        { key: 'list', className: 'footer-head--list u-reset' },
        Object(__WEBPACK_IMPORTED_MODULE_1_looppa__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5_constants_menus__["a" /* contentPages */])())(function (_ref2, i) {
            var url = _ref2.url,
                title = _ref2.title;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { className: 'footer-head--item', key: i },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* NavLink */],
                    {
                        tabIndex: tabIndex,
                        activeClassName: 'footer-head--link__is-active',
                        className: 'footer-head--link u-reset',
                        exact: true,
                        to: url
                    },
                    title
                )
            );
        })
    )];
}

AmigosMenu.propTypes = {
    tabIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired
};

/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__blank__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__two_columns__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__two_columns_no_container__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__full_width__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__full_width_no_container__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__one_column__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__webview_counter__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__webview__ = __webpack_require__(606);
// Pages layouts









/* harmony default export */ __webpack_exports__["a"] = ({
    blank: __WEBPACK_IMPORTED_MODULE_0__blank__["a" /* default */],
    'two-columns': __WEBPACK_IMPORTED_MODULE_1__two_columns__["a" /* default */],
    'two-columns-no-container': __WEBPACK_IMPORTED_MODULE_2__two_columns_no_container__["a" /* default */],
    'full-width': __WEBPACK_IMPORTED_MODULE_3__full_width__["a" /* default */],
    'full-width-no-container': __WEBPACK_IMPORTED_MODULE_4__full_width_no_container__["a" /* default */],
    'one-column': __WEBPACK_IMPORTED_MODULE_5__one_column__["a" /* default */],
    'webview-counter': __WEBPACK_IMPORTED_MODULE_6__webview_counter__["a" /* default */],
    webview: __WEBPACK_IMPORTED_MODULE_7__webview__["a" /* default */]
});

/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Blank;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_page_layout__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_page_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_page_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_react_facet__ = __webpack_require__(185);






function Blank(_ref) {
    var facet = _ref.facet;

    var facetClasses = Object(__WEBPACK_IMPORTED_MODULE_4_util_react_facet__["a" /* default */])(facet, 'layout');
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_page_layout__["Slot"], { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('layout', 'layout__blank', facetClasses), name: 'content' });
}

Blank.propTypes = {
    facet: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any
};

/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_page_layout__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_page_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_page_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_main_footer__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_react_facet__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_containers_main_content__ = __webpack_require__(312);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var TwoColumns = function (_Component) {
    _inherits(TwoColumns, _Component);

    function TwoColumns() {
        _classCallCheck(this, TwoColumns);

        return _possibleConstructorReturn(this, (TwoColumns.__proto__ || Object.getPrototypeOf(TwoColumns)).apply(this, arguments));
    }

    _createClass(TwoColumns, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                facet = _props.facet,
                props = _objectWithoutProperties(_props, ['facet']);

            var facetClasses = Object(__WEBPACK_IMPORTED_MODULE_5_util_react_facet__["a" /* default */])(facet, 'layout');
            var content = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_page_layout__["Slot"], { key: 'sidebar', className: 'layout--sidebar', name: 'sidebar' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_containers_main_content__["a" /* default */],
                { key: 'main-content', className: 'layout--page grid grid__two-cols' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_page_layout__["Slot"], { className: 'layout--page-content', name: 'content' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_main_footer__["a" /* default */], null)
            )];

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                _extends({}, props, { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('layout', 'layout__two-cols', facetClasses) }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'layout--row' },
                    facet && Array.isArray(facet) && facet.includes('sidebar-right') ? content.reverse() : content
                )
            );
        }
    }]);

    return TwoColumns;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

TwoColumns.propTypes = {
    facet: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array])
};
/* harmony default export */ __webpack_exports__["a"] = (TwoColumns);

/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_page_layout__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_page_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_page_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_main_footer__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_react_facet__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_containers_main_content__ = __webpack_require__(312);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var TwoColumnsNoContainer = function (_Component) {
    _inherits(TwoColumnsNoContainer, _Component);

    function TwoColumnsNoContainer() {
        _classCallCheck(this, TwoColumnsNoContainer);

        return _possibleConstructorReturn(this, (TwoColumnsNoContainer.__proto__ || Object.getPrototypeOf(TwoColumnsNoContainer)).apply(this, arguments));
    }

    _createClass(TwoColumnsNoContainer, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                facet = _props.facet,
                props = _objectWithoutProperties(_props, ['facet']);

            var facetClasses = Object(__WEBPACK_IMPORTED_MODULE_5_util_react_facet__["a" /* default */])(facet, 'layout');

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                _extends({}, props, {
                    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('layout', 'layout__two-cols', 'layout__no-container', facetClasses)
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'layout--row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_page_layout__["Slot"], { className: 'layout--sidebar', name: 'sidebar' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_containers_main_content__["a" /* default */],
                        { className: 'layout--page grid grid__two-cols', isWrapped: false },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_page_layout__["Slot"], { className: 'layout--page-content', name: 'content' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'grid--container' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'layout--compact-footer' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_main_footer__["a" /* default */], null)
                            )
                        )
                    )
                )
            );
        }
    }]);

    return TwoColumnsNoContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

TwoColumnsNoContainer.propTypes = {
    facet: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array])
};
/* harmony default export */ __webpack_exports__["a"] = (TwoColumnsNoContainer);

/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_page_layout__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_page_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_page_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_main_footer__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_react_facet__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_containers_main_content__ = __webpack_require__(312);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var FullWidth = function (_Component) {
    _inherits(FullWidth, _Component);

    function FullWidth() {
        _classCallCheck(this, FullWidth);

        return _possibleConstructorReturn(this, (FullWidth.__proto__ || Object.getPrototypeOf(FullWidth)).apply(this, arguments));
    }

    _createClass(FullWidth, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                facet = _props.facet,
                props = _objectWithoutProperties(_props, ['facet']);

            var facetClasses = Object(__WEBPACK_IMPORTED_MODULE_5_util_react_facet__["a" /* default */])(facet, 'layout');

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                _extends({}, props, { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('layout', 'layout__full-width', facetClasses) }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'layout--row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_containers_main_content__["a" /* default */],
                        { className: 'layout--page grid' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_page_layout__["Slot"], { className: 'layout--page-content', name: 'content' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_main_footer__["a" /* default */], null)
                    )
                )
            );
        }
    }]);

    return FullWidth;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

FullWidth.propTypes = {
    facet: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array])
};
/* harmony default export */ __webpack_exports__["a"] = (FullWidth);

/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_page_layout__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_page_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_page_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_main_footer__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_react_facet__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_containers_main_content__ = __webpack_require__(312);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var FullWidthNoContainer = function (_Component) {
    _inherits(FullWidthNoContainer, _Component);

    function FullWidthNoContainer() {
        _classCallCheck(this, FullWidthNoContainer);

        return _possibleConstructorReturn(this, (FullWidthNoContainer.__proto__ || Object.getPrototypeOf(FullWidthNoContainer)).apply(this, arguments));
    }

    _createClass(FullWidthNoContainer, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                facet = _props.facet,
                props = _objectWithoutProperties(_props, ['facet']);

            var facetClasses = Object(__WEBPACK_IMPORTED_MODULE_5_util_react_facet__["a" /* default */])(facet, 'layout');

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                _extends({}, props, {
                    className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('layout', 'layout__full-width', 'layout__no-container', facetClasses)
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'layout--row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_containers_main_content__["a" /* default */],
                        { className: 'layout--page grid', isWrapped: false },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_page_layout__["Slot"], { className: 'layout--page-content', name: 'content' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'grid--container' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'layout--compact-footer' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_main_footer__["a" /* default */], null)
                            )
                        )
                    )
                )
            );
        }
    }]);

    return FullWidthNoContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

FullWidthNoContainer.propTypes = {
    facet: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array])
};
/* harmony default export */ __webpack_exports__["a"] = (FullWidthNoContainer);

/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_page_layout__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_page_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_page_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_main_footer__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_react_facet__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_containers_main_content__ = __webpack_require__(312);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









/**
 * This is actually the two columns layout grid but without the sidebar
 */

var OneColumn = function (_Component) {
    _inherits(OneColumn, _Component);

    function OneColumn() {
        _classCallCheck(this, OneColumn);

        return _possibleConstructorReturn(this, (OneColumn.__proto__ || Object.getPrototypeOf(OneColumn)).apply(this, arguments));
    }

    _createClass(OneColumn, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                facet = _props.facet,
                props = _objectWithoutProperties(_props, ['facet']);

            var facetClasses = Object(__WEBPACK_IMPORTED_MODULE_5_util_react_facet__["a" /* default */])(facet, 'layout');

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                _extends({}, props, { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('layout', 'layout__two-cols', facetClasses) }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'layout--row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_6_containers_main_content__["a" /* default */],
                        { className: 'layout--page grid grid__two-cols' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_page_layout__["Slot"], { className: 'layout--page-content', name: 'content' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_main_footer__["a" /* default */], null)
                    )
                )
            );
        }
    }]);

    return OneColumn;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

OneColumn.propTypes = {
    facet: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array])
};
/* harmony default export */ __webpack_exports__["a"] = (OneColumn);

/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = WebviewCounter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_page_layout__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_page_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_page_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_react_facet__ = __webpack_require__(185);






function WebviewCounter(_ref) {
    var facet = _ref.facet;

    var facetClasses = Object(__WEBPACK_IMPORTED_MODULE_4_util_react_facet__["a" /* default */])(facet, 'layout');
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_page_layout__["Slot"], { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('layout', 'layout__blank', facetClasses), name: 'content' });
}

WebviewCounter.propTypes = {
    facet: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any
};

/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export routeData */
/* unused harmony export router */
/* harmony export (immutable) */ __webpack_exports__["a"] = render;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_router_parser__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_router_constants__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_router_registry__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_templates__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_containers_page__ = __webpack_require__(1427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_router_validator__ = __webpack_require__(1429);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











__WEBPACK_IMPORTED_MODULE_5_router_registry__["flush"]();
var routeData = Object(__WEBPACK_IMPORTED_MODULE_2_router_parser__["a" /* parse */])(globals.config.routes[0]);
Object(__WEBPACK_IMPORTED_MODULE_8_router_validator__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5_router_registry__["registry"]); // validate the router registry to check if all the pages were properly set into the backend

var router = _extends({}, __WEBPACK_IMPORTED_MODULE_4_router_constants__, routeData, {
    registry: __WEBPACK_IMPORTED_MODULE_5_router_registry__
});

/**
 * All the app routes are lazily evaluated and loaded in runtime
 * @returns {XML}
 */
function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* Switch */],
        null,
        Object(__WEBPACK_IMPORTED_MODULE_1_looppa__["a" /* default */])(router.routes)(function (route) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Route */], {
                exact: true,
                key: route.path,
                path: route.path,
                render: function render(props) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_containers_page__["a" /* default */], _extends({}, props, route, {
                        component: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(route.component, _extends({}, props, route)) }));
                } });
        }),
        globals.config.env !== 'prod' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Route */], { exact: true, path: '/styleguide', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_templates__["f" /* default */].styleguide, props);
            } }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Redirect */], { exact: true, from: '/', to: __WEBPACK_IMPORTED_MODULE_5_router_registry__["get"]() }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Route */], { render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_containers_page__["a" /* default */], _extends({}, props, {
                    template: __WEBPACK_IMPORTED_MODULE_6_templates__["a" /* ERROR_NOT_FOUND */],
                    component: Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_6_templates__["f" /* default */][__WEBPACK_IMPORTED_MODULE_6_templates__["a" /* ERROR_NOT_FOUND */]]) }));
            } })
    );
}

/* unused harmony default export */ var _unused_webpack_default_export = (router);

/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parse;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tree_model__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tree_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tree_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_router_registry__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_templates__ = __webpack_require__(444);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





/**
 * Parse the routes object creating a tree model
 * @param {object} routeData - application routes as object raw coming
 * @returns {TreeModel} object.tree - a new Tree Model instance
 * @returns {TreeModel} object.routes - the raw routes tree populated with the data we need to use for our application
 */
function parse(routeData) {
    var tree = new __WEBPACK_IMPORTED_MODULE_0_tree_model___default.a({
        childrenPropertyName: 'routes'
    }).parse(routeData);
    var routes = [];

    // walk through each route data node
    tree.walk(function (node) {
        var model = node.model,
            parent = node.parent;
        // use the route fragments array to flatten the paths for the children nodes

        var fragments = parent ? [].concat(_toConsumableArray(parent.model.fragments), [model.path]) : [model.path];
        // get the real path concatenating all the previous url fragments
        var path = '/' + fragments.join('/') + '/';
        // extend the node model
        // that's actually not really nice because we extend pseudo immutable data
        node.model = _extends({}, model, { fragments: fragments });

        // add this model to the routes cloning it
        routes.push(_extends({}, model, {
            component: Object(__WEBPACK_IMPORTED_MODULE_2_templates__["g" /* get */])(model.template),
            name: model.name,
            path: path
        }));

        // add the route name to the registry if we need it
        if (model.name) {
            Object(__WEBPACK_IMPORTED_MODULE_1_router_registry__["add"])(model.name, path, model.meta.menu_title || model.meta.title);
        }
    });

    return { tree: tree, routes: routes };
}

/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var LazyRoute = function (_Component) {
    _inherits(LazyRoute, _Component);

    function LazyRoute() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, LazyRoute);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LazyRoute.__proto__ || Object.getPrototypeOf(LazyRoute)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            loaded: false
        }, _this._isUnmounted = false, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(LazyRoute, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.props.component.then(function (module) {
                if (!_this2._isUnmounted) {
                    _this2.component = module.default;
                    _this2.props.onLoaded();
                    _this2.setState({ loaded: true });
                }
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this._isUnmounted = true;
        }
    }, {
        key: 'render',
        value: function render() {
            var loaded = this.state.loaded;


            if (loaded === true) {
                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.component, this.props);
            }

            return null;
        }
    }]);

    return LazyRoute;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

LazyRoute.defaultProps = {
    onLoaded: __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a
};
LazyRoute.propTypes = {
    onLoaded: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (LazyRoute);

/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_page_layout__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_page_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_page_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_error_image_critical__ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_translations_index__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_misc_link_to_home__ = __webpack_require__(198);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Error = function (_PureComponent) {
    _inherits(Error, _PureComponent);

    function Error() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Error);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Error.__proto__ || Object.getPrototypeOf(Error)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            contentOffset: 0
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Error, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // small hack to unflag also global variables
            window.__is_not_found__ = false;
            this.updateOffset();
            this.props.setMainContentIsLoaded({ isLoaded: true });
            this.props.setBreadcrumbs({
                breadcrumbs: [{
                    url: Object(__WEBPACK_IMPORTED_MODULE_7_util_misc_link_to_home__["a" /* default */])(this.props.activeRegion),
                    name: Object(__WEBPACK_IMPORTED_MODULE_6_translations_index__["c" /* default */])('breadcrumbs.overview')
                }]
            });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(_ref2, _ref3) {
            var viewportMqWidth = _ref2.viewportMqWidth;
            var viewportMqWidthNew = _ref3.viewportMqWidth;

            if (viewportMqWidth !== viewportMqWidthNew) {
                this.updateOffset();
            }
        }

        /**
         * Create an offset top to center the error message on the image
         */

    }, {
        key: 'updateOffset',
        value: function updateOffset() {
            var image = this.image,
                content = this.content,
                description = this.description;

            var titleHeight = content.offsetHeight - description.offsetHeight;
            var contentOffset = this.props.isDesktop ? (image.offsetHeight - titleHeight) / 2 : 0;

            this.setState({
                contentOffset: contentOffset + 'px'
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                isDesktop = _props.isDesktop,
                subtitle = _props.subtitle,
                title = _props.title,
                description = _props.description;
            var contentOffset = this.state.contentOffset;


            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_page_layout__["Page"],
                { layout: isDesktop ? 'one-column' : 'full-width', facet: 'narrow' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_page_layout__["Section"],
                    { slot: 'content' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'page' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'page--content' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'page-error page-error__description page-error__dynamic' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'page-error--body' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        {
                                            className: 'page-error--image',
                                            ref: function ref(_ref4) {
                                                _this2.image = _ref4;
                                            }
                                        },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_error_image_critical__["a" /* default */], { alt: Object(__WEBPACK_IMPORTED_MODULE_6_translations_index__["c" /* default */])(subtitle), className: 'page-error--img' })
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        {
                                            className: 'page-error--content',
                                            ref: function ref(_ref6) {
                                                _this2.content = _ref6;
                                            },
                                            style: { top: contentOffset }
                                        },
                                        subtitle && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'h2',
                                            { className: 'u-reset page-error--subtitle' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_translations_index__["a" /* Trans */], { path: subtitle })
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'h1',
                                            { className: 'page-error--title' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_translations_index__["a" /* Trans */], { path: title })
                                        ),
                                        description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            {
                                                className: 'page-error--description cms-richtext',
                                                ref: function ref(_ref5) {
                                                    _this2.description = _ref5;
                                                }
                                            },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_translations_index__["b" /* TransMD */], { path: description })
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Error;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Error.propTypes = {
    isDesktop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    subtitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
    activeRegion: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
    setBreadcrumbs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    viewportMqWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    lastRoute: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    setMainContentIsLoaded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_2_util_redux__["b" /* default */].mapStateToProps({
    isDesktop: 'viewport.isDesktop',
    viewportMqWidth: 'viewport.mq.width',
    activeRegion: 'region.active',
    lastRoute: 'router.lastRoute'
}), __WEBPACK_IMPORTED_MODULE_2_util_redux__["b" /* default */].mapDispatchToProps({
    setBreadcrumbs: 'breadcrumbs.set',
    setMainContentIsLoaded: 'main-content.setIsLoaded'
}))(Error));

/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_misc_static_assets_path__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);





var ErrorImageCritical = function ErrorImageCritical(_ref) {
    var className = _ref.className,
        alt = _ref.alt;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: Object(__WEBPACK_IMPORTED_MODULE_2_util_misc_static_assets_path__["a" /* default */])('img/error/im-critical.png'), alt: alt, className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('error-critical', className) });
};

ErrorImageCritical.propTypes = {
    className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    alt: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

/* harmony default export */ __webpack_exports__["a"] = (ErrorImageCritical);

/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_misc_link_to_home__ = __webpack_require__(198);







function RootPage(_ref) {
    var activeRegion = _ref.activeRegion;

    var query = document.location.search;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Redirect */], { to: '' + Object(__WEBPACK_IMPORTED_MODULE_5_util_misc_link_to_home__["a" /* default */])(activeRegion) + query });
}

RootPage.propTypes = {
    activeRegion: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_2_util_redux__["b" /* default */].mapStateToProps({
    activeRegion: 'region.active'
}))(RootPage));

/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_page_layout__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_page_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_page_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_main_sidebar__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_booster_bar__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_categories_menu__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_cms_placeholder__ = __webpack_require__(242);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var Dashboard = function (_PureComponent) {
    _inherits(Dashboard, _PureComponent);

    function Dashboard() {
        _classCallCheck(this, Dashboard);

        return _possibleConstructorReturn(this, (Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).apply(this, arguments));
    }

    _createClass(Dashboard, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.props.setActiveCategory({ category: null });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.resetBreadcrumbs();
        }
    }, {
        key: 'render',
        value: function render() {
            var setMainContentIsLoaded = this.props.setMainContentIsLoaded;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_page_layout__["Page"],
                { layout: 'two-columns', facet: 'narrow' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_page_layout__["Section"],
                    { slot: 'sidebar' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_5_components_main_sidebar__["a" /* default */],
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_categories_menu__["a" /* default */], null)
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_page_layout__["Section"],
                    { slot: 'content' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'page' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_booster_bar__["a" /* default */], null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'page--content' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_cms_placeholder__["a" /* default */], { onLoaded: function onLoaded() {
                                    return setMainContentIsLoaded({ isLoaded: true });
                                }, id: 'dashboard' })
                        )
                    )
                )
            );
        }
    }]);

    return Dashboard;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Dashboard.propTypes = {
    setActiveCategory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    resetBreadcrumbs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    setMainContentIsLoaded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(null, __WEBPACK_IMPORTED_MODULE_2_util_redux__["b" /* default */].mapDispatchToProps({
    resetBreadcrumbs: 'breadcrumbs.reset',
    setActiveCategory: 'categories.setActiveCategory',
    setMainContentIsLoaded: 'main-content.setIsLoaded'
}))(Dashboard));

/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_collapsible__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_collapsible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_collapsible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util_misc_normalise_trailing_slash__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_icon__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_notification__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_constants_timeformat__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_constants_transitions_props__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_constants_notifications__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_countdown__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_util_misc_static_assets_path__ = __webpack_require__(197);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















function formatDate(_ref) {
    var delivery_start = _ref.delivery_start,
        delivery_end = _ref.delivery_end;

    var start = __WEBPACK_IMPORTED_MODULE_6_moment___default()(delivery_start);
    var end = __WEBPACK_IMPORTED_MODULE_6_moment___default()(delivery_end);

    return {
        delivery_day: start.format(__WEBPACK_IMPORTED_MODULE_11_constants_timeformat__["a" /* BOOSTER_BAR_DELIVERY_DATE */]),
        delivery_time: start.format(__WEBPACK_IMPORTED_MODULE_11_constants_timeformat__["i" /* TIME_FORMAT */]) + '-' + end.format(__WEBPACK_IMPORTED_MODULE_11_constants_timeformat__["i" /* TIME_FORMAT */])
    };
}

var BoosterBarItem = function (_PureComponent) {
    _inherits(BoosterBarItem, _PureComponent);

    function BoosterBarItem() {
        var _ref2;

        var _temp, _this, _ret;

        _classCallCheck(this, BoosterBarItem);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = BoosterBarItem.__proto__ || Object.getPrototypeOf(BoosterBarItem)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
            isOpen: false
        }, _this.doAction = function () {
            var has_close = _this.props.has_close;


            if (has_close) {
                _this.props.onRemove();
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(BoosterBarItem, [{
        key: 'hasCountdownComponent',
        value: function hasCountdownComponent(props) {
            return props.type === __WEBPACK_IMPORTED_MODULE_13_constants_notifications__["b" /* NOTIFICATION_TYPE_PROMOTION */] && props.data && props.data.deadline;
        }
    }, {
        key: 'getIconProps',
        value: function getIconProps() {
            var type = this.props.type;

            var props = {
                symbol: null,
                size: 'medium'
            };

            switch (type) {
                case __WEBPACK_IMPORTED_MODULE_13_constants_notifications__["b" /* NOTIFICATION_TYPE_PROMOTION */]:
                    props.symbol = 'gift';
                    break;
                case __WEBPACK_IMPORTED_MODULE_13_constants_notifications__["c" /* NOTIFICATION_TYPE_SEARCHING */]:
                    props.symbol = 'clock';
                    break;
                default:
                    props.symbol = 'list';
                    break;
            }

            return props;
        }
    }, {
        key: 'renderAction',
        value: function renderAction() {
            var _props = this.props,
                detail = _props.detail,
                has_close = _props.has_close;
            var isOpen = this.state.isOpen;


            if (!detail && !has_close) {
                return null;
            }

            return has_close ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_icon__["a" /* default */], { symbol: 'cancel-extra-small', size: 'small' }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_icon__["a" /* default */], { symbol: isOpen ? 'basket-remove' : 'basket-add', size: 'small' });
        }
    }, {
        key: 'renderNotificationHeader',
        value: function renderNotificationHeader() {
            var _props2 = this.props,
                data = _props2.data,
                type = _props2.type;

            var hasCountdown = this.hasCountdownComponent(this.props);

            if (hasCountdown) {
                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'booster-bar--countdown' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_countdown__["a" /* default */], { startDate: data.now, endDate: data.deadline,
                        rootFacet: 'booster-bar', facet: 'booster-bar' })
                );
            }

            if (type === __WEBPACK_IMPORTED_MODULE_13_constants_notifications__["b" /* NOTIFICATION_TYPE_PROMOTION */]) {
                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'booster-bar--icon' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: Object(__WEBPACK_IMPORTED_MODULE_15_util_misc_static_assets_path__["a" /* default */])('img/notifications/present.svg') })
                );
            }

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'booster-bar--icon' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_icon__["a" /* default */], this.getIconProps())
            );
        }
    }, {
        key: 'renderContent',
        value: function renderContent() {
            var _props3 = this.props,
                link = _props3.link,
                teaser = _props3.teaser,
                data = _props3.data,
                type = _props3.type;


            if (type === __WEBPACK_IMPORTED_MODULE_13_constants_notifications__["a" /* NOTIFICATION_TYPE_PICKING */]) {
                Object.assign(data, formatDate(data));
            }

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'booster-bar--row' },
                this.renderNotificationHeader(),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'booster-bar--text' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p', { className: 'booster-bar--paragraph',
                        dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_8_translations__["e" /* markdown */])(teaser, data) } }),
                    link ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],
                        { className: 'booster-bar--link u-reset',
                            to: Object(__WEBPACK_IMPORTED_MODULE_7_util_misc_normalise_trailing_slash__["a" /* default */])(link.url) },
                        Object(__WEBPACK_IMPORTED_MODULE_8_translations__["c" /* default */])(link.text)
                    ) : null
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'booster-bar--action', onClick: this.doAction },
                    this.renderAction()
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props4 = this.props,
                type = _props4.type,
                detail = _props4.detail;

            var notificationFacet = type === __WEBPACK_IMPORTED_MODULE_13_constants_notifications__["b" /* NOTIFICATION_TYPE_PROMOTION */] ? 'promotion' : 'blank';

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'li',
                { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('booster-bar--item', 'booster-bar--item__' + type, {
                        'booster-bar--item__has-countdown': this.hasCountdownComponent(this.props)
                    }) },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_10_components_notification__["a" /* default */],
                    { facet: notificationFacet },
                    detail ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_react_collapsible___default.a,
                        { triggerClassName: 'booster-bar--trigger',
                            transitionTime: __WEBPACK_IMPORTED_MODULE_12_constants_transitions_props__["b" /* accordionSpeed */],
                            easing: __WEBPACK_IMPORTED_MODULE_12_constants_transitions_props__["a" /* accordionEasingFn */],
                            onOpen: function onOpen() {
                                return _this2.setState({ isOpen: true });
                            },
                            onClose: function onClose() {
                                return _this2.setState({ isOpen: false });
                            }, trigger: this.renderContent() },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p', { className: 'booster-bar--accordion-content',
                            dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_8_translations__["e" /* markdown */])(detail) } })
                    ) : this.renderContent()
                )
            );
        }
    }]);

    return BoosterBarItem;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

BoosterBarItem.defaultProps = {
    onRemove: __WEBPACK_IMPORTED_MODULE_0_lodash_noop___default.a
};
BoosterBarItem.propTypes = {
    type: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    has_close: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,
    teaser: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    onRemove: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    detail: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    data: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    link: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (BoosterBarItem);

/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NOTIFICATION_TYPE_PROMOTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NOTIFICATION_TYPE_SEARCHING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NOTIFICATION_TYPE_PICKING; });
var NOTIFICATION_TYPE_PROMOTION = 'promotion';
var NOTIFICATION_TYPE_SEARCHING = 'searching';
var NOTIFICATION_TYPE_PICKING = 'picking';

/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_flip_move__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_looppa__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__slide_down__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__slide_right__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__slide_left__ = __webpack_require__(1241);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Animation = function (_Component) {
    _inherits(Animation, _Component);

    function Animation(props) {
        _classCallCheck(this, Animation);

        var _this = _possibleConstructorReturn(this, (Animation.__proto__ || Object.getPrototypeOf(Animation)).call(this, props));

        _this.animations = {};

        _this.animations['slideDown'] = __WEBPACK_IMPORTED_MODULE_4__slide_down__["a" /* default */];
        _this.animations['slideRight'] = __WEBPACK_IMPORTED_MODULE_5__slide_right__["a" /* default */];
        _this.animations['slideLeft'] = __WEBPACK_IMPORTED_MODULE_6__slide_left__["a" /* default */];
        return _this;
    }

    _createClass(Animation, [{
        key: 'getAnimation',
        value: function getAnimation() {
            if (this.props.animationConfig) {
                return this.props.animationConfig;
            }

            var animation = this.props.animation;

            if (!this.animations[animation]) {
                console.warn('No animation named ' + animation + ' found');
            }

            return this.animations[animation];
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                duration = _props.duration,
                easing = _props.easing;

            var animation = this.getAnimation();

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_1_react_flip_move__["a" /* default */],
                {
                    duration: duration,
                    easing: easing,
                    appearAnimation: animation.in,
                    enterAnimation: animation.in,
                    leaveAnimation: animation.out
                },
                Array.isArray(children) ? Object(__WEBPACK_IMPORTED_MODULE_2_looppa__["a" /* default */])(children)(function (child) {
                    return { child: child };
                }) : children
            );
        }
    }]);

    return Animation;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Animation.defaultProps = {
    animation: 'slideDown',
    animationConfig: null,
    duration: 200,
    easing: 'cubic-bezier(0.25, 0.1, 0.75, 1)'
};
Animation.propTypes = {
    children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any.isRequired,
    animation: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    animationConfig: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
    duration: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    easing: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (Animation);

/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    in: {
        from: {
            transform: 'translateY(-100px)'
        },
        to: {
            transform: ''
        }
    },

    out: {
        from: {
            transform: 'translateY(0)'
        },
        to: {
            transform: 'translateY(-100px)'
        }
    }
});

/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    in: {
        from: {
            transform: 'translateX(32px)',
            opacity: '0'
        },
        to: {
            transform: '',
            opacity: ''
        }
    },

    out: null
});

/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    in: {
        from: {
            transform: 'translateX(-32px)',
            opacity: '0'
        },
        to: {
            transform: '',
            opacity: ''
        }
    },

    out: null
});

/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_onboarding__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_page_layout__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_page_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_page_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_cms_placeholder_section__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_util_misc_static_assets_path__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_free_delivery_batch__ = __webpack_require__(1245);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var Onboarding = function (_PureComponent) {
    _inherits(Onboarding, _PureComponent);

    function Onboarding() {
        _classCallCheck(this, Onboarding);

        return _possibleConstructorReturn(this, (Onboarding.__proto__ || Object.getPrototypeOf(Onboarding)).apply(this, arguments));
    }

    _createClass(Onboarding, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_page_layout__["Page"],
                { layout: 'full-width-no-container' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_6_react_page_layout__["Section"],
                    { slot: 'content' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'page page__onboarding page__compact' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            {
                                className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('page--content', {
                                    'page--content__is-visible': true
                                })
                            },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_free_delivery_batch__["a" /* default */], null),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_onboarding__["a" /* default */], { onLoaded: function onLoaded() {
                                    return _this2.props.setMainContentIsLoaded({ isLoaded: true });
                                } }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_7_components_cms_placeholder_section__["a" /* default */],
                                { type: 'section', color: 'accent' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                                    className: 'section--footer-image',
                                    src: Object(__WEBPACK_IMPORTED_MODULE_8_util_misc_static_assets_path__["a" /* default */])('img/spacer/img-footer-on-purple.png')
                                })
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Onboarding;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Onboarding.propTypes = {
    setBreadcrumbs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    meta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    isLoaded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    setMainContentIsLoaded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_2_util_redux__["b" /* default */].mapStateToProps({
    pageName: 'router.name',
    isLoaded: 'main-content.isLoaded'
}), __WEBPACK_IMPORTED_MODULE_2_util_redux__["b" /* default */].mapDispatchToProps({
    setBreadcrumbs: 'breadcrumbs.set',
    setMainContentIsLoaded: 'main-content.setIsLoaded'
}))(Onboarding));

/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_cms_placeholder__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__intro__ = __webpack_require__(1244);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Onboarding = function (_PureComponent) {
    _inherits(Onboarding, _PureComponent);

    function Onboarding() {
        _classCallCheck(this, Onboarding);

        return _possibleConstructorReturn(this, (Onboarding.__proto__ || Object.getPrototypeOf(Onboarding)).apply(this, arguments));
    }

    _createClass(Onboarding, [{
        key: 'render',
        value: function render() {
            var pageName = this.props.pageName;

            return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__intro__["a" /* default */], { key: 'intro' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_cms_placeholder__["a" /* default */], { key: 'placeholder', onLoaded: this.props.onLoaded, id: pageName })];
        }
    }]);

    return Onboarding;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Onboarding.propTypes = {
    onLoaded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    pageName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};
;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_2_util_redux__["b" /* default */].mapStateToProps({
    pageName: 'router.name'
}))(Onboarding));

/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util_misc_static_assets_path__ = __webpack_require__(197);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var OnboardingIntroOverlay = function (_PureComponent) {
    _inherits(OnboardingIntroOverlay, _PureComponent);

    function OnboardingIntroOverlay() {
        _classCallCheck(this, OnboardingIntroOverlay);

        return _possibleConstructorReturn(this, (OnboardingIntroOverlay.__proto__ || Object.getPrototypeOf(OnboardingIntroOverlay)).apply(this, arguments));
    }

    _createClass(OnboardingIntroOverlay, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'onboarding-intro' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { onClick: function onClick() {
                            return _this2.props.openModal({ layout: 'zip-form' });
                        }, className: 'onboarding-intro--inner grid--container' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'onboarding-intro--logo', src: Object(__WEBPACK_IMPORTED_MODULE_4_util_misc_static_assets_path__["a" /* default */])('img/logos/amigos-large.svg') })
                )
            );
        }
    }]);

    return OnboardingIntroOverlay;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

OnboardingIntroOverlay.propTypes = {
    openModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    pageName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};
;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_2_util_redux__["b" /* default */].mapStateToProps({
    pageName: 'router.name'
}), __WEBPACK_IMPORTED_MODULE_2_util_redux__["b" /* default */].mapDispatchToProps({
    openModal: 'modal.open'
}))(OnboardingIntroOverlay));

/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_redux__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(173);






function FreeDeliveryBatch(_ref) {
    var openModal = _ref.openModal;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'grid--container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'cms-placeholder cms-placeholder__section free-delivery-batch__wrapper' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                        return openModal({ layout: 'zip-form' });
                    }, className: 'free-delivery-batch' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'free-delivery-batch__text' },
                    Object(__WEBPACK_IMPORTED_MODULE_2_translations__["f" /* t */])('amigos.free-delivery')
                )
            )
        )
    );
};

FreeDeliveryBatch.propTypes = {
    openModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(null, __WEBPACK_IMPORTED_MODULE_3_util_redux__["b" /* default */].mapDispatchToProps({
    openModal: 'modal.open'
}))(FreeDeliveryBatch));

/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STRIPE_JAVASCRIPT_API; });
var STRIPE_JAVASCRIPT_API = 'https://js.stripe.com/v3/';

/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_memoize__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_memoize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_memoize__);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_lodash_memoize___default()(function loadScript(url) {
    return new Promise(function (resolve) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.onload = function () {
            setTimeout(resolve, 10);
        };
        script.src = url;
        document.getElementsByTagName('head')[0].appendChild(script);
    });
}));

/***/ }),
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_redux_index__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bianco_events__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tracking_index__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_templates__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_templates_config__ = __webpack_require__(1428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_misc_get_region__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_util_misc_link_to_dashboard__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_util_misc_link_to_sibling_region__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_translations__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_constants_page_names__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_constants_protected_pages__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_constants_cart_error_types__ = __webpack_require__(564);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var isSplashScreenRemoved = false;

var PageContainer = function (_PureComponent) {
    _inherits(PageContainer, _PureComponent);

    function PageContainer(props) {
        _classCallCheck(this, PageContainer);

        var _this = _possibleConstructorReturn(this, (PageContainer.__proto__ || Object.getPrototypeOf(PageContainer)).call(this, props));

        _this.state = {
            redirectRouteName: null,
            redirectToLogin: false
        };

        _this.setRoute(props);
        return _this;
    }

    _createClass(PageContainer, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (!window.__is_not_found__) {
                this.props.setForceNotFound({ mustForceNotFound: false });
            }
            // reset the scroll position
            this.setBodyBusyState(this.props);
            this.props.setMainContentIsLoaded({ isLoaded: false });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var _props = this.props,
                template = _props.template,
                meta = _props.meta,
                setLastRoute = _props.setLastRoute,
                routeLocation = _props.routeLocation,
                routeMeta = _props.routeMeta,
                isFirstRoute = _props.isFirstRoute,
                setPageTitle = _props.setPageTitle;

            // close the modals in case of url changes or browser back

            Object(__WEBPACK_IMPORTED_MODULE_5_bianco_events__["a" /* add */])(window, 'hashchange popstate', function () {
                return _this2.props.closeModal();
            });

            // set automatically the page title
            // but don't do it the product pages
            if (![__WEBPACK_IMPORTED_MODULE_7_templates__["d" /* PRODUCT_DETAIL */], __WEBPACK_IMPORTED_MODULE_7_templates__["c" /* PRODUCTS_OVERVIEW */], __WEBPACK_IMPORTED_MODULE_7_templates__["b" /* PRODUCTS_LIST */], __WEBPACK_IMPORTED_MODULE_7_templates__["e" /* TOPICS */]].includes(template)) {
                setPageTitle({
                    title: meta.title
                });
            }

            if (!isFirstRoute) {
                setLastRoute({
                    lastRoute: {
                        location: routeLocation,
                        meta: routeMeta
                    }
                });
            }

            if (!this.props.wasCartFetched && !this.props.isNative && !this.props.isCartFetching) {
                this.props.requestOrder();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this3 = this;

            if (nextProps.routeLocation.pathname !== window.location.pathname) {
                this.setRoute(nextProps);
            }

            if (this.props.isLoaded !== nextProps.isLoaded) {
                this.setBodyBusyState(nextProps);
            }

            // Handle redirects for non-public page names (routes)
            this.routeToLogin(nextProps);

            // prevent users browsing the checkout page without having an active region selected
            if (nextProps.name === __WEBPACK_IMPORTED_MODULE_13_constants_page_names__["CHECKOUT"] && !this.props.activeRegion) {
                // wait that the side panel eventually will be closed
                setTimeout(function () {
                    _this3.showCartZipError(nextProps);
                }, 400);

                this.routeToDashboard(nextProps);
            }

            if (
            // this case checks whether the user has just set for the first time his/her region but he/she is in the wrong section of the site
            // see also https://jira.migros.net/browse/MCART-2524?focusedCommentId=1882306&page=com.atlassian.jira.plugin.system.issuetabpanels%3Acomment-tabpanel#comment-1882306
            this.hasUserJustSetUserRegion(nextProps) && this.isUserInWrongRegionPages(nextProps) ||
            // these other conditions match whether the user will change his/her region in runtime having it already set previously
            nextProps.activeRegion && this.props.activeRegion && nextProps.activeRegion.cooperative !== this.props.activeRegion.cooperative) {
                this.routeToUsersProducts(nextProps);
            }

            if (nextProps.cartError) {
                this.showCartErrorModal(nextProps);
            }

            if (!this.props.isMainContentLoaded && nextProps.isMainContentLoaded) {
                this.onMainContentLoaded();
            }

            if (nextProps.isLoaded && !isSplashScreenRemoved) {
                window.__removeSplash__();
                isSplashScreenRemoved = true;
            }
        }
    }, {
        key: 'onMainContentLoaded',
        value: function onMainContentLoaded() {
            if (isSplashScreenRemoved || this.hasStartedWithARedirect()) {
                __WEBPACK_IMPORTED_MODULE_6_tracking_index__["a" /* default */].pageView(_extends({}, this.props), this.props.breadcrumbs, this.props.user);
            }

            window.scrollTo(0, 0);
        }

        /**
         * The initial page tracking event is weird and makes no sense but the script below does what they told me to do...
         * If there was an initial redirect via react we need to track it as pageView event otherwise don't track anything
         */

    }, {
        key: 'hasStartedWithARedirect',
        value: function hasStartedWithARedirect() {
            return !!(window.dataLayer && window.dataLayer.length && window.dataLayer.some(function (e) {
                return e.originalLocation && e.pnam !== document.location.pathname;
            }));
        }
    }, {
        key: 'isUserInWrongRegionPages',
        value: function isUserInWrongRegionPages(nextProps) {
            return !!(nextProps.routeCooperative && nextProps.routeCooperative !== nextProps.activeRegion.cooperative);
        }
    }, {
        key: 'hasUserJustSetUserRegion',
        value: function hasUserJustSetUserRegion(nextProps) {
            return !!(!this.props.activeRegion && nextProps.activeRegion && nextProps.isLoaded);
        }
    }, {
        key: 'setBodyBusyState',
        value: function setBodyBusyState(props) {
            document.body.setAttribute('aria-busy', !props.isLoaded);
            if (window.topconent) {
                // restore the focus on the top contents
                window.topconent.focus();
            }
        }
    }, {
        key: 'setRoute',
        value: function setRoute(_ref) {
            var match = _ref.match,
                history = _ref.history,
                location = _ref.location,
                meta = _ref.meta,
                name = _ref.name,
                component = _ref.component;
            var cooperative = meta.cooperative;


            this.props.setRoute({
                route: {
                    match: match,
                    history: history,
                    location: location,
                    meta: meta,
                    name: name || '',
                    config: Object(__WEBPACK_IMPORTED_MODULE_8_templates_config__["a" /* default */])(component.props.template)
                }
            });

            if (cooperative !== this.props.routeCooperative) {
                this.props.setCooperative({
                    cooperative: cooperative
                });
            }
        }
    }, {
        key: 'routeToDashboard',
        value: function routeToDashboard(nextProps) {
            this.setState({
                redirectRouteName: Object(__WEBPACK_IMPORTED_MODULE_10_util_misc_link_to_dashboard__["c" /* linkToDashboardByUser */])(nextProps.requestedRegion)
            });
        }
    }, {
        key: 'routeToLogin',
        value: function routeToLogin(_ref2) {
            var name = _ref2.name,
                isAuthenticated = _ref2.isAuthenticated,
                hasMissingMloginData = _ref2.hasMissingMloginData;

            switch (true) {
                case !isAuthenticated && __WEBPACK_IMPORTED_MODULE_14_constants_protected_pages__["a" /* default */].includes(name):
                case hasMissingMloginData && name === __WEBPACK_IMPORTED_MODULE_13_constants_page_names__["CHECKOUT"]:
                    this.setState({
                        redirectToLogin: true
                    });
                    break;
                default:
                    break;
            }
        }
    }, {
        key: 'routeToUsersProducts',
        value: function routeToUsersProducts(nextProps) {
            this.props.flushProducts();
            // trigger an hard page reload
            this.props.clearCart().then(function () {
                window.location.href = Object(__WEBPACK_IMPORTED_MODULE_11_util_misc_link_to_sibling_region__["a" /* default */])(nextProps.activeRegion, nextProps.routeCooperative, nextProps.pathname);
            });
        }
    }, {
        key: 'showCartErrorModal',
        value: function showCartErrorModal(nextProps) {
            // clear the cart errors once displayed once
            this.props.clearCartError();
            switch (nextProps.cartError) {
                case __WEBPACK_IMPORTED_MODULE_15_constants_cart_error_types__["a" /* MISSING_ZIP_CODE */]:
                    return this.showCartZipError(nextProps);
                case __WEBPACK_IMPORTED_MODULE_15_constants_cart_error_types__["c" /* PRODUCT_NOT_IN_REGION */]:
                    return this.showCartRegionError(nextProps);
                case __WEBPACK_IMPORTED_MODULE_15_constants_cart_error_types__["b" /* ORDER_PENDING */]:
                    return this.showCartPendingOrderError(nextProps);
                default:
                    return Promise.reject();
            }
        }
    }, {
        key: 'showCartPendingOrderError',
        value: function showCartPendingOrderError() {
            return this.props.openModal({
                layout: 'alert',
                meta: {
                    type: 'error',
                    icon: {
                        size: 'large',
                        symbol: 'alert'
                    },
                    title: Object(__WEBPACK_IMPORTED_MODULE_12_translations__["c" /* default */])('alert.pending_orders.title'),
                    description: Object(__WEBPACK_IMPORTED_MODULE_12_translations__["c" /* default */])('alert.pending_orders.description')
                }
            });
        }
    }, {
        key: 'showCartRegionError',
        value: function showCartRegionError(nextProps) {
            var _this4 = this;

            var translationsData = {
                user_zip: nextProps.activeRegion.zip,
                user_region: Object(__WEBPACK_IMPORTED_MODULE_9_util_misc_get_region__["a" /* findRegionByCooperative */])(nextProps.activeRegion.cooperative).region_display,
                products_region: Object(__WEBPACK_IMPORTED_MODULE_9_util_misc_get_region__["a" /* findRegionByCooperative */])(nextProps.routeCooperative).region_display
            };

            return this.props.openModal({
                layout: 'confirm',
                meta: {
                    type: 'error',
                    icon: {
                        size: 'large',
                        symbol: 'alert'
                    },
                    actions: [{
                        name: Object(__WEBPACK_IMPORTED_MODULE_12_translations__["c" /* default */])('modal.close'),
                        facet: 'secondary',
                        event: function event() {
                            _this4.props.closeModal();
                        }
                    }, {
                        name: Object(__WEBPACK_IMPORTED_MODULE_12_translations__["c" /* default */])('alert.product_not_in_region.change_region', translationsData),
                        event: function event() {
                            _this4.props.closeModal();
                            _this4.routeToUsersProducts(nextProps);
                        }
                    }],
                    title: Object(__WEBPACK_IMPORTED_MODULE_12_translations__["c" /* default */])('alert.product_not_in_region.title', translationsData),
                    description: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_translations__["b" /* TransMD */], { path: 'alert.product_not_in_region.description', data: translationsData })
                }
            });
        }
    }, {
        key: 'showCartZipError',
        value: function showCartZipError() {
            return this.props.openModal({
                layout: 'zip-form',
                meta: {
                    descriptionPath: 'zip.notDefined'
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                login = _props2.login,
                pathname = _props2.pathname,
                component = _props2.component,
                mustForceNotFound = _props2.mustForceNotFound;
            var _state = this.state,
                redirectToLogin = _state.redirectToLogin,
                redirectRouteName = _state.redirectRouteName;


            if (redirectToLogin) {
                login(window.location.href);
                return null;
            }

            if (redirectRouteName && redirectRouteName !== pathname) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Redirect */], { to: redirectRouteName });
            }

            if (mustForceNotFound) {
                return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_7_templates__["f" /* default */][__WEBPACK_IMPORTED_MODULE_7_templates__["a" /* ERROR_NOT_FOUND */]], this.props);
            }

            return component;
        }
    }]);

    return PageContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

PageContainer.propTypes = {
    activeRegion: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    isAuthenticated: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    isFirstRoute: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    breadcrumbs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
    login: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    mustForceNotFound: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    match: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    meta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    template: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    pathname: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    deliveryStatus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    flushProducts: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    user: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    requestedRegion: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    hasMissingMloginData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    wasCartFetched: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    routeLocation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    routeMeta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    setCooperative: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    routerRegistry: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    setLastRoute: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    setRoute: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    isCartFetching: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    isMainContentLoaded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    setPageTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    clearCart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    openModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    closeModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    clearCartError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    requestOrder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    isNative: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    routeCooperative: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    setMainContentIsLoaded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    cartError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    isLoaded: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
    setForceNotFound: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
PageContainer.defaultProps = {
    meta: {}
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_3_util_redux_index__["b" /* default */].mapStateToProps({
    routeLocation: 'router.location',
    routeMeta: 'router.meta',
    breadcrumbs: 'breadcrumbs.items',
    isFirstRoute: 'router.isFirstRoute',
    requestedRegion: 'region.requested',
    activeRegion: 'region.active',
    isCartFetching: 'cart.isFetching',
    wasCartFetched: 'cart.wasFetched',
    routerRegistry: 'router.registry',
    pathname: 'router.location.pathname',
    routeCooperative: 'router.cooperative',
    cartError: 'cart.cartError',
    user: 'user',
    isNative: 'viewport.isNative',
    isMainContentLoaded: 'main-content.isLoaded',
    isAuthenticated: 'user.isAuthenticated',
    hasMissingMloginData: 'user.has_missing_mlogin_data',
    isLoaded: 'main-content.isLoaded',
    lastRoute: 'router.lastRoute',
    mustForceNotFound: 'router.mustForceNotFound'
}), __WEBPACK_IMPORTED_MODULE_3_util_redux_index__["b" /* default */].mapDispatchToProps({
    setRoute: 'router.set',
    flushProducts: 'products.flush',
    openModal: 'modal.open',
    closeModal: 'modal.close',
    setPageTitle: 'viewport.setTitle',
    clearCart: 'cart.clearCart',
    requestOrder: 'poll.requestOrder',
    clearCartError: 'cart.clearCartError',
    setLastRoute: 'router.setLastRoute',
    login: 'user.login',
    setForceNotFound: 'router.setForceNotFound',
    setMainContentIsLoaded: 'main-content.setIsLoaded',
    setCooperative: 'router.setCooperative'
}))(PageContainer));

/***/ }),
/* 1428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var templateConfig = [{
    name: 'default',
    header: 'default',
    footer: 'default',
    boosterbar: 'default'
}, {
    name: 'content_page_no_container',
    header: 'default',
    footer: 'default',
    boosterbar: 'none'
}, {
    name: 'checkout',
    header: 'reduced',
    footer: 'lite',
    boosterbar: 'default'
}, {
    name: 'delivery_search',
    header: 'reduced',
    footer: 'default',
    boosterbar: 'default'
}, {
    name: 'onboarding',
    header: 'none',
    footer: 'reduced',
    boosterbar: 'default'
}];

var getTemplateConfig = function getTemplateConfig(template) {
    var config = templateConfig.find(function (obj) {
        return obj.name === template;
    });
    if (config) {
        return config;
    }
    return templateConfig.find(function (obj) {
        return obj.name === 'default';
    });
};

/* harmony default export */ __webpack_exports__["a"] = (getTemplateConfig);

/***/ }),
/* 1429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_difference__ = __webpack_require__(1430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_difference___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_difference__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_misc_log_error__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_page_names__ = __webpack_require__(194);





/**
 * Verify if all the pages needed to run this project were properly set in the backend route
 * @props {object} registry - router registry where all main application routes will get stored
 */
function validate(registry) {
    // we could have used Object.values here but IE sucks and the polyfill are not available yet here :(
    var pageNamesCollection = Object.keys(__WEBPACK_IMPORTED_MODULE_2_constants_page_names__).reduce(function (acc, key) {
        return acc.concat(__WEBPACK_IMPORTED_MODULE_2_constants_page_names__[key]);
    }, []);
    var registryNames = Object.keys(registry);
    var diff = __WEBPACK_IMPORTED_MODULE_0_lodash_difference___default()(pageNamesCollection, registryNames);

    if (diff.length) {
        Object(__WEBPACK_IMPORTED_MODULE_1_util_misc_log_error__["a" /* default */])(new Error('Please make sure that all the main application routes have a "name", I couldn\'t find any route for the pages: "' + diff.join(', ') + '"'));
        return false;
    }

    return true;
}

/***/ })
]));


// WEBPACK FOOTER //
// chunks/2/index.b78ffab9792e085afe8a.js